/* eslint-disable */
import type { TypedDocumentNode as DocumentNode } from '@graphql-typed-document-node/core';
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = {
  [K in keyof T]: T[K];
};
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & {
  [SubKey in K]?: Maybe<T[SubKey]>;
};
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & {
  [SubKey in K]: Maybe<T[SubKey]>;
};
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: string;
  String: string;
  Boolean: boolean;
  Int: number;
  Float: number;
  DateTime: string;
  /** Decimal parser */
  Decimal: number;
  Json: object;
  Long: number;
  Upload: File;
};

export type AccessRequest = {
  createdAt: Scalars['DateTime'];
  grantedAt?: Maybe<Scalars['DateTime']>;
  grantedUntil?: Maybe<Scalars['DateTime']>;
  id: Scalars['ID'];
  requester: User;
  school: School;
  status: ExtendedAccessRequestStatus;
  updatedAt: Scalars['DateTime'];
};

export type AccessRequestConnection = {
  aggregate: AggregateAccessRequest;
  edges: Array<Maybe<AccessRequestEdge>>;
  pageInfo: PageInfo;
};

export type AccessRequestCreateInput = {
  schoolId: Scalars['String'];
};

export type AccessRequestCreateManyWithoutSchoolInput = {
  connect?: InputMaybe<Array<AccessRequestWhereUniqueInput>>;
  create?: InputMaybe<Array<AccessRequestCreateWithoutSchoolInput>>;
};

export type AccessRequestCreateWithoutSchoolInput = {
  grantedAt?: InputMaybe<Scalars['DateTime']>;
  grantedUntil?: InputMaybe<Scalars['DateTime']>;
  id?: InputMaybe<Scalars['ID']>;
  requesterId: Scalars['ID'];
  status?: InputMaybe<AccessRequestStatus>;
};

export type AccessRequestEdge = {
  cursor: Scalars['String'];
  node: AccessRequest;
};

export type AccessRequestOrderByInput =
  | 'createdAt_ASC'
  | 'createdAt_DESC'
  | 'grantedAt_ASC'
  | 'grantedAt_DESC'
  | 'grantedUntil_ASC'
  | 'grantedUntil_DESC'
  | 'id_ASC'
  | 'id_DESC'
  | 'requesterId_ASC'
  | 'requesterId_DESC'
  | 'status_ASC'
  | 'status_DESC'
  | 'updatedAt_ASC'
  | 'updatedAt_DESC';

export type AccessRequestPreviousValues = {
  createdAt: Scalars['DateTime'];
  grantedAt?: Maybe<Scalars['DateTime']>;
  grantedUntil?: Maybe<Scalars['DateTime']>;
  id: Scalars['ID'];
  requesterId: Scalars['ID'];
  status: AccessRequestStatus;
  updatedAt: Scalars['DateTime'];
};

export type AccessRequestScalarWhereInput = {
  AND?: InputMaybe<Array<AccessRequestScalarWhereInput>>;
  NOT?: InputMaybe<Array<AccessRequestScalarWhereInput>>;
  OR?: InputMaybe<Array<AccessRequestScalarWhereInput>>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  createdAt_gt?: InputMaybe<Scalars['DateTime']>;
  createdAt_gte?: InputMaybe<Scalars['DateTime']>;
  createdAt_in?: InputMaybe<Array<Scalars['DateTime']>>;
  createdAt_lt?: InputMaybe<Scalars['DateTime']>;
  createdAt_lte?: InputMaybe<Scalars['DateTime']>;
  createdAt_not?: InputMaybe<Scalars['DateTime']>;
  createdAt_not_in?: InputMaybe<Array<Scalars['DateTime']>>;
  grantedAt?: InputMaybe<Scalars['DateTime']>;
  grantedAt_gt?: InputMaybe<Scalars['DateTime']>;
  grantedAt_gte?: InputMaybe<Scalars['DateTime']>;
  grantedAt_in?: InputMaybe<Array<Scalars['DateTime']>>;
  grantedAt_lt?: InputMaybe<Scalars['DateTime']>;
  grantedAt_lte?: InputMaybe<Scalars['DateTime']>;
  grantedAt_not?: InputMaybe<Scalars['DateTime']>;
  grantedAt_not_in?: InputMaybe<Array<Scalars['DateTime']>>;
  grantedUntil?: InputMaybe<Scalars['DateTime']>;
  grantedUntil_gt?: InputMaybe<Scalars['DateTime']>;
  grantedUntil_gte?: InputMaybe<Scalars['DateTime']>;
  grantedUntil_in?: InputMaybe<Array<Scalars['DateTime']>>;
  grantedUntil_lt?: InputMaybe<Scalars['DateTime']>;
  grantedUntil_lte?: InputMaybe<Scalars['DateTime']>;
  grantedUntil_not?: InputMaybe<Scalars['DateTime']>;
  grantedUntil_not_in?: InputMaybe<Array<Scalars['DateTime']>>;
  id?: InputMaybe<Scalars['ID']>;
  id_contains?: InputMaybe<Scalars['ID']>;
  id_ends_with?: InputMaybe<Scalars['ID']>;
  id_gt?: InputMaybe<Scalars['ID']>;
  id_gte?: InputMaybe<Scalars['ID']>;
  id_in?: InputMaybe<Array<Scalars['ID']>>;
  id_lt?: InputMaybe<Scalars['ID']>;
  id_lte?: InputMaybe<Scalars['ID']>;
  id_not?: InputMaybe<Scalars['ID']>;
  id_not_contains?: InputMaybe<Scalars['ID']>;
  id_not_ends_with?: InputMaybe<Scalars['ID']>;
  id_not_in?: InputMaybe<Array<Scalars['ID']>>;
  id_not_starts_with?: InputMaybe<Scalars['ID']>;
  id_starts_with?: InputMaybe<Scalars['ID']>;
  requesterId?: InputMaybe<Scalars['ID']>;
  requesterId_contains?: InputMaybe<Scalars['ID']>;
  requesterId_ends_with?: InputMaybe<Scalars['ID']>;
  requesterId_gt?: InputMaybe<Scalars['ID']>;
  requesterId_gte?: InputMaybe<Scalars['ID']>;
  requesterId_in?: InputMaybe<Array<Scalars['ID']>>;
  requesterId_lt?: InputMaybe<Scalars['ID']>;
  requesterId_lte?: InputMaybe<Scalars['ID']>;
  requesterId_not?: InputMaybe<Scalars['ID']>;
  requesterId_not_contains?: InputMaybe<Scalars['ID']>;
  requesterId_not_ends_with?: InputMaybe<Scalars['ID']>;
  requesterId_not_in?: InputMaybe<Array<Scalars['ID']>>;
  requesterId_not_starts_with?: InputMaybe<Scalars['ID']>;
  requesterId_starts_with?: InputMaybe<Scalars['ID']>;
  status?: InputMaybe<AccessRequestStatus>;
  status_in?: InputMaybe<Array<AccessRequestStatus>>;
  status_not?: InputMaybe<AccessRequestStatus>;
  status_not_in?: InputMaybe<Array<AccessRequestStatus>>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
  updatedAt_gt?: InputMaybe<Scalars['DateTime']>;
  updatedAt_gte?: InputMaybe<Scalars['DateTime']>;
  updatedAt_in?: InputMaybe<Array<Scalars['DateTime']>>;
  updatedAt_lt?: InputMaybe<Scalars['DateTime']>;
  updatedAt_lte?: InputMaybe<Scalars['DateTime']>;
  updatedAt_not?: InputMaybe<Scalars['DateTime']>;
  updatedAt_not_in?: InputMaybe<Array<Scalars['DateTime']>>;
};

export type AccessRequestStatus = 'DENIED' | 'GRANTED' | 'PENDING';

export type AccessRequestSubscriptionPayload = {
  mutation: MutationType;
  node?: Maybe<AccessRequest>;
  previousValues?: Maybe<AccessRequestPreviousValues>;
  updatedFields?: Maybe<Array<Scalars['String']>>;
};

export type AccessRequestSubscriptionWhereInput = {
  AND?: InputMaybe<Array<AccessRequestSubscriptionWhereInput>>;
  NOT?: InputMaybe<Array<AccessRequestSubscriptionWhereInput>>;
  OR?: InputMaybe<Array<AccessRequestSubscriptionWhereInput>>;
  mutation_in?: InputMaybe<Array<MutationType>>;
  node?: InputMaybe<AccessRequestWhereInput>;
  updatedFields_contains?: InputMaybe<Scalars['String']>;
  updatedFields_contains_every?: InputMaybe<Array<Scalars['String']>>;
  updatedFields_contains_some?: InputMaybe<Array<Scalars['String']>>;
};

export type AccessRequestUpdateInput = {
  status: AccessRequestStatus;
};

export type AccessRequestUpdateManyDataInput = {
  grantedAt?: InputMaybe<Scalars['DateTime']>;
  grantedUntil?: InputMaybe<Scalars['DateTime']>;
  requesterId?: InputMaybe<Scalars['ID']>;
  status?: InputMaybe<AccessRequestStatus>;
};

export type AccessRequestUpdateManyMutationInput = {
  grantedAt?: InputMaybe<Scalars['DateTime']>;
  grantedUntil?: InputMaybe<Scalars['DateTime']>;
  requesterId?: InputMaybe<Scalars['ID']>;
  status?: InputMaybe<AccessRequestStatus>;
};

export type AccessRequestUpdateManyWithWhereNestedInput = {
  data: AccessRequestUpdateManyDataInput;
  where: AccessRequestScalarWhereInput;
};

export type AccessRequestUpdateManyWithoutSchoolInput = {
  connect?: InputMaybe<Array<AccessRequestWhereUniqueInput>>;
  create?: InputMaybe<Array<AccessRequestCreateWithoutSchoolInput>>;
  delete?: InputMaybe<Array<AccessRequestWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<AccessRequestScalarWhereInput>>;
  disconnect?: InputMaybe<Array<AccessRequestWhereUniqueInput>>;
  set?: InputMaybe<Array<AccessRequestWhereUniqueInput>>;
  update?: InputMaybe<
    Array<AccessRequestUpdateWithWhereUniqueWithoutSchoolInput>
  >;
  updateMany?: InputMaybe<Array<AccessRequestUpdateManyWithWhereNestedInput>>;
  upsert?: InputMaybe<
    Array<AccessRequestUpsertWithWhereUniqueWithoutSchoolInput>
  >;
};

export type AccessRequestUpdateWithWhereUniqueWithoutSchoolInput = {
  data: AccessRequestUpdateWithoutSchoolDataInput;
  where: AccessRequestWhereUniqueInput;
};

export type AccessRequestUpdateWithoutSchoolDataInput = {
  grantedAt?: InputMaybe<Scalars['DateTime']>;
  grantedUntil?: InputMaybe<Scalars['DateTime']>;
  requesterId?: InputMaybe<Scalars['ID']>;
  status?: InputMaybe<AccessRequestStatus>;
};

export type AccessRequestUpsertWithWhereUniqueWithoutSchoolInput = {
  create: AccessRequestCreateWithoutSchoolInput;
  update: AccessRequestUpdateWithoutSchoolDataInput;
  where: AccessRequestWhereUniqueInput;
};

export type AccessRequestWhereInput = {
  AND?: InputMaybe<Array<AccessRequestWhereInput>>;
  NOT?: InputMaybe<Array<AccessRequestWhereInput>>;
  OR?: InputMaybe<Array<AccessRequestWhereInput>>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  createdAt_gt?: InputMaybe<Scalars['DateTime']>;
  createdAt_gte?: InputMaybe<Scalars['DateTime']>;
  createdAt_in?: InputMaybe<Array<Scalars['DateTime']>>;
  createdAt_lt?: InputMaybe<Scalars['DateTime']>;
  createdAt_lte?: InputMaybe<Scalars['DateTime']>;
  createdAt_not?: InputMaybe<Scalars['DateTime']>;
  createdAt_not_in?: InputMaybe<Array<Scalars['DateTime']>>;
  grantedAt?: InputMaybe<Scalars['DateTime']>;
  grantedAt_gt?: InputMaybe<Scalars['DateTime']>;
  grantedAt_gte?: InputMaybe<Scalars['DateTime']>;
  grantedAt_in?: InputMaybe<Array<Scalars['DateTime']>>;
  grantedAt_lt?: InputMaybe<Scalars['DateTime']>;
  grantedAt_lte?: InputMaybe<Scalars['DateTime']>;
  grantedAt_not?: InputMaybe<Scalars['DateTime']>;
  grantedAt_not_in?: InputMaybe<Array<Scalars['DateTime']>>;
  grantedUntil?: InputMaybe<Scalars['DateTime']>;
  grantedUntil_gt?: InputMaybe<Scalars['DateTime']>;
  grantedUntil_gte?: InputMaybe<Scalars['DateTime']>;
  grantedUntil_in?: InputMaybe<Array<Scalars['DateTime']>>;
  grantedUntil_lt?: InputMaybe<Scalars['DateTime']>;
  grantedUntil_lte?: InputMaybe<Scalars['DateTime']>;
  grantedUntil_not?: InputMaybe<Scalars['DateTime']>;
  grantedUntil_not_in?: InputMaybe<Array<Scalars['DateTime']>>;
  id?: InputMaybe<Scalars['ID']>;
  id_contains?: InputMaybe<Scalars['ID']>;
  id_ends_with?: InputMaybe<Scalars['ID']>;
  id_gt?: InputMaybe<Scalars['ID']>;
  id_gte?: InputMaybe<Scalars['ID']>;
  id_in?: InputMaybe<Array<Scalars['ID']>>;
  id_lt?: InputMaybe<Scalars['ID']>;
  id_lte?: InputMaybe<Scalars['ID']>;
  id_not?: InputMaybe<Scalars['ID']>;
  id_not_contains?: InputMaybe<Scalars['ID']>;
  id_not_ends_with?: InputMaybe<Scalars['ID']>;
  id_not_in?: InputMaybe<Array<Scalars['ID']>>;
  id_not_starts_with?: InputMaybe<Scalars['ID']>;
  id_starts_with?: InputMaybe<Scalars['ID']>;
  requesterId?: InputMaybe<Scalars['ID']>;
  requesterId_contains?: InputMaybe<Scalars['ID']>;
  requesterId_ends_with?: InputMaybe<Scalars['ID']>;
  requesterId_gt?: InputMaybe<Scalars['ID']>;
  requesterId_gte?: InputMaybe<Scalars['ID']>;
  requesterId_in?: InputMaybe<Array<Scalars['ID']>>;
  requesterId_lt?: InputMaybe<Scalars['ID']>;
  requesterId_lte?: InputMaybe<Scalars['ID']>;
  requesterId_not?: InputMaybe<Scalars['ID']>;
  requesterId_not_contains?: InputMaybe<Scalars['ID']>;
  requesterId_not_ends_with?: InputMaybe<Scalars['ID']>;
  requesterId_not_in?: InputMaybe<Array<Scalars['ID']>>;
  requesterId_not_starts_with?: InputMaybe<Scalars['ID']>;
  requesterId_starts_with?: InputMaybe<Scalars['ID']>;
  school?: InputMaybe<SchoolWhereInput>;
  status?: InputMaybe<AccessRequestStatus>;
  status_in?: InputMaybe<Array<AccessRequestStatus>>;
  status_not?: InputMaybe<AccessRequestStatus>;
  status_not_in?: InputMaybe<Array<AccessRequestStatus>>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
  updatedAt_gt?: InputMaybe<Scalars['DateTime']>;
  updatedAt_gte?: InputMaybe<Scalars['DateTime']>;
  updatedAt_in?: InputMaybe<Array<Scalars['DateTime']>>;
  updatedAt_lt?: InputMaybe<Scalars['DateTime']>;
  updatedAt_lte?: InputMaybe<Scalars['DateTime']>;
  updatedAt_not?: InputMaybe<Scalars['DateTime']>;
  updatedAt_not_in?: InputMaybe<Array<Scalars['DateTime']>>;
};

export type AccessRequestWhereUniqueInput = {
  id?: InputMaybe<Scalars['ID']>;
};

export type AddressUpdateOneRequiredInput = {
  update: ContactDetailsUpdateDataInput;
};

export type AdjustSubscriptionLicenses = {
  quantity: Scalars['Int'];
  resource: ResourceInput;
};

export type Aggregate = {
  count: Scalars['Int'];
};

export type AggregateAccessRequest = {
  count: Scalars['Int'];
};

export type AggregateAlfredoMessage = {
  count: Scalars['Int'];
};

export type AggregateAlfredoMessageGameUser = {
  count: Scalars['Int'];
};

export type AggregateArchivedUser = {
  count: Scalars['Int'];
};

export type AggregateBeheerUser = {
  count: Scalars['Int'];
};

export type AggregateChallenge = {
  count: Scalars['Int'];
};

export type AggregateChallengeRequest = {
  count: Scalars['Int'];
};

export type AggregateChallengeResult = {
  count: Scalars['Int'];
};

export type AggregateContactDetails = {
  count: Scalars['Int'];
};

export type AggregateCoupon = {
  count: Scalars['Int'];
};

export type AggregateCourseGroup = {
  count: Scalars['Int'];
};

export type AggregateExercise = {
  count: Scalars['Int'];
};

export type AggregateGameUser = {
  count: Scalars['Int'];
};

export type AggregateGameUserKwouwselAccessory = {
  count: Scalars['Int'];
};

export type AggregateGameUserKwouwselUpgrade = {
  count: Scalars['Int'];
};

export type AggregateKwouwselAccessory = {
  count: Scalars['Int'];
};

export type AggregateKwouwselUpgrade = {
  count: Scalars['Int'];
};

export type AggregateLevel = {
  count: Scalars['Int'];
};

export type AggregateLevelSetting = {
  count: Scalars['Int'];
};

export type AggregateLicense = {
  count: Scalars['Int'];
};

export type AggregateLicensePool = {
  count: Scalars['Int'];
};

export type AggregateLicenseSubscriptionInfo = {
  count: Scalars['Int'];
};

export type AggregateNote = {
  count: Scalars['Int'];
};

export type AggregatePartner = {
  count: Scalars['Int'];
};

export type AggregateSchool = {
  count: Scalars['Int'];
};

export type AggregateSchoolDistrict = {
  count: Scalars['Int'];
};

export type AggregateSkillCourse = {
  count: Scalars['Int'];
};

export type AggregateUserLevel = {
  count: Scalars['Int'];
};

export type AlfredoMessage = {
  id: Scalars['ID'];
  message: Scalars['String'];
  order: Scalars['Int'];
  title: Scalars['String'];
};

export type AlfredoMessageConnection = {
  aggregate: AggregateAlfredoMessage;
  edges: Array<Maybe<AlfredoMessageEdge>>;
  pageInfo: PageInfo;
};

export type AlfredoMessageCreateInput = {
  id?: InputMaybe<Scalars['ID']>;
  message: Scalars['String'];
  order: Scalars['Int'];
  title?: InputMaybe<Scalars['String']>;
};

export type AlfredoMessageCreateOneInput = {
  connect?: InputMaybe<AlfredoMessageWhereUniqueInput>;
  create?: InputMaybe<AlfredoMessageCreateInput>;
};

export type AlfredoMessageEdge = {
  cursor: Scalars['String'];
  node: AlfredoMessage;
};

export type AlfredoMessageGameUser = {
  alfredoMessage: AlfredoMessage;
  displayedAt: Scalars['DateTime'];
  gameUser: GameUser;
  id: Scalars['ID'];
};

export type AlfredoMessageGameUserConnection = {
  aggregate: AggregateAlfredoMessageGameUser;
  edges: Array<Maybe<AlfredoMessageGameUserEdge>>;
  pageInfo: PageInfo;
};

export type AlfredoMessageGameUserCreateInput = {
  alfredoMessage: AlfredoMessageCreateOneInput;
  gameUser: GameUserCreateOneWithoutDisplayedAlfredoMessagesInput;
  id?: InputMaybe<Scalars['ID']>;
};

export type AlfredoMessageGameUserCreateManyWithoutGameUserInput = {
  connect?: InputMaybe<Array<AlfredoMessageGameUserWhereUniqueInput>>;
  create?: InputMaybe<Array<AlfredoMessageGameUserCreateWithoutGameUserInput>>;
};

export type AlfredoMessageGameUserCreateWithoutGameUserInput = {
  alfredoMessage: AlfredoMessageCreateOneInput;
  id?: InputMaybe<Scalars['ID']>;
};

export type AlfredoMessageGameUserEdge = {
  cursor: Scalars['String'];
  node: AlfredoMessageGameUser;
};

export type AlfredoMessageGameUserOrderByInput =
  | 'displayedAt_ASC'
  | 'displayedAt_DESC'
  | 'id_ASC'
  | 'id_DESC';

export type AlfredoMessageGameUserScalarWhereInput = {
  AND?: InputMaybe<Array<AlfredoMessageGameUserScalarWhereInput>>;
  NOT?: InputMaybe<Array<AlfredoMessageGameUserScalarWhereInput>>;
  OR?: InputMaybe<Array<AlfredoMessageGameUserScalarWhereInput>>;
  displayedAt?: InputMaybe<Scalars['DateTime']>;
  displayedAt_gt?: InputMaybe<Scalars['DateTime']>;
  displayedAt_gte?: InputMaybe<Scalars['DateTime']>;
  displayedAt_in?: InputMaybe<Array<Scalars['DateTime']>>;
  displayedAt_lt?: InputMaybe<Scalars['DateTime']>;
  displayedAt_lte?: InputMaybe<Scalars['DateTime']>;
  displayedAt_not?: InputMaybe<Scalars['DateTime']>;
  displayedAt_not_in?: InputMaybe<Array<Scalars['DateTime']>>;
  id?: InputMaybe<Scalars['ID']>;
  id_contains?: InputMaybe<Scalars['ID']>;
  id_ends_with?: InputMaybe<Scalars['ID']>;
  id_gt?: InputMaybe<Scalars['ID']>;
  id_gte?: InputMaybe<Scalars['ID']>;
  id_in?: InputMaybe<Array<Scalars['ID']>>;
  id_lt?: InputMaybe<Scalars['ID']>;
  id_lte?: InputMaybe<Scalars['ID']>;
  id_not?: InputMaybe<Scalars['ID']>;
  id_not_contains?: InputMaybe<Scalars['ID']>;
  id_not_ends_with?: InputMaybe<Scalars['ID']>;
  id_not_in?: InputMaybe<Array<Scalars['ID']>>;
  id_not_starts_with?: InputMaybe<Scalars['ID']>;
  id_starts_with?: InputMaybe<Scalars['ID']>;
};

export type AlfredoMessageGameUserUpdateInput = {
  alfredoMessage?: InputMaybe<AlfredoMessageUpdateOneRequiredInput>;
  gameUser?: InputMaybe<GameUserUpdateOneRequiredWithoutDisplayedAlfredoMessagesInput>;
};

export type AlfredoMessageGameUserUpdateManyWithoutGameUserInput = {
  connect?: InputMaybe<Array<AlfredoMessageGameUserWhereUniqueInput>>;
  create?: InputMaybe<Array<AlfredoMessageGameUserCreateWithoutGameUserInput>>;
  delete?: InputMaybe<Array<AlfredoMessageGameUserWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<AlfredoMessageGameUserScalarWhereInput>>;
  disconnect?: InputMaybe<Array<AlfredoMessageGameUserWhereUniqueInput>>;
  set?: InputMaybe<Array<AlfredoMessageGameUserWhereUniqueInput>>;
  update?: InputMaybe<
    Array<AlfredoMessageGameUserUpdateWithWhereUniqueWithoutGameUserInput>
  >;
  upsert?: InputMaybe<
    Array<AlfredoMessageGameUserUpsertWithWhereUniqueWithoutGameUserInput>
  >;
};

export type AlfredoMessageGameUserUpdateWithWhereUniqueWithoutGameUserInput = {
  data: AlfredoMessageGameUserUpdateWithoutGameUserDataInput;
  where: AlfredoMessageGameUserWhereUniqueInput;
};

export type AlfredoMessageGameUserUpdateWithoutGameUserDataInput = {
  alfredoMessage?: InputMaybe<AlfredoMessageUpdateOneRequiredInput>;
};

export type AlfredoMessageGameUserUpsertWithWhereUniqueWithoutGameUserInput = {
  create: AlfredoMessageGameUserCreateWithoutGameUserInput;
  update: AlfredoMessageGameUserUpdateWithoutGameUserDataInput;
  where: AlfredoMessageGameUserWhereUniqueInput;
};

export type AlfredoMessageGameUserWhereInput = {
  AND?: InputMaybe<Array<AlfredoMessageGameUserWhereInput>>;
  NOT?: InputMaybe<Array<AlfredoMessageGameUserWhereInput>>;
  OR?: InputMaybe<Array<AlfredoMessageGameUserWhereInput>>;
  alfredoMessage?: InputMaybe<AlfredoMessageWhereInput>;
  displayedAt?: InputMaybe<Scalars['DateTime']>;
  displayedAt_gt?: InputMaybe<Scalars['DateTime']>;
  displayedAt_gte?: InputMaybe<Scalars['DateTime']>;
  displayedAt_in?: InputMaybe<Array<Scalars['DateTime']>>;
  displayedAt_lt?: InputMaybe<Scalars['DateTime']>;
  displayedAt_lte?: InputMaybe<Scalars['DateTime']>;
  displayedAt_not?: InputMaybe<Scalars['DateTime']>;
  displayedAt_not_in?: InputMaybe<Array<Scalars['DateTime']>>;
  gameUser?: InputMaybe<GameUserWhereInput>;
  id?: InputMaybe<Scalars['ID']>;
  id_contains?: InputMaybe<Scalars['ID']>;
  id_ends_with?: InputMaybe<Scalars['ID']>;
  id_gt?: InputMaybe<Scalars['ID']>;
  id_gte?: InputMaybe<Scalars['ID']>;
  id_in?: InputMaybe<Array<Scalars['ID']>>;
  id_lt?: InputMaybe<Scalars['ID']>;
  id_lte?: InputMaybe<Scalars['ID']>;
  id_not?: InputMaybe<Scalars['ID']>;
  id_not_contains?: InputMaybe<Scalars['ID']>;
  id_not_ends_with?: InputMaybe<Scalars['ID']>;
  id_not_in?: InputMaybe<Array<Scalars['ID']>>;
  id_not_starts_with?: InputMaybe<Scalars['ID']>;
  id_starts_with?: InputMaybe<Scalars['ID']>;
};

export type AlfredoMessageGameUserWhereUniqueInput = {
  id?: InputMaybe<Scalars['ID']>;
};

export type AlfredoMessageOrderByInput =
  | 'id_ASC'
  | 'id_DESC'
  | 'message_ASC'
  | 'message_DESC'
  | 'order_ASC'
  | 'order_DESC'
  | 'title_ASC'
  | 'title_DESC';

export type AlfredoMessageUpdateDataInput = {
  message?: InputMaybe<Scalars['String']>;
  order?: InputMaybe<Scalars['Int']>;
  title?: InputMaybe<Scalars['String']>;
};

export type AlfredoMessageUpdateInput = {
  message?: InputMaybe<Scalars['String']>;
  order?: InputMaybe<Scalars['Int']>;
  title?: InputMaybe<Scalars['String']>;
};

export type AlfredoMessageUpdateManyMutationInput = {
  message?: InputMaybe<Scalars['String']>;
  order?: InputMaybe<Scalars['Int']>;
  title?: InputMaybe<Scalars['String']>;
};

export type AlfredoMessageUpdateOneRequiredInput = {
  connect?: InputMaybe<AlfredoMessageWhereUniqueInput>;
  create?: InputMaybe<AlfredoMessageCreateInput>;
  update?: InputMaybe<AlfredoMessageUpdateDataInput>;
  upsert?: InputMaybe<AlfredoMessageUpsertNestedInput>;
};

export type AlfredoMessageUpsertNestedInput = {
  create: AlfredoMessageCreateInput;
  update: AlfredoMessageUpdateDataInput;
};

export type AlfredoMessageWhereInput = {
  AND?: InputMaybe<Array<AlfredoMessageWhereInput>>;
  NOT?: InputMaybe<Array<AlfredoMessageWhereInput>>;
  OR?: InputMaybe<Array<AlfredoMessageWhereInput>>;
  id?: InputMaybe<Scalars['ID']>;
  id_contains?: InputMaybe<Scalars['ID']>;
  id_ends_with?: InputMaybe<Scalars['ID']>;
  id_gt?: InputMaybe<Scalars['ID']>;
  id_gte?: InputMaybe<Scalars['ID']>;
  id_in?: InputMaybe<Array<Scalars['ID']>>;
  id_lt?: InputMaybe<Scalars['ID']>;
  id_lte?: InputMaybe<Scalars['ID']>;
  id_not?: InputMaybe<Scalars['ID']>;
  id_not_contains?: InputMaybe<Scalars['ID']>;
  id_not_ends_with?: InputMaybe<Scalars['ID']>;
  id_not_in?: InputMaybe<Array<Scalars['ID']>>;
  id_not_starts_with?: InputMaybe<Scalars['ID']>;
  id_starts_with?: InputMaybe<Scalars['ID']>;
  message?: InputMaybe<Scalars['String']>;
  message_contains?: InputMaybe<Scalars['String']>;
  message_ends_with?: InputMaybe<Scalars['String']>;
  message_gt?: InputMaybe<Scalars['String']>;
  message_gte?: InputMaybe<Scalars['String']>;
  message_in?: InputMaybe<Array<Scalars['String']>>;
  message_lt?: InputMaybe<Scalars['String']>;
  message_lte?: InputMaybe<Scalars['String']>;
  message_not?: InputMaybe<Scalars['String']>;
  message_not_contains?: InputMaybe<Scalars['String']>;
  message_not_ends_with?: InputMaybe<Scalars['String']>;
  message_not_in?: InputMaybe<Array<Scalars['String']>>;
  message_not_starts_with?: InputMaybe<Scalars['String']>;
  message_starts_with?: InputMaybe<Scalars['String']>;
  order?: InputMaybe<Scalars['Int']>;
  order_gt?: InputMaybe<Scalars['Int']>;
  order_gte?: InputMaybe<Scalars['Int']>;
  order_in?: InputMaybe<Array<Scalars['Int']>>;
  order_lt?: InputMaybe<Scalars['Int']>;
  order_lte?: InputMaybe<Scalars['Int']>;
  order_not?: InputMaybe<Scalars['Int']>;
  order_not_in?: InputMaybe<Array<Scalars['Int']>>;
  title?: InputMaybe<Scalars['String']>;
  title_contains?: InputMaybe<Scalars['String']>;
  title_ends_with?: InputMaybe<Scalars['String']>;
  title_gt?: InputMaybe<Scalars['String']>;
  title_gte?: InputMaybe<Scalars['String']>;
  title_in?: InputMaybe<Array<Scalars['String']>>;
  title_lt?: InputMaybe<Scalars['String']>;
  title_lte?: InputMaybe<Scalars['String']>;
  title_not?: InputMaybe<Scalars['String']>;
  title_not_contains?: InputMaybe<Scalars['String']>;
  title_not_ends_with?: InputMaybe<Scalars['String']>;
  title_not_in?: InputMaybe<Array<Scalars['String']>>;
  title_not_starts_with?: InputMaybe<Scalars['String']>;
  title_starts_with?: InputMaybe<Scalars['String']>;
};

export type AlfredoMessageWhereUniqueInput = {
  id?: InputMaybe<Scalars['ID']>;
};

export type AnonymousUser = {
  id: Scalars['ID'];
  schools: Array<School>;
};

export type ArchivedUser = {
  basispoortId?: Maybe<Scalars['Int']>;
  birthDate?: Maybe<Scalars['DateTime']>;
  deletedAt: Scalars['DateTime'];
  email: Scalars['String'];
  emailConfirmedAt?: Maybe<Scalars['DateTime']>;
  endDate?: Maybe<Scalars['DateTime']>;
  firstName: Scalars['String'];
  gender?: Maybe<Gender>;
  id: Scalars['ID'];
  keyboardLayout: KeyboardLayout;
  lastName: Scalars['String'];
  mobile?: Maybe<Scalars['String']>;
  mostRecentLoginDate?: Maybe<Scalars['DateTime']>;
  phone?: Maybe<Scalars['String']>;
  roles: Array<Role>;
  schools?: Maybe<Array<School>>;
  startDate?: Maybe<Scalars['DateTime']>;
  userCreatedAt: Scalars['DateTime'];
  userUpdatedAt: Scalars['DateTime'];
  username: Scalars['String'];
};

export type ArchivedUserConnection = {
  aggregate: AggregateArchivedUser;
  edges: Array<Maybe<ArchivedUserEdge>>;
  pageInfo: PageInfo;
};

export type ArchivedUserEdge = {
  cursor: Scalars['String'];
  node: ArchivedUser;
};

export type ArchivedUserOrderByInput =
  | 'birthDate_ASC'
  | 'birthDate_DESC'
  | 'deletedAt_ASC'
  | 'deletedAt_DESC'
  | 'emailConfirmedAt_ASC'
  | 'emailConfirmedAt_DESC'
  | 'email_ASC'
  | 'email_DESC'
  | 'endDate_ASC'
  | 'endDate_DESC'
  | 'firstName_ASC'
  | 'firstName_DESC'
  | 'gender_ASC'
  | 'gender_DESC'
  | 'id_ASC'
  | 'id_DESC'
  | 'lastName_ASC'
  | 'lastName_DESC'
  | 'mobile_ASC'
  | 'mobile_DESC'
  | 'mostRecentLoginDate_ASC'
  | 'mostRecentLoginDate_DESC'
  | 'phone_ASC'
  | 'phone_DESC'
  | 'startDate_ASC'
  | 'startDate_DESC'
  | 'userCreatedAt_ASC'
  | 'userCreatedAt_DESC'
  | 'userUpdatedAt_ASC'
  | 'userUpdatedAt_DESC'
  | 'username_ASC'
  | 'username_DESC';

export type ArchivedUserWhereInput = {
  birthDate?: InputMaybe<Scalars['DateTime']>;
  birthDate_gt?: InputMaybe<Scalars['DateTime']>;
  birthDate_gte?: InputMaybe<Scalars['DateTime']>;
  birthDate_in?: InputMaybe<Array<Scalars['DateTime']>>;
  birthDate_lt?: InputMaybe<Scalars['DateTime']>;
  birthDate_lte?: InputMaybe<Scalars['DateTime']>;
  birthDate_not?: InputMaybe<Scalars['DateTime']>;
  birthDate_not_in?: InputMaybe<Array<Scalars['DateTime']>>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  deletedAt_gt?: InputMaybe<Scalars['DateTime']>;
  deletedAt_gte?: InputMaybe<Scalars['DateTime']>;
  deletedAt_in?: InputMaybe<Array<Scalars['DateTime']>>;
  deletedAt_lt?: InputMaybe<Scalars['DateTime']>;
  deletedAt_lte?: InputMaybe<Scalars['DateTime']>;
  deletedAt_not?: InputMaybe<Scalars['DateTime']>;
  deletedAt_not_in?: InputMaybe<Array<Scalars['DateTime']>>;
  email?: InputMaybe<Scalars['String']>;
  emailConfirmedAt?: InputMaybe<Scalars['DateTime']>;
  emailConfirmedAt_gt?: InputMaybe<Scalars['DateTime']>;
  emailConfirmedAt_gte?: InputMaybe<Scalars['DateTime']>;
  emailConfirmedAt_in?: InputMaybe<Array<Scalars['DateTime']>>;
  emailConfirmedAt_lt?: InputMaybe<Scalars['DateTime']>;
  emailConfirmedAt_lte?: InputMaybe<Scalars['DateTime']>;
  emailConfirmedAt_not?: InputMaybe<Scalars['DateTime']>;
  emailConfirmedAt_not_in?: InputMaybe<Array<Scalars['DateTime']>>;
  email_contains?: InputMaybe<Scalars['String']>;
  email_ends_with?: InputMaybe<Scalars['String']>;
  email_gt?: InputMaybe<Scalars['String']>;
  email_gte?: InputMaybe<Scalars['String']>;
  email_in?: InputMaybe<Array<Scalars['String']>>;
  email_lt?: InputMaybe<Scalars['String']>;
  email_lte?: InputMaybe<Scalars['String']>;
  email_not?: InputMaybe<Scalars['String']>;
  email_not_contains?: InputMaybe<Scalars['String']>;
  email_not_ends_with?: InputMaybe<Scalars['String']>;
  email_not_in?: InputMaybe<Array<Scalars['String']>>;
  email_not_starts_with?: InputMaybe<Scalars['String']>;
  email_starts_with?: InputMaybe<Scalars['String']>;
  endDate?: InputMaybe<Scalars['DateTime']>;
  endDate_gt?: InputMaybe<Scalars['DateTime']>;
  endDate_gte?: InputMaybe<Scalars['DateTime']>;
  endDate_in?: InputMaybe<Array<Scalars['DateTime']>>;
  endDate_lt?: InputMaybe<Scalars['DateTime']>;
  endDate_lte?: InputMaybe<Scalars['DateTime']>;
  endDate_not?: InputMaybe<Scalars['DateTime']>;
  endDate_not_in?: InputMaybe<Array<Scalars['DateTime']>>;
  firstName?: InputMaybe<Scalars['String']>;
  firstName_contains?: InputMaybe<Scalars['String']>;
  firstName_ends_with?: InputMaybe<Scalars['String']>;
  firstName_gt?: InputMaybe<Scalars['String']>;
  firstName_gte?: InputMaybe<Scalars['String']>;
  firstName_in?: InputMaybe<Array<Scalars['String']>>;
  firstName_lt?: InputMaybe<Scalars['String']>;
  firstName_lte?: InputMaybe<Scalars['String']>;
  firstName_mode?: InputMaybe<FilterMode>;
  firstName_not?: InputMaybe<Scalars['String']>;
  firstName_not_contains?: InputMaybe<Scalars['String']>;
  firstName_not_ends_with?: InputMaybe<Scalars['String']>;
  firstName_not_in?: InputMaybe<Array<Scalars['String']>>;
  firstName_not_starts_with?: InputMaybe<Scalars['String']>;
  firstName_starts_with?: InputMaybe<Scalars['String']>;
  gender?: InputMaybe<Gender>;
  gender_in?: InputMaybe<Array<Gender>>;
  gender_not?: InputMaybe<Gender>;
  gender_not_in?: InputMaybe<Array<Gender>>;
  id?: InputMaybe<Scalars['ID']>;
  id_contains?: InputMaybe<Scalars['ID']>;
  id_ends_with?: InputMaybe<Scalars['ID']>;
  id_gt?: InputMaybe<Scalars['ID']>;
  id_gte?: InputMaybe<Scalars['ID']>;
  id_in?: InputMaybe<Array<Scalars['ID']>>;
  id_lt?: InputMaybe<Scalars['ID']>;
  id_lte?: InputMaybe<Scalars['ID']>;
  id_not?: InputMaybe<Scalars['ID']>;
  id_not_contains?: InputMaybe<Scalars['ID']>;
  id_not_ends_with?: InputMaybe<Scalars['ID']>;
  id_not_in?: InputMaybe<Array<Scalars['ID']>>;
  id_not_starts_with?: InputMaybe<Scalars['ID']>;
  id_starts_with?: InputMaybe<Scalars['ID']>;
  lastName?: InputMaybe<Scalars['String']>;
  lastName_contains?: InputMaybe<Scalars['String']>;
  lastName_ends_with?: InputMaybe<Scalars['String']>;
  lastName_gt?: InputMaybe<Scalars['String']>;
  lastName_gte?: InputMaybe<Scalars['String']>;
  lastName_in?: InputMaybe<Array<Scalars['String']>>;
  lastName_lt?: InputMaybe<Scalars['String']>;
  lastName_lte?: InputMaybe<Scalars['String']>;
  lastName_mode?: InputMaybe<FilterMode>;
  lastName_not?: InputMaybe<Scalars['String']>;
  lastName_not_contains?: InputMaybe<Scalars['String']>;
  lastName_not_ends_with?: InputMaybe<Scalars['String']>;
  lastName_not_in?: InputMaybe<Array<Scalars['String']>>;
  lastName_not_starts_with?: InputMaybe<Scalars['String']>;
  lastName_starts_with?: InputMaybe<Scalars['String']>;
  mobile?: InputMaybe<Scalars['String']>;
  mobile_contains?: InputMaybe<Scalars['String']>;
  mobile_ends_with?: InputMaybe<Scalars['String']>;
  mobile_gt?: InputMaybe<Scalars['String']>;
  mobile_gte?: InputMaybe<Scalars['String']>;
  mobile_in?: InputMaybe<Array<Scalars['String']>>;
  mobile_lt?: InputMaybe<Scalars['String']>;
  mobile_lte?: InputMaybe<Scalars['String']>;
  mobile_not?: InputMaybe<Scalars['String']>;
  mobile_not_contains?: InputMaybe<Scalars['String']>;
  mobile_not_ends_with?: InputMaybe<Scalars['String']>;
  mobile_not_in?: InputMaybe<Array<Scalars['String']>>;
  mobile_not_starts_with?: InputMaybe<Scalars['String']>;
  mobile_starts_with?: InputMaybe<Scalars['String']>;
  mostRecentLoginDate?: InputMaybe<Scalars['DateTime']>;
  mostRecentLoginDate_gt?: InputMaybe<Scalars['DateTime']>;
  mostRecentLoginDate_gte?: InputMaybe<Scalars['DateTime']>;
  mostRecentLoginDate_in?: InputMaybe<Array<Scalars['DateTime']>>;
  mostRecentLoginDate_lt?: InputMaybe<Scalars['DateTime']>;
  mostRecentLoginDate_lte?: InputMaybe<Scalars['DateTime']>;
  mostRecentLoginDate_not?: InputMaybe<Scalars['DateTime']>;
  mostRecentLoginDate_not_in?: InputMaybe<Array<Scalars['DateTime']>>;
  phone?: InputMaybe<Scalars['String']>;
  phone_contains?: InputMaybe<Scalars['String']>;
  phone_ends_with?: InputMaybe<Scalars['String']>;
  phone_gt?: InputMaybe<Scalars['String']>;
  phone_gte?: InputMaybe<Scalars['String']>;
  phone_in?: InputMaybe<Array<Scalars['String']>>;
  phone_lt?: InputMaybe<Scalars['String']>;
  phone_lte?: InputMaybe<Scalars['String']>;
  phone_not?: InputMaybe<Scalars['String']>;
  phone_not_contains?: InputMaybe<Scalars['String']>;
  phone_not_ends_with?: InputMaybe<Scalars['String']>;
  phone_not_in?: InputMaybe<Array<Scalars['String']>>;
  phone_not_starts_with?: InputMaybe<Scalars['String']>;
  phone_starts_with?: InputMaybe<Scalars['String']>;
  startDate?: InputMaybe<Scalars['DateTime']>;
  startDate_gt?: InputMaybe<Scalars['DateTime']>;
  startDate_gte?: InputMaybe<Scalars['DateTime']>;
  startDate_in?: InputMaybe<Array<Scalars['DateTime']>>;
  startDate_lt?: InputMaybe<Scalars['DateTime']>;
  startDate_lte?: InputMaybe<Scalars['DateTime']>;
  startDate_not?: InputMaybe<Scalars['DateTime']>;
  startDate_not_in?: InputMaybe<Array<Scalars['DateTime']>>;
  userCreatedAt?: InputMaybe<Scalars['DateTime']>;
  userCreatedAt_gt?: InputMaybe<Scalars['DateTime']>;
  userCreatedAt_gte?: InputMaybe<Scalars['DateTime']>;
  userCreatedAt_in?: InputMaybe<Array<Scalars['DateTime']>>;
  userCreatedAt_lt?: InputMaybe<Scalars['DateTime']>;
  userCreatedAt_lte?: InputMaybe<Scalars['DateTime']>;
  userCreatedAt_not?: InputMaybe<Scalars['DateTime']>;
  userCreatedAt_not_in?: InputMaybe<Array<Scalars['DateTime']>>;
  userUpdatedAt?: InputMaybe<Scalars['DateTime']>;
  userUpdatedAt_gt?: InputMaybe<Scalars['DateTime']>;
  userUpdatedAt_gte?: InputMaybe<Scalars['DateTime']>;
  userUpdatedAt_in?: InputMaybe<Array<Scalars['DateTime']>>;
  userUpdatedAt_lt?: InputMaybe<Scalars['DateTime']>;
  userUpdatedAt_lte?: InputMaybe<Scalars['DateTime']>;
  userUpdatedAt_not?: InputMaybe<Scalars['DateTime']>;
  userUpdatedAt_not_in?: InputMaybe<Array<Scalars['DateTime']>>;
  username?: InputMaybe<Scalars['String']>;
  username_contains?: InputMaybe<Scalars['String']>;
  username_ends_with?: InputMaybe<Scalars['String']>;
  username_gt?: InputMaybe<Scalars['String']>;
  username_gte?: InputMaybe<Scalars['String']>;
  username_in?: InputMaybe<Array<Scalars['String']>>;
  username_lt?: InputMaybe<Scalars['String']>;
  username_lte?: InputMaybe<Scalars['String']>;
  username_not?: InputMaybe<Scalars['String']>;
  username_not_contains?: InputMaybe<Scalars['String']>;
  username_not_ends_with?: InputMaybe<Scalars['String']>;
  username_not_in?: InputMaybe<Array<Scalars['String']>>;
  username_not_starts_with?: InputMaybe<Scalars['String']>;
  username_starts_with?: InputMaybe<Scalars['String']>;
};

export type ArchivedUsersWithCount = {
  count: Scalars['Int'];
  users: Array<Maybe<ArchivedUser>>;
};

export type AuthBatchPayload = {
  count: Scalars['Int'];
};

export type AuthResponsePayload = {
  message: Scalars['String'];
};

export type BasispoortSchoolSearchResult = {
  brinNumber?: Maybe<Scalars['String']>;
  city?: Maybe<Scalars['String']>;
  id: Scalars['Int'];
  name: Scalars['String'];
  postalCode?: Maybe<Scalars['String']>;
  street?: Maybe<Scalars['String']>;
  streetNumber?: Maybe<Scalars['String']>;
  streetNumberAddition?: Maybe<Scalars['String']>;
};

export type BasispoortSchoolWhereInput = {
  address?: InputMaybe<Scalars['String']>;
  brinNumber?: InputMaybe<Scalars['String']>;
  city?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  postalCode?: InputMaybe<Scalars['String']>;
};

export type BatchPayload = {
  count: Scalars['Long'];
};

export type BeheerUser = {
  archived: Scalars['Boolean'];
  coachedCourseGroups?: Maybe<Array<CourseGroup>>;
  createdAt: Scalars['DateTime'];
  followingCourseGroup?: Maybe<CourseGroup>;
  id: Scalars['ID'];
  license?: Maybe<License>;
  mostRecentResourceId?: Maybe<Scalars['String']>;
  mostRecentResourceType?: Maybe<Scalars['String']>;
  partners?: Maybe<Array<Partner>>;
  schoolDistricts?: Maybe<Array<SchoolDistrict>>;
  schools?: Maybe<Array<School>>;
  updatedAt: Scalars['DateTime'];
  user_id: Scalars['String'];
};

export type BeheerUserCoachedCourseGroupsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<CourseGroupOrderByInput>;
  skip?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<CourseGroupWhereInput>;
};

export type BeheerUserPartnersArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<PartnerOrderByInput>;
  skip?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<PartnerWhereInput>;
};

export type BeheerUserSchoolDistrictsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<SchoolDistrictOrderByInput>;
  skip?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<SchoolDistrictWhereInput>;
};

export type BeheerUserSchoolsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<SchoolOrderByInput>;
  skip?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<SchoolWhereInput>;
};

export type BeheerUserConnection = {
  aggregate: AggregateBeheerUser;
  edges: Array<Maybe<BeheerUserEdge>>;
  pageInfo: PageInfo;
};

export type BeheerUserCreateInput = {
  archived?: InputMaybe<Scalars['Boolean']>;
  coachedCourseGroups?: InputMaybe<CourseGroupCreateManyWithoutCoachesInput>;
  followingCourseGroup?: InputMaybe<CourseGroupCreateOneWithoutStudentsInput>;
  id?: InputMaybe<Scalars['ID']>;
  license?: InputMaybe<LicenseCreateOneWithoutUserInput>;
  mostRecentResourceId?: InputMaybe<Scalars['String']>;
  mostRecentResourceType?: InputMaybe<Scalars['String']>;
  partners?: InputMaybe<PartnerCreateManyWithoutUsersInput>;
  schoolDistricts?: InputMaybe<SchoolDistrictCreateManyWithoutUsersInput>;
  schools?: InputMaybe<SchoolCreateManyWithoutUsersInput>;
  user_id: Scalars['String'];
};

export type BeheerUserCreateManyWithoutCoachedCourseGroupsInput = {
  connect?: InputMaybe<Array<BeheerUserWhereUniqueInput>>;
  create?: InputMaybe<Array<BeheerUserCreateWithoutCoachedCourseGroupsInput>>;
};

export type BeheerUserCreateManyWithoutFollowingCourseGroupInput = {
  connect?: InputMaybe<Array<BeheerUserWhereUniqueInput>>;
  create?: InputMaybe<Array<BeheerUserCreateWithoutFollowingCourseGroupInput>>;
};

export type BeheerUserCreateManyWithoutPartnersInput = {
  connect?: InputMaybe<Array<BeheerUserWhereUniqueInput>>;
  create?: InputMaybe<Array<BeheerUserCreateWithoutPartnersInput>>;
};

export type BeheerUserCreateManyWithoutSchoolDistrictsInput = {
  connect?: InputMaybe<Array<BeheerUserWhereUniqueInput>>;
  create?: InputMaybe<Array<BeheerUserCreateWithoutSchoolDistrictsInput>>;
};

export type BeheerUserCreateManyWithoutSchoolsInput = {
  connect?: InputMaybe<Array<BeheerUserWhereUniqueInput>>;
  create?: InputMaybe<Array<BeheerUserCreateWithoutSchoolsInput>>;
};

export type BeheerUserCreateOneWithoutLicenseInput = {
  connect?: InputMaybe<BeheerUserWhereUniqueInput>;
  create?: InputMaybe<BeheerUserCreateWithoutLicenseInput>;
};

export type BeheerUserCreateWithoutCoachedCourseGroupsInput = {
  archived?: InputMaybe<Scalars['Boolean']>;
  followingCourseGroup?: InputMaybe<CourseGroupCreateOneWithoutStudentsInput>;
  id?: InputMaybe<Scalars['ID']>;
  license?: InputMaybe<LicenseCreateOneWithoutUserInput>;
  mostRecentResourceId?: InputMaybe<Scalars['String']>;
  mostRecentResourceType?: InputMaybe<Scalars['String']>;
  partners?: InputMaybe<PartnerCreateManyWithoutUsersInput>;
  schoolDistricts?: InputMaybe<SchoolDistrictCreateManyWithoutUsersInput>;
  schools?: InputMaybe<SchoolCreateManyWithoutUsersInput>;
  user_id: Scalars['String'];
};

export type BeheerUserCreateWithoutFollowingCourseGroupInput = {
  archived?: InputMaybe<Scalars['Boolean']>;
  coachedCourseGroups?: InputMaybe<CourseGroupCreateManyWithoutCoachesInput>;
  id?: InputMaybe<Scalars['ID']>;
  license?: InputMaybe<LicenseCreateOneWithoutUserInput>;
  mostRecentResourceId?: InputMaybe<Scalars['String']>;
  mostRecentResourceType?: InputMaybe<Scalars['String']>;
  partners?: InputMaybe<PartnerCreateManyWithoutUsersInput>;
  schoolDistricts?: InputMaybe<SchoolDistrictCreateManyWithoutUsersInput>;
  schools?: InputMaybe<SchoolCreateManyWithoutUsersInput>;
  user_id: Scalars['String'];
};

export type BeheerUserCreateWithoutLicenseInput = {
  archived?: InputMaybe<Scalars['Boolean']>;
  coachedCourseGroups?: InputMaybe<CourseGroupCreateManyWithoutCoachesInput>;
  followingCourseGroup?: InputMaybe<CourseGroupCreateOneWithoutStudentsInput>;
  id?: InputMaybe<Scalars['ID']>;
  mostRecentResourceId?: InputMaybe<Scalars['String']>;
  mostRecentResourceType?: InputMaybe<Scalars['String']>;
  partners?: InputMaybe<PartnerCreateManyWithoutUsersInput>;
  schoolDistricts?: InputMaybe<SchoolDistrictCreateManyWithoutUsersInput>;
  schools?: InputMaybe<SchoolCreateManyWithoutUsersInput>;
  user_id: Scalars['String'];
};

export type BeheerUserCreateWithoutPartnersInput = {
  archived?: InputMaybe<Scalars['Boolean']>;
  coachedCourseGroups?: InputMaybe<CourseGroupCreateManyWithoutCoachesInput>;
  followingCourseGroup?: InputMaybe<CourseGroupCreateOneWithoutStudentsInput>;
  id?: InputMaybe<Scalars['ID']>;
  license?: InputMaybe<LicenseCreateOneWithoutUserInput>;
  mostRecentResourceId?: InputMaybe<Scalars['String']>;
  mostRecentResourceType?: InputMaybe<Scalars['String']>;
  schoolDistricts?: InputMaybe<SchoolDistrictCreateManyWithoutUsersInput>;
  schools?: InputMaybe<SchoolCreateManyWithoutUsersInput>;
  user_id: Scalars['String'];
};

export type BeheerUserCreateWithoutSchoolDistrictsInput = {
  archived?: InputMaybe<Scalars['Boolean']>;
  coachedCourseGroups?: InputMaybe<CourseGroupCreateManyWithoutCoachesInput>;
  followingCourseGroup?: InputMaybe<CourseGroupCreateOneWithoutStudentsInput>;
  id?: InputMaybe<Scalars['ID']>;
  license?: InputMaybe<LicenseCreateOneWithoutUserInput>;
  mostRecentResourceId?: InputMaybe<Scalars['String']>;
  mostRecentResourceType?: InputMaybe<Scalars['String']>;
  partners?: InputMaybe<PartnerCreateManyWithoutUsersInput>;
  schools?: InputMaybe<SchoolCreateManyWithoutUsersInput>;
  user_id: Scalars['String'];
};

export type BeheerUserCreateWithoutSchoolsInput = {
  archived?: InputMaybe<Scalars['Boolean']>;
  coachedCourseGroups?: InputMaybe<CourseGroupCreateManyWithoutCoachesInput>;
  followingCourseGroup?: InputMaybe<CourseGroupCreateOneWithoutStudentsInput>;
  id?: InputMaybe<Scalars['ID']>;
  license?: InputMaybe<LicenseCreateOneWithoutUserInput>;
  mostRecentResourceId?: InputMaybe<Scalars['String']>;
  mostRecentResourceType?: InputMaybe<Scalars['String']>;
  partners?: InputMaybe<PartnerCreateManyWithoutUsersInput>;
  schoolDistricts?: InputMaybe<SchoolDistrictCreateManyWithoutUsersInput>;
  user_id: Scalars['String'];
};

export type BeheerUserEdge = {
  cursor: Scalars['String'];
  node: BeheerUser;
};

export type BeheerUserOrderByInput =
  | 'archived_ASC'
  | 'archived_DESC'
  | 'createdAt_ASC'
  | 'createdAt_DESC'
  | 'id_ASC'
  | 'id_DESC'
  | 'mostRecentResourceId_ASC'
  | 'mostRecentResourceId_DESC'
  | 'mostRecentResourceType_ASC'
  | 'mostRecentResourceType_DESC'
  | 'updatedAt_ASC'
  | 'updatedAt_DESC'
  | 'user_id_ASC'
  | 'user_id_DESC';

export type BeheerUserPreviousValues = {
  archived: Scalars['Boolean'];
  createdAt: Scalars['DateTime'];
  id: Scalars['ID'];
  mostRecentResourceId?: Maybe<Scalars['String']>;
  mostRecentResourceType?: Maybe<Scalars['String']>;
  updatedAt: Scalars['DateTime'];
  user_id: Scalars['String'];
};

export type BeheerUserScalarWhereInput = {
  AND?: InputMaybe<Array<BeheerUserScalarWhereInput>>;
  NOT?: InputMaybe<Array<BeheerUserScalarWhereInput>>;
  OR?: InputMaybe<Array<BeheerUserScalarWhereInput>>;
  archived?: InputMaybe<Scalars['Boolean']>;
  archived_not?: InputMaybe<Scalars['Boolean']>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  createdAt_gt?: InputMaybe<Scalars['DateTime']>;
  createdAt_gte?: InputMaybe<Scalars['DateTime']>;
  createdAt_in?: InputMaybe<Array<Scalars['DateTime']>>;
  createdAt_lt?: InputMaybe<Scalars['DateTime']>;
  createdAt_lte?: InputMaybe<Scalars['DateTime']>;
  createdAt_not?: InputMaybe<Scalars['DateTime']>;
  createdAt_not_in?: InputMaybe<Array<Scalars['DateTime']>>;
  id?: InputMaybe<Scalars['ID']>;
  id_contains?: InputMaybe<Scalars['ID']>;
  id_ends_with?: InputMaybe<Scalars['ID']>;
  id_gt?: InputMaybe<Scalars['ID']>;
  id_gte?: InputMaybe<Scalars['ID']>;
  id_in?: InputMaybe<Array<Scalars['ID']>>;
  id_lt?: InputMaybe<Scalars['ID']>;
  id_lte?: InputMaybe<Scalars['ID']>;
  id_not?: InputMaybe<Scalars['ID']>;
  id_not_contains?: InputMaybe<Scalars['ID']>;
  id_not_ends_with?: InputMaybe<Scalars['ID']>;
  id_not_in?: InputMaybe<Array<Scalars['ID']>>;
  id_not_starts_with?: InputMaybe<Scalars['ID']>;
  id_starts_with?: InputMaybe<Scalars['ID']>;
  mostRecentResourceId?: InputMaybe<Scalars['String']>;
  mostRecentResourceId_contains?: InputMaybe<Scalars['String']>;
  mostRecentResourceId_ends_with?: InputMaybe<Scalars['String']>;
  mostRecentResourceId_gt?: InputMaybe<Scalars['String']>;
  mostRecentResourceId_gte?: InputMaybe<Scalars['String']>;
  mostRecentResourceId_in?: InputMaybe<Array<Scalars['String']>>;
  mostRecentResourceId_lt?: InputMaybe<Scalars['String']>;
  mostRecentResourceId_lte?: InputMaybe<Scalars['String']>;
  mostRecentResourceId_not?: InputMaybe<Scalars['String']>;
  mostRecentResourceId_not_contains?: InputMaybe<Scalars['String']>;
  mostRecentResourceId_not_ends_with?: InputMaybe<Scalars['String']>;
  mostRecentResourceId_not_in?: InputMaybe<Array<Scalars['String']>>;
  mostRecentResourceId_not_starts_with?: InputMaybe<Scalars['String']>;
  mostRecentResourceId_starts_with?: InputMaybe<Scalars['String']>;
  mostRecentResourceType?: InputMaybe<Scalars['String']>;
  mostRecentResourceType_contains?: InputMaybe<Scalars['String']>;
  mostRecentResourceType_ends_with?: InputMaybe<Scalars['String']>;
  mostRecentResourceType_gt?: InputMaybe<Scalars['String']>;
  mostRecentResourceType_gte?: InputMaybe<Scalars['String']>;
  mostRecentResourceType_in?: InputMaybe<Array<Scalars['String']>>;
  mostRecentResourceType_lt?: InputMaybe<Scalars['String']>;
  mostRecentResourceType_lte?: InputMaybe<Scalars['String']>;
  mostRecentResourceType_not?: InputMaybe<Scalars['String']>;
  mostRecentResourceType_not_contains?: InputMaybe<Scalars['String']>;
  mostRecentResourceType_not_ends_with?: InputMaybe<Scalars['String']>;
  mostRecentResourceType_not_in?: InputMaybe<Array<Scalars['String']>>;
  mostRecentResourceType_not_starts_with?: InputMaybe<Scalars['String']>;
  mostRecentResourceType_starts_with?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
  updatedAt_gt?: InputMaybe<Scalars['DateTime']>;
  updatedAt_gte?: InputMaybe<Scalars['DateTime']>;
  updatedAt_in?: InputMaybe<Array<Scalars['DateTime']>>;
  updatedAt_lt?: InputMaybe<Scalars['DateTime']>;
  updatedAt_lte?: InputMaybe<Scalars['DateTime']>;
  updatedAt_not?: InputMaybe<Scalars['DateTime']>;
  updatedAt_not_in?: InputMaybe<Array<Scalars['DateTime']>>;
  user_id?: InputMaybe<Scalars['String']>;
  user_id_contains?: InputMaybe<Scalars['String']>;
  user_id_ends_with?: InputMaybe<Scalars['String']>;
  user_id_gt?: InputMaybe<Scalars['String']>;
  user_id_gte?: InputMaybe<Scalars['String']>;
  user_id_in?: InputMaybe<Array<Scalars['String']>>;
  user_id_lt?: InputMaybe<Scalars['String']>;
  user_id_lte?: InputMaybe<Scalars['String']>;
  user_id_not?: InputMaybe<Scalars['String']>;
  user_id_not_contains?: InputMaybe<Scalars['String']>;
  user_id_not_ends_with?: InputMaybe<Scalars['String']>;
  user_id_not_in?: InputMaybe<Array<Scalars['String']>>;
  user_id_not_starts_with?: InputMaybe<Scalars['String']>;
  user_id_starts_with?: InputMaybe<Scalars['String']>;
};

export type BeheerUserSubscriptionPayload = {
  mutation: MutationType;
  node?: Maybe<BeheerUser>;
  previousValues?: Maybe<BeheerUserPreviousValues>;
  updatedFields?: Maybe<Array<Scalars['String']>>;
};

export type BeheerUserSubscriptionWhereInput = {
  AND?: InputMaybe<Array<BeheerUserSubscriptionWhereInput>>;
  NOT?: InputMaybe<Array<BeheerUserSubscriptionWhereInput>>;
  OR?: InputMaybe<Array<BeheerUserSubscriptionWhereInput>>;
  mutation_in?: InputMaybe<Array<MutationType>>;
  node?: InputMaybe<BeheerUserWhereInput>;
  updatedFields_contains?: InputMaybe<Scalars['String']>;
  updatedFields_contains_every?: InputMaybe<Array<Scalars['String']>>;
  updatedFields_contains_some?: InputMaybe<Array<Scalars['String']>>;
};

export type BeheerUserUpdateInput = {
  archived?: InputMaybe<Scalars['Boolean']>;
  coachedCourseGroups?: InputMaybe<CourseGroupUpdateManyWithoutCoachesInput>;
  followingCourseGroup?: InputMaybe<CourseGroupUpdateOneWithoutStudentsInput>;
  license?: InputMaybe<LicenseUpdateOneWithoutUserInput>;
  mostRecentResourceId?: InputMaybe<Scalars['String']>;
  mostRecentResourceType?: InputMaybe<Scalars['String']>;
  partners?: InputMaybe<PartnerUpdateManyWithoutUsersInput>;
  schoolDistricts?: InputMaybe<SchoolDistrictUpdateManyWithoutUsersInput>;
  schools?: InputMaybe<SchoolUpdateManyWithoutUsersInput>;
  user_id?: InputMaybe<Scalars['String']>;
};

export type BeheerUserUpdateManyDataInput = {
  archived?: InputMaybe<Scalars['Boolean']>;
  mostRecentResourceId?: InputMaybe<Scalars['String']>;
  mostRecentResourceType?: InputMaybe<Scalars['String']>;
  user_id?: InputMaybe<Scalars['String']>;
};

export type BeheerUserUpdateManyMutationInput = {
  archived?: InputMaybe<Scalars['Boolean']>;
  mostRecentResourceId?: InputMaybe<Scalars['String']>;
  mostRecentResourceType?: InputMaybe<Scalars['String']>;
  user_id?: InputMaybe<Scalars['String']>;
};

export type BeheerUserUpdateManyWithWhereNestedInput = {
  data: BeheerUserUpdateManyDataInput;
  where: BeheerUserScalarWhereInput;
};

export type BeheerUserUpdateManyWithoutCoachedCourseGroupsInput = {
  connect?: InputMaybe<Array<BeheerUserWhereUniqueInput>>;
  create?: InputMaybe<Array<BeheerUserCreateWithoutCoachedCourseGroupsInput>>;
  delete?: InputMaybe<Array<BeheerUserWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<BeheerUserScalarWhereInput>>;
  disconnect?: InputMaybe<Array<BeheerUserWhereUniqueInput>>;
  set?: InputMaybe<Array<BeheerUserWhereUniqueInput>>;
  update?: InputMaybe<
    Array<BeheerUserUpdateWithWhereUniqueWithoutCoachedCourseGroupsInput>
  >;
  updateMany?: InputMaybe<Array<BeheerUserUpdateManyWithWhereNestedInput>>;
  upsert?: InputMaybe<
    Array<BeheerUserUpsertWithWhereUniqueWithoutCoachedCourseGroupsInput>
  >;
};

export type BeheerUserUpdateManyWithoutFollowingCourseGroupInput = {
  connect?: InputMaybe<Array<BeheerUserWhereUniqueInput>>;
  create?: InputMaybe<Array<BeheerUserCreateWithoutFollowingCourseGroupInput>>;
  delete?: InputMaybe<Array<BeheerUserWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<BeheerUserScalarWhereInput>>;
  disconnect?: InputMaybe<Array<BeheerUserWhereUniqueInput>>;
  set?: InputMaybe<Array<BeheerUserWhereUniqueInput>>;
  update?: InputMaybe<
    Array<BeheerUserUpdateWithWhereUniqueWithoutFollowingCourseGroupInput>
  >;
  updateMany?: InputMaybe<Array<BeheerUserUpdateManyWithWhereNestedInput>>;
  upsert?: InputMaybe<
    Array<BeheerUserUpsertWithWhereUniqueWithoutFollowingCourseGroupInput>
  >;
};

export type BeheerUserUpdateManyWithoutPartnersInput = {
  connect?: InputMaybe<Array<BeheerUserWhereUniqueInput>>;
  disconnect?: InputMaybe<Array<BeheerUserWhereUniqueInput>>;
  set?: InputMaybe<Array<BeheerUserWhereUniqueInput>>;
};

export type BeheerUserUpdateManyWithoutSchoolDistrictsInput = {
  connect?: InputMaybe<Array<BeheerUserWhereUniqueInput>>;
  create?: InputMaybe<Array<BeheerUserCreateWithoutSchoolDistrictsInput>>;
  delete?: InputMaybe<Array<BeheerUserWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<BeheerUserScalarWhereInput>>;
  disconnect?: InputMaybe<Array<BeheerUserWhereUniqueInput>>;
  set?: InputMaybe<Array<BeheerUserWhereUniqueInput>>;
  update?: InputMaybe<
    Array<BeheerUserUpdateWithWhereUniqueWithoutSchoolDistrictsInput>
  >;
  updateMany?: InputMaybe<Array<BeheerUserUpdateManyWithWhereNestedInput>>;
  upsert?: InputMaybe<
    Array<BeheerUserUpsertWithWhereUniqueWithoutSchoolDistrictsInput>
  >;
};

export type BeheerUserUpdateManyWithoutSchoolsInput = {
  connect?: InputMaybe<Array<BeheerUserWhereUniqueInput>>;
  create?: InputMaybe<Array<BeheerUserCreateWithoutSchoolsInput>>;
  delete?: InputMaybe<Array<BeheerUserWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<BeheerUserScalarWhereInput>>;
  disconnect?: InputMaybe<Array<BeheerUserWhereUniqueInput>>;
  set?: InputMaybe<Array<BeheerUserWhereUniqueInput>>;
  update?: InputMaybe<
    Array<BeheerUserUpdateWithWhereUniqueWithoutSchoolsInput>
  >;
  updateMany?: InputMaybe<Array<BeheerUserUpdateManyWithWhereNestedInput>>;
  upsert?: InputMaybe<
    Array<BeheerUserUpsertWithWhereUniqueWithoutSchoolsInput>
  >;
};

export type BeheerUserUpdateOneWithoutLicenseInput = {
  connect?: InputMaybe<BeheerUserWhereUniqueInput>;
  create?: InputMaybe<BeheerUserCreateWithoutLicenseInput>;
  delete?: InputMaybe<Scalars['Boolean']>;
  disconnect?: InputMaybe<Scalars['Boolean']>;
  update?: InputMaybe<BeheerUserUpdateWithoutLicenseDataInput>;
  upsert?: InputMaybe<BeheerUserUpsertWithoutLicenseInput>;
};

export type BeheerUserUpdateWithWhereUniqueWithoutCoachedCourseGroupsInput = {
  data: BeheerUserUpdateWithoutCoachedCourseGroupsDataInput;
  where: BeheerUserWhereUniqueInput;
};

export type BeheerUserUpdateWithWhereUniqueWithoutFollowingCourseGroupInput = {
  data: BeheerUserUpdateWithoutFollowingCourseGroupDataInput;
  where: BeheerUserWhereUniqueInput;
};

export type BeheerUserUpdateWithWhereUniqueWithoutPartnersInput = {
  data: BeheerUserUpdateWithoutPartnersDataInput;
  where: BeheerUserWhereUniqueInput;
};

export type BeheerUserUpdateWithWhereUniqueWithoutSchoolDistrictsInput = {
  data: BeheerUserUpdateWithoutSchoolDistrictsDataInput;
  where: BeheerUserWhereUniqueInput;
};

export type BeheerUserUpdateWithWhereUniqueWithoutSchoolsInput = {
  data: BeheerUserUpdateWithoutSchoolsDataInput;
  where: BeheerUserWhereUniqueInput;
};

export type BeheerUserUpdateWithoutCoachedCourseGroupsDataInput = {
  archived?: InputMaybe<Scalars['Boolean']>;
  followingCourseGroup?: InputMaybe<CourseGroupUpdateOneWithoutStudentsInput>;
  license?: InputMaybe<LicenseUpdateOneWithoutUserInput>;
  mostRecentResourceId?: InputMaybe<Scalars['String']>;
  mostRecentResourceType?: InputMaybe<Scalars['String']>;
  partners?: InputMaybe<PartnerUpdateManyWithoutUsersInput>;
  schoolDistricts?: InputMaybe<SchoolDistrictUpdateManyWithoutUsersInput>;
  schools?: InputMaybe<SchoolUpdateManyWithoutUsersInput>;
  user_id?: InputMaybe<Scalars['String']>;
};

export type BeheerUserUpdateWithoutFollowingCourseGroupDataInput = {
  archived?: InputMaybe<Scalars['Boolean']>;
  coachedCourseGroups?: InputMaybe<CourseGroupUpdateManyWithoutCoachesInput>;
  license?: InputMaybe<LicenseUpdateOneWithoutUserInput>;
  mostRecentResourceId?: InputMaybe<Scalars['String']>;
  mostRecentResourceType?: InputMaybe<Scalars['String']>;
  partners?: InputMaybe<PartnerUpdateManyWithoutUsersInput>;
  schoolDistricts?: InputMaybe<SchoolDistrictUpdateManyWithoutUsersInput>;
  schools?: InputMaybe<SchoolUpdateManyWithoutUsersInput>;
  user_id?: InputMaybe<Scalars['String']>;
};

export type BeheerUserUpdateWithoutLicenseDataInput = {
  archived?: InputMaybe<Scalars['Boolean']>;
  coachedCourseGroups?: InputMaybe<CourseGroupUpdateManyWithoutCoachesInput>;
  followingCourseGroup?: InputMaybe<CourseGroupUpdateOneWithoutStudentsInput>;
  mostRecentResourceId?: InputMaybe<Scalars['String']>;
  mostRecentResourceType?: InputMaybe<Scalars['String']>;
  partners?: InputMaybe<PartnerUpdateManyWithoutUsersInput>;
  schoolDistricts?: InputMaybe<SchoolDistrictUpdateManyWithoutUsersInput>;
  schools?: InputMaybe<SchoolUpdateManyWithoutUsersInput>;
  user_id?: InputMaybe<Scalars['String']>;
};

export type BeheerUserUpdateWithoutPartnersDataInput = {
  archived?: InputMaybe<Scalars['Boolean']>;
  coachedCourseGroups?: InputMaybe<CourseGroupUpdateManyWithoutCoachesInput>;
  followingCourseGroup?: InputMaybe<CourseGroupUpdateOneWithoutStudentsInput>;
  license?: InputMaybe<LicenseUpdateOneWithoutUserInput>;
  mostRecentResourceId?: InputMaybe<Scalars['String']>;
  mostRecentResourceType?: InputMaybe<Scalars['String']>;
  schoolDistricts?: InputMaybe<SchoolDistrictUpdateManyWithoutUsersInput>;
  schools?: InputMaybe<SchoolUpdateManyWithoutUsersInput>;
  user_id?: InputMaybe<Scalars['String']>;
};

export type BeheerUserUpdateWithoutSchoolDistrictsDataInput = {
  archived?: InputMaybe<Scalars['Boolean']>;
  coachedCourseGroups?: InputMaybe<CourseGroupUpdateManyWithoutCoachesInput>;
  followingCourseGroup?: InputMaybe<CourseGroupUpdateOneWithoutStudentsInput>;
  license?: InputMaybe<LicenseUpdateOneWithoutUserInput>;
  mostRecentResourceId?: InputMaybe<Scalars['String']>;
  mostRecentResourceType?: InputMaybe<Scalars['String']>;
  partners?: InputMaybe<PartnerUpdateManyWithoutUsersInput>;
  schools?: InputMaybe<SchoolUpdateManyWithoutUsersInput>;
  user_id?: InputMaybe<Scalars['String']>;
};

export type BeheerUserUpdateWithoutSchoolsDataInput = {
  archived?: InputMaybe<Scalars['Boolean']>;
  coachedCourseGroups?: InputMaybe<CourseGroupUpdateManyWithoutCoachesInput>;
  followingCourseGroup?: InputMaybe<CourseGroupUpdateOneWithoutStudentsInput>;
  license?: InputMaybe<LicenseUpdateOneWithoutUserInput>;
  mostRecentResourceId?: InputMaybe<Scalars['String']>;
  mostRecentResourceType?: InputMaybe<Scalars['String']>;
  partners?: InputMaybe<PartnerUpdateManyWithoutUsersInput>;
  schoolDistricts?: InputMaybe<SchoolDistrictUpdateManyWithoutUsersInput>;
  user_id?: InputMaybe<Scalars['String']>;
};

export type BeheerUserUpsertWithWhereUniqueWithoutCoachedCourseGroupsInput = {
  create: BeheerUserCreateWithoutCoachedCourseGroupsInput;
  update: BeheerUserUpdateWithoutCoachedCourseGroupsDataInput;
  where: BeheerUserWhereUniqueInput;
};

export type BeheerUserUpsertWithWhereUniqueWithoutFollowingCourseGroupInput = {
  create: BeheerUserCreateWithoutFollowingCourseGroupInput;
  update: BeheerUserUpdateWithoutFollowingCourseGroupDataInput;
  where: BeheerUserWhereUniqueInput;
};

export type BeheerUserUpsertWithWhereUniqueWithoutPartnersInput = {
  create: BeheerUserCreateWithoutPartnersInput;
  update: BeheerUserUpdateWithoutPartnersDataInput;
  where: BeheerUserWhereUniqueInput;
};

export type BeheerUserUpsertWithWhereUniqueWithoutSchoolDistrictsInput = {
  create: BeheerUserCreateWithoutSchoolDistrictsInput;
  update: BeheerUserUpdateWithoutSchoolDistrictsDataInput;
  where: BeheerUserWhereUniqueInput;
};

export type BeheerUserUpsertWithWhereUniqueWithoutSchoolsInput = {
  create: BeheerUserCreateWithoutSchoolsInput;
  update: BeheerUserUpdateWithoutSchoolsDataInput;
  where: BeheerUserWhereUniqueInput;
};

export type BeheerUserUpsertWithoutLicenseInput = {
  create: BeheerUserCreateWithoutLicenseInput;
  update: BeheerUserUpdateWithoutLicenseDataInput;
};

export type BeheerUserWhereInput = {
  AND?: InputMaybe<Array<BeheerUserWhereInput>>;
  NOT?: InputMaybe<Array<BeheerUserWhereInput>>;
  OR?: InputMaybe<Array<BeheerUserWhereInput>>;
  archived?: InputMaybe<Scalars['Boolean']>;
  archived_not?: InputMaybe<Scalars['Boolean']>;
  coachedCourseGroups_every?: InputMaybe<CourseGroupWhereInput>;
  coachedCourseGroups_none?: InputMaybe<CourseGroupWhereInput>;
  coachedCourseGroups_some?: InputMaybe<CourseGroupWhereInput>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  createdAt_gt?: InputMaybe<Scalars['DateTime']>;
  createdAt_gte?: InputMaybe<Scalars['DateTime']>;
  createdAt_in?: InputMaybe<Array<Scalars['DateTime']>>;
  createdAt_lt?: InputMaybe<Scalars['DateTime']>;
  createdAt_lte?: InputMaybe<Scalars['DateTime']>;
  createdAt_not?: InputMaybe<Scalars['DateTime']>;
  createdAt_not_in?: InputMaybe<Array<Scalars['DateTime']>>;
  followingCourseGroup?: InputMaybe<CourseGroupWhereInput>;
  id?: InputMaybe<Scalars['ID']>;
  id_contains?: InputMaybe<Scalars['ID']>;
  id_ends_with?: InputMaybe<Scalars['ID']>;
  id_gt?: InputMaybe<Scalars['ID']>;
  id_gte?: InputMaybe<Scalars['ID']>;
  id_in?: InputMaybe<Array<Scalars['ID']>>;
  id_lt?: InputMaybe<Scalars['ID']>;
  id_lte?: InputMaybe<Scalars['ID']>;
  id_not?: InputMaybe<Scalars['ID']>;
  id_not_contains?: InputMaybe<Scalars['ID']>;
  id_not_ends_with?: InputMaybe<Scalars['ID']>;
  id_not_in?: InputMaybe<Array<Scalars['ID']>>;
  id_not_starts_with?: InputMaybe<Scalars['ID']>;
  id_starts_with?: InputMaybe<Scalars['ID']>;
  license?: InputMaybe<LicenseWhereInput>;
  mostRecentResourceId?: InputMaybe<Scalars['String']>;
  mostRecentResourceId_contains?: InputMaybe<Scalars['String']>;
  mostRecentResourceId_ends_with?: InputMaybe<Scalars['String']>;
  mostRecentResourceId_gt?: InputMaybe<Scalars['String']>;
  mostRecentResourceId_gte?: InputMaybe<Scalars['String']>;
  mostRecentResourceId_in?: InputMaybe<Array<Scalars['String']>>;
  mostRecentResourceId_lt?: InputMaybe<Scalars['String']>;
  mostRecentResourceId_lte?: InputMaybe<Scalars['String']>;
  mostRecentResourceId_not?: InputMaybe<Scalars['String']>;
  mostRecentResourceId_not_contains?: InputMaybe<Scalars['String']>;
  mostRecentResourceId_not_ends_with?: InputMaybe<Scalars['String']>;
  mostRecentResourceId_not_in?: InputMaybe<Array<Scalars['String']>>;
  mostRecentResourceId_not_starts_with?: InputMaybe<Scalars['String']>;
  mostRecentResourceId_starts_with?: InputMaybe<Scalars['String']>;
  mostRecentResourceType?: InputMaybe<Scalars['String']>;
  mostRecentResourceType_contains?: InputMaybe<Scalars['String']>;
  mostRecentResourceType_ends_with?: InputMaybe<Scalars['String']>;
  mostRecentResourceType_gt?: InputMaybe<Scalars['String']>;
  mostRecentResourceType_gte?: InputMaybe<Scalars['String']>;
  mostRecentResourceType_in?: InputMaybe<Array<Scalars['String']>>;
  mostRecentResourceType_lt?: InputMaybe<Scalars['String']>;
  mostRecentResourceType_lte?: InputMaybe<Scalars['String']>;
  mostRecentResourceType_not?: InputMaybe<Scalars['String']>;
  mostRecentResourceType_not_contains?: InputMaybe<Scalars['String']>;
  mostRecentResourceType_not_ends_with?: InputMaybe<Scalars['String']>;
  mostRecentResourceType_not_in?: InputMaybe<Array<Scalars['String']>>;
  mostRecentResourceType_not_starts_with?: InputMaybe<Scalars['String']>;
  mostRecentResourceType_starts_with?: InputMaybe<Scalars['String']>;
  partners_every?: InputMaybe<PartnerWhereInput>;
  partners_none?: InputMaybe<PartnerWhereInput>;
  partners_some?: InputMaybe<PartnerWhereInput>;
  schoolDistricts_every?: InputMaybe<SchoolDistrictWhereInput>;
  schoolDistricts_none?: InputMaybe<SchoolDistrictWhereInput>;
  schoolDistricts_some?: InputMaybe<SchoolDistrictWhereInput>;
  schools_every?: InputMaybe<SchoolWhereInput>;
  schools_none?: InputMaybe<SchoolWhereInput>;
  schools_some?: InputMaybe<SchoolWhereInput>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
  updatedAt_gt?: InputMaybe<Scalars['DateTime']>;
  updatedAt_gte?: InputMaybe<Scalars['DateTime']>;
  updatedAt_in?: InputMaybe<Array<Scalars['DateTime']>>;
  updatedAt_lt?: InputMaybe<Scalars['DateTime']>;
  updatedAt_lte?: InputMaybe<Scalars['DateTime']>;
  updatedAt_not?: InputMaybe<Scalars['DateTime']>;
  updatedAt_not_in?: InputMaybe<Array<Scalars['DateTime']>>;
  user_id?: InputMaybe<Scalars['String']>;
  user_id_contains?: InputMaybe<Scalars['String']>;
  user_id_ends_with?: InputMaybe<Scalars['String']>;
  user_id_gt?: InputMaybe<Scalars['String']>;
  user_id_gte?: InputMaybe<Scalars['String']>;
  user_id_in?: InputMaybe<Array<Scalars['String']>>;
  user_id_lt?: InputMaybe<Scalars['String']>;
  user_id_lte?: InputMaybe<Scalars['String']>;
  user_id_not?: InputMaybe<Scalars['String']>;
  user_id_not_contains?: InputMaybe<Scalars['String']>;
  user_id_not_ends_with?: InputMaybe<Scalars['String']>;
  user_id_not_in?: InputMaybe<Array<Scalars['String']>>;
  user_id_not_starts_with?: InputMaybe<Scalars['String']>;
  user_id_starts_with?: InputMaybe<Scalars['String']>;
};

export type BeheerUserWhereUniqueInput = {
  id?: InputMaybe<Scalars['ID']>;
  user_id?: InputMaybe<Scalars['String']>;
};

export type BrinSearchResult = {
  brinNumber: Scalars['ID'];
  competentAuthorityNumber: Scalars['String'];
  coropAreaCode: Scalars['String'];
  coropAreaName: Scalars['String'];
  denomination: Scalars['String'];
  educationalAreaCode: Scalars['String'];
  educationalAreaName: Scalars['String'];
  educationalStructure?: Maybe<Scalars['String']>;
  establishmentName: Scalars['String'];
  houseNumberAddition: Scalars['String'];
  houseNumberAdditionCorrespondenceAddress: Scalars['String'];
  internetAddress: Scalars['String'];
  locationNumber: Scalars['String'];
  municipalityName: Scalars['String'];
  municipalityNumber: Scalars['String'];
  nodalAreaCode: Scalars['String'];
  nodalAreaName: Scalars['String'];
  phoneNumber: Scalars['String'];
  placeName: Scalars['String'];
  placeNameCorrespondenceAddress: Scalars['String'];
  postalCode: Scalars['String'];
  postalCodeCorrespondenceAddress: Scalars['String'];
  province: Scalars['String'];
  rmcRegionCode: Scalars['String'];
  rmcRegionName: Scalars['String'];
  rpaAreaCode: Scalars['String'];
  rpaFieldName: Scalars['String'];
  streetName: Scalars['String'];
  streetNameCorrespondenceAddress: Scalars['String'];
  wgrAreaCode: Scalars['String'];
  wgrAreaName: Scalars['String'];
};

export type CalcLicensesExtendPayload = {
  currentHighestQuantity: Scalars['Int'];
  discountPrice: Scalars['Float'];
  leftOverUnitPrice: Scalars['Float'];
  licenseProduct: Product;
  licensesPrice: Scalars['Float'];
  newQuantityDifference: Scalars['Int'];
  serviceProduct: Product;
  totalPrice: Scalars['Float'];
  totalUpgradePrice: Scalars['Float'];
};

export type CalcLicensesPayload = {
  discountPrice: Scalars['Float'];
  licenseProduct: Product;
  licensesPrice: Scalars['Float'];
  serviceProduct: Product;
  totalPrice: Scalars['Float'];
};

export type Challenge = {
  averageAccuracy?: Maybe<Scalars['Decimal']>;
  averageCharactersPerMinute?: Maybe<Scalars['Decimal']>;
  challengeRequests?: Maybe<Array<ChallengeRequest>>;
  correctAnswer: Scalars['String'];
  id: Scalars['ID'];
  level: Level;
  skill: Scalars['Decimal'];
  skillCourse?: Maybe<Array<SkillCourse>>;
  text: Scalars['String'];
};

export type ChallengeChallengeRequestsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<ChallengeRequestOrderByInput>;
  skip?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<ChallengeRequestWhereInput>;
};

export type ChallengeSkillCourseArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<SkillCourseOrderByInput>;
  skip?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<SkillCourseWhereInput>;
};

export type ChallengeConnection = {
  aggregate: AggregateChallenge;
  edges: Array<Maybe<ChallengeEdge>>;
  pageInfo: PageInfo;
};

export type ChallengeCreateInput = {
  averageAccuracy?: InputMaybe<Scalars['Decimal']>;
  averageCharactersPerMinute?: InputMaybe<Scalars['Decimal']>;
  challengeRequests?: InputMaybe<ChallengeRequestCreateManyWithoutChallengeInput>;
  correctAnswer: Scalars['String'];
  id?: InputMaybe<Scalars['ID']>;
  level: LevelCreateOneWithoutChallengesInput;
  skill?: InputMaybe<Scalars['Decimal']>;
  skillCourse?: InputMaybe<SkillCourseCreateManyWithoutChallengeInput>;
  text: Scalars['String'];
};

export type ChallengeCreateManyWithoutLevelInput = {
  connect?: InputMaybe<Array<ChallengeWhereUniqueInput>>;
  create?: InputMaybe<Array<ChallengeCreateWithoutLevelInput>>;
};

export type ChallengeCreateOneInput = {
  connect?: InputMaybe<ChallengeWhereUniqueInput>;
};

export type ChallengeCreateOneWithoutChallengeRequestsInput = {
  connect?: InputMaybe<ChallengeWhereUniqueInput>;
  create?: InputMaybe<ChallengeCreateWithoutChallengeRequestsInput>;
};

export type ChallengeCreateOneWithoutSkillCourseInput = {
  connect?: InputMaybe<ChallengeWhereUniqueInput>;
  create?: InputMaybe<ChallengeCreateWithoutSkillCourseInput>;
};

export type ChallengeCreateWithoutChallengeRequestsInput = {
  averageAccuracy?: InputMaybe<Scalars['Decimal']>;
  averageCharactersPerMinute?: InputMaybe<Scalars['Decimal']>;
  correctAnswer: Scalars['String'];
  id?: InputMaybe<Scalars['ID']>;
  level: LevelCreateOneWithoutChallengesInput;
  skill?: InputMaybe<Scalars['Decimal']>;
  skillCourse?: InputMaybe<SkillCourseCreateManyWithoutChallengeInput>;
  text: Scalars['String'];
};

export type ChallengeCreateWithoutLevelInput = {
  averageAccuracy?: InputMaybe<Scalars['Decimal']>;
  averageCharactersPerMinute?: InputMaybe<Scalars['Decimal']>;
  challengeRequests?: InputMaybe<ChallengeRequestCreateManyWithoutChallengeInput>;
  correctAnswer: Scalars['String'];
  id?: InputMaybe<Scalars['ID']>;
  skill?: InputMaybe<Scalars['Decimal']>;
  skillCourse?: InputMaybe<SkillCourseCreateManyWithoutChallengeInput>;
  text: Scalars['String'];
};

export type ChallengeCreateWithoutSkillCourseInput = {
  averageAccuracy?: InputMaybe<Scalars['Decimal']>;
  averageCharactersPerMinute?: InputMaybe<Scalars['Decimal']>;
  challengeRequests?: InputMaybe<ChallengeRequestCreateManyWithoutChallengeInput>;
  correctAnswer: Scalars['String'];
  id?: InputMaybe<Scalars['ID']>;
  level: LevelCreateOneWithoutChallengesInput;
  skill?: InputMaybe<Scalars['Decimal']>;
  text: Scalars['String'];
};

export type ChallengeEdge = {
  cursor: Scalars['String'];
  node: Challenge;
};

export type ChallengeOrderByInput =
  | 'averageAccuracy_ASC'
  | 'averageAccuracy_DESC'
  | 'averageCharactersPerMinute_ASC'
  | 'averageCharactersPerMinute_DESC'
  | 'correctAnswer_ASC'
  | 'correctAnswer_DESC'
  | 'id_ASC'
  | 'id_DESC'
  | 'skill_ASC'
  | 'skill_DESC'
  | 'text_ASC'
  | 'text_DESC';

export type ChallengeRequest = {
  challenge: Challenge;
  createdAt: Scalars['DateTime'];
  exercise: Exercise;
  id: Scalars['ID'];
  ignored: Scalars['Boolean'];
};

export type ChallengeRequestConnection = {
  aggregate: AggregateChallengeRequest;
  edges: Array<Maybe<ChallengeRequestEdge>>;
  pageInfo: PageInfo;
};

export type ChallengeRequestCreateInput = {
  challenge: ChallengeCreateOneWithoutChallengeRequestsInput;
  exercise: ExerciseCreateOneWithoutChallengeRequestsInput;
  id?: InputMaybe<Scalars['ID']>;
  ignored?: InputMaybe<Scalars['Boolean']>;
};

export type ChallengeRequestCreateManyWithoutChallengeInput = {
  connect?: InputMaybe<Array<ChallengeRequestWhereUniqueInput>>;
  create?: InputMaybe<Array<ChallengeRequestCreateWithoutChallengeInput>>;
};

export type ChallengeRequestCreateManyWithoutExerciseInput = {
  connect?: InputMaybe<Array<ChallengeRequestWhereUniqueInput>>;
  create?: InputMaybe<Array<ChallengeRequestCreateWithoutExerciseInput>>;
};

export type ChallengeRequestCreateWithoutChallengeInput = {
  exercise: ExerciseCreateOneWithoutChallengeRequestsInput;
  id?: InputMaybe<Scalars['ID']>;
  ignored?: InputMaybe<Scalars['Boolean']>;
};

export type ChallengeRequestCreateWithoutExerciseInput = {
  challenge: ChallengeCreateOneWithoutChallengeRequestsInput;
  id?: InputMaybe<Scalars['ID']>;
  ignored?: InputMaybe<Scalars['Boolean']>;
};

export type ChallengeRequestEdge = {
  cursor: Scalars['String'];
  node: ChallengeRequest;
};

export type ChallengeRequestOrderByInput =
  | 'createdAt_ASC'
  | 'createdAt_DESC'
  | 'id_ASC'
  | 'id_DESC'
  | 'ignored_ASC'
  | 'ignored_DESC';

export type ChallengeRequestScalarWhereInput = {
  AND?: InputMaybe<Array<ChallengeRequestScalarWhereInput>>;
  NOT?: InputMaybe<Array<ChallengeRequestScalarWhereInput>>;
  OR?: InputMaybe<Array<ChallengeRequestScalarWhereInput>>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  createdAt_gt?: InputMaybe<Scalars['DateTime']>;
  createdAt_gte?: InputMaybe<Scalars['DateTime']>;
  createdAt_in?: InputMaybe<Array<Scalars['DateTime']>>;
  createdAt_lt?: InputMaybe<Scalars['DateTime']>;
  createdAt_lte?: InputMaybe<Scalars['DateTime']>;
  createdAt_not?: InputMaybe<Scalars['DateTime']>;
  createdAt_not_in?: InputMaybe<Array<Scalars['DateTime']>>;
  id?: InputMaybe<Scalars['ID']>;
  id_contains?: InputMaybe<Scalars['ID']>;
  id_ends_with?: InputMaybe<Scalars['ID']>;
  id_gt?: InputMaybe<Scalars['ID']>;
  id_gte?: InputMaybe<Scalars['ID']>;
  id_in?: InputMaybe<Array<Scalars['ID']>>;
  id_lt?: InputMaybe<Scalars['ID']>;
  id_lte?: InputMaybe<Scalars['ID']>;
  id_not?: InputMaybe<Scalars['ID']>;
  id_not_contains?: InputMaybe<Scalars['ID']>;
  id_not_ends_with?: InputMaybe<Scalars['ID']>;
  id_not_in?: InputMaybe<Array<Scalars['ID']>>;
  id_not_starts_with?: InputMaybe<Scalars['ID']>;
  id_starts_with?: InputMaybe<Scalars['ID']>;
  ignored?: InputMaybe<Scalars['Boolean']>;
  ignored_not?: InputMaybe<Scalars['Boolean']>;
};

export type ChallengeRequestUpdateDataInput = {
  challenge?: InputMaybe<ChallengeUpdateOneRequiredWithoutChallengeRequestsInput>;
  exercise?: InputMaybe<ExerciseUpdateOneRequiredWithoutChallengeRequestsInput>;
  ignored?: InputMaybe<Scalars['Boolean']>;
};

export type ChallengeRequestUpdateInput = {
  challenge?: InputMaybe<ChallengeUpdateOneRequiredWithoutChallengeRequestsInput>;
  exercise?: InputMaybe<ExerciseUpdateOneRequiredWithoutChallengeRequestsInput>;
  ignored?: InputMaybe<Scalars['Boolean']>;
};

export type ChallengeRequestUpdateManyDataInput = {
  ignored?: InputMaybe<Scalars['Boolean']>;
};

export type ChallengeRequestUpdateManyMutationInput = {
  ignored?: InputMaybe<Scalars['Boolean']>;
};

export type ChallengeRequestUpdateManyWithWhereNestedInput = {
  data: ChallengeRequestUpdateManyDataInput;
  where: ChallengeRequestScalarWhereInput;
};

export type ChallengeRequestUpdateManyWithoutChallengeInput = {
  connect?: InputMaybe<Array<ChallengeRequestWhereUniqueInput>>;
  create?: InputMaybe<Array<ChallengeRequestCreateWithoutChallengeInput>>;
  delete?: InputMaybe<Array<ChallengeRequestWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<ChallengeRequestScalarWhereInput>>;
  disconnect?: InputMaybe<Array<ChallengeRequestWhereUniqueInput>>;
  set?: InputMaybe<Array<ChallengeRequestWhereUniqueInput>>;
  update?: InputMaybe<
    Array<ChallengeRequestUpdateWithWhereUniqueWithoutChallengeInput>
  >;
  updateMany?: InputMaybe<
    Array<ChallengeRequestUpdateManyWithWhereNestedInput>
  >;
  upsert?: InputMaybe<
    Array<ChallengeRequestUpsertWithWhereUniqueWithoutChallengeInput>
  >;
};

export type ChallengeRequestUpdateManyWithoutExerciseInput = {
  connect?: InputMaybe<Array<ChallengeRequestWhereUniqueInput>>;
  create?: InputMaybe<Array<ChallengeRequestCreateWithoutExerciseInput>>;
  delete?: InputMaybe<Array<ChallengeRequestWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<ChallengeRequestScalarWhereInput>>;
  disconnect?: InputMaybe<Array<ChallengeRequestWhereUniqueInput>>;
  set?: InputMaybe<Array<ChallengeRequestWhereUniqueInput>>;
  update?: InputMaybe<
    Array<ChallengeRequestUpdateWithWhereUniqueWithoutExerciseInput>
  >;
  updateMany?: InputMaybe<
    Array<ChallengeRequestUpdateManyWithWhereNestedInput>
  >;
  upsert?: InputMaybe<
    Array<ChallengeRequestUpsertWithWhereUniqueWithoutExerciseInput>
  >;
};

export type ChallengeRequestUpdateOneRequiredInput = {
  connect?: InputMaybe<ChallengeRequestWhereUniqueInput>;
  create?: InputMaybe<ChallengeRequestCreateInput>;
  update?: InputMaybe<ChallengeRequestUpdateDataInput>;
  upsert?: InputMaybe<ChallengeRequestUpsertNestedInput>;
};

export type ChallengeRequestUpdateWithWhereUniqueWithoutChallengeInput = {
  data: ChallengeRequestUpdateWithoutChallengeDataInput;
  where: ChallengeRequestWhereUniqueInput;
};

export type ChallengeRequestUpdateWithWhereUniqueWithoutExerciseInput = {
  data: ChallengeRequestUpdateWithoutExerciseDataInput;
  where: ChallengeRequestWhereUniqueInput;
};

export type ChallengeRequestUpdateWithoutChallengeDataInput = {
  exercise?: InputMaybe<ExerciseUpdateOneRequiredWithoutChallengeRequestsInput>;
  ignored?: InputMaybe<Scalars['Boolean']>;
};

export type ChallengeRequestUpdateWithoutExerciseDataInput = {
  challenge?: InputMaybe<ChallengeUpdateOneRequiredWithoutChallengeRequestsInput>;
  ignored?: InputMaybe<Scalars['Boolean']>;
};

export type ChallengeRequestUpsertNestedInput = {
  create: ChallengeRequestCreateInput;
  update: ChallengeRequestUpdateDataInput;
};

export type ChallengeRequestUpsertWithWhereUniqueWithoutChallengeInput = {
  create: ChallengeRequestCreateWithoutChallengeInput;
  update: ChallengeRequestUpdateWithoutChallengeDataInput;
  where: ChallengeRequestWhereUniqueInput;
};

export type ChallengeRequestUpsertWithWhereUniqueWithoutExerciseInput = {
  create: ChallengeRequestCreateWithoutExerciseInput;
  update: ChallengeRequestUpdateWithoutExerciseDataInput;
  where: ChallengeRequestWhereUniqueInput;
};

export type ChallengeRequestWhereInput = {
  AND?: InputMaybe<Array<ChallengeRequestWhereInput>>;
  NOT?: InputMaybe<Array<ChallengeRequestWhereInput>>;
  OR?: InputMaybe<Array<ChallengeRequestWhereInput>>;
  challenge?: InputMaybe<ChallengeWhereInput>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  createdAt_gt?: InputMaybe<Scalars['DateTime']>;
  createdAt_gte?: InputMaybe<Scalars['DateTime']>;
  createdAt_in?: InputMaybe<Array<Scalars['DateTime']>>;
  createdAt_lt?: InputMaybe<Scalars['DateTime']>;
  createdAt_lte?: InputMaybe<Scalars['DateTime']>;
  createdAt_not?: InputMaybe<Scalars['DateTime']>;
  createdAt_not_in?: InputMaybe<Array<Scalars['DateTime']>>;
  exercise?: InputMaybe<ExerciseWhereInput>;
  id?: InputMaybe<Scalars['ID']>;
  id_contains?: InputMaybe<Scalars['ID']>;
  id_ends_with?: InputMaybe<Scalars['ID']>;
  id_gt?: InputMaybe<Scalars['ID']>;
  id_gte?: InputMaybe<Scalars['ID']>;
  id_in?: InputMaybe<Array<Scalars['ID']>>;
  id_lt?: InputMaybe<Scalars['ID']>;
  id_lte?: InputMaybe<Scalars['ID']>;
  id_not?: InputMaybe<Scalars['ID']>;
  id_not_contains?: InputMaybe<Scalars['ID']>;
  id_not_ends_with?: InputMaybe<Scalars['ID']>;
  id_not_in?: InputMaybe<Array<Scalars['ID']>>;
  id_not_starts_with?: InputMaybe<Scalars['ID']>;
  id_starts_with?: InputMaybe<Scalars['ID']>;
  ignored?: InputMaybe<Scalars['Boolean']>;
  ignored_not?: InputMaybe<Scalars['Boolean']>;
};

export type ChallengeRequestWhereUniqueInput = {
  id?: InputMaybe<Scalars['ID']>;
};

export type ChallengeResult = {
  accuracy: Scalars['Decimal'];
  challengeRequest: ChallengeRequest;
  charactersPerMinute: Scalars['Decimal'];
  charactersPerMinuteStandard: Scalars['Decimal'];
  createdAt: Scalars['DateTime'];
  cupsEarned?: Maybe<Scalars['Int']>;
  diamondsEarned?: Maybe<Scalars['Int']>;
  /** In seconds */
  durationSinceRequest: Scalars['Int'];
  enteredText: Scalars['String'];
  id: Scalars['ID'];
  passed: Scalars['Boolean'];
  responseTimePerCharacterInMs: ResponseTimePerCharacter;
  startTime: Scalars['DateTime'];
  timeInMs: Scalars['Int'];
  updatedAt: Scalars['DateTime'];
};

export type ChallengeResultConnection = {
  aggregate: AggregateChallengeResult;
  edges: Array<Maybe<ChallengeResultEdge>>;
  pageInfo: PageInfo;
};

export type ChallengeResultCreateInput = {
  challengeRequest: ChallengeRequestWhereUniqueInput;
  enteredText: Scalars['String'];
  responseTimePerCharacterInMs: ResponseTimePerCharacterInput;
  startTime: Scalars['DateTime'];
  timeInMs: Scalars['Int'];
};

export type ChallengeResultCreateManyInput = {
  connect?: InputMaybe<Array<ChallengeResultWhereUniqueInput>>;
  create?: InputMaybe<Array<ChallengeResultCreateInput>>;
};

export type ChallengeResultCreateOneInput = {
  connect?: InputMaybe<ChallengeResultWhereUniqueInput>;
  create?: InputMaybe<ChallengeResultCreateInput>;
};

export type ChallengeResultEdge = {
  cursor: Scalars['String'];
  node: ChallengeResult;
};

export type ChallengeResultOrderByInput =
  | 'accuracy_ASC'
  | 'accuracy_DESC'
  | 'charactersPerMinuteStandard_ASC'
  | 'charactersPerMinuteStandard_DESC'
  | 'charactersPerMinute_ASC'
  | 'charactersPerMinute_DESC'
  | 'createdAt_ASC'
  | 'createdAt_DESC'
  | 'cupsEarned_ASC'
  | 'cupsEarned_DESC'
  | 'diamondsEarned_ASC'
  | 'diamondsEarned_DESC'
  | 'durationSinceRequest_ASC'
  | 'durationSinceRequest_DESC'
  | 'enteredText_ASC'
  | 'enteredText_DESC'
  | 'id_ASC'
  | 'id_DESC'
  | 'passed_ASC'
  | 'passed_DESC'
  | 'responseTimePerCharacterInMs_ASC'
  | 'responseTimePerCharacterInMs_DESC'
  | 'startTime_ASC'
  | 'startTime_DESC'
  | 'timeInMs_ASC'
  | 'timeInMs_DESC'
  | 'updatedAt_ASC'
  | 'updatedAt_DESC';

export type ChallengeResultScalarWhereInput = {
  AND?: InputMaybe<Array<ChallengeResultScalarWhereInput>>;
  NOT?: InputMaybe<Array<ChallengeResultScalarWhereInput>>;
  OR?: InputMaybe<Array<ChallengeResultScalarWhereInput>>;
  accuracy?: InputMaybe<Scalars['Decimal']>;
  accuracy_gt?: InputMaybe<Scalars['Decimal']>;
  accuracy_gte?: InputMaybe<Scalars['Decimal']>;
  accuracy_in?: InputMaybe<Array<Scalars['Decimal']>>;
  accuracy_lt?: InputMaybe<Scalars['Decimal']>;
  accuracy_lte?: InputMaybe<Scalars['Decimal']>;
  accuracy_not?: InputMaybe<Scalars['Decimal']>;
  accuracy_not_in?: InputMaybe<Array<Scalars['Decimal']>>;
  charactersPerMinute?: InputMaybe<Scalars['Decimal']>;
  charactersPerMinuteStandard?: InputMaybe<Scalars['Decimal']>;
  charactersPerMinuteStandard_gt?: InputMaybe<Scalars['Decimal']>;
  charactersPerMinuteStandard_gte?: InputMaybe<Scalars['Decimal']>;
  charactersPerMinuteStandard_in?: InputMaybe<Array<Scalars['Decimal']>>;
  charactersPerMinuteStandard_lt?: InputMaybe<Scalars['Decimal']>;
  charactersPerMinuteStandard_lte?: InputMaybe<Scalars['Decimal']>;
  charactersPerMinuteStandard_not?: InputMaybe<Scalars['Decimal']>;
  charactersPerMinuteStandard_not_in?: InputMaybe<Array<Scalars['Decimal']>>;
  charactersPerMinute_gt?: InputMaybe<Scalars['Decimal']>;
  charactersPerMinute_gte?: InputMaybe<Scalars['Decimal']>;
  charactersPerMinute_in?: InputMaybe<Array<Scalars['Decimal']>>;
  charactersPerMinute_lt?: InputMaybe<Scalars['Decimal']>;
  charactersPerMinute_lte?: InputMaybe<Scalars['Decimal']>;
  charactersPerMinute_not?: InputMaybe<Scalars['Decimal']>;
  charactersPerMinute_not_in?: InputMaybe<Array<Scalars['Decimal']>>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  createdAt_gt?: InputMaybe<Scalars['DateTime']>;
  createdAt_gte?: InputMaybe<Scalars['DateTime']>;
  createdAt_in?: InputMaybe<Array<Scalars['DateTime']>>;
  createdAt_lt?: InputMaybe<Scalars['DateTime']>;
  createdAt_lte?: InputMaybe<Scalars['DateTime']>;
  createdAt_not?: InputMaybe<Scalars['DateTime']>;
  createdAt_not_in?: InputMaybe<Array<Scalars['DateTime']>>;
  cupsEarned?: InputMaybe<Scalars['Int']>;
  cupsEarned_gt?: InputMaybe<Scalars['Int']>;
  cupsEarned_gte?: InputMaybe<Scalars['Int']>;
  cupsEarned_in?: InputMaybe<Array<Scalars['Int']>>;
  cupsEarned_lt?: InputMaybe<Scalars['Int']>;
  cupsEarned_lte?: InputMaybe<Scalars['Int']>;
  cupsEarned_not?: InputMaybe<Scalars['Int']>;
  cupsEarned_not_in?: InputMaybe<Array<Scalars['Int']>>;
  diamondsEarned?: InputMaybe<Scalars['Int']>;
  diamondsEarned_gt?: InputMaybe<Scalars['Int']>;
  diamondsEarned_gte?: InputMaybe<Scalars['Int']>;
  diamondsEarned_in?: InputMaybe<Array<Scalars['Int']>>;
  diamondsEarned_lt?: InputMaybe<Scalars['Int']>;
  diamondsEarned_lte?: InputMaybe<Scalars['Int']>;
  diamondsEarned_not?: InputMaybe<Scalars['Int']>;
  diamondsEarned_not_in?: InputMaybe<Array<Scalars['Int']>>;
  durationSinceRequest?: InputMaybe<Scalars['Int']>;
  durationSinceRequest_gt?: InputMaybe<Scalars['Int']>;
  durationSinceRequest_gte?: InputMaybe<Scalars['Int']>;
  durationSinceRequest_in?: InputMaybe<Array<Scalars['Int']>>;
  durationSinceRequest_lt?: InputMaybe<Scalars['Int']>;
  durationSinceRequest_lte?: InputMaybe<Scalars['Int']>;
  durationSinceRequest_not?: InputMaybe<Scalars['Int']>;
  durationSinceRequest_not_in?: InputMaybe<Array<Scalars['Int']>>;
  enteredText?: InputMaybe<Scalars['String']>;
  enteredText_contains?: InputMaybe<Scalars['String']>;
  enteredText_ends_with?: InputMaybe<Scalars['String']>;
  enteredText_gt?: InputMaybe<Scalars['String']>;
  enteredText_gte?: InputMaybe<Scalars['String']>;
  enteredText_in?: InputMaybe<Array<Scalars['String']>>;
  enteredText_lt?: InputMaybe<Scalars['String']>;
  enteredText_lte?: InputMaybe<Scalars['String']>;
  enteredText_not?: InputMaybe<Scalars['String']>;
  enteredText_not_contains?: InputMaybe<Scalars['String']>;
  enteredText_not_ends_with?: InputMaybe<Scalars['String']>;
  enteredText_not_in?: InputMaybe<Array<Scalars['String']>>;
  enteredText_not_starts_with?: InputMaybe<Scalars['String']>;
  enteredText_starts_with?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['ID']>;
  id_contains?: InputMaybe<Scalars['ID']>;
  id_ends_with?: InputMaybe<Scalars['ID']>;
  id_gt?: InputMaybe<Scalars['ID']>;
  id_gte?: InputMaybe<Scalars['ID']>;
  id_in?: InputMaybe<Array<Scalars['ID']>>;
  id_lt?: InputMaybe<Scalars['ID']>;
  id_lte?: InputMaybe<Scalars['ID']>;
  id_not?: InputMaybe<Scalars['ID']>;
  id_not_contains?: InputMaybe<Scalars['ID']>;
  id_not_ends_with?: InputMaybe<Scalars['ID']>;
  id_not_in?: InputMaybe<Array<Scalars['ID']>>;
  id_not_starts_with?: InputMaybe<Scalars['ID']>;
  id_starts_with?: InputMaybe<Scalars['ID']>;
  passed?: InputMaybe<Scalars['Boolean']>;
  passed_not?: InputMaybe<Scalars['Boolean']>;
  startTime?: InputMaybe<Scalars['DateTime']>;
  startTime_gt?: InputMaybe<Scalars['DateTime']>;
  startTime_gte?: InputMaybe<Scalars['DateTime']>;
  startTime_in?: InputMaybe<Array<Scalars['DateTime']>>;
  startTime_lt?: InputMaybe<Scalars['DateTime']>;
  startTime_lte?: InputMaybe<Scalars['DateTime']>;
  startTime_not?: InputMaybe<Scalars['DateTime']>;
  startTime_not_in?: InputMaybe<Array<Scalars['DateTime']>>;
  timeInMs?: InputMaybe<Scalars['Int']>;
  timeInMs_gt?: InputMaybe<Scalars['Int']>;
  timeInMs_gte?: InputMaybe<Scalars['Int']>;
  timeInMs_in?: InputMaybe<Array<Scalars['Int']>>;
  timeInMs_lt?: InputMaybe<Scalars['Int']>;
  timeInMs_lte?: InputMaybe<Scalars['Int']>;
  timeInMs_not?: InputMaybe<Scalars['Int']>;
  timeInMs_not_in?: InputMaybe<Array<Scalars['Int']>>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
  updatedAt_gt?: InputMaybe<Scalars['DateTime']>;
  updatedAt_gte?: InputMaybe<Scalars['DateTime']>;
  updatedAt_in?: InputMaybe<Array<Scalars['DateTime']>>;
  updatedAt_lt?: InputMaybe<Scalars['DateTime']>;
  updatedAt_lte?: InputMaybe<Scalars['DateTime']>;
  updatedAt_not?: InputMaybe<Scalars['DateTime']>;
  updatedAt_not_in?: InputMaybe<Array<Scalars['DateTime']>>;
};

export type ChallengeResultUpdateDataInput = {
  accuracy?: InputMaybe<Scalars['Decimal']>;
  challengeRequest?: InputMaybe<ChallengeRequestUpdateOneRequiredInput>;
  charactersPerMinute?: InputMaybe<Scalars['Decimal']>;
  charactersPerMinuteStandard?: InputMaybe<Scalars['Decimal']>;
  cupsEarned?: InputMaybe<Scalars['Int']>;
  diamondsEarned?: InputMaybe<Scalars['Int']>;
  durationSinceRequest?: InputMaybe<Scalars['Int']>;
  enteredText?: InputMaybe<Scalars['String']>;
  level?: InputMaybe<LevelUpdateOneRequiredInput>;
  passed?: InputMaybe<Scalars['Boolean']>;
  responseTimePerCharacterInMs?: InputMaybe<Scalars['Json']>;
  startTime?: InputMaybe<Scalars['DateTime']>;
  timeInMs?: InputMaybe<Scalars['Int']>;
  user?: InputMaybe<GameUserUpdateOneRequiredInput>;
};

export type ChallengeResultUpdateInput = {
  accuracy?: InputMaybe<Scalars['Decimal']>;
  challengeRequest?: InputMaybe<ChallengeRequestUpdateOneRequiredInput>;
  charactersPerMinute?: InputMaybe<Scalars['Decimal']>;
  charactersPerMinuteStandard?: InputMaybe<Scalars['Decimal']>;
  cupsEarned?: InputMaybe<Scalars['Int']>;
  diamondsEarned?: InputMaybe<Scalars['Int']>;
  durationSinceRequest?: InputMaybe<Scalars['Int']>;
  enteredText?: InputMaybe<Scalars['String']>;
  level?: InputMaybe<LevelUpdateOneRequiredInput>;
  passed?: InputMaybe<Scalars['Boolean']>;
  responseTimePerCharacterInMs?: InputMaybe<Scalars['Json']>;
  startTime?: InputMaybe<Scalars['DateTime']>;
  timeInMs?: InputMaybe<Scalars['Int']>;
  user?: InputMaybe<GameUserUpdateOneRequiredInput>;
};

export type ChallengeResultUpdateManyDataInput = {
  accuracy?: InputMaybe<Scalars['Decimal']>;
  charactersPerMinute?: InputMaybe<Scalars['Decimal']>;
  charactersPerMinuteStandard?: InputMaybe<Scalars['Decimal']>;
  cupsEarned?: InputMaybe<Scalars['Int']>;
  diamondsEarned?: InputMaybe<Scalars['Int']>;
  durationSinceRequest?: InputMaybe<Scalars['Int']>;
  enteredText?: InputMaybe<Scalars['String']>;
  passed?: InputMaybe<Scalars['Boolean']>;
  responseTimePerCharacterInMs?: InputMaybe<Scalars['Json']>;
  startTime?: InputMaybe<Scalars['DateTime']>;
  timeInMs?: InputMaybe<Scalars['Int']>;
};

export type ChallengeResultUpdateManyInput = {
  connect?: InputMaybe<Array<ChallengeResultWhereUniqueInput>>;
  create?: InputMaybe<Array<ChallengeResultCreateInput>>;
  delete?: InputMaybe<Array<ChallengeResultWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<ChallengeResultScalarWhereInput>>;
  disconnect?: InputMaybe<Array<ChallengeResultWhereUniqueInput>>;
  set?: InputMaybe<Array<ChallengeResultWhereUniqueInput>>;
  update?: InputMaybe<Array<ChallengeResultUpdateWithWhereUniqueNestedInput>>;
  updateMany?: InputMaybe<Array<ChallengeResultUpdateManyWithWhereNestedInput>>;
  upsert?: InputMaybe<Array<ChallengeResultUpsertWithWhereUniqueNestedInput>>;
};

export type ChallengeResultUpdateManyMutationInput = {
  accuracy?: InputMaybe<Scalars['Decimal']>;
  charactersPerMinute?: InputMaybe<Scalars['Decimal']>;
  charactersPerMinuteStandard?: InputMaybe<Scalars['Decimal']>;
  cupsEarned?: InputMaybe<Scalars['Int']>;
  diamondsEarned?: InputMaybe<Scalars['Int']>;
  durationSinceRequest?: InputMaybe<Scalars['Int']>;
  enteredText?: InputMaybe<Scalars['String']>;
  passed?: InputMaybe<Scalars['Boolean']>;
  responseTimePerCharacterInMs?: InputMaybe<Scalars['Json']>;
  startTime?: InputMaybe<Scalars['DateTime']>;
  timeInMs?: InputMaybe<Scalars['Int']>;
};

export type ChallengeResultUpdateManyWithWhereNestedInput = {
  data: ChallengeResultUpdateManyDataInput;
  where: ChallengeResultScalarWhereInput;
};

export type ChallengeResultUpdateOneInput = {
  connect?: InputMaybe<ChallengeResultWhereUniqueInput>;
  create?: InputMaybe<ChallengeResultCreateInput>;
  delete?: InputMaybe<Scalars['Boolean']>;
  disconnect?: InputMaybe<Scalars['Boolean']>;
  update?: InputMaybe<ChallengeResultUpdateDataInput>;
  upsert?: InputMaybe<ChallengeResultUpsertNestedInput>;
};

export type ChallengeResultUpdateWithWhereUniqueNestedInput = {
  data: ChallengeResultUpdateDataInput;
  where: ChallengeResultWhereUniqueInput;
};

export type ChallengeResultUpsertNestedInput = {
  create: ChallengeResultCreateInput;
  update: ChallengeResultUpdateDataInput;
};

export type ChallengeResultUpsertWithWhereUniqueNestedInput = {
  create: ChallengeResultCreateInput;
  update: ChallengeResultUpdateDataInput;
  where: ChallengeResultWhereUniqueInput;
};

export type ChallengeResultWhereInput = {
  AND?: InputMaybe<Array<ChallengeResultWhereInput>>;
  NOT?: InputMaybe<Array<ChallengeResultWhereInput>>;
  OR?: InputMaybe<Array<ChallengeResultWhereInput>>;
  accuracy?: InputMaybe<Scalars['Decimal']>;
  accuracy_gt?: InputMaybe<Scalars['Decimal']>;
  accuracy_gte?: InputMaybe<Scalars['Decimal']>;
  accuracy_in?: InputMaybe<Array<Scalars['Decimal']>>;
  accuracy_lt?: InputMaybe<Scalars['Decimal']>;
  accuracy_lte?: InputMaybe<Scalars['Decimal']>;
  accuracy_not?: InputMaybe<Scalars['Decimal']>;
  accuracy_not_in?: InputMaybe<Array<Scalars['Decimal']>>;
  challengeRequest?: InputMaybe<ChallengeRequestWhereInput>;
  charactersPerMinute?: InputMaybe<Scalars['Decimal']>;
  charactersPerMinuteStandard?: InputMaybe<Scalars['Decimal']>;
  charactersPerMinuteStandard_gt?: InputMaybe<Scalars['Decimal']>;
  charactersPerMinuteStandard_gte?: InputMaybe<Scalars['Decimal']>;
  charactersPerMinuteStandard_in?: InputMaybe<Array<Scalars['Decimal']>>;
  charactersPerMinuteStandard_lt?: InputMaybe<Scalars['Decimal']>;
  charactersPerMinuteStandard_lte?: InputMaybe<Scalars['Decimal']>;
  charactersPerMinuteStandard_not?: InputMaybe<Scalars['Decimal']>;
  charactersPerMinuteStandard_not_in?: InputMaybe<Array<Scalars['Decimal']>>;
  charactersPerMinute_gt?: InputMaybe<Scalars['Decimal']>;
  charactersPerMinute_gte?: InputMaybe<Scalars['Decimal']>;
  charactersPerMinute_in?: InputMaybe<Array<Scalars['Decimal']>>;
  charactersPerMinute_lt?: InputMaybe<Scalars['Decimal']>;
  charactersPerMinute_lte?: InputMaybe<Scalars['Decimal']>;
  charactersPerMinute_not?: InputMaybe<Scalars['Decimal']>;
  charactersPerMinute_not_in?: InputMaybe<Array<Scalars['Decimal']>>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  createdAt_gt?: InputMaybe<Scalars['DateTime']>;
  createdAt_gte?: InputMaybe<Scalars['DateTime']>;
  createdAt_in?: InputMaybe<Array<Scalars['DateTime']>>;
  createdAt_lt?: InputMaybe<Scalars['DateTime']>;
  createdAt_lte?: InputMaybe<Scalars['DateTime']>;
  createdAt_not?: InputMaybe<Scalars['DateTime']>;
  createdAt_not_in?: InputMaybe<Array<Scalars['DateTime']>>;
  cupsEarned?: InputMaybe<Scalars['Int']>;
  cupsEarned_gt?: InputMaybe<Scalars['Int']>;
  cupsEarned_gte?: InputMaybe<Scalars['Int']>;
  cupsEarned_in?: InputMaybe<Array<Scalars['Int']>>;
  cupsEarned_lt?: InputMaybe<Scalars['Int']>;
  cupsEarned_lte?: InputMaybe<Scalars['Int']>;
  cupsEarned_not?: InputMaybe<Scalars['Int']>;
  cupsEarned_not_in?: InputMaybe<Array<Scalars['Int']>>;
  diamondsEarned?: InputMaybe<Scalars['Int']>;
  diamondsEarned_gt?: InputMaybe<Scalars['Int']>;
  diamondsEarned_gte?: InputMaybe<Scalars['Int']>;
  diamondsEarned_in?: InputMaybe<Array<Scalars['Int']>>;
  diamondsEarned_lt?: InputMaybe<Scalars['Int']>;
  diamondsEarned_lte?: InputMaybe<Scalars['Int']>;
  diamondsEarned_not?: InputMaybe<Scalars['Int']>;
  diamondsEarned_not_in?: InputMaybe<Array<Scalars['Int']>>;
  durationSinceRequest?: InputMaybe<Scalars['Int']>;
  durationSinceRequest_gt?: InputMaybe<Scalars['Int']>;
  durationSinceRequest_gte?: InputMaybe<Scalars['Int']>;
  durationSinceRequest_in?: InputMaybe<Array<Scalars['Int']>>;
  durationSinceRequest_lt?: InputMaybe<Scalars['Int']>;
  durationSinceRequest_lte?: InputMaybe<Scalars['Int']>;
  durationSinceRequest_not?: InputMaybe<Scalars['Int']>;
  durationSinceRequest_not_in?: InputMaybe<Array<Scalars['Int']>>;
  enteredText?: InputMaybe<Scalars['String']>;
  enteredText_contains?: InputMaybe<Scalars['String']>;
  enteredText_ends_with?: InputMaybe<Scalars['String']>;
  enteredText_gt?: InputMaybe<Scalars['String']>;
  enteredText_gte?: InputMaybe<Scalars['String']>;
  enteredText_in?: InputMaybe<Array<Scalars['String']>>;
  enteredText_lt?: InputMaybe<Scalars['String']>;
  enteredText_lte?: InputMaybe<Scalars['String']>;
  enteredText_not?: InputMaybe<Scalars['String']>;
  enteredText_not_contains?: InputMaybe<Scalars['String']>;
  enteredText_not_ends_with?: InputMaybe<Scalars['String']>;
  enteredText_not_in?: InputMaybe<Array<Scalars['String']>>;
  enteredText_not_starts_with?: InputMaybe<Scalars['String']>;
  enteredText_starts_with?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['ID']>;
  id_contains?: InputMaybe<Scalars['ID']>;
  id_ends_with?: InputMaybe<Scalars['ID']>;
  id_gt?: InputMaybe<Scalars['ID']>;
  id_gte?: InputMaybe<Scalars['ID']>;
  id_in?: InputMaybe<Array<Scalars['ID']>>;
  id_lt?: InputMaybe<Scalars['ID']>;
  id_lte?: InputMaybe<Scalars['ID']>;
  id_not?: InputMaybe<Scalars['ID']>;
  id_not_contains?: InputMaybe<Scalars['ID']>;
  id_not_ends_with?: InputMaybe<Scalars['ID']>;
  id_not_in?: InputMaybe<Array<Scalars['ID']>>;
  id_not_starts_with?: InputMaybe<Scalars['ID']>;
  id_starts_with?: InputMaybe<Scalars['ID']>;
  level?: InputMaybe<LevelWhereInput>;
  passed?: InputMaybe<Scalars['Boolean']>;
  passed_not?: InputMaybe<Scalars['Boolean']>;
  startTime?: InputMaybe<Scalars['DateTime']>;
  startTime_gt?: InputMaybe<Scalars['DateTime']>;
  startTime_gte?: InputMaybe<Scalars['DateTime']>;
  startTime_in?: InputMaybe<Array<Scalars['DateTime']>>;
  startTime_lt?: InputMaybe<Scalars['DateTime']>;
  startTime_lte?: InputMaybe<Scalars['DateTime']>;
  startTime_not?: InputMaybe<Scalars['DateTime']>;
  startTime_not_in?: InputMaybe<Array<Scalars['DateTime']>>;
  timeInMs?: InputMaybe<Scalars['Int']>;
  timeInMs_gt?: InputMaybe<Scalars['Int']>;
  timeInMs_gte?: InputMaybe<Scalars['Int']>;
  timeInMs_in?: InputMaybe<Array<Scalars['Int']>>;
  timeInMs_lt?: InputMaybe<Scalars['Int']>;
  timeInMs_lte?: InputMaybe<Scalars['Int']>;
  timeInMs_not?: InputMaybe<Scalars['Int']>;
  timeInMs_not_in?: InputMaybe<Array<Scalars['Int']>>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
  updatedAt_gt?: InputMaybe<Scalars['DateTime']>;
  updatedAt_gte?: InputMaybe<Scalars['DateTime']>;
  updatedAt_in?: InputMaybe<Array<Scalars['DateTime']>>;
  updatedAt_lt?: InputMaybe<Scalars['DateTime']>;
  updatedAt_lte?: InputMaybe<Scalars['DateTime']>;
  updatedAt_not?: InputMaybe<Scalars['DateTime']>;
  updatedAt_not_in?: InputMaybe<Array<Scalars['DateTime']>>;
  user?: InputMaybe<GameUserWhereInput>;
};

export type ChallengeResultWhereUniqueInput = {
  id?: InputMaybe<Scalars['ID']>;
};

export type ChallengeScalarWhereInput = {
  AND?: InputMaybe<Array<ChallengeScalarWhereInput>>;
  NOT?: InputMaybe<Array<ChallengeScalarWhereInput>>;
  OR?: InputMaybe<Array<ChallengeScalarWhereInput>>;
  averageAccuracy?: InputMaybe<Scalars['Decimal']>;
  averageAccuracy_gt?: InputMaybe<Scalars['Decimal']>;
  averageAccuracy_gte?: InputMaybe<Scalars['Decimal']>;
  averageAccuracy_in?: InputMaybe<Array<Scalars['Decimal']>>;
  averageAccuracy_lt?: InputMaybe<Scalars['Decimal']>;
  averageAccuracy_lte?: InputMaybe<Scalars['Decimal']>;
  averageAccuracy_not?: InputMaybe<Scalars['Decimal']>;
  averageAccuracy_not_in?: InputMaybe<Array<Scalars['Decimal']>>;
  averageCharactersPerMinute?: InputMaybe<Scalars['Decimal']>;
  averageCharactersPerMinute_gt?: InputMaybe<Scalars['Decimal']>;
  averageCharactersPerMinute_gte?: InputMaybe<Scalars['Decimal']>;
  averageCharactersPerMinute_in?: InputMaybe<Array<Scalars['Decimal']>>;
  averageCharactersPerMinute_lt?: InputMaybe<Scalars['Decimal']>;
  averageCharactersPerMinute_lte?: InputMaybe<Scalars['Decimal']>;
  averageCharactersPerMinute_not?: InputMaybe<Scalars['Decimal']>;
  averageCharactersPerMinute_not_in?: InputMaybe<Array<Scalars['Decimal']>>;
  correctAnswer?: InputMaybe<Scalars['String']>;
  correctAnswer_contains?: InputMaybe<Scalars['String']>;
  correctAnswer_ends_with?: InputMaybe<Scalars['String']>;
  correctAnswer_gt?: InputMaybe<Scalars['String']>;
  correctAnswer_gte?: InputMaybe<Scalars['String']>;
  correctAnswer_in?: InputMaybe<Array<Scalars['String']>>;
  correctAnswer_lt?: InputMaybe<Scalars['String']>;
  correctAnswer_lte?: InputMaybe<Scalars['String']>;
  correctAnswer_not?: InputMaybe<Scalars['String']>;
  correctAnswer_not_contains?: InputMaybe<Scalars['String']>;
  correctAnswer_not_ends_with?: InputMaybe<Scalars['String']>;
  correctAnswer_not_in?: InputMaybe<Array<Scalars['String']>>;
  correctAnswer_not_starts_with?: InputMaybe<Scalars['String']>;
  correctAnswer_starts_with?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['ID']>;
  id_contains?: InputMaybe<Scalars['ID']>;
  id_ends_with?: InputMaybe<Scalars['ID']>;
  id_gt?: InputMaybe<Scalars['ID']>;
  id_gte?: InputMaybe<Scalars['ID']>;
  id_in?: InputMaybe<Array<Scalars['ID']>>;
  id_lt?: InputMaybe<Scalars['ID']>;
  id_lte?: InputMaybe<Scalars['ID']>;
  id_not?: InputMaybe<Scalars['ID']>;
  id_not_contains?: InputMaybe<Scalars['ID']>;
  id_not_ends_with?: InputMaybe<Scalars['ID']>;
  id_not_in?: InputMaybe<Array<Scalars['ID']>>;
  id_not_starts_with?: InputMaybe<Scalars['ID']>;
  id_starts_with?: InputMaybe<Scalars['ID']>;
  skill?: InputMaybe<Scalars['Decimal']>;
  skill_gt?: InputMaybe<Scalars['Decimal']>;
  skill_gte?: InputMaybe<Scalars['Decimal']>;
  skill_in?: InputMaybe<Array<Scalars['Decimal']>>;
  skill_lt?: InputMaybe<Scalars['Decimal']>;
  skill_lte?: InputMaybe<Scalars['Decimal']>;
  skill_not?: InputMaybe<Scalars['Decimal']>;
  skill_not_in?: InputMaybe<Array<Scalars['Decimal']>>;
  text?: InputMaybe<Scalars['String']>;
  text_contains?: InputMaybe<Scalars['String']>;
  text_ends_with?: InputMaybe<Scalars['String']>;
  text_gt?: InputMaybe<Scalars['String']>;
  text_gte?: InputMaybe<Scalars['String']>;
  text_in?: InputMaybe<Array<Scalars['String']>>;
  text_lt?: InputMaybe<Scalars['String']>;
  text_lte?: InputMaybe<Scalars['String']>;
  text_not?: InputMaybe<Scalars['String']>;
  text_not_contains?: InputMaybe<Scalars['String']>;
  text_not_ends_with?: InputMaybe<Scalars['String']>;
  text_not_in?: InputMaybe<Array<Scalars['String']>>;
  text_not_starts_with?: InputMaybe<Scalars['String']>;
  text_starts_with?: InputMaybe<Scalars['String']>;
};

export type ChallengeUpdateInput = {
  averageAccuracy?: InputMaybe<Scalars['Decimal']>;
  averageCharactersPerMinute?: InputMaybe<Scalars['Decimal']>;
  challengeRequests?: InputMaybe<ChallengeRequestUpdateManyWithoutChallengeInput>;
  correctAnswer?: InputMaybe<Scalars['String']>;
  level?: InputMaybe<LevelUpdateOneRequiredWithoutChallengesInput>;
  skill?: InputMaybe<Scalars['Decimal']>;
  skillCourse?: InputMaybe<SkillCourseUpdateManyWithoutChallengeInput>;
  text?: InputMaybe<Scalars['String']>;
};

export type ChallengeUpdateManyDataInput = {
  averageAccuracy?: InputMaybe<Scalars['Decimal']>;
  averageCharactersPerMinute?: InputMaybe<Scalars['Decimal']>;
  correctAnswer?: InputMaybe<Scalars['String']>;
  skill?: InputMaybe<Scalars['Decimal']>;
  text?: InputMaybe<Scalars['String']>;
};

export type ChallengeUpdateManyMutationInput = {
  averageAccuracy?: InputMaybe<Scalars['Decimal']>;
  averageCharactersPerMinute?: InputMaybe<Scalars['Decimal']>;
  correctAnswer?: InputMaybe<Scalars['String']>;
  skill?: InputMaybe<Scalars['Decimal']>;
  text?: InputMaybe<Scalars['String']>;
};

export type ChallengeUpdateManyWithWhereNestedInput = {
  data: ChallengeUpdateManyDataInput;
  where: ChallengeScalarWhereInput;
};

export type ChallengeUpdateManyWithoutLevelInput = {
  connect?: InputMaybe<Array<ChallengeWhereUniqueInput>>;
  create?: InputMaybe<Array<ChallengeCreateWithoutLevelInput>>;
  delete?: InputMaybe<Array<ChallengeWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<ChallengeScalarWhereInput>>;
  disconnect?: InputMaybe<Array<ChallengeWhereUniqueInput>>;
  set?: InputMaybe<Array<ChallengeWhereUniqueInput>>;
  update?: InputMaybe<Array<ChallengeUpdateWithWhereUniqueWithoutLevelInput>>;
  updateMany?: InputMaybe<Array<ChallengeUpdateManyWithWhereNestedInput>>;
  upsert?: InputMaybe<Array<ChallengeUpsertWithWhereUniqueWithoutLevelInput>>;
};

export type ChallengeUpdateOneRequiredWithoutChallengeRequestsInput = {
  connect?: InputMaybe<ChallengeWhereUniqueInput>;
  create?: InputMaybe<ChallengeCreateWithoutChallengeRequestsInput>;
  update?: InputMaybe<ChallengeUpdateWithoutChallengeRequestsDataInput>;
  upsert?: InputMaybe<ChallengeUpsertWithoutChallengeRequestsInput>;
};

export type ChallengeUpdateOneWithoutSkillCourseInput = {
  connect?: InputMaybe<ChallengeWhereUniqueInput>;
  create?: InputMaybe<ChallengeCreateWithoutSkillCourseInput>;
  delete?: InputMaybe<Scalars['Boolean']>;
  disconnect?: InputMaybe<Scalars['Boolean']>;
  update?: InputMaybe<ChallengeUpdateWithoutSkillCourseDataInput>;
  upsert?: InputMaybe<ChallengeUpsertWithoutSkillCourseInput>;
};

export type ChallengeUpdateWithWhereUniqueWithoutLevelInput = {
  data: ChallengeUpdateWithoutLevelDataInput;
  where: ChallengeWhereUniqueInput;
};

export type ChallengeUpdateWithoutChallengeRequestsDataInput = {
  averageAccuracy?: InputMaybe<Scalars['Decimal']>;
  averageCharactersPerMinute?: InputMaybe<Scalars['Decimal']>;
  correctAnswer?: InputMaybe<Scalars['String']>;
  level?: InputMaybe<LevelUpdateOneRequiredWithoutChallengesInput>;
  skill?: InputMaybe<Scalars['Decimal']>;
  skillCourse?: InputMaybe<SkillCourseUpdateManyWithoutChallengeInput>;
  text?: InputMaybe<Scalars['String']>;
};

export type ChallengeUpdateWithoutLevelDataInput = {
  averageAccuracy?: InputMaybe<Scalars['Decimal']>;
  averageCharactersPerMinute?: InputMaybe<Scalars['Decimal']>;
  challengeRequests?: InputMaybe<ChallengeRequestUpdateManyWithoutChallengeInput>;
  correctAnswer?: InputMaybe<Scalars['String']>;
  skill?: InputMaybe<Scalars['Decimal']>;
  skillCourse?: InputMaybe<SkillCourseUpdateManyWithoutChallengeInput>;
  text?: InputMaybe<Scalars['String']>;
};

export type ChallengeUpdateWithoutSkillCourseDataInput = {
  averageAccuracy?: InputMaybe<Scalars['Decimal']>;
  averageCharactersPerMinute?: InputMaybe<Scalars['Decimal']>;
  challengeRequests?: InputMaybe<ChallengeRequestUpdateManyWithoutChallengeInput>;
  correctAnswer?: InputMaybe<Scalars['String']>;
  level?: InputMaybe<LevelUpdateOneRequiredWithoutChallengesInput>;
  skill?: InputMaybe<Scalars['Decimal']>;
  text?: InputMaybe<Scalars['String']>;
};

export type ChallengeUpsertWithWhereUniqueWithoutLevelInput = {
  create: ChallengeCreateWithoutLevelInput;
  update: ChallengeUpdateWithoutLevelDataInput;
  where: ChallengeWhereUniqueInput;
};

export type ChallengeUpsertWithoutChallengeRequestsInput = {
  create: ChallengeCreateWithoutChallengeRequestsInput;
  update: ChallengeUpdateWithoutChallengeRequestsDataInput;
};

export type ChallengeUpsertWithoutSkillCourseInput = {
  create: ChallengeCreateWithoutSkillCourseInput;
  update: ChallengeUpdateWithoutSkillCourseDataInput;
};

export type ChallengeWhereInput = {
  AND?: InputMaybe<Array<ChallengeWhereInput>>;
  NOT?: InputMaybe<Array<ChallengeWhereInput>>;
  OR?: InputMaybe<Array<ChallengeWhereInput>>;
  averageAccuracy?: InputMaybe<Scalars['Decimal']>;
  averageAccuracy_gt?: InputMaybe<Scalars['Decimal']>;
  averageAccuracy_gte?: InputMaybe<Scalars['Decimal']>;
  averageAccuracy_in?: InputMaybe<Array<Scalars['Decimal']>>;
  averageAccuracy_lt?: InputMaybe<Scalars['Decimal']>;
  averageAccuracy_lte?: InputMaybe<Scalars['Decimal']>;
  averageAccuracy_not?: InputMaybe<Scalars['Decimal']>;
  averageAccuracy_not_in?: InputMaybe<Array<Scalars['Decimal']>>;
  averageCharactersPerMinute?: InputMaybe<Scalars['Decimal']>;
  averageCharactersPerMinute_gt?: InputMaybe<Scalars['Decimal']>;
  averageCharactersPerMinute_gte?: InputMaybe<Scalars['Decimal']>;
  averageCharactersPerMinute_in?: InputMaybe<Array<Scalars['Decimal']>>;
  averageCharactersPerMinute_lt?: InputMaybe<Scalars['Decimal']>;
  averageCharactersPerMinute_lte?: InputMaybe<Scalars['Decimal']>;
  averageCharactersPerMinute_not?: InputMaybe<Scalars['Decimal']>;
  averageCharactersPerMinute_not_in?: InputMaybe<Array<Scalars['Decimal']>>;
  challengeRequests_every?: InputMaybe<ChallengeRequestWhereInput>;
  challengeRequests_none?: InputMaybe<ChallengeRequestWhereInput>;
  challengeRequests_some?: InputMaybe<ChallengeRequestWhereInput>;
  correctAnswer?: InputMaybe<Scalars['String']>;
  correctAnswer_contains?: InputMaybe<Scalars['String']>;
  correctAnswer_ends_with?: InputMaybe<Scalars['String']>;
  correctAnswer_gt?: InputMaybe<Scalars['String']>;
  correctAnswer_gte?: InputMaybe<Scalars['String']>;
  correctAnswer_in?: InputMaybe<Array<Scalars['String']>>;
  correctAnswer_lt?: InputMaybe<Scalars['String']>;
  correctAnswer_lte?: InputMaybe<Scalars['String']>;
  correctAnswer_not?: InputMaybe<Scalars['String']>;
  correctAnswer_not_contains?: InputMaybe<Scalars['String']>;
  correctAnswer_not_ends_with?: InputMaybe<Scalars['String']>;
  correctAnswer_not_in?: InputMaybe<Array<Scalars['String']>>;
  correctAnswer_not_starts_with?: InputMaybe<Scalars['String']>;
  correctAnswer_starts_with?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['ID']>;
  id_contains?: InputMaybe<Scalars['ID']>;
  id_ends_with?: InputMaybe<Scalars['ID']>;
  id_gt?: InputMaybe<Scalars['ID']>;
  id_gte?: InputMaybe<Scalars['ID']>;
  id_in?: InputMaybe<Array<Scalars['ID']>>;
  id_lt?: InputMaybe<Scalars['ID']>;
  id_lte?: InputMaybe<Scalars['ID']>;
  id_not?: InputMaybe<Scalars['ID']>;
  id_not_contains?: InputMaybe<Scalars['ID']>;
  id_not_ends_with?: InputMaybe<Scalars['ID']>;
  id_not_in?: InputMaybe<Array<Scalars['ID']>>;
  id_not_starts_with?: InputMaybe<Scalars['ID']>;
  id_starts_with?: InputMaybe<Scalars['ID']>;
  level?: InputMaybe<LevelWhereInput>;
  skill?: InputMaybe<Scalars['Decimal']>;
  skillCourse_every?: InputMaybe<SkillCourseWhereInput>;
  skillCourse_none?: InputMaybe<SkillCourseWhereInput>;
  skillCourse_some?: InputMaybe<SkillCourseWhereInput>;
  skill_gt?: InputMaybe<Scalars['Decimal']>;
  skill_gte?: InputMaybe<Scalars['Decimal']>;
  skill_in?: InputMaybe<Array<Scalars['Decimal']>>;
  skill_lt?: InputMaybe<Scalars['Decimal']>;
  skill_lte?: InputMaybe<Scalars['Decimal']>;
  skill_not?: InputMaybe<Scalars['Decimal']>;
  skill_not_in?: InputMaybe<Array<Scalars['Decimal']>>;
  text?: InputMaybe<Scalars['String']>;
  text_contains?: InputMaybe<Scalars['String']>;
  text_ends_with?: InputMaybe<Scalars['String']>;
  text_gt?: InputMaybe<Scalars['String']>;
  text_gte?: InputMaybe<Scalars['String']>;
  text_in?: InputMaybe<Array<Scalars['String']>>;
  text_lt?: InputMaybe<Scalars['String']>;
  text_lte?: InputMaybe<Scalars['String']>;
  text_not?: InputMaybe<Scalars['String']>;
  text_not_contains?: InputMaybe<Scalars['String']>;
  text_not_ends_with?: InputMaybe<Scalars['String']>;
  text_not_in?: InputMaybe<Array<Scalars['String']>>;
  text_not_starts_with?: InputMaybe<Scalars['String']>;
  text_starts_with?: InputMaybe<Scalars['String']>;
};

export type ChallengeWhereUniqueInput = {
  id?: InputMaybe<Scalars['ID']>;
};

export type ChangePasswordInput = {
  password: Scalars['String'];
  passwordConfirmation: Scalars['String'];
  passwordResetToken: Scalars['String'];
  userId: Scalars['String'];
};

export type ChangeRenewalDateInput = {
  renewalDate: Scalars['DateTime'];
  resource: ResourceInput;
};

export type ConfirmUserInput = {
  password: Scalars['String'];
  passwordConfirmation: Scalars['String'];
  passwordResetToken: Scalars['String'];
  userId: Scalars['String'];
};

export type ConnectLicenseInput = {
  followingCourseGroupIds?: InputMaybe<Array<Scalars['ID']>>;
  userIds?: InputMaybe<Array<Scalars['ID']>>;
};

export type ContactDetails = {
  city: Scalars['String'];
  companyName?: Maybe<Scalars['String']>;
  contact?: Maybe<Scalars['String']>;
  country: Scalars['String'];
  id: Scalars['ID'];
  number: Scalars['String'];
  phone?: Maybe<Scalars['String']>;
  postalCode: Scalars['String'];
  street: Scalars['String'];
};

export type ContactDetailsConnection = {
  aggregate: AggregateContactDetails;
  edges: Array<Maybe<ContactDetailsEdge>>;
  pageInfo: PageInfo;
};

export type ContactDetailsCreateInput = {
  city: Scalars['String'];
  companyName?: InputMaybe<Scalars['String']>;
  contact?: InputMaybe<Scalars['String']>;
  country: Scalars['String'];
  id?: InputMaybe<Scalars['ID']>;
  number: Scalars['String'];
  phone?: InputMaybe<Scalars['String']>;
  postalCode: Scalars['String'];
  street: Scalars['String'];
};

export type ContactDetailsCreateOneInput = {
  connect?: InputMaybe<ContactDetailsWhereUniqueInput>;
  create?: InputMaybe<ContactDetailsCreateInput>;
};

export type ContactDetailsEdge = {
  cursor: Scalars['String'];
  node: ContactDetails;
};

export type ContactDetailsInput = {
  city?: InputMaybe<Scalars['String']>;
  companyName?: InputMaybe<Scalars['String']>;
  contact?: InputMaybe<Scalars['String']>;
  country?: InputMaybe<Scalars['String']>;
  number?: InputMaybe<Scalars['String']>;
  phone?: InputMaybe<Scalars['String']>;
  postalCode?: InputMaybe<Scalars['String']>;
  street?: InputMaybe<Scalars['String']>;
};

export type ContactDetailsOrderByInput =
  | 'city_ASC'
  | 'city_DESC'
  | 'companyName_ASC'
  | 'companyName_DESC'
  | 'contact_ASC'
  | 'contact_DESC'
  | 'country_ASC'
  | 'country_DESC'
  | 'id_ASC'
  | 'id_DESC'
  | 'number_ASC'
  | 'number_DESC'
  | 'phone_ASC'
  | 'phone_DESC'
  | 'postalCode_ASC'
  | 'postalCode_DESC'
  | 'street_ASC'
  | 'street_DESC';

export type ContactDetailsPreviousValues = {
  city: Scalars['String'];
  companyName?: Maybe<Scalars['String']>;
  contact?: Maybe<Scalars['String']>;
  country: Scalars['String'];
  id: Scalars['ID'];
  number: Scalars['String'];
  phone?: Maybe<Scalars['String']>;
  postalCode: Scalars['String'];
  street: Scalars['String'];
};

export type ContactDetailsSubscriptionPayload = {
  mutation: MutationType;
  node?: Maybe<ContactDetails>;
  previousValues?: Maybe<ContactDetailsPreviousValues>;
  updatedFields?: Maybe<Array<Scalars['String']>>;
};

export type ContactDetailsSubscriptionWhereInput = {
  AND?: InputMaybe<Array<ContactDetailsSubscriptionWhereInput>>;
  NOT?: InputMaybe<Array<ContactDetailsSubscriptionWhereInput>>;
  OR?: InputMaybe<Array<ContactDetailsSubscriptionWhereInput>>;
  mutation_in?: InputMaybe<Array<MutationType>>;
  node?: InputMaybe<ContactDetailsWhereInput>;
  updatedFields_contains?: InputMaybe<Scalars['String']>;
  updatedFields_contains_every?: InputMaybe<Array<Scalars['String']>>;
  updatedFields_contains_some?: InputMaybe<Array<Scalars['String']>>;
};

export type ContactDetailsUpdateDataInput = {
  city?: InputMaybe<Scalars['String']>;
  companyName?: InputMaybe<Scalars['String']>;
  contact?: InputMaybe<Scalars['String']>;
  country?: InputMaybe<Scalars['String']>;
  number?: InputMaybe<Scalars['String']>;
  phone?: InputMaybe<Scalars['String']>;
  postalCode?: InputMaybe<Scalars['String']>;
  street?: InputMaybe<Scalars['String']>;
};

export type ContactDetailsUpdateInput = {
  city?: InputMaybe<Scalars['String']>;
  companyName?: InputMaybe<Scalars['String']>;
  contact?: InputMaybe<Scalars['String']>;
  country?: InputMaybe<Scalars['String']>;
  number?: InputMaybe<Scalars['String']>;
  phone?: InputMaybe<Scalars['String']>;
  postalCode?: InputMaybe<Scalars['String']>;
  street?: InputMaybe<Scalars['String']>;
};

export type ContactDetailsUpdateManyMutationInput = {
  city?: InputMaybe<Scalars['String']>;
  companyName?: InputMaybe<Scalars['String']>;
  contact?: InputMaybe<Scalars['String']>;
  country?: InputMaybe<Scalars['String']>;
  number?: InputMaybe<Scalars['String']>;
  phone?: InputMaybe<Scalars['String']>;
  postalCode?: InputMaybe<Scalars['String']>;
  street?: InputMaybe<Scalars['String']>;
};

export type ContactDetailsUpdateOneInput = {
  connect?: InputMaybe<ContactDetailsWhereUniqueInput>;
  create?: InputMaybe<ContactDetailsCreateInput>;
  delete?: InputMaybe<Scalars['Boolean']>;
  disconnect?: InputMaybe<Scalars['Boolean']>;
  update?: InputMaybe<ContactDetailsUpdateDataInput>;
  upsert?: InputMaybe<ContactDetailsUpsertNestedInput>;
};

export type ContactDetailsUpdateOneRequiredInput = {
  connect?: InputMaybe<ContactDetailsWhereUniqueInput>;
  create?: InputMaybe<ContactDetailsCreateInput>;
  update?: InputMaybe<ContactDetailsUpdateDataInput>;
  upsert?: InputMaybe<ContactDetailsUpsertNestedInput>;
};

export type ContactDetailsUpsertNestedInput = {
  create: ContactDetailsCreateInput;
  update: ContactDetailsUpdateDataInput;
};

export type ContactDetailsWhereInput = {
  AND?: InputMaybe<Array<ContactDetailsWhereInput>>;
  NOT?: InputMaybe<Array<ContactDetailsWhereInput>>;
  OR?: InputMaybe<Array<ContactDetailsWhereInput>>;
  city?: InputMaybe<Scalars['String']>;
  city_contains?: InputMaybe<Scalars['String']>;
  city_ends_with?: InputMaybe<Scalars['String']>;
  city_gt?: InputMaybe<Scalars['String']>;
  city_gte?: InputMaybe<Scalars['String']>;
  city_in?: InputMaybe<Array<Scalars['String']>>;
  city_lt?: InputMaybe<Scalars['String']>;
  city_lte?: InputMaybe<Scalars['String']>;
  city_not?: InputMaybe<Scalars['String']>;
  city_not_contains?: InputMaybe<Scalars['String']>;
  city_not_ends_with?: InputMaybe<Scalars['String']>;
  city_not_in?: InputMaybe<Array<Scalars['String']>>;
  city_not_starts_with?: InputMaybe<Scalars['String']>;
  city_starts_with?: InputMaybe<Scalars['String']>;
  companyName?: InputMaybe<Scalars['String']>;
  companyName_contains?: InputMaybe<Scalars['String']>;
  companyName_ends_with?: InputMaybe<Scalars['String']>;
  companyName_gt?: InputMaybe<Scalars['String']>;
  companyName_gte?: InputMaybe<Scalars['String']>;
  companyName_in?: InputMaybe<Array<Scalars['String']>>;
  companyName_lt?: InputMaybe<Scalars['String']>;
  companyName_lte?: InputMaybe<Scalars['String']>;
  companyName_not?: InputMaybe<Scalars['String']>;
  companyName_not_contains?: InputMaybe<Scalars['String']>;
  companyName_not_ends_with?: InputMaybe<Scalars['String']>;
  companyName_not_in?: InputMaybe<Array<Scalars['String']>>;
  companyName_not_starts_with?: InputMaybe<Scalars['String']>;
  companyName_starts_with?: InputMaybe<Scalars['String']>;
  contact?: InputMaybe<Scalars['String']>;
  contact_contains?: InputMaybe<Scalars['String']>;
  contact_ends_with?: InputMaybe<Scalars['String']>;
  contact_gt?: InputMaybe<Scalars['String']>;
  contact_gte?: InputMaybe<Scalars['String']>;
  contact_in?: InputMaybe<Array<Scalars['String']>>;
  contact_lt?: InputMaybe<Scalars['String']>;
  contact_lte?: InputMaybe<Scalars['String']>;
  contact_not?: InputMaybe<Scalars['String']>;
  contact_not_contains?: InputMaybe<Scalars['String']>;
  contact_not_ends_with?: InputMaybe<Scalars['String']>;
  contact_not_in?: InputMaybe<Array<Scalars['String']>>;
  contact_not_starts_with?: InputMaybe<Scalars['String']>;
  contact_starts_with?: InputMaybe<Scalars['String']>;
  country?: InputMaybe<Scalars['String']>;
  country_contains?: InputMaybe<Scalars['String']>;
  country_ends_with?: InputMaybe<Scalars['String']>;
  country_gt?: InputMaybe<Scalars['String']>;
  country_gte?: InputMaybe<Scalars['String']>;
  country_in?: InputMaybe<Array<Scalars['String']>>;
  country_lt?: InputMaybe<Scalars['String']>;
  country_lte?: InputMaybe<Scalars['String']>;
  country_not?: InputMaybe<Scalars['String']>;
  country_not_contains?: InputMaybe<Scalars['String']>;
  country_not_ends_with?: InputMaybe<Scalars['String']>;
  country_not_in?: InputMaybe<Array<Scalars['String']>>;
  country_not_starts_with?: InputMaybe<Scalars['String']>;
  country_starts_with?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['ID']>;
  id_contains?: InputMaybe<Scalars['ID']>;
  id_ends_with?: InputMaybe<Scalars['ID']>;
  id_gt?: InputMaybe<Scalars['ID']>;
  id_gte?: InputMaybe<Scalars['ID']>;
  id_in?: InputMaybe<Array<Scalars['ID']>>;
  id_lt?: InputMaybe<Scalars['ID']>;
  id_lte?: InputMaybe<Scalars['ID']>;
  id_not?: InputMaybe<Scalars['ID']>;
  id_not_contains?: InputMaybe<Scalars['ID']>;
  id_not_ends_with?: InputMaybe<Scalars['ID']>;
  id_not_in?: InputMaybe<Array<Scalars['ID']>>;
  id_not_starts_with?: InputMaybe<Scalars['ID']>;
  id_starts_with?: InputMaybe<Scalars['ID']>;
  number?: InputMaybe<Scalars['String']>;
  number_contains?: InputMaybe<Scalars['String']>;
  number_ends_with?: InputMaybe<Scalars['String']>;
  number_gt?: InputMaybe<Scalars['String']>;
  number_gte?: InputMaybe<Scalars['String']>;
  number_in?: InputMaybe<Array<Scalars['String']>>;
  number_lt?: InputMaybe<Scalars['String']>;
  number_lte?: InputMaybe<Scalars['String']>;
  number_not?: InputMaybe<Scalars['String']>;
  number_not_contains?: InputMaybe<Scalars['String']>;
  number_not_ends_with?: InputMaybe<Scalars['String']>;
  number_not_in?: InputMaybe<Array<Scalars['String']>>;
  number_not_starts_with?: InputMaybe<Scalars['String']>;
  number_starts_with?: InputMaybe<Scalars['String']>;
  phone?: InputMaybe<Scalars['String']>;
  phone_contains?: InputMaybe<Scalars['String']>;
  phone_ends_with?: InputMaybe<Scalars['String']>;
  phone_gt?: InputMaybe<Scalars['String']>;
  phone_gte?: InputMaybe<Scalars['String']>;
  phone_in?: InputMaybe<Array<Scalars['String']>>;
  phone_lt?: InputMaybe<Scalars['String']>;
  phone_lte?: InputMaybe<Scalars['String']>;
  phone_not?: InputMaybe<Scalars['String']>;
  phone_not_contains?: InputMaybe<Scalars['String']>;
  phone_not_ends_with?: InputMaybe<Scalars['String']>;
  phone_not_in?: InputMaybe<Array<Scalars['String']>>;
  phone_not_starts_with?: InputMaybe<Scalars['String']>;
  phone_starts_with?: InputMaybe<Scalars['String']>;
  postalCode?: InputMaybe<Scalars['String']>;
  postalCode_contains?: InputMaybe<Scalars['String']>;
  postalCode_ends_with?: InputMaybe<Scalars['String']>;
  postalCode_gt?: InputMaybe<Scalars['String']>;
  postalCode_gte?: InputMaybe<Scalars['String']>;
  postalCode_in?: InputMaybe<Array<Scalars['String']>>;
  postalCode_lt?: InputMaybe<Scalars['String']>;
  postalCode_lte?: InputMaybe<Scalars['String']>;
  postalCode_not?: InputMaybe<Scalars['String']>;
  postalCode_not_contains?: InputMaybe<Scalars['String']>;
  postalCode_not_ends_with?: InputMaybe<Scalars['String']>;
  postalCode_not_in?: InputMaybe<Array<Scalars['String']>>;
  postalCode_not_starts_with?: InputMaybe<Scalars['String']>;
  postalCode_starts_with?: InputMaybe<Scalars['String']>;
  street?: InputMaybe<Scalars['String']>;
  street_contains?: InputMaybe<Scalars['String']>;
  street_ends_with?: InputMaybe<Scalars['String']>;
  street_gt?: InputMaybe<Scalars['String']>;
  street_gte?: InputMaybe<Scalars['String']>;
  street_in?: InputMaybe<Array<Scalars['String']>>;
  street_lt?: InputMaybe<Scalars['String']>;
  street_lte?: InputMaybe<Scalars['String']>;
  street_not?: InputMaybe<Scalars['String']>;
  street_not_contains?: InputMaybe<Scalars['String']>;
  street_not_ends_with?: InputMaybe<Scalars['String']>;
  street_not_in?: InputMaybe<Array<Scalars['String']>>;
  street_not_starts_with?: InputMaybe<Scalars['String']>;
  street_starts_with?: InputMaybe<Scalars['String']>;
};

export type ContactDetailsWhereUniqueInput = {
  id?: InputMaybe<Scalars['ID']>;
};

export type Country = {
  code: Scalars['String'];
  label: Scalars['String'];
};

export type Coupon = {
  createdAt: Scalars['DateTime'];
  discountPercentage: Scalars['Int'];
  expirationDate?: Maybe<Scalars['DateTime']>;
  id: Scalars['ID'];
  maxUsages?: Maybe<Scalars['Int']>;
  slug: Scalars['String'];
  updatedAt: Scalars['DateTime'];
  usages: Scalars['Int'];
};

export type CouponConnection = {
  aggregate: AggregateCoupon;
  edges: Array<Maybe<CouponEdge>>;
  pageInfo: PageInfo;
};

export type CouponCreateInput = {
  discountPercentage: Scalars['Int'];
  expirationDate?: InputMaybe<Scalars['DateTime']>;
  id?: InputMaybe<Scalars['ID']>;
  maxUsages?: InputMaybe<Scalars['Int']>;
  slug: Scalars['String'];
  usages?: InputMaybe<Scalars['Int']>;
};

export type CouponEdge = {
  cursor: Scalars['String'];
  node: Coupon;
};

export type CouponOrderByInput =
  | 'createdAt_ASC'
  | 'createdAt_DESC'
  | 'discountPercentage_ASC'
  | 'discountPercentage_DESC'
  | 'expirationDate_ASC'
  | 'expirationDate_DESC'
  | 'id_ASC'
  | 'id_DESC'
  | 'maxUsages_ASC'
  | 'maxUsages_DESC'
  | 'slug_ASC'
  | 'slug_DESC'
  | 'updatedAt_ASC'
  | 'updatedAt_DESC'
  | 'usages_ASC'
  | 'usages_DESC';

export type CouponPreviousValues = {
  createdAt: Scalars['DateTime'];
  discountPercentage: Scalars['Int'];
  expirationDate?: Maybe<Scalars['DateTime']>;
  id: Scalars['ID'];
  maxUsages?: Maybe<Scalars['Int']>;
  slug: Scalars['String'];
  updatedAt: Scalars['DateTime'];
  usages: Scalars['Int'];
};

export type CouponSubscriptionPayload = {
  mutation: MutationType;
  node?: Maybe<Coupon>;
  previousValues?: Maybe<CouponPreviousValues>;
  updatedFields?: Maybe<Array<Scalars['String']>>;
};

export type CouponSubscriptionWhereInput = {
  AND?: InputMaybe<Array<CouponSubscriptionWhereInput>>;
  NOT?: InputMaybe<Array<CouponSubscriptionWhereInput>>;
  OR?: InputMaybe<Array<CouponSubscriptionWhereInput>>;
  mutation_in?: InputMaybe<Array<MutationType>>;
  node?: InputMaybe<CouponWhereInput>;
  updatedFields_contains?: InputMaybe<Scalars['String']>;
  updatedFields_contains_every?: InputMaybe<Array<Scalars['String']>>;
  updatedFields_contains_some?: InputMaybe<Array<Scalars['String']>>;
};

export type CouponUpdateInput = {
  discountPercentage?: InputMaybe<Scalars['Int']>;
  expirationDate?: InputMaybe<Scalars['DateTime']>;
  maxUsages?: InputMaybe<Scalars['Int']>;
  slug?: InputMaybe<Scalars['String']>;
  usages?: InputMaybe<Scalars['Int']>;
};

export type CouponUpdateManyMutationInput = {
  discountPercentage?: InputMaybe<Scalars['Int']>;
  expirationDate?: InputMaybe<Scalars['DateTime']>;
  maxUsages?: InputMaybe<Scalars['Int']>;
  slug?: InputMaybe<Scalars['String']>;
  usages?: InputMaybe<Scalars['Int']>;
};

export type CouponValidationResult = {
  discountPercentage?: Maybe<Scalars['Int']>;
  reason?: Maybe<Scalars['String']>;
  valid: Scalars['Boolean'];
};

export type CouponWhereInput = {
  AND?: InputMaybe<Array<CouponWhereInput>>;
  NOT?: InputMaybe<Array<CouponWhereInput>>;
  OR?: InputMaybe<Array<CouponWhereInput>>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  createdAt_gt?: InputMaybe<Scalars['DateTime']>;
  createdAt_gte?: InputMaybe<Scalars['DateTime']>;
  createdAt_in?: InputMaybe<Array<Scalars['DateTime']>>;
  createdAt_lt?: InputMaybe<Scalars['DateTime']>;
  createdAt_lte?: InputMaybe<Scalars['DateTime']>;
  createdAt_not?: InputMaybe<Scalars['DateTime']>;
  createdAt_not_in?: InputMaybe<Array<Scalars['DateTime']>>;
  discountPercentage?: InputMaybe<Scalars['Int']>;
  discountPercentage_gt?: InputMaybe<Scalars['Int']>;
  discountPercentage_gte?: InputMaybe<Scalars['Int']>;
  discountPercentage_in?: InputMaybe<Array<Scalars['Int']>>;
  discountPercentage_lt?: InputMaybe<Scalars['Int']>;
  discountPercentage_lte?: InputMaybe<Scalars['Int']>;
  discountPercentage_not?: InputMaybe<Scalars['Int']>;
  discountPercentage_not_in?: InputMaybe<Array<Scalars['Int']>>;
  expirationDate?: InputMaybe<Scalars['DateTime']>;
  expirationDate_gt?: InputMaybe<Scalars['DateTime']>;
  expirationDate_gte?: InputMaybe<Scalars['DateTime']>;
  expirationDate_in?: InputMaybe<Array<Scalars['DateTime']>>;
  expirationDate_lt?: InputMaybe<Scalars['DateTime']>;
  expirationDate_lte?: InputMaybe<Scalars['DateTime']>;
  expirationDate_not?: InputMaybe<Scalars['DateTime']>;
  expirationDate_not_in?: InputMaybe<Array<Scalars['DateTime']>>;
  id?: InputMaybe<Scalars['ID']>;
  id_contains?: InputMaybe<Scalars['ID']>;
  id_ends_with?: InputMaybe<Scalars['ID']>;
  id_gt?: InputMaybe<Scalars['ID']>;
  id_gte?: InputMaybe<Scalars['ID']>;
  id_in?: InputMaybe<Array<Scalars['ID']>>;
  id_lt?: InputMaybe<Scalars['ID']>;
  id_lte?: InputMaybe<Scalars['ID']>;
  id_not?: InputMaybe<Scalars['ID']>;
  id_not_contains?: InputMaybe<Scalars['ID']>;
  id_not_ends_with?: InputMaybe<Scalars['ID']>;
  id_not_in?: InputMaybe<Array<Scalars['ID']>>;
  id_not_starts_with?: InputMaybe<Scalars['ID']>;
  id_starts_with?: InputMaybe<Scalars['ID']>;
  maxUsages?: InputMaybe<Scalars['Int']>;
  maxUsages_gt?: InputMaybe<Scalars['Int']>;
  maxUsages_gte?: InputMaybe<Scalars['Int']>;
  maxUsages_in?: InputMaybe<Array<Scalars['Int']>>;
  maxUsages_lt?: InputMaybe<Scalars['Int']>;
  maxUsages_lte?: InputMaybe<Scalars['Int']>;
  maxUsages_not?: InputMaybe<Scalars['Int']>;
  maxUsages_not_in?: InputMaybe<Array<Scalars['Int']>>;
  slug?: InputMaybe<Scalars['String']>;
  slug_contains?: InputMaybe<Scalars['String']>;
  slug_ends_with?: InputMaybe<Scalars['String']>;
  slug_gt?: InputMaybe<Scalars['String']>;
  slug_gte?: InputMaybe<Scalars['String']>;
  slug_in?: InputMaybe<Array<Scalars['String']>>;
  slug_lt?: InputMaybe<Scalars['String']>;
  slug_lte?: InputMaybe<Scalars['String']>;
  slug_not?: InputMaybe<Scalars['String']>;
  slug_not_contains?: InputMaybe<Scalars['String']>;
  slug_not_ends_with?: InputMaybe<Scalars['String']>;
  slug_not_in?: InputMaybe<Array<Scalars['String']>>;
  slug_not_starts_with?: InputMaybe<Scalars['String']>;
  slug_starts_with?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
  updatedAt_gt?: InputMaybe<Scalars['DateTime']>;
  updatedAt_gte?: InputMaybe<Scalars['DateTime']>;
  updatedAt_in?: InputMaybe<Array<Scalars['DateTime']>>;
  updatedAt_lt?: InputMaybe<Scalars['DateTime']>;
  updatedAt_lte?: InputMaybe<Scalars['DateTime']>;
  updatedAt_not?: InputMaybe<Scalars['DateTime']>;
  updatedAt_not_in?: InputMaybe<Array<Scalars['DateTime']>>;
  usages?: InputMaybe<Scalars['Int']>;
  usages_gt?: InputMaybe<Scalars['Int']>;
  usages_gte?: InputMaybe<Scalars['Int']>;
  usages_in?: InputMaybe<Array<Scalars['Int']>>;
  usages_lt?: InputMaybe<Scalars['Int']>;
  usages_lte?: InputMaybe<Scalars['Int']>;
  usages_not?: InputMaybe<Scalars['Int']>;
  usages_not_in?: InputMaybe<Array<Scalars['Int']>>;
};

export type CouponWhereUniqueInput = {
  id?: InputMaybe<Scalars['ID']>;
  slug?: InputMaybe<Scalars['String']>;
};

export type CourseGroup = {
  coaches?: Maybe<UsersFilterMessage>;
  coachesCount: Scalars['Int'];
  createdAt: Scalars['DateTime'];
  endDate?: Maybe<Scalars['DateTime']>;
  id: Scalars['ID'];
  levelSettings: Array<LevelSetting>;
  name: Scalars['String'];
  school: School;
  startDate?: Maybe<Scalars['DateTime']>;
  stbId?: Maybe<Scalars['String']>;
  students?: Maybe<UsersFilterMessage>;
  studentsCount: Scalars['Int'];
  updatedAt: Scalars['DateTime'];
  useLevelSettings: Scalars['Boolean'];
};

export type CourseGroupCoachesArgs = {
  filter?: InputMaybe<UsersFilterArguments>;
};

export type CourseGroupStudentsArgs = {
  filter?: InputMaybe<UsersFilterArguments>;
};

export type CourseGroupCoachInput = {
  courseGroups?: InputMaybe<Array<Scalars['ID']>>;
  userId: Scalars['ID'];
};

export type CourseGroupConnection = {
  aggregate: AggregateCourseGroup;
  edges: Array<Maybe<CourseGroupEdge>>;
  pageInfo: PageInfo;
};

export type CourseGroupCreateInput = {
  name: Scalars['String'];
};

export type CourseGroupCreateManyWithoutCoachesInput = {
  connect?: InputMaybe<Array<CourseGroupWhereUniqueInput>>;
  create?: InputMaybe<Array<CourseGroupCreateWithoutCoachesInput>>;
};

export type CourseGroupCreateManyWithoutSchoolInput = {
  connect?: InputMaybe<Array<CourseGroupWhereUniqueInput>>;
  create?: InputMaybe<Array<CourseGroupCreateWithoutSchoolInput>>;
};

export type CourseGroupCreateOneWithoutLevelSettingsInput = {
  connect?: InputMaybe<CourseGroupWhereUniqueInput>;
  create?: InputMaybe<CourseGroupCreateWithoutLevelSettingsInput>;
};

export type CourseGroupCreateOneWithoutStudentsInput = {
  connect?: InputMaybe<CourseGroupWhereUniqueInput>;
  create?: InputMaybe<CourseGroupCreateWithoutStudentsInput>;
};

export type CourseGroupCreateWithoutCoachesInput = {
  deletable?: InputMaybe<Scalars['Boolean']>;
  endDate?: InputMaybe<Scalars['DateTime']>;
  id?: InputMaybe<Scalars['ID']>;
  levelSettings?: InputMaybe<LevelSettingCreateManyWithoutCourseGroupInput>;
  name: Scalars['String'];
  school?: InputMaybe<SchoolCreateOneWithoutCourseGroupsInput>;
  startDate?: InputMaybe<Scalars['DateTime']>;
  stbId?: InputMaybe<Scalars['String']>;
  students?: InputMaybe<BeheerUserCreateManyWithoutFollowingCourseGroupInput>;
  useLevelSettings?: InputMaybe<Scalars['Boolean']>;
};

export type CourseGroupCreateWithoutLevelSettingsInput = {
  coaches?: InputMaybe<BeheerUserCreateManyWithoutCoachedCourseGroupsInput>;
  deletable?: InputMaybe<Scalars['Boolean']>;
  endDate?: InputMaybe<Scalars['DateTime']>;
  id?: InputMaybe<Scalars['ID']>;
  name: Scalars['String'];
  school?: InputMaybe<SchoolCreateOneWithoutCourseGroupsInput>;
  startDate?: InputMaybe<Scalars['DateTime']>;
  stbId?: InputMaybe<Scalars['String']>;
  students?: InputMaybe<BeheerUserCreateManyWithoutFollowingCourseGroupInput>;
  useLevelSettings?: InputMaybe<Scalars['Boolean']>;
};

export type CourseGroupCreateWithoutSchoolInput = {
  coaches?: InputMaybe<BeheerUserCreateManyWithoutCoachedCourseGroupsInput>;
  deletable?: InputMaybe<Scalars['Boolean']>;
  endDate?: InputMaybe<Scalars['DateTime']>;
  id?: InputMaybe<Scalars['ID']>;
  levelSettings?: InputMaybe<LevelSettingCreateManyWithoutCourseGroupInput>;
  name: Scalars['String'];
  startDate?: InputMaybe<Scalars['DateTime']>;
  stbId?: InputMaybe<Scalars['String']>;
  students?: InputMaybe<BeheerUserCreateManyWithoutFollowingCourseGroupInput>;
  useLevelSettings?: InputMaybe<Scalars['Boolean']>;
};

export type CourseGroupCreateWithoutStudentsInput = {
  coaches?: InputMaybe<BeheerUserCreateManyWithoutCoachedCourseGroupsInput>;
  deletable?: InputMaybe<Scalars['Boolean']>;
  endDate?: InputMaybe<Scalars['DateTime']>;
  id?: InputMaybe<Scalars['ID']>;
  levelSettings?: InputMaybe<LevelSettingCreateManyWithoutCourseGroupInput>;
  name: Scalars['String'];
  school?: InputMaybe<SchoolCreateOneWithoutCourseGroupsInput>;
  startDate?: InputMaybe<Scalars['DateTime']>;
  stbId?: InputMaybe<Scalars['String']>;
  useLevelSettings?: InputMaybe<Scalars['Boolean']>;
};

export type CourseGroupEdge = {
  cursor: Scalars['String'];
  node: CourseGroup;
};

export type CourseGroupOrderByColumns =
  | 'coaches'
  | 'createdAt'
  | 'id'
  | 'name'
  | 'school'
  | 'stbId'
  | 'studentsCount';

export type CourseGroupOrderByInput =
  | 'createdAt_ASC'
  | 'createdAt_DESC'
  | 'deletable_ASC'
  | 'deletable_DESC'
  | 'endDate_ASC'
  | 'endDate_DESC'
  | 'id_ASC'
  | 'id_DESC'
  | 'name_ASC'
  | 'name_DESC'
  | 'startDate_ASC'
  | 'startDate_DESC'
  | 'stbId_ASC'
  | 'stbId_DESC'
  | 'updatedAt_ASC'
  | 'updatedAt_DESC'
  | 'useLevelSettings_ASC'
  | 'useLevelSettings_DESC';

export type CourseGroupPreviousValues = {
  createdAt: Scalars['DateTime'];
  deletable: Scalars['Boolean'];
  endDate?: Maybe<Scalars['DateTime']>;
  id: Scalars['ID'];
  name: Scalars['String'];
  startDate?: Maybe<Scalars['DateTime']>;
  stbId?: Maybe<Scalars['String']>;
  updatedAt: Scalars['DateTime'];
  useLevelSettings: Scalars['Boolean'];
};

export type CourseGroupScalarWhereInput = {
  AND?: InputMaybe<Array<CourseGroupScalarWhereInput>>;
  NOT?: InputMaybe<Array<CourseGroupScalarWhereInput>>;
  OR?: InputMaybe<Array<CourseGroupScalarWhereInput>>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  createdAt_gt?: InputMaybe<Scalars['DateTime']>;
  createdAt_gte?: InputMaybe<Scalars['DateTime']>;
  createdAt_in?: InputMaybe<Array<Scalars['DateTime']>>;
  createdAt_lt?: InputMaybe<Scalars['DateTime']>;
  createdAt_lte?: InputMaybe<Scalars['DateTime']>;
  createdAt_not?: InputMaybe<Scalars['DateTime']>;
  createdAt_not_in?: InputMaybe<Array<Scalars['DateTime']>>;
  deletable?: InputMaybe<Scalars['Boolean']>;
  deletable_not?: InputMaybe<Scalars['Boolean']>;
  endDate?: InputMaybe<Scalars['DateTime']>;
  endDate_gt?: InputMaybe<Scalars['DateTime']>;
  endDate_gte?: InputMaybe<Scalars['DateTime']>;
  endDate_in?: InputMaybe<Array<Scalars['DateTime']>>;
  endDate_lt?: InputMaybe<Scalars['DateTime']>;
  endDate_lte?: InputMaybe<Scalars['DateTime']>;
  endDate_not?: InputMaybe<Scalars['DateTime']>;
  endDate_not_in?: InputMaybe<Array<Scalars['DateTime']>>;
  id?: InputMaybe<Scalars['ID']>;
  id_contains?: InputMaybe<Scalars['ID']>;
  id_ends_with?: InputMaybe<Scalars['ID']>;
  id_gt?: InputMaybe<Scalars['ID']>;
  id_gte?: InputMaybe<Scalars['ID']>;
  id_in?: InputMaybe<Array<Scalars['ID']>>;
  id_lt?: InputMaybe<Scalars['ID']>;
  id_lte?: InputMaybe<Scalars['ID']>;
  id_not?: InputMaybe<Scalars['ID']>;
  id_not_contains?: InputMaybe<Scalars['ID']>;
  id_not_ends_with?: InputMaybe<Scalars['ID']>;
  id_not_in?: InputMaybe<Array<Scalars['ID']>>;
  id_not_starts_with?: InputMaybe<Scalars['ID']>;
  id_starts_with?: InputMaybe<Scalars['ID']>;
  name?: InputMaybe<Scalars['String']>;
  name_contains?: InputMaybe<Scalars['String']>;
  name_ends_with?: InputMaybe<Scalars['String']>;
  name_gt?: InputMaybe<Scalars['String']>;
  name_gte?: InputMaybe<Scalars['String']>;
  name_in?: InputMaybe<Array<Scalars['String']>>;
  name_lt?: InputMaybe<Scalars['String']>;
  name_lte?: InputMaybe<Scalars['String']>;
  name_not?: InputMaybe<Scalars['String']>;
  name_not_contains?: InputMaybe<Scalars['String']>;
  name_not_ends_with?: InputMaybe<Scalars['String']>;
  name_not_in?: InputMaybe<Array<Scalars['String']>>;
  name_not_starts_with?: InputMaybe<Scalars['String']>;
  name_starts_with?: InputMaybe<Scalars['String']>;
  startDate?: InputMaybe<Scalars['DateTime']>;
  startDate_gt?: InputMaybe<Scalars['DateTime']>;
  startDate_gte?: InputMaybe<Scalars['DateTime']>;
  startDate_in?: InputMaybe<Array<Scalars['DateTime']>>;
  startDate_lt?: InputMaybe<Scalars['DateTime']>;
  startDate_lte?: InputMaybe<Scalars['DateTime']>;
  startDate_not?: InputMaybe<Scalars['DateTime']>;
  startDate_not_in?: InputMaybe<Array<Scalars['DateTime']>>;
  stbId?: InputMaybe<Scalars['String']>;
  stbId_contains?: InputMaybe<Scalars['String']>;
  stbId_ends_with?: InputMaybe<Scalars['String']>;
  stbId_gt?: InputMaybe<Scalars['String']>;
  stbId_gte?: InputMaybe<Scalars['String']>;
  stbId_in?: InputMaybe<Array<Scalars['String']>>;
  stbId_lt?: InputMaybe<Scalars['String']>;
  stbId_lte?: InputMaybe<Scalars['String']>;
  stbId_not?: InputMaybe<Scalars['String']>;
  stbId_not_contains?: InputMaybe<Scalars['String']>;
  stbId_not_ends_with?: InputMaybe<Scalars['String']>;
  stbId_not_in?: InputMaybe<Array<Scalars['String']>>;
  stbId_not_starts_with?: InputMaybe<Scalars['String']>;
  stbId_starts_with?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
  updatedAt_gt?: InputMaybe<Scalars['DateTime']>;
  updatedAt_gte?: InputMaybe<Scalars['DateTime']>;
  updatedAt_in?: InputMaybe<Array<Scalars['DateTime']>>;
  updatedAt_lt?: InputMaybe<Scalars['DateTime']>;
  updatedAt_lte?: InputMaybe<Scalars['DateTime']>;
  updatedAt_not?: InputMaybe<Scalars['DateTime']>;
  updatedAt_not_in?: InputMaybe<Array<Scalars['DateTime']>>;
  useLevelSettings?: InputMaybe<Scalars['Boolean']>;
  useLevelSettings_not?: InputMaybe<Scalars['Boolean']>;
};

export type CourseGroupSearchOrderBy = {
  columnName?: InputMaybe<CourseGroupOrderByColumns>;
  order?: InputMaybe<SortOrder>;
};

export type CourseGroupSearchResult = {
  aggregate: AggregateCourseGroup;
  edges: Array<Maybe<CourseGroupEdge>>;
};

export type CourseGroupSearchWhereInput = {
  coaches?: InputMaybe<StringFilterInput>;
  createdAt?: InputMaybe<DateFilterInput>;
  id?: InputMaybe<StringFilterInput>;
  name?: InputMaybe<StringFilterInput>;
  school?: InputMaybe<StringFilterInput>;
  stbId?: InputMaybe<StringFilterInput>;
  studentsCount?: InputMaybe<NumberFilterInput>;
};

export type CourseGroupSubscriptionPayload = {
  mutation: MutationType;
  node?: Maybe<CourseGroup>;
  previousValues?: Maybe<CourseGroupPreviousValues>;
  updatedFields?: Maybe<Array<Scalars['String']>>;
};

export type CourseGroupSubscriptionWhereInput = {
  AND?: InputMaybe<Array<CourseGroupSubscriptionWhereInput>>;
  NOT?: InputMaybe<Array<CourseGroupSubscriptionWhereInput>>;
  OR?: InputMaybe<Array<CourseGroupSubscriptionWhereInput>>;
  mutation_in?: InputMaybe<Array<MutationType>>;
  node?: InputMaybe<CourseGroupWhereInput>;
  updatedFields_contains?: InputMaybe<Scalars['String']>;
  updatedFields_contains_every?: InputMaybe<Array<Scalars['String']>>;
  updatedFields_contains_some?: InputMaybe<Array<Scalars['String']>>;
};

export type CourseGroupUpdateInput = {
  endDate?: InputMaybe<Scalars['DateTime']>;
  name?: InputMaybe<Scalars['String']>;
  startDate?: InputMaybe<Scalars['DateTime']>;
  useLevelSettings?: InputMaybe<Scalars['Boolean']>;
};

export type CourseGroupUpdateManyDataInput = {
  deletable?: InputMaybe<Scalars['Boolean']>;
  endDate?: InputMaybe<Scalars['DateTime']>;
  name?: InputMaybe<Scalars['String']>;
  startDate?: InputMaybe<Scalars['DateTime']>;
  stbId?: InputMaybe<Scalars['String']>;
  useLevelSettings?: InputMaybe<Scalars['Boolean']>;
};

export type CourseGroupUpdateManyMutationInput = {
  deletable?: InputMaybe<Scalars['Boolean']>;
  endDate?: InputMaybe<Scalars['DateTime']>;
  name?: InputMaybe<Scalars['String']>;
  startDate?: InputMaybe<Scalars['DateTime']>;
  stbId?: InputMaybe<Scalars['String']>;
  useLevelSettings?: InputMaybe<Scalars['Boolean']>;
};

export type CourseGroupUpdateManyWithWhereNestedInput = {
  data: CourseGroupUpdateManyDataInput;
  where: CourseGroupScalarWhereInput;
};

export type CourseGroupUpdateManyWithoutCoachesInput = {
  connect?: InputMaybe<Array<CourseGroupWhereUniqueInput>>;
  create?: InputMaybe<Array<CourseGroupCreateWithoutCoachesInput>>;
  delete?: InputMaybe<Array<CourseGroupWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<CourseGroupScalarWhereInput>>;
  disconnect?: InputMaybe<Array<CourseGroupWhereUniqueInput>>;
  set?: InputMaybe<Array<CourseGroupWhereUniqueInput>>;
  update?: InputMaybe<
    Array<CourseGroupUpdateWithWhereUniqueWithoutCoachesInput>
  >;
  updateMany?: InputMaybe<Array<CourseGroupUpdateManyWithWhereNestedInput>>;
  upsert?: InputMaybe<
    Array<CourseGroupUpsertWithWhereUniqueWithoutCoachesInput>
  >;
};

export type CourseGroupUpdateManyWithoutSchoolInput = {
  connect?: InputMaybe<Array<CourseGroupWhereUniqueInput>>;
  create?: InputMaybe<Array<CourseGroupCreateWithoutSchoolInput>>;
  delete?: InputMaybe<Array<CourseGroupWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<CourseGroupScalarWhereInput>>;
  disconnect?: InputMaybe<Array<CourseGroupWhereUniqueInput>>;
  set?: InputMaybe<Array<CourseGroupWhereUniqueInput>>;
  update?: InputMaybe<
    Array<CourseGroupUpdateWithWhereUniqueWithoutSchoolInput>
  >;
  updateMany?: InputMaybe<Array<CourseGroupUpdateManyWithWhereNestedInput>>;
  upsert?: InputMaybe<
    Array<CourseGroupUpsertWithWhereUniqueWithoutSchoolInput>
  >;
};

export type CourseGroupUpdateOneRequiredWithoutLevelSettingsInput = {
  connect?: InputMaybe<CourseGroupWhereUniqueInput>;
  create?: InputMaybe<CourseGroupCreateWithoutLevelSettingsInput>;
  update?: InputMaybe<CourseGroupUpdateWithoutLevelSettingsDataInput>;
  upsert?: InputMaybe<CourseGroupUpsertWithoutLevelSettingsInput>;
};

export type CourseGroupUpdateOneWithoutStudentsInput = {
  connect?: InputMaybe<CourseGroupWhereUniqueInput>;
  create?: InputMaybe<CourseGroupCreateWithoutStudentsInput>;
  delete?: InputMaybe<Scalars['Boolean']>;
  disconnect?: InputMaybe<Scalars['Boolean']>;
  update?: InputMaybe<CourseGroupUpdateWithoutStudentsDataInput>;
  upsert?: InputMaybe<CourseGroupUpsertWithoutStudentsInput>;
};

export type CourseGroupUpdateWithWhereUniqueWithoutCoachesInput = {
  data: CourseGroupUpdateWithoutCoachesDataInput;
  where: CourseGroupWhereUniqueInput;
};

export type CourseGroupUpdateWithWhereUniqueWithoutSchoolInput = {
  data: CourseGroupUpdateWithoutSchoolDataInput;
  where: CourseGroupWhereUniqueInput;
};

export type CourseGroupUpdateWithoutCoachesDataInput = {
  deletable?: InputMaybe<Scalars['Boolean']>;
  endDate?: InputMaybe<Scalars['DateTime']>;
  levelSettings?: InputMaybe<LevelSettingUpdateManyWithoutCourseGroupInput>;
  name?: InputMaybe<Scalars['String']>;
  school?: InputMaybe<SchoolUpdateOneWithoutCourseGroupsInput>;
  startDate?: InputMaybe<Scalars['DateTime']>;
  stbId?: InputMaybe<Scalars['String']>;
  students?: InputMaybe<BeheerUserUpdateManyWithoutFollowingCourseGroupInput>;
  useLevelSettings?: InputMaybe<Scalars['Boolean']>;
};

export type CourseGroupUpdateWithoutLevelSettingsDataInput = {
  coaches?: InputMaybe<BeheerUserUpdateManyWithoutCoachedCourseGroupsInput>;
  deletable?: InputMaybe<Scalars['Boolean']>;
  endDate?: InputMaybe<Scalars['DateTime']>;
  name?: InputMaybe<Scalars['String']>;
  school?: InputMaybe<SchoolUpdateOneWithoutCourseGroupsInput>;
  startDate?: InputMaybe<Scalars['DateTime']>;
  stbId?: InputMaybe<Scalars['String']>;
  students?: InputMaybe<BeheerUserUpdateManyWithoutFollowingCourseGroupInput>;
  useLevelSettings?: InputMaybe<Scalars['Boolean']>;
};

export type CourseGroupUpdateWithoutSchoolDataInput = {
  coaches?: InputMaybe<BeheerUserUpdateManyWithoutCoachedCourseGroupsInput>;
  deletable?: InputMaybe<Scalars['Boolean']>;
  endDate?: InputMaybe<Scalars['DateTime']>;
  levelSettings?: InputMaybe<LevelSettingUpdateManyWithoutCourseGroupInput>;
  name?: InputMaybe<Scalars['String']>;
  startDate?: InputMaybe<Scalars['DateTime']>;
  stbId?: InputMaybe<Scalars['String']>;
  students?: InputMaybe<BeheerUserUpdateManyWithoutFollowingCourseGroupInput>;
  useLevelSettings?: InputMaybe<Scalars['Boolean']>;
};

export type CourseGroupUpdateWithoutStudentsDataInput = {
  coaches?: InputMaybe<BeheerUserUpdateManyWithoutCoachedCourseGroupsInput>;
  deletable?: InputMaybe<Scalars['Boolean']>;
  endDate?: InputMaybe<Scalars['DateTime']>;
  levelSettings?: InputMaybe<LevelSettingUpdateManyWithoutCourseGroupInput>;
  name?: InputMaybe<Scalars['String']>;
  school?: InputMaybe<SchoolUpdateOneWithoutCourseGroupsInput>;
  startDate?: InputMaybe<Scalars['DateTime']>;
  stbId?: InputMaybe<Scalars['String']>;
  useLevelSettings?: InputMaybe<Scalars['Boolean']>;
};

export type CourseGroupUpsertWithWhereUniqueWithoutCoachesInput = {
  create: CourseGroupCreateWithoutCoachesInput;
  update: CourseGroupUpdateWithoutCoachesDataInput;
  where: CourseGroupWhereUniqueInput;
};

export type CourseGroupUpsertWithWhereUniqueWithoutSchoolInput = {
  create: CourseGroupCreateWithoutSchoolInput;
  update: CourseGroupUpdateWithoutSchoolDataInput;
  where: CourseGroupWhereUniqueInput;
};

export type CourseGroupUpsertWithoutLevelSettingsInput = {
  create: CourseGroupCreateWithoutLevelSettingsInput;
  update: CourseGroupUpdateWithoutLevelSettingsDataInput;
};

export type CourseGroupUpsertWithoutStudentsInput = {
  create: CourseGroupCreateWithoutStudentsInput;
  update: CourseGroupUpdateWithoutStudentsDataInput;
};

export type CourseGroupWhereInput = {
  AND?: InputMaybe<Array<CourseGroupWhereInput>>;
  NOT?: InputMaybe<Array<CourseGroupWhereInput>>;
  OR?: InputMaybe<Array<CourseGroupWhereInput>>;
  coaches_every?: InputMaybe<BeheerUserWhereInput>;
  coaches_none?: InputMaybe<BeheerUserWhereInput>;
  coaches_some?: InputMaybe<BeheerUserWhereInput>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  createdAt_gt?: InputMaybe<Scalars['DateTime']>;
  createdAt_gte?: InputMaybe<Scalars['DateTime']>;
  createdAt_in?: InputMaybe<Array<Scalars['DateTime']>>;
  createdAt_lt?: InputMaybe<Scalars['DateTime']>;
  createdAt_lte?: InputMaybe<Scalars['DateTime']>;
  createdAt_not?: InputMaybe<Scalars['DateTime']>;
  createdAt_not_in?: InputMaybe<Array<Scalars['DateTime']>>;
  deletable?: InputMaybe<Scalars['Boolean']>;
  deletable_not?: InputMaybe<Scalars['Boolean']>;
  endDate?: InputMaybe<Scalars['DateTime']>;
  endDate_gt?: InputMaybe<Scalars['DateTime']>;
  endDate_gte?: InputMaybe<Scalars['DateTime']>;
  endDate_in?: InputMaybe<Array<Scalars['DateTime']>>;
  endDate_lt?: InputMaybe<Scalars['DateTime']>;
  endDate_lte?: InputMaybe<Scalars['DateTime']>;
  endDate_not?: InputMaybe<Scalars['DateTime']>;
  endDate_not_in?: InputMaybe<Array<Scalars['DateTime']>>;
  id?: InputMaybe<Scalars['ID']>;
  id_contains?: InputMaybe<Scalars['ID']>;
  id_ends_with?: InputMaybe<Scalars['ID']>;
  id_gt?: InputMaybe<Scalars['ID']>;
  id_gte?: InputMaybe<Scalars['ID']>;
  id_in?: InputMaybe<Array<Scalars['ID']>>;
  id_lt?: InputMaybe<Scalars['ID']>;
  id_lte?: InputMaybe<Scalars['ID']>;
  id_not?: InputMaybe<Scalars['ID']>;
  id_not_contains?: InputMaybe<Scalars['ID']>;
  id_not_ends_with?: InputMaybe<Scalars['ID']>;
  id_not_in?: InputMaybe<Array<Scalars['ID']>>;
  id_not_starts_with?: InputMaybe<Scalars['ID']>;
  id_starts_with?: InputMaybe<Scalars['ID']>;
  levelSettings_every?: InputMaybe<LevelSettingWhereInput>;
  levelSettings_none?: InputMaybe<LevelSettingWhereInput>;
  levelSettings_some?: InputMaybe<LevelSettingWhereInput>;
  name?: InputMaybe<Scalars['String']>;
  name_contains?: InputMaybe<Scalars['String']>;
  name_ends_with?: InputMaybe<Scalars['String']>;
  name_gt?: InputMaybe<Scalars['String']>;
  name_gte?: InputMaybe<Scalars['String']>;
  name_in?: InputMaybe<Array<Scalars['String']>>;
  name_lt?: InputMaybe<Scalars['String']>;
  name_lte?: InputMaybe<Scalars['String']>;
  name_not?: InputMaybe<Scalars['String']>;
  name_not_contains?: InputMaybe<Scalars['String']>;
  name_not_ends_with?: InputMaybe<Scalars['String']>;
  name_not_in?: InputMaybe<Array<Scalars['String']>>;
  name_not_starts_with?: InputMaybe<Scalars['String']>;
  name_starts_with?: InputMaybe<Scalars['String']>;
  school?: InputMaybe<SchoolWhereInput>;
  startDate?: InputMaybe<Scalars['DateTime']>;
  startDate_gt?: InputMaybe<Scalars['DateTime']>;
  startDate_gte?: InputMaybe<Scalars['DateTime']>;
  startDate_in?: InputMaybe<Array<Scalars['DateTime']>>;
  startDate_lt?: InputMaybe<Scalars['DateTime']>;
  startDate_lte?: InputMaybe<Scalars['DateTime']>;
  startDate_not?: InputMaybe<Scalars['DateTime']>;
  startDate_not_in?: InputMaybe<Array<Scalars['DateTime']>>;
  stbId?: InputMaybe<Scalars['String']>;
  stbId_contains?: InputMaybe<Scalars['String']>;
  stbId_ends_with?: InputMaybe<Scalars['String']>;
  stbId_gt?: InputMaybe<Scalars['String']>;
  stbId_gte?: InputMaybe<Scalars['String']>;
  stbId_in?: InputMaybe<Array<Scalars['String']>>;
  stbId_lt?: InputMaybe<Scalars['String']>;
  stbId_lte?: InputMaybe<Scalars['String']>;
  stbId_not?: InputMaybe<Scalars['String']>;
  stbId_not_contains?: InputMaybe<Scalars['String']>;
  stbId_not_ends_with?: InputMaybe<Scalars['String']>;
  stbId_not_in?: InputMaybe<Array<Scalars['String']>>;
  stbId_not_starts_with?: InputMaybe<Scalars['String']>;
  stbId_starts_with?: InputMaybe<Scalars['String']>;
  students_every?: InputMaybe<BeheerUserWhereInput>;
  students_none?: InputMaybe<BeheerUserWhereInput>;
  students_some?: InputMaybe<BeheerUserWhereInput>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
  updatedAt_gt?: InputMaybe<Scalars['DateTime']>;
  updatedAt_gte?: InputMaybe<Scalars['DateTime']>;
  updatedAt_in?: InputMaybe<Array<Scalars['DateTime']>>;
  updatedAt_lt?: InputMaybe<Scalars['DateTime']>;
  updatedAt_lte?: InputMaybe<Scalars['DateTime']>;
  updatedAt_not?: InputMaybe<Scalars['DateTime']>;
  updatedAt_not_in?: InputMaybe<Array<Scalars['DateTime']>>;
  useLevelSettings?: InputMaybe<Scalars['Boolean']>;
  useLevelSettings_not?: InputMaybe<Scalars['Boolean']>;
};

export type CourseGroupWhereUniqueInput = {
  id?: InputMaybe<Scalars['ID']>;
  stbId?: InputMaybe<Scalars['String']>;
};

export type CourseGroupsFilterInput = {
  first?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<CourseGroupSearchOrderBy>;
  skip?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<CourseGroupSearchWhereInput>;
};

export type CurrentResource = Partner | School | SchoolDistrict;

export type DateFilterInput = {
  eq?: InputMaybe<Scalars['DateTime']>;
  gt?: InputMaybe<Scalars['DateTime']>;
  gte?: InputMaybe<Scalars['DateTime']>;
  lt?: InputMaybe<Scalars['DateTime']>;
  lte?: InputMaybe<Scalars['DateTime']>;
};

export type DeleteManyMessagesInput = {
  id: MessageIdFilter;
};

export type DeleteMessageInput = {
  id: Scalars['String'];
};

export type EducationGroup = {
  createdAt: Scalars['DateTime'];
  id: Scalars['ID'];
  name: Scalars['String'];
  slug: Scalars['String'];
  updatedAt: Scalars['DateTime'];
};

export type EducationGroupCreateOneInput = {
  connect?: InputMaybe<EducationGroupWhereUniqueInput>;
};

export type EducationGroupOrderByInput =
  | 'createdAt_ASC'
  | 'createdAt_DESC'
  | 'id_ASC'
  | 'id_DESC'
  | 'name_ASC'
  | 'name_DESC'
  | 'slug_ASC'
  | 'slug_DESC'
  | 'updatedAt_ASC'
  | 'updatedAt_DESC';

export type EducationGroupUpdateOneInput = {
  connect?: InputMaybe<EducationGroupWhereUniqueInput>;
};

export type EducationGroupWhereInput = {
  AND?: InputMaybe<Array<EducationGroupWhereInput>>;
  NOT?: InputMaybe<Array<EducationGroupWhereInput>>;
  OR?: InputMaybe<Array<EducationGroupWhereInput>>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  createdAt_gt?: InputMaybe<Scalars['DateTime']>;
  createdAt_gte?: InputMaybe<Scalars['DateTime']>;
  createdAt_in?: InputMaybe<Array<Scalars['DateTime']>>;
  createdAt_lt?: InputMaybe<Scalars['DateTime']>;
  createdAt_lte?: InputMaybe<Scalars['DateTime']>;
  createdAt_not?: InputMaybe<Scalars['DateTime']>;
  createdAt_not_in?: InputMaybe<Array<Scalars['DateTime']>>;
  id?: InputMaybe<Scalars['ID']>;
  id_contains?: InputMaybe<Scalars['ID']>;
  id_ends_with?: InputMaybe<Scalars['ID']>;
  id_gt?: InputMaybe<Scalars['ID']>;
  id_gte?: InputMaybe<Scalars['ID']>;
  id_in?: InputMaybe<Array<Scalars['ID']>>;
  id_lt?: InputMaybe<Scalars['ID']>;
  id_lte?: InputMaybe<Scalars['ID']>;
  id_not?: InputMaybe<Scalars['ID']>;
  id_not_contains?: InputMaybe<Scalars['ID']>;
  id_not_ends_with?: InputMaybe<Scalars['ID']>;
  id_not_in?: InputMaybe<Array<Scalars['ID']>>;
  id_not_starts_with?: InputMaybe<Scalars['ID']>;
  id_starts_with?: InputMaybe<Scalars['ID']>;
  name?: InputMaybe<Scalars['String']>;
  name_contains?: InputMaybe<Scalars['String']>;
  name_ends_with?: InputMaybe<Scalars['String']>;
  name_gt?: InputMaybe<Scalars['String']>;
  name_gte?: InputMaybe<Scalars['String']>;
  name_in?: InputMaybe<Array<Scalars['String']>>;
  name_lt?: InputMaybe<Scalars['String']>;
  name_lte?: InputMaybe<Scalars['String']>;
  name_not?: InputMaybe<Scalars['String']>;
  name_not_contains?: InputMaybe<Scalars['String']>;
  name_not_ends_with?: InputMaybe<Scalars['String']>;
  name_not_in?: InputMaybe<Array<Scalars['String']>>;
  name_not_starts_with?: InputMaybe<Scalars['String']>;
  name_starts_with?: InputMaybe<Scalars['String']>;
  slug?: InputMaybe<Scalars['String']>;
  slug_contains?: InputMaybe<Scalars['String']>;
  slug_ends_with?: InputMaybe<Scalars['String']>;
  slug_gt?: InputMaybe<Scalars['String']>;
  slug_gte?: InputMaybe<Scalars['String']>;
  slug_in?: InputMaybe<Array<Scalars['String']>>;
  slug_lt?: InputMaybe<Scalars['String']>;
  slug_lte?: InputMaybe<Scalars['String']>;
  slug_not?: InputMaybe<Scalars['String']>;
  slug_not_contains?: InputMaybe<Scalars['String']>;
  slug_not_ends_with?: InputMaybe<Scalars['String']>;
  slug_not_in?: InputMaybe<Array<Scalars['String']>>;
  slug_not_starts_with?: InputMaybe<Scalars['String']>;
  slug_starts_with?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
  updatedAt_gt?: InputMaybe<Scalars['DateTime']>;
  updatedAt_gte?: InputMaybe<Scalars['DateTime']>;
  updatedAt_in?: InputMaybe<Array<Scalars['DateTime']>>;
  updatedAt_lt?: InputMaybe<Scalars['DateTime']>;
  updatedAt_lte?: InputMaybe<Scalars['DateTime']>;
  updatedAt_not?: InputMaybe<Scalars['DateTime']>;
  updatedAt_not_in?: InputMaybe<Array<Scalars['DateTime']>>;
};

export type EducationGroupWhereUniqueInput = {
  id?: InputMaybe<Scalars['ID']>;
  slug?: InputMaybe<Scalars['String']>;
};

export type EmailFrequency = 'DAILY' | 'NEVER' | 'WEEKLY';

export type EmailPreferences = {
  unreadMessagesEmailFrequency: EmailFrequency;
};

export type EmailPreferencesUpdateInput = {
  unreadMessagesEmailFrequency?: InputMaybe<EmailFrequency>;
};

export type EmailPreferencesWhereUniqueInput = {
  userId: Scalars['ID'];
};

export type ExamState =
  | 'Failed'
  | 'Incomplete'
  | 'Passed'
  | 'WaitingForTheLastResult';

export type Exercise = {
  accuracy?: Maybe<Scalars['Decimal']>;
  challengeRequests?: Maybe<Array<ChallengeRequest>>;
  charactersPerMinute?: Maybe<Scalars['Decimal']>;
  createdAt: Scalars['DateTime'];
  extraDiamonds?: Maybe<Scalars['Int']>;
  id: Scalars['ID'];
  level: Level;
  numberOfChallenges: Scalars['Int'];
  updatedAt: Scalars['DateTime'];
  user: GameUser;
};

export type ExerciseChallengeRequestsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<ChallengeRequestOrderByInput>;
  skip?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<ChallengeRequestWhereInput>;
};

export type ExerciseConnection = {
  aggregate: AggregateExercise;
  edges: Array<Maybe<ExerciseEdge>>;
  pageInfo: PageInfo;
};

export type ExerciseCreateInput = {
  level: LevelCreateOneInput;
};

export type ExerciseCreateManyWithoutLevelInput = {
  connect?: InputMaybe<Array<ExerciseWhereUniqueInput>>;
  create?: InputMaybe<Array<ExerciseCreateWithoutLevelInput>>;
};

export type ExerciseCreateOneWithoutChallengeRequestsInput = {
  connect?: InputMaybe<ExerciseWhereUniqueInput>;
  create?: InputMaybe<ExerciseCreateWithoutChallengeRequestsInput>;
};

export type ExerciseCreateWithoutChallengeRequestsInput = {
  accuracy?: InputMaybe<Scalars['Decimal']>;
  charactersPerMinute?: InputMaybe<Scalars['Decimal']>;
  extraDiamonds?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['ID']>;
  level: LevelCreateOneWithoutExercisesInput;
  numberOfChallenges?: InputMaybe<Scalars['Int']>;
  user: GameUserCreateOneInput;
};

export type ExerciseCreateWithoutLevelInput = {
  accuracy?: InputMaybe<Scalars['Decimal']>;
  challengeRequests?: InputMaybe<ChallengeRequestCreateManyWithoutExerciseInput>;
  charactersPerMinute?: InputMaybe<Scalars['Decimal']>;
  extraDiamonds?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['ID']>;
  numberOfChallenges?: InputMaybe<Scalars['Int']>;
  user: GameUserCreateOneInput;
};

export type ExerciseEdge = {
  cursor: Scalars['String'];
  node: Exercise;
};

export type ExerciseOrderByInput =
  | 'accuracy_ASC'
  | 'accuracy_DESC'
  | 'charactersPerMinute_ASC'
  | 'charactersPerMinute_DESC'
  | 'createdAt_ASC'
  | 'createdAt_DESC'
  | 'extraDiamonds_ASC'
  | 'extraDiamonds_DESC'
  | 'id_ASC'
  | 'id_DESC'
  | 'numberOfChallenges_ASC'
  | 'numberOfChallenges_DESC'
  | 'updatedAt_ASC'
  | 'updatedAt_DESC';

export type ExerciseResult = {
  accuracy: Scalars['Decimal'];
  averageAccuracy?: Maybe<Scalars['Decimal']>;
  averageCharactersPerMinute?: Maybe<Scalars['Decimal']>;
  charactersPerMinute: Scalars['Decimal'];
  correctChallengesPercentage?: Maybe<Scalars['Decimal']>;
  createdAt: Scalars['DateTime'];
  extraDiamonds: Scalars['Int'];
  id: Scalars['ID'];
  numberOfChallenges: Scalars['Int'];
  updatedAt: Scalars['DateTime'];
};

export type ExerciseScalarWhereInput = {
  AND?: InputMaybe<Array<ExerciseScalarWhereInput>>;
  NOT?: InputMaybe<Array<ExerciseScalarWhereInput>>;
  OR?: InputMaybe<Array<ExerciseScalarWhereInput>>;
  accuracy?: InputMaybe<Scalars['Decimal']>;
  accuracy_gt?: InputMaybe<Scalars['Decimal']>;
  accuracy_gte?: InputMaybe<Scalars['Decimal']>;
  accuracy_in?: InputMaybe<Array<Scalars['Decimal']>>;
  accuracy_lt?: InputMaybe<Scalars['Decimal']>;
  accuracy_lte?: InputMaybe<Scalars['Decimal']>;
  accuracy_not?: InputMaybe<Scalars['Decimal']>;
  accuracy_not_in?: InputMaybe<Array<Scalars['Decimal']>>;
  charactersPerMinute?: InputMaybe<Scalars['Decimal']>;
  charactersPerMinute_gt?: InputMaybe<Scalars['Decimal']>;
  charactersPerMinute_gte?: InputMaybe<Scalars['Decimal']>;
  charactersPerMinute_in?: InputMaybe<Array<Scalars['Decimal']>>;
  charactersPerMinute_lt?: InputMaybe<Scalars['Decimal']>;
  charactersPerMinute_lte?: InputMaybe<Scalars['Decimal']>;
  charactersPerMinute_not?: InputMaybe<Scalars['Decimal']>;
  charactersPerMinute_not_in?: InputMaybe<Array<Scalars['Decimal']>>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  createdAt_gt?: InputMaybe<Scalars['DateTime']>;
  createdAt_gte?: InputMaybe<Scalars['DateTime']>;
  createdAt_in?: InputMaybe<Array<Scalars['DateTime']>>;
  createdAt_lt?: InputMaybe<Scalars['DateTime']>;
  createdAt_lte?: InputMaybe<Scalars['DateTime']>;
  createdAt_not?: InputMaybe<Scalars['DateTime']>;
  createdAt_not_in?: InputMaybe<Array<Scalars['DateTime']>>;
  extraDiamonds?: InputMaybe<Scalars['Int']>;
  extraDiamonds_gt?: InputMaybe<Scalars['Int']>;
  extraDiamonds_gte?: InputMaybe<Scalars['Int']>;
  extraDiamonds_in?: InputMaybe<Array<Scalars['Int']>>;
  extraDiamonds_lt?: InputMaybe<Scalars['Int']>;
  extraDiamonds_lte?: InputMaybe<Scalars['Int']>;
  extraDiamonds_not?: InputMaybe<Scalars['Int']>;
  extraDiamonds_not_in?: InputMaybe<Array<Scalars['Int']>>;
  id?: InputMaybe<Scalars['ID']>;
  id_contains?: InputMaybe<Scalars['ID']>;
  id_ends_with?: InputMaybe<Scalars['ID']>;
  id_gt?: InputMaybe<Scalars['ID']>;
  id_gte?: InputMaybe<Scalars['ID']>;
  id_in?: InputMaybe<Array<Scalars['ID']>>;
  id_lt?: InputMaybe<Scalars['ID']>;
  id_lte?: InputMaybe<Scalars['ID']>;
  id_not?: InputMaybe<Scalars['ID']>;
  id_not_contains?: InputMaybe<Scalars['ID']>;
  id_not_ends_with?: InputMaybe<Scalars['ID']>;
  id_not_in?: InputMaybe<Array<Scalars['ID']>>;
  id_not_starts_with?: InputMaybe<Scalars['ID']>;
  id_starts_with?: InputMaybe<Scalars['ID']>;
  numberOfChallenges?: InputMaybe<Scalars['Int']>;
  numberOfChallenges_gt?: InputMaybe<Scalars['Int']>;
  numberOfChallenges_gte?: InputMaybe<Scalars['Int']>;
  numberOfChallenges_in?: InputMaybe<Array<Scalars['Int']>>;
  numberOfChallenges_lt?: InputMaybe<Scalars['Int']>;
  numberOfChallenges_lte?: InputMaybe<Scalars['Int']>;
  numberOfChallenges_not?: InputMaybe<Scalars['Int']>;
  numberOfChallenges_not_in?: InputMaybe<Array<Scalars['Int']>>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
  updatedAt_gt?: InputMaybe<Scalars['DateTime']>;
  updatedAt_gte?: InputMaybe<Scalars['DateTime']>;
  updatedAt_in?: InputMaybe<Array<Scalars['DateTime']>>;
  updatedAt_lt?: InputMaybe<Scalars['DateTime']>;
  updatedAt_lte?: InputMaybe<Scalars['DateTime']>;
  updatedAt_not?: InputMaybe<Scalars['DateTime']>;
  updatedAt_not_in?: InputMaybe<Array<Scalars['DateTime']>>;
};

export type ExerciseUpdateInput = {
  accuracy?: InputMaybe<Scalars['Decimal']>;
  challengeRequests?: InputMaybe<ChallengeRequestUpdateManyWithoutExerciseInput>;
  charactersPerMinute?: InputMaybe<Scalars['Decimal']>;
  extraDiamonds?: InputMaybe<Scalars['Int']>;
  level?: InputMaybe<LevelUpdateOneRequiredWithoutExercisesInput>;
  numberOfChallenges?: InputMaybe<Scalars['Int']>;
  user?: InputMaybe<GameUserUpdateOneRequiredInput>;
};

export type ExerciseUpdateManyDataInput = {
  accuracy?: InputMaybe<Scalars['Decimal']>;
  charactersPerMinute?: InputMaybe<Scalars['Decimal']>;
  extraDiamonds?: InputMaybe<Scalars['Int']>;
  numberOfChallenges?: InputMaybe<Scalars['Int']>;
};

export type ExerciseUpdateManyMutationInput = {
  accuracy?: InputMaybe<Scalars['Decimal']>;
  charactersPerMinute?: InputMaybe<Scalars['Decimal']>;
  extraDiamonds?: InputMaybe<Scalars['Int']>;
  numberOfChallenges?: InputMaybe<Scalars['Int']>;
};

export type ExerciseUpdateManyWithWhereNestedInput = {
  data: ExerciseUpdateManyDataInput;
  where: ExerciseScalarWhereInput;
};

export type ExerciseUpdateManyWithoutLevelInput = {
  connect?: InputMaybe<Array<ExerciseWhereUniqueInput>>;
  create?: InputMaybe<Array<ExerciseCreateWithoutLevelInput>>;
  delete?: InputMaybe<Array<ExerciseWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<ExerciseScalarWhereInput>>;
  disconnect?: InputMaybe<Array<ExerciseWhereUniqueInput>>;
  set?: InputMaybe<Array<ExerciseWhereUniqueInput>>;
  update?: InputMaybe<Array<ExerciseUpdateWithWhereUniqueWithoutLevelInput>>;
  updateMany?: InputMaybe<Array<ExerciseUpdateManyWithWhereNestedInput>>;
  upsert?: InputMaybe<Array<ExerciseUpsertWithWhereUniqueWithoutLevelInput>>;
};

export type ExerciseUpdateOneRequiredWithoutChallengeRequestsInput = {
  connect?: InputMaybe<ExerciseWhereUniqueInput>;
  create?: InputMaybe<ExerciseCreateWithoutChallengeRequestsInput>;
  update?: InputMaybe<ExerciseUpdateWithoutChallengeRequestsDataInput>;
  upsert?: InputMaybe<ExerciseUpsertWithoutChallengeRequestsInput>;
};

export type ExerciseUpdateWithWhereUniqueWithoutLevelInput = {
  data: ExerciseUpdateWithoutLevelDataInput;
  where: ExerciseWhereUniqueInput;
};

export type ExerciseUpdateWithoutChallengeRequestsDataInput = {
  accuracy?: InputMaybe<Scalars['Decimal']>;
  charactersPerMinute?: InputMaybe<Scalars['Decimal']>;
  extraDiamonds?: InputMaybe<Scalars['Int']>;
  level?: InputMaybe<LevelUpdateOneRequiredWithoutExercisesInput>;
  numberOfChallenges?: InputMaybe<Scalars['Int']>;
  user?: InputMaybe<GameUserUpdateOneRequiredInput>;
};

export type ExerciseUpdateWithoutLevelDataInput = {
  accuracy?: InputMaybe<Scalars['Decimal']>;
  challengeRequests?: InputMaybe<ChallengeRequestUpdateManyWithoutExerciseInput>;
  charactersPerMinute?: InputMaybe<Scalars['Decimal']>;
  extraDiamonds?: InputMaybe<Scalars['Int']>;
  numberOfChallenges?: InputMaybe<Scalars['Int']>;
  user?: InputMaybe<GameUserUpdateOneRequiredInput>;
};

export type ExerciseUpsertWithWhereUniqueWithoutLevelInput = {
  create: ExerciseCreateWithoutLevelInput;
  update: ExerciseUpdateWithoutLevelDataInput;
  where: ExerciseWhereUniqueInput;
};

export type ExerciseUpsertWithoutChallengeRequestsInput = {
  create: ExerciseCreateWithoutChallengeRequestsInput;
  update: ExerciseUpdateWithoutChallengeRequestsDataInput;
};

export type ExerciseWhereInput = {
  AND?: InputMaybe<Array<ExerciseWhereInput>>;
  NOT?: InputMaybe<Array<ExerciseWhereInput>>;
  OR?: InputMaybe<Array<ExerciseWhereInput>>;
  accuracy?: InputMaybe<Scalars['Decimal']>;
  accuracy_gt?: InputMaybe<Scalars['Decimal']>;
  accuracy_gte?: InputMaybe<Scalars['Decimal']>;
  accuracy_in?: InputMaybe<Array<Scalars['Decimal']>>;
  accuracy_lt?: InputMaybe<Scalars['Decimal']>;
  accuracy_lte?: InputMaybe<Scalars['Decimal']>;
  accuracy_not?: InputMaybe<Scalars['Decimal']>;
  accuracy_not_in?: InputMaybe<Array<Scalars['Decimal']>>;
  challengeRequests_every?: InputMaybe<ChallengeRequestWhereInput>;
  challengeRequests_none?: InputMaybe<ChallengeRequestWhereInput>;
  challengeRequests_some?: InputMaybe<ChallengeRequestWhereInput>;
  charactersPerMinute?: InputMaybe<Scalars['Decimal']>;
  charactersPerMinute_gt?: InputMaybe<Scalars['Decimal']>;
  charactersPerMinute_gte?: InputMaybe<Scalars['Decimal']>;
  charactersPerMinute_in?: InputMaybe<Array<Scalars['Decimal']>>;
  charactersPerMinute_lt?: InputMaybe<Scalars['Decimal']>;
  charactersPerMinute_lte?: InputMaybe<Scalars['Decimal']>;
  charactersPerMinute_not?: InputMaybe<Scalars['Decimal']>;
  charactersPerMinute_not_in?: InputMaybe<Array<Scalars['Decimal']>>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  createdAt_gt?: InputMaybe<Scalars['DateTime']>;
  createdAt_gte?: InputMaybe<Scalars['DateTime']>;
  createdAt_in?: InputMaybe<Array<Scalars['DateTime']>>;
  createdAt_lt?: InputMaybe<Scalars['DateTime']>;
  createdAt_lte?: InputMaybe<Scalars['DateTime']>;
  createdAt_not?: InputMaybe<Scalars['DateTime']>;
  createdAt_not_in?: InputMaybe<Array<Scalars['DateTime']>>;
  extraDiamonds?: InputMaybe<Scalars['Int']>;
  extraDiamonds_gt?: InputMaybe<Scalars['Int']>;
  extraDiamonds_gte?: InputMaybe<Scalars['Int']>;
  extraDiamonds_in?: InputMaybe<Array<Scalars['Int']>>;
  extraDiamonds_lt?: InputMaybe<Scalars['Int']>;
  extraDiamonds_lte?: InputMaybe<Scalars['Int']>;
  extraDiamonds_not?: InputMaybe<Scalars['Int']>;
  extraDiamonds_not_in?: InputMaybe<Array<Scalars['Int']>>;
  id?: InputMaybe<Scalars['ID']>;
  id_contains?: InputMaybe<Scalars['ID']>;
  id_ends_with?: InputMaybe<Scalars['ID']>;
  id_gt?: InputMaybe<Scalars['ID']>;
  id_gte?: InputMaybe<Scalars['ID']>;
  id_in?: InputMaybe<Array<Scalars['ID']>>;
  id_lt?: InputMaybe<Scalars['ID']>;
  id_lte?: InputMaybe<Scalars['ID']>;
  id_not?: InputMaybe<Scalars['ID']>;
  id_not_contains?: InputMaybe<Scalars['ID']>;
  id_not_ends_with?: InputMaybe<Scalars['ID']>;
  id_not_in?: InputMaybe<Array<Scalars['ID']>>;
  id_not_starts_with?: InputMaybe<Scalars['ID']>;
  id_starts_with?: InputMaybe<Scalars['ID']>;
  level?: InputMaybe<LevelWhereInput>;
  numberOfChallenges?: InputMaybe<Scalars['Int']>;
  numberOfChallenges_gt?: InputMaybe<Scalars['Int']>;
  numberOfChallenges_gte?: InputMaybe<Scalars['Int']>;
  numberOfChallenges_in?: InputMaybe<Array<Scalars['Int']>>;
  numberOfChallenges_lt?: InputMaybe<Scalars['Int']>;
  numberOfChallenges_lte?: InputMaybe<Scalars['Int']>;
  numberOfChallenges_not?: InputMaybe<Scalars['Int']>;
  numberOfChallenges_not_in?: InputMaybe<Array<Scalars['Int']>>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
  updatedAt_gt?: InputMaybe<Scalars['DateTime']>;
  updatedAt_gte?: InputMaybe<Scalars['DateTime']>;
  updatedAt_in?: InputMaybe<Array<Scalars['DateTime']>>;
  updatedAt_lt?: InputMaybe<Scalars['DateTime']>;
  updatedAt_lte?: InputMaybe<Scalars['DateTime']>;
  updatedAt_not?: InputMaybe<Scalars['DateTime']>;
  updatedAt_not_in?: InputMaybe<Array<Scalars['DateTime']>>;
  user?: InputMaybe<GameUserWhereInput>;
};

export type ExerciseWhereUniqueInput = {
  id?: InputMaybe<Scalars['ID']>;
};

export type ExtendedAccessRequestStatus =
  | 'DENIED'
  | 'EXPIRED'
  | 'GRANTED'
  | 'PENDING';

export type FilterMode = 'default' | 'insensitive';

export type FontType = 'CourierNew' | 'OpenDyslexic' | 'UbuntuMono';

export type ForgotPasswordInput = {
  login: Scalars['String'];
};

export type ForgotUsernamesInput = {
  email: Scalars['String'];
};

export type Game = 'TYPETUIN';

export type GameUser = {
  allowedToRequestDiploma: Scalars['Boolean'];
  allowedToRequestParticipationCertificate: Scalars['Boolean'];
  amountOfChallengesToCalculateStars?: Maybe<Scalars['Int']>;
  audioMuted: Scalars['Boolean'];
  averageAccuracy?: Maybe<Scalars['Decimal']>;
  averageCharactersPerMinute?: Maybe<Scalars['Decimal']>;
  charactersPerMinuteStandard: Scalars['Int'];
  createdAt: Scalars['DateTime'];
  diamonds: Scalars['Int'];
  diplomaIsSent: Scalars['Boolean'];
  displayedAlfredoMessages?: Maybe<Array<AlfredoMessageGameUser>>;
  earnedDiamonds: Scalars['Int'];
  /** 5 more days until unlocking exam */
  examOpeningDayCountDown: Scalars['Int'];
  examRequests?: Maybe<Array<Maybe<ChallengeRequest>>>;
  examResults?: Maybe<Array<Maybe<ChallengeResult>>>;
  examState: ExamState;
  firstSuccessfulTestExam?: Maybe<ChallengeResult>;
  focusMode: Scalars['Boolean'];
  fontType: FontType;
  gameCompleted: Scalars['Boolean'];
  gameCompletedDate?: Maybe<Scalars['DateTime']>;
  gamename?: Maybe<Scalars['String']>;
  hasRequestedDiploma: Scalars['Boolean'];
  hasRequestedParticipationCertificate: Scalars['Boolean'];
  hideDiamonds: Scalars['Boolean'];
  highestCups: Scalars['Int'];
  id: Scalars['ID'];
  introductionCompleted: Scalars['Boolean'];
  kwouwselAccessories: Array<Maybe<GameUserKwouwselAccessory>>;
  kwouwselUpgrades: Array<Maybe<GameUserKwouwselUpgrade>>;
  lastPlay?: Maybe<ChallengeResult>;
  lastSuccessfulTestExam?: Maybe<ChallengeResult>;
  miniGamesStates: MiniGamesStates;
  notDisplayedAlfredoMessages?: Maybe<Array<AlfredoMessage>>;
  participationCertificateIsSent: Scalars['Boolean'];
  practiceTime: Array<PracticeTimeBucket>;
  showInterpunct: Scalars['Boolean'];
  showPracticeTimeTimer: Scalars['Boolean'];
  stars?: Maybe<Scalars['Int']>;
  startedAt?: Maybe<Scalars['DateTime']>;
  testExamResults?: Maybe<Array<Maybe<ChallengeResult>>>;
  updatedAt: Scalars['DateTime'];
  usePersonalLevelSettings: Scalars['Boolean'];
  userId: Scalars['String'];
  userLevels: Array<UserLevel>;
};

export type GameUserPracticeTimeArgs = {
  bucket: TimeSeriesBucket;
  from: Scalars['DateTime'];
  to: Scalars['DateTime'];
};

export type GameUserConnection = {
  aggregate: AggregateGameUser;
  edges: Array<Maybe<GameUserEdge>>;
  pageInfo: PageInfo;
};

export type GameUserCreateInput = {
  audioMuted?: InputMaybe<Scalars['Boolean']>;
  charactersPerMinuteStandard?: InputMaybe<Scalars['Int']>;
  diamonds?: InputMaybe<Scalars['Int']>;
  diplomaIsSent?: InputMaybe<Scalars['Boolean']>;
  displayedAlfredoMessages?: InputMaybe<AlfredoMessageGameUserCreateManyWithoutGameUserInput>;
  earnedDiamonds?: InputMaybe<Scalars['Int']>;
  examState?: InputMaybe<ExamState>;
  exams?: InputMaybe<ChallengeResultCreateManyInput>;
  firstSuccessfulTestExam?: InputMaybe<ChallengeResultCreateOneInput>;
  focusMode?: InputMaybe<Scalars['Boolean']>;
  fontType?: InputMaybe<FontType>;
  gameCompleted?: InputMaybe<Scalars['Boolean']>;
  gameCompletedDate?: InputMaybe<Scalars['DateTime']>;
  gamename?: InputMaybe<Scalars['String']>;
  hasRequestedDiploma?: InputMaybe<Scalars['Boolean']>;
  hasRequestedParticipationCertificate?: InputMaybe<Scalars['Boolean']>;
  hideDiamonds?: InputMaybe<Scalars['Boolean']>;
  highestCups?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['ID']>;
  introductionCompleted?: InputMaybe<Scalars['Boolean']>;
  kwouwselAccessories?: InputMaybe<GameUserKwouwselAccessoryCreateManyWithoutUserInput>;
  kwouwselUpgrades?: InputMaybe<GameUserKwouwselUpgradeCreateManyWithoutUserInput>;
  lastPlay?: InputMaybe<ChallengeResultCreateOneInput>;
  lastSuccessfulTestExam?: InputMaybe<ChallengeResultCreateOneInput>;
  participationCertificateIsSent?: InputMaybe<Scalars['Boolean']>;
  showInterpunct?: InputMaybe<Scalars['Boolean']>;
  startedAt?: InputMaybe<Scalars['DateTime']>;
  usePersonalLevelSettings?: InputMaybe<Scalars['Boolean']>;
  userId: Scalars['String'];
  userLevels?: InputMaybe<UserLevelCreateManyWithoutUserInput>;
};

export type GameUserCreateOneInput = {
  connect?: InputMaybe<GameUserWhereUniqueInput>;
  create?: InputMaybe<GameUserCreateInput>;
};

export type GameUserCreateOneWithoutDisplayedAlfredoMessagesInput = {
  connect?: InputMaybe<GameUserWhereUniqueInput>;
  create?: InputMaybe<GameUserCreateWithoutDisplayedAlfredoMessagesInput>;
};

export type GameUserCreateOneWithoutKwouwselAccessoriesInput = {
  connect?: InputMaybe<GameUserWhereUniqueInput>;
  create?: InputMaybe<GameUserCreateWithoutKwouwselAccessoriesInput>;
};

export type GameUserCreateOneWithoutKwouwselUpgradesInput = {
  connect?: InputMaybe<GameUserWhereUniqueInput>;
  create?: InputMaybe<GameUserCreateWithoutKwouwselUpgradesInput>;
};

export type GameUserCreateOneWithoutUserLevelsInput = {
  connect?: InputMaybe<GameUserWhereUniqueInput>;
  create?: InputMaybe<GameUserCreateWithoutUserLevelsInput>;
};

export type GameUserCreateWithoutDisplayedAlfredoMessagesInput = {
  audioMuted?: InputMaybe<Scalars['Boolean']>;
  charactersPerMinuteStandard?: InputMaybe<Scalars['Int']>;
  diamonds?: InputMaybe<Scalars['Int']>;
  diplomaIsSent?: InputMaybe<Scalars['Boolean']>;
  earnedDiamonds?: InputMaybe<Scalars['Int']>;
  examState?: InputMaybe<ExamState>;
  exams?: InputMaybe<ChallengeResultCreateManyInput>;
  firstSuccessfulTestExam?: InputMaybe<ChallengeResultCreateOneInput>;
  focusMode?: InputMaybe<Scalars['Boolean']>;
  fontType?: InputMaybe<FontType>;
  gameCompleted?: InputMaybe<Scalars['Boolean']>;
  gameCompletedDate?: InputMaybe<Scalars['DateTime']>;
  gamename?: InputMaybe<Scalars['String']>;
  hasRequestedDiploma?: InputMaybe<Scalars['Boolean']>;
  hasRequestedParticipationCertificate?: InputMaybe<Scalars['Boolean']>;
  hideDiamonds?: InputMaybe<Scalars['Boolean']>;
  highestCups?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['ID']>;
  introductionCompleted?: InputMaybe<Scalars['Boolean']>;
  kwouwselAccessories?: InputMaybe<GameUserKwouwselAccessoryCreateManyWithoutUserInput>;
  kwouwselUpgrades?: InputMaybe<GameUserKwouwselUpgradeCreateManyWithoutUserInput>;
  lastPlay?: InputMaybe<ChallengeResultCreateOneInput>;
  lastSuccessfulTestExam?: InputMaybe<ChallengeResultCreateOneInput>;
  participationCertificateIsSent?: InputMaybe<Scalars['Boolean']>;
  showInterpunct?: InputMaybe<Scalars['Boolean']>;
  startedAt?: InputMaybe<Scalars['DateTime']>;
  usePersonalLevelSettings?: InputMaybe<Scalars['Boolean']>;
  userId: Scalars['String'];
  userLevels?: InputMaybe<UserLevelCreateManyWithoutUserInput>;
};

export type GameUserCreateWithoutKwouwselAccessoriesInput = {
  audioMuted?: InputMaybe<Scalars['Boolean']>;
  charactersPerMinuteStandard?: InputMaybe<Scalars['Int']>;
  diamonds?: InputMaybe<Scalars['Int']>;
  diplomaIsSent?: InputMaybe<Scalars['Boolean']>;
  displayedAlfredoMessages?: InputMaybe<AlfredoMessageGameUserCreateManyWithoutGameUserInput>;
  earnedDiamonds?: InputMaybe<Scalars['Int']>;
  examState?: InputMaybe<ExamState>;
  exams?: InputMaybe<ChallengeResultCreateManyInput>;
  firstSuccessfulTestExam?: InputMaybe<ChallengeResultCreateOneInput>;
  focusMode?: InputMaybe<Scalars['Boolean']>;
  fontType?: InputMaybe<FontType>;
  gameCompleted?: InputMaybe<Scalars['Boolean']>;
  gameCompletedDate?: InputMaybe<Scalars['DateTime']>;
  gamename?: InputMaybe<Scalars['String']>;
  hasRequestedDiploma?: InputMaybe<Scalars['Boolean']>;
  hasRequestedParticipationCertificate?: InputMaybe<Scalars['Boolean']>;
  hideDiamonds?: InputMaybe<Scalars['Boolean']>;
  highestCups?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['ID']>;
  introductionCompleted?: InputMaybe<Scalars['Boolean']>;
  kwouwselUpgrades?: InputMaybe<GameUserKwouwselUpgradeCreateManyWithoutUserInput>;
  lastPlay?: InputMaybe<ChallengeResultCreateOneInput>;
  lastSuccessfulTestExam?: InputMaybe<ChallengeResultCreateOneInput>;
  participationCertificateIsSent?: InputMaybe<Scalars['Boolean']>;
  showInterpunct?: InputMaybe<Scalars['Boolean']>;
  startedAt?: InputMaybe<Scalars['DateTime']>;
  usePersonalLevelSettings?: InputMaybe<Scalars['Boolean']>;
  userId: Scalars['String'];
  userLevels?: InputMaybe<UserLevelCreateManyWithoutUserInput>;
};

export type GameUserCreateWithoutKwouwselUpgradesInput = {
  audioMuted?: InputMaybe<Scalars['Boolean']>;
  charactersPerMinuteStandard?: InputMaybe<Scalars['Int']>;
  diamonds?: InputMaybe<Scalars['Int']>;
  diplomaIsSent?: InputMaybe<Scalars['Boolean']>;
  displayedAlfredoMessages?: InputMaybe<AlfredoMessageGameUserCreateManyWithoutGameUserInput>;
  earnedDiamonds?: InputMaybe<Scalars['Int']>;
  examState?: InputMaybe<ExamState>;
  exams?: InputMaybe<ChallengeResultCreateManyInput>;
  firstSuccessfulTestExam?: InputMaybe<ChallengeResultCreateOneInput>;
  focusMode?: InputMaybe<Scalars['Boolean']>;
  fontType?: InputMaybe<FontType>;
  gameCompleted?: InputMaybe<Scalars['Boolean']>;
  gameCompletedDate?: InputMaybe<Scalars['DateTime']>;
  gamename?: InputMaybe<Scalars['String']>;
  hasRequestedDiploma?: InputMaybe<Scalars['Boolean']>;
  hasRequestedParticipationCertificate?: InputMaybe<Scalars['Boolean']>;
  hideDiamonds?: InputMaybe<Scalars['Boolean']>;
  highestCups?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['ID']>;
  introductionCompleted?: InputMaybe<Scalars['Boolean']>;
  kwouwselAccessories?: InputMaybe<GameUserKwouwselAccessoryCreateManyWithoutUserInput>;
  lastPlay?: InputMaybe<ChallengeResultCreateOneInput>;
  lastSuccessfulTestExam?: InputMaybe<ChallengeResultCreateOneInput>;
  participationCertificateIsSent?: InputMaybe<Scalars['Boolean']>;
  showInterpunct?: InputMaybe<Scalars['Boolean']>;
  startedAt?: InputMaybe<Scalars['DateTime']>;
  usePersonalLevelSettings?: InputMaybe<Scalars['Boolean']>;
  userId: Scalars['String'];
  userLevels?: InputMaybe<UserLevelCreateManyWithoutUserInput>;
};

export type GameUserCreateWithoutUserLevelsInput = {
  audioMuted?: InputMaybe<Scalars['Boolean']>;
  charactersPerMinuteStandard?: InputMaybe<Scalars['Int']>;
  diamonds?: InputMaybe<Scalars['Int']>;
  diplomaIsSent?: InputMaybe<Scalars['Boolean']>;
  displayedAlfredoMessages?: InputMaybe<AlfredoMessageGameUserCreateManyWithoutGameUserInput>;
  earnedDiamonds?: InputMaybe<Scalars['Int']>;
  examState?: InputMaybe<ExamState>;
  exams?: InputMaybe<ChallengeResultCreateManyInput>;
  firstSuccessfulTestExam?: InputMaybe<ChallengeResultCreateOneInput>;
  focusMode?: InputMaybe<Scalars['Boolean']>;
  fontType?: InputMaybe<FontType>;
  gameCompleted?: InputMaybe<Scalars['Boolean']>;
  gameCompletedDate?: InputMaybe<Scalars['DateTime']>;
  gamename?: InputMaybe<Scalars['String']>;
  hasRequestedDiploma?: InputMaybe<Scalars['Boolean']>;
  hasRequestedParticipationCertificate?: InputMaybe<Scalars['Boolean']>;
  hideDiamonds?: InputMaybe<Scalars['Boolean']>;
  highestCups?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['ID']>;
  introductionCompleted?: InputMaybe<Scalars['Boolean']>;
  kwouwselAccessories?: InputMaybe<GameUserKwouwselAccessoryCreateManyWithoutUserInput>;
  kwouwselUpgrades?: InputMaybe<GameUserKwouwselUpgradeCreateManyWithoutUserInput>;
  lastPlay?: InputMaybe<ChallengeResultCreateOneInput>;
  lastSuccessfulTestExam?: InputMaybe<ChallengeResultCreateOneInput>;
  participationCertificateIsSent?: InputMaybe<Scalars['Boolean']>;
  showInterpunct?: InputMaybe<Scalars['Boolean']>;
  startedAt?: InputMaybe<Scalars['DateTime']>;
  usePersonalLevelSettings?: InputMaybe<Scalars['Boolean']>;
  userId: Scalars['String'];
};

export type GameUserEdge = {
  cursor: Scalars['String'];
  node: GameUser;
};

export type GameUserKwouwselAccessory = {
  active: Scalars['Boolean'];
  bought: Scalars['Boolean'];
  createdAt: Scalars['DateTime'];
  id: Scalars['ID'];
  type: KwouwselAccessory;
  updatedAt: Scalars['DateTime'];
  user: GameUser;
};

export type GameUserKwouwselAccessoryConnection = {
  aggregate: AggregateGameUserKwouwselAccessory;
  edges: Array<Maybe<GameUserKwouwselAccessoryEdge>>;
  pageInfo: PageInfo;
};

export type GameUserKwouwselAccessoryCreateInput = {
  active?: InputMaybe<Scalars['Boolean']>;
  bought?: InputMaybe<Scalars['Boolean']>;
  id?: InputMaybe<Scalars['ID']>;
  type: KwouwselAccessoryCreateOneInput;
  user: GameUserCreateOneWithoutKwouwselAccessoriesInput;
};

export type GameUserKwouwselAccessoryCreateManyWithoutUserInput = {
  connect?: InputMaybe<Array<GameUserKwouwselAccessoryWhereUniqueInput>>;
  create?: InputMaybe<Array<GameUserKwouwselAccessoryCreateWithoutUserInput>>;
};

export type GameUserKwouwselAccessoryCreateWithoutUserInput = {
  active?: InputMaybe<Scalars['Boolean']>;
  bought?: InputMaybe<Scalars['Boolean']>;
  id?: InputMaybe<Scalars['ID']>;
  type: KwouwselAccessoryCreateOneInput;
};

export type GameUserKwouwselAccessoryEdge = {
  cursor: Scalars['String'];
  node: GameUserKwouwselAccessory;
};

export type GameUserKwouwselAccessoryOrderByInput =
  | 'active_ASC'
  | 'active_DESC'
  | 'bought_ASC'
  | 'bought_DESC'
  | 'createdAt_ASC'
  | 'createdAt_DESC'
  | 'id_ASC'
  | 'id_DESC'
  | 'updatedAt_ASC'
  | 'updatedAt_DESC';

export type GameUserKwouwselAccessoryScalarWhereInput = {
  AND?: InputMaybe<Array<GameUserKwouwselAccessoryScalarWhereInput>>;
  NOT?: InputMaybe<Array<GameUserKwouwselAccessoryScalarWhereInput>>;
  OR?: InputMaybe<Array<GameUserKwouwselAccessoryScalarWhereInput>>;
  active?: InputMaybe<Scalars['Boolean']>;
  active_not?: InputMaybe<Scalars['Boolean']>;
  bought?: InputMaybe<Scalars['Boolean']>;
  bought_not?: InputMaybe<Scalars['Boolean']>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  createdAt_gt?: InputMaybe<Scalars['DateTime']>;
  createdAt_gte?: InputMaybe<Scalars['DateTime']>;
  createdAt_in?: InputMaybe<Array<Scalars['DateTime']>>;
  createdAt_lt?: InputMaybe<Scalars['DateTime']>;
  createdAt_lte?: InputMaybe<Scalars['DateTime']>;
  createdAt_not?: InputMaybe<Scalars['DateTime']>;
  createdAt_not_in?: InputMaybe<Array<Scalars['DateTime']>>;
  id?: InputMaybe<Scalars['ID']>;
  id_contains?: InputMaybe<Scalars['ID']>;
  id_ends_with?: InputMaybe<Scalars['ID']>;
  id_gt?: InputMaybe<Scalars['ID']>;
  id_gte?: InputMaybe<Scalars['ID']>;
  id_in?: InputMaybe<Array<Scalars['ID']>>;
  id_lt?: InputMaybe<Scalars['ID']>;
  id_lte?: InputMaybe<Scalars['ID']>;
  id_not?: InputMaybe<Scalars['ID']>;
  id_not_contains?: InputMaybe<Scalars['ID']>;
  id_not_ends_with?: InputMaybe<Scalars['ID']>;
  id_not_in?: InputMaybe<Array<Scalars['ID']>>;
  id_not_starts_with?: InputMaybe<Scalars['ID']>;
  id_starts_with?: InputMaybe<Scalars['ID']>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
  updatedAt_gt?: InputMaybe<Scalars['DateTime']>;
  updatedAt_gte?: InputMaybe<Scalars['DateTime']>;
  updatedAt_in?: InputMaybe<Array<Scalars['DateTime']>>;
  updatedAt_lt?: InputMaybe<Scalars['DateTime']>;
  updatedAt_lte?: InputMaybe<Scalars['DateTime']>;
  updatedAt_not?: InputMaybe<Scalars['DateTime']>;
  updatedAt_not_in?: InputMaybe<Array<Scalars['DateTime']>>;
};

export type GameUserKwouwselAccessoryUpdateInput = {
  active?: InputMaybe<Scalars['Boolean']>;
  bought?: InputMaybe<Scalars['Boolean']>;
  type?: InputMaybe<KwouwselAccessoryUpdateOneRequiredInput>;
  user?: InputMaybe<GameUserUpdateOneRequiredWithoutKwouwselAccessoriesInput>;
};

export type GameUserKwouwselAccessoryUpdateManyDataInput = {
  active?: InputMaybe<Scalars['Boolean']>;
  bought?: InputMaybe<Scalars['Boolean']>;
};

export type GameUserKwouwselAccessoryUpdateManyMutationInput = {
  active?: InputMaybe<Scalars['Boolean']>;
  bought?: InputMaybe<Scalars['Boolean']>;
};

export type GameUserKwouwselAccessoryUpdateManyWithWhereNestedInput = {
  data: GameUserKwouwselAccessoryUpdateManyDataInput;
  where: GameUserKwouwselAccessoryScalarWhereInput;
};

export type GameUserKwouwselAccessoryUpdateManyWithoutUserInput = {
  connect?: InputMaybe<Array<GameUserKwouwselAccessoryWhereUniqueInput>>;
  create?: InputMaybe<Array<GameUserKwouwselAccessoryCreateWithoutUserInput>>;
  delete?: InputMaybe<Array<GameUserKwouwselAccessoryWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<GameUserKwouwselAccessoryScalarWhereInput>>;
  disconnect?: InputMaybe<Array<GameUserKwouwselAccessoryWhereUniqueInput>>;
  set?: InputMaybe<Array<GameUserKwouwselAccessoryWhereUniqueInput>>;
  update?: InputMaybe<
    Array<GameUserKwouwselAccessoryUpdateWithWhereUniqueWithoutUserInput>
  >;
  updateMany?: InputMaybe<
    Array<GameUserKwouwselAccessoryUpdateManyWithWhereNestedInput>
  >;
  upsert?: InputMaybe<
    Array<GameUserKwouwselAccessoryUpsertWithWhereUniqueWithoutUserInput>
  >;
};

export type GameUserKwouwselAccessoryUpdateWithWhereUniqueWithoutUserInput = {
  data: GameUserKwouwselAccessoryUpdateWithoutUserDataInput;
  where: GameUserKwouwselAccessoryWhereUniqueInput;
};

export type GameUserKwouwselAccessoryUpdateWithoutUserDataInput = {
  active?: InputMaybe<Scalars['Boolean']>;
  bought?: InputMaybe<Scalars['Boolean']>;
  type?: InputMaybe<KwouwselAccessoryUpdateOneRequiredInput>;
};

export type GameUserKwouwselAccessoryUpsertWithWhereUniqueWithoutUserInput = {
  create: GameUserKwouwselAccessoryCreateWithoutUserInput;
  update: GameUserKwouwselAccessoryUpdateWithoutUserDataInput;
  where: GameUserKwouwselAccessoryWhereUniqueInput;
};

export type GameUserKwouwselAccessoryWhereInput = {
  AND?: InputMaybe<Array<GameUserKwouwselAccessoryWhereInput>>;
  NOT?: InputMaybe<Array<GameUserKwouwselAccessoryWhereInput>>;
  OR?: InputMaybe<Array<GameUserKwouwselAccessoryWhereInput>>;
  active?: InputMaybe<Scalars['Boolean']>;
  active_not?: InputMaybe<Scalars['Boolean']>;
  bought?: InputMaybe<Scalars['Boolean']>;
  bought_not?: InputMaybe<Scalars['Boolean']>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  createdAt_gt?: InputMaybe<Scalars['DateTime']>;
  createdAt_gte?: InputMaybe<Scalars['DateTime']>;
  createdAt_in?: InputMaybe<Array<Scalars['DateTime']>>;
  createdAt_lt?: InputMaybe<Scalars['DateTime']>;
  createdAt_lte?: InputMaybe<Scalars['DateTime']>;
  createdAt_not?: InputMaybe<Scalars['DateTime']>;
  createdAt_not_in?: InputMaybe<Array<Scalars['DateTime']>>;
  id?: InputMaybe<Scalars['ID']>;
  id_contains?: InputMaybe<Scalars['ID']>;
  id_ends_with?: InputMaybe<Scalars['ID']>;
  id_gt?: InputMaybe<Scalars['ID']>;
  id_gte?: InputMaybe<Scalars['ID']>;
  id_in?: InputMaybe<Array<Scalars['ID']>>;
  id_lt?: InputMaybe<Scalars['ID']>;
  id_lte?: InputMaybe<Scalars['ID']>;
  id_not?: InputMaybe<Scalars['ID']>;
  id_not_contains?: InputMaybe<Scalars['ID']>;
  id_not_ends_with?: InputMaybe<Scalars['ID']>;
  id_not_in?: InputMaybe<Array<Scalars['ID']>>;
  id_not_starts_with?: InputMaybe<Scalars['ID']>;
  id_starts_with?: InputMaybe<Scalars['ID']>;
  type?: InputMaybe<KwouwselAccessoryWhereInput>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
  updatedAt_gt?: InputMaybe<Scalars['DateTime']>;
  updatedAt_gte?: InputMaybe<Scalars['DateTime']>;
  updatedAt_in?: InputMaybe<Array<Scalars['DateTime']>>;
  updatedAt_lt?: InputMaybe<Scalars['DateTime']>;
  updatedAt_lte?: InputMaybe<Scalars['DateTime']>;
  updatedAt_not?: InputMaybe<Scalars['DateTime']>;
  updatedAt_not_in?: InputMaybe<Array<Scalars['DateTime']>>;
  user?: InputMaybe<GameUserWhereInput>;
};

export type GameUserKwouwselAccessoryWhereUniqueInput = {
  id?: InputMaybe<Scalars['ID']>;
};

export type GameUserKwouwselUpgrade = {
  active: Scalars['Boolean'];
  bought: Scalars['Boolean'];
  createdAt: Scalars['DateTime'];
  id: Scalars['ID'];
  type: KwouwselUpgrade;
  updatedAt: Scalars['DateTime'];
  user: GameUser;
};

export type GameUserKwouwselUpgradeConnection = {
  aggregate: AggregateGameUserKwouwselUpgrade;
  edges: Array<Maybe<GameUserKwouwselUpgradeEdge>>;
  pageInfo: PageInfo;
};

export type GameUserKwouwselUpgradeCreateInput = {
  active?: InputMaybe<Scalars['Boolean']>;
  bought?: InputMaybe<Scalars['Boolean']>;
  id?: InputMaybe<Scalars['ID']>;
  type: KwouwselUpgradeCreateOneInput;
  user: GameUserCreateOneWithoutKwouwselUpgradesInput;
};

export type GameUserKwouwselUpgradeCreateManyWithoutUserInput = {
  connect?: InputMaybe<Array<GameUserKwouwselUpgradeWhereUniqueInput>>;
  create?: InputMaybe<Array<GameUserKwouwselUpgradeCreateWithoutUserInput>>;
};

export type GameUserKwouwselUpgradeCreateWithoutUserInput = {
  active?: InputMaybe<Scalars['Boolean']>;
  bought?: InputMaybe<Scalars['Boolean']>;
  id?: InputMaybe<Scalars['ID']>;
  type: KwouwselUpgradeCreateOneInput;
};

export type GameUserKwouwselUpgradeEdge = {
  cursor: Scalars['String'];
  node: GameUserKwouwselUpgrade;
};

export type GameUserKwouwselUpgradeOrderByInput =
  | 'active_ASC'
  | 'active_DESC'
  | 'bought_ASC'
  | 'bought_DESC'
  | 'createdAt_ASC'
  | 'createdAt_DESC'
  | 'id_ASC'
  | 'id_DESC'
  | 'updatedAt_ASC'
  | 'updatedAt_DESC';

export type GameUserKwouwselUpgradeScalarWhereInput = {
  AND?: InputMaybe<Array<GameUserKwouwselUpgradeScalarWhereInput>>;
  NOT?: InputMaybe<Array<GameUserKwouwselUpgradeScalarWhereInput>>;
  OR?: InputMaybe<Array<GameUserKwouwselUpgradeScalarWhereInput>>;
  active?: InputMaybe<Scalars['Boolean']>;
  active_not?: InputMaybe<Scalars['Boolean']>;
  bought?: InputMaybe<Scalars['Boolean']>;
  bought_not?: InputMaybe<Scalars['Boolean']>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  createdAt_gt?: InputMaybe<Scalars['DateTime']>;
  createdAt_gte?: InputMaybe<Scalars['DateTime']>;
  createdAt_in?: InputMaybe<Array<Scalars['DateTime']>>;
  createdAt_lt?: InputMaybe<Scalars['DateTime']>;
  createdAt_lte?: InputMaybe<Scalars['DateTime']>;
  createdAt_not?: InputMaybe<Scalars['DateTime']>;
  createdAt_not_in?: InputMaybe<Array<Scalars['DateTime']>>;
  id?: InputMaybe<Scalars['ID']>;
  id_contains?: InputMaybe<Scalars['ID']>;
  id_ends_with?: InputMaybe<Scalars['ID']>;
  id_gt?: InputMaybe<Scalars['ID']>;
  id_gte?: InputMaybe<Scalars['ID']>;
  id_in?: InputMaybe<Array<Scalars['ID']>>;
  id_lt?: InputMaybe<Scalars['ID']>;
  id_lte?: InputMaybe<Scalars['ID']>;
  id_not?: InputMaybe<Scalars['ID']>;
  id_not_contains?: InputMaybe<Scalars['ID']>;
  id_not_ends_with?: InputMaybe<Scalars['ID']>;
  id_not_in?: InputMaybe<Array<Scalars['ID']>>;
  id_not_starts_with?: InputMaybe<Scalars['ID']>;
  id_starts_with?: InputMaybe<Scalars['ID']>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
  updatedAt_gt?: InputMaybe<Scalars['DateTime']>;
  updatedAt_gte?: InputMaybe<Scalars['DateTime']>;
  updatedAt_in?: InputMaybe<Array<Scalars['DateTime']>>;
  updatedAt_lt?: InputMaybe<Scalars['DateTime']>;
  updatedAt_lte?: InputMaybe<Scalars['DateTime']>;
  updatedAt_not?: InputMaybe<Scalars['DateTime']>;
  updatedAt_not_in?: InputMaybe<Array<Scalars['DateTime']>>;
};

export type GameUserKwouwselUpgradeUpdateInput = {
  active?: InputMaybe<Scalars['Boolean']>;
  bought?: InputMaybe<Scalars['Boolean']>;
  type?: InputMaybe<KwouwselUpgradeUpdateOneRequiredInput>;
  user?: InputMaybe<GameUserUpdateOneRequiredWithoutKwouwselUpgradesInput>;
};

export type GameUserKwouwselUpgradeUpdateManyDataInput = {
  active?: InputMaybe<Scalars['Boolean']>;
  bought?: InputMaybe<Scalars['Boolean']>;
};

export type GameUserKwouwselUpgradeUpdateManyMutationInput = {
  active?: InputMaybe<Scalars['Boolean']>;
  bought?: InputMaybe<Scalars['Boolean']>;
};

export type GameUserKwouwselUpgradeUpdateManyWithWhereNestedInput = {
  data: GameUserKwouwselUpgradeUpdateManyDataInput;
  where: GameUserKwouwselUpgradeScalarWhereInput;
};

export type GameUserKwouwselUpgradeUpdateManyWithoutUserInput = {
  connect?: InputMaybe<Array<GameUserKwouwselUpgradeWhereUniqueInput>>;
  create?: InputMaybe<Array<GameUserKwouwselUpgradeCreateWithoutUserInput>>;
  delete?: InputMaybe<Array<GameUserKwouwselUpgradeWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<GameUserKwouwselUpgradeScalarWhereInput>>;
  disconnect?: InputMaybe<Array<GameUserKwouwselUpgradeWhereUniqueInput>>;
  set?: InputMaybe<Array<GameUserKwouwselUpgradeWhereUniqueInput>>;
  update?: InputMaybe<
    Array<GameUserKwouwselUpgradeUpdateWithWhereUniqueWithoutUserInput>
  >;
  updateMany?: InputMaybe<
    Array<GameUserKwouwselUpgradeUpdateManyWithWhereNestedInput>
  >;
  upsert?: InputMaybe<
    Array<GameUserKwouwselUpgradeUpsertWithWhereUniqueWithoutUserInput>
  >;
};

export type GameUserKwouwselUpgradeUpdateWithWhereUniqueWithoutUserInput = {
  data: GameUserKwouwselUpgradeUpdateWithoutUserDataInput;
  where: GameUserKwouwselUpgradeWhereUniqueInput;
};

export type GameUserKwouwselUpgradeUpdateWithoutUserDataInput = {
  active?: InputMaybe<Scalars['Boolean']>;
  bought?: InputMaybe<Scalars['Boolean']>;
  type?: InputMaybe<KwouwselUpgradeUpdateOneRequiredInput>;
};

export type GameUserKwouwselUpgradeUpsertWithWhereUniqueWithoutUserInput = {
  create: GameUserKwouwselUpgradeCreateWithoutUserInput;
  update: GameUserKwouwselUpgradeUpdateWithoutUserDataInput;
  where: GameUserKwouwselUpgradeWhereUniqueInput;
};

export type GameUserKwouwselUpgradeWhereInput = {
  AND?: InputMaybe<Array<GameUserKwouwselUpgradeWhereInput>>;
  NOT?: InputMaybe<Array<GameUserKwouwselUpgradeWhereInput>>;
  OR?: InputMaybe<Array<GameUserKwouwselUpgradeWhereInput>>;
  active?: InputMaybe<Scalars['Boolean']>;
  active_not?: InputMaybe<Scalars['Boolean']>;
  bought?: InputMaybe<Scalars['Boolean']>;
  bought_not?: InputMaybe<Scalars['Boolean']>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  createdAt_gt?: InputMaybe<Scalars['DateTime']>;
  createdAt_gte?: InputMaybe<Scalars['DateTime']>;
  createdAt_in?: InputMaybe<Array<Scalars['DateTime']>>;
  createdAt_lt?: InputMaybe<Scalars['DateTime']>;
  createdAt_lte?: InputMaybe<Scalars['DateTime']>;
  createdAt_not?: InputMaybe<Scalars['DateTime']>;
  createdAt_not_in?: InputMaybe<Array<Scalars['DateTime']>>;
  id?: InputMaybe<Scalars['ID']>;
  id_contains?: InputMaybe<Scalars['ID']>;
  id_ends_with?: InputMaybe<Scalars['ID']>;
  id_gt?: InputMaybe<Scalars['ID']>;
  id_gte?: InputMaybe<Scalars['ID']>;
  id_in?: InputMaybe<Array<Scalars['ID']>>;
  id_lt?: InputMaybe<Scalars['ID']>;
  id_lte?: InputMaybe<Scalars['ID']>;
  id_not?: InputMaybe<Scalars['ID']>;
  id_not_contains?: InputMaybe<Scalars['ID']>;
  id_not_ends_with?: InputMaybe<Scalars['ID']>;
  id_not_in?: InputMaybe<Array<Scalars['ID']>>;
  id_not_starts_with?: InputMaybe<Scalars['ID']>;
  id_starts_with?: InputMaybe<Scalars['ID']>;
  type?: InputMaybe<KwouwselUpgradeWhereInput>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
  updatedAt_gt?: InputMaybe<Scalars['DateTime']>;
  updatedAt_gte?: InputMaybe<Scalars['DateTime']>;
  updatedAt_in?: InputMaybe<Array<Scalars['DateTime']>>;
  updatedAt_lt?: InputMaybe<Scalars['DateTime']>;
  updatedAt_lte?: InputMaybe<Scalars['DateTime']>;
  updatedAt_not?: InputMaybe<Scalars['DateTime']>;
  updatedAt_not_in?: InputMaybe<Array<Scalars['DateTime']>>;
  user?: InputMaybe<GameUserWhereInput>;
};

export type GameUserKwouwselUpgradeWhereUniqueInput = {
  id?: InputMaybe<Scalars['ID']>;
};

export type GameUserOrderByInput =
  | 'audioMuted_ASC'
  | 'audioMuted_DESC'
  | 'charactersPerMinuteStandard_ASC'
  | 'charactersPerMinuteStandard_DESC'
  | 'createdAt_ASC'
  | 'createdAt_DESC'
  | 'diamonds_ASC'
  | 'diamonds_DESC'
  | 'diplomaIsSent_ASC'
  | 'diplomaIsSent_DESC'
  | 'earnedDiamonds_ASC'
  | 'earnedDiamonds_DESC'
  | 'examState_ASC'
  | 'examState_DESC'
  | 'focusMode_ASC'
  | 'focusMode_DESC'
  | 'fontType_ASC'
  | 'fontType_DESC'
  | 'gameCompletedDate_ASC'
  | 'gameCompletedDate_DESC'
  | 'gameCompleted_ASC'
  | 'gameCompleted_DESC'
  | 'gamename_ASC'
  | 'gamename_DESC'
  | 'hasRequestedDiploma_ASC'
  | 'hasRequestedDiploma_DESC'
  | 'hasRequestedParticipationCertificate_ASC'
  | 'hasRequestedParticipationCertificate_DESC'
  | 'hideDiamonds_ASC'
  | 'hideDiamonds_DESC'
  | 'highestCups_ASC'
  | 'highestCups_DESC'
  | 'id_ASC'
  | 'id_DESC'
  | 'introductionCompleted_ASC'
  | 'introductionCompleted_DESC'
  | 'participationCertificateIsSent_ASC'
  | 'participationCertificateIsSent_DESC'
  | 'showInterpunct_ASC'
  | 'showInterpunct_DESC'
  | 'startedAt_ASC'
  | 'startedAt_DESC'
  | 'updatedAt_ASC'
  | 'updatedAt_DESC'
  | 'usePersonalLevelSettings_ASC'
  | 'usePersonalLevelSettings_DESC'
  | 'userId_ASC'
  | 'userId_DESC';

export type GameUserUpdateDataInput = {
  audioMuted?: InputMaybe<Scalars['Boolean']>;
  charactersPerMinuteStandard?: InputMaybe<Scalars['Int']>;
  diamonds?: InputMaybe<Scalars['Int']>;
  diplomaIsSent?: InputMaybe<Scalars['Boolean']>;
  displayedAlfredoMessages?: InputMaybe<AlfredoMessageGameUserUpdateManyWithoutGameUserInput>;
  earnedDiamonds?: InputMaybe<Scalars['Int']>;
  examState?: InputMaybe<ExamState>;
  exams?: InputMaybe<ChallengeResultUpdateManyInput>;
  firstSuccessfulTestExam?: InputMaybe<ChallengeResultUpdateOneInput>;
  focusMode?: InputMaybe<Scalars['Boolean']>;
  fontType?: InputMaybe<FontType>;
  gameCompleted?: InputMaybe<Scalars['Boolean']>;
  gameCompletedDate?: InputMaybe<Scalars['DateTime']>;
  gamename?: InputMaybe<Scalars['String']>;
  hasRequestedDiploma?: InputMaybe<Scalars['Boolean']>;
  hasRequestedParticipationCertificate?: InputMaybe<Scalars['Boolean']>;
  hideDiamonds?: InputMaybe<Scalars['Boolean']>;
  highestCups?: InputMaybe<Scalars['Int']>;
  introductionCompleted?: InputMaybe<Scalars['Boolean']>;
  kwouwselAccessories?: InputMaybe<GameUserKwouwselAccessoryUpdateManyWithoutUserInput>;
  kwouwselUpgrades?: InputMaybe<GameUserKwouwselUpgradeUpdateManyWithoutUserInput>;
  lastPlay?: InputMaybe<ChallengeResultUpdateOneInput>;
  lastSuccessfulTestExam?: InputMaybe<ChallengeResultUpdateOneInput>;
  participationCertificateIsSent?: InputMaybe<Scalars['Boolean']>;
  showInterpunct?: InputMaybe<Scalars['Boolean']>;
  startedAt?: InputMaybe<Scalars['DateTime']>;
  usePersonalLevelSettings?: InputMaybe<Scalars['Boolean']>;
  userId?: InputMaybe<Scalars['String']>;
  userLevels?: InputMaybe<UserLevelUpdateManyWithoutUserInput>;
};

export type GameUserUpdateInput = {
  audioMuted?: InputMaybe<Scalars['Boolean']>;
  charactersPerMinuteStandard?: InputMaybe<Scalars['Int']>;
  diamonds?: InputMaybe<Scalars['Int']>;
  diplomaIsSent?: InputMaybe<Scalars['Boolean']>;
  focusMode?: InputMaybe<Scalars['Boolean']>;
  fontType?: InputMaybe<FontType>;
  gamename?: InputMaybe<Scalars['String']>;
  hasRequestedDiploma?: InputMaybe<Scalars['Boolean']>;
  hasRequestedParticipationCertificate?: InputMaybe<Scalars['Boolean']>;
  hideDiamonds?: InputMaybe<Scalars['Boolean']>;
  introductionCompleted?: InputMaybe<Scalars['Boolean']>;
  participationCertificateIsSent?: InputMaybe<Scalars['Boolean']>;
  showInterpunct?: InputMaybe<Scalars['Boolean']>;
  showPracticeTimeTimer?: InputMaybe<Scalars['Boolean']>;
  usePersonalLevelSettings?: InputMaybe<Scalars['Boolean']>;
};

export type GameUserUpdateManyMutationInput = {
  audioMuted?: InputMaybe<Scalars['Boolean']>;
  charactersPerMinuteStandard?: InputMaybe<Scalars['Int']>;
  diamonds?: InputMaybe<Scalars['Int']>;
  diplomaIsSent?: InputMaybe<Scalars['Boolean']>;
  earnedDiamonds?: InputMaybe<Scalars['Int']>;
  examState?: InputMaybe<ExamState>;
  focusMode?: InputMaybe<Scalars['Boolean']>;
  fontType?: InputMaybe<FontType>;
  gameCompleted?: InputMaybe<Scalars['Boolean']>;
  gameCompletedDate?: InputMaybe<Scalars['DateTime']>;
  gamename?: InputMaybe<Scalars['String']>;
  hasRequestedDiploma?: InputMaybe<Scalars['Boolean']>;
  hasRequestedParticipationCertificate?: InputMaybe<Scalars['Boolean']>;
  hideDiamonds?: InputMaybe<Scalars['Boolean']>;
  highestCups?: InputMaybe<Scalars['Int']>;
  introductionCompleted?: InputMaybe<Scalars['Boolean']>;
  participationCertificateIsSent?: InputMaybe<Scalars['Boolean']>;
  showInterpunct?: InputMaybe<Scalars['Boolean']>;
  startedAt?: InputMaybe<Scalars['DateTime']>;
  usePersonalLevelSettings?: InputMaybe<Scalars['Boolean']>;
  userId?: InputMaybe<Scalars['String']>;
};

export type GameUserUpdateOneRequiredInput = {
  connect?: InputMaybe<GameUserWhereUniqueInput>;
  create?: InputMaybe<GameUserCreateInput>;
  update?: InputMaybe<GameUserUpdateDataInput>;
  upsert?: InputMaybe<GameUserUpsertNestedInput>;
};

export type GameUserUpdateOneRequiredWithoutDisplayedAlfredoMessagesInput = {
  connect?: InputMaybe<GameUserWhereUniqueInput>;
  create?: InputMaybe<GameUserCreateWithoutDisplayedAlfredoMessagesInput>;
  update?: InputMaybe<GameUserUpdateWithoutDisplayedAlfredoMessagesDataInput>;
  upsert?: InputMaybe<GameUserUpsertWithoutDisplayedAlfredoMessagesInput>;
};

export type GameUserUpdateOneRequiredWithoutKwouwselAccessoriesInput = {
  connect?: InputMaybe<GameUserWhereUniqueInput>;
  create?: InputMaybe<GameUserCreateWithoutKwouwselAccessoriesInput>;
  update?: InputMaybe<GameUserUpdateWithoutKwouwselAccessoriesDataInput>;
  upsert?: InputMaybe<GameUserUpsertWithoutKwouwselAccessoriesInput>;
};

export type GameUserUpdateOneRequiredWithoutKwouwselUpgradesInput = {
  connect?: InputMaybe<GameUserWhereUniqueInput>;
  create?: InputMaybe<GameUserCreateWithoutKwouwselUpgradesInput>;
  update?: InputMaybe<GameUserUpdateWithoutKwouwselUpgradesDataInput>;
  upsert?: InputMaybe<GameUserUpsertWithoutKwouwselUpgradesInput>;
};

export type GameUserUpdateOneRequiredWithoutUserLevelsInput = {
  connect?: InputMaybe<GameUserWhereUniqueInput>;
  create?: InputMaybe<GameUserCreateWithoutUserLevelsInput>;
  update?: InputMaybe<GameUserUpdateWithoutUserLevelsDataInput>;
  upsert?: InputMaybe<GameUserUpsertWithoutUserLevelsInput>;
};

export type GameUserUpdateWithoutDisplayedAlfredoMessagesDataInput = {
  audioMuted?: InputMaybe<Scalars['Boolean']>;
  charactersPerMinuteStandard?: InputMaybe<Scalars['Int']>;
  diamonds?: InputMaybe<Scalars['Int']>;
  diplomaIsSent?: InputMaybe<Scalars['Boolean']>;
  earnedDiamonds?: InputMaybe<Scalars['Int']>;
  examState?: InputMaybe<ExamState>;
  exams?: InputMaybe<ChallengeResultUpdateManyInput>;
  firstSuccessfulTestExam?: InputMaybe<ChallengeResultUpdateOneInput>;
  focusMode?: InputMaybe<Scalars['Boolean']>;
  fontType?: InputMaybe<FontType>;
  gameCompleted?: InputMaybe<Scalars['Boolean']>;
  gameCompletedDate?: InputMaybe<Scalars['DateTime']>;
  gamename?: InputMaybe<Scalars['String']>;
  hasRequestedDiploma?: InputMaybe<Scalars['Boolean']>;
  hasRequestedParticipationCertificate?: InputMaybe<Scalars['Boolean']>;
  hideDiamonds?: InputMaybe<Scalars['Boolean']>;
  highestCups?: InputMaybe<Scalars['Int']>;
  introductionCompleted?: InputMaybe<Scalars['Boolean']>;
  kwouwselAccessories?: InputMaybe<GameUserKwouwselAccessoryUpdateManyWithoutUserInput>;
  kwouwselUpgrades?: InputMaybe<GameUserKwouwselUpgradeUpdateManyWithoutUserInput>;
  lastPlay?: InputMaybe<ChallengeResultUpdateOneInput>;
  lastSuccessfulTestExam?: InputMaybe<ChallengeResultUpdateOneInput>;
  participationCertificateIsSent?: InputMaybe<Scalars['Boolean']>;
  showInterpunct?: InputMaybe<Scalars['Boolean']>;
  startedAt?: InputMaybe<Scalars['DateTime']>;
  usePersonalLevelSettings?: InputMaybe<Scalars['Boolean']>;
  userId?: InputMaybe<Scalars['String']>;
  userLevels?: InputMaybe<UserLevelUpdateManyWithoutUserInput>;
};

export type GameUserUpdateWithoutKwouwselAccessoriesDataInput = {
  audioMuted?: InputMaybe<Scalars['Boolean']>;
  charactersPerMinuteStandard?: InputMaybe<Scalars['Int']>;
  diamonds?: InputMaybe<Scalars['Int']>;
  diplomaIsSent?: InputMaybe<Scalars['Boolean']>;
  displayedAlfredoMessages?: InputMaybe<AlfredoMessageGameUserUpdateManyWithoutGameUserInput>;
  earnedDiamonds?: InputMaybe<Scalars['Int']>;
  examState?: InputMaybe<ExamState>;
  exams?: InputMaybe<ChallengeResultUpdateManyInput>;
  firstSuccessfulTestExam?: InputMaybe<ChallengeResultUpdateOneInput>;
  focusMode?: InputMaybe<Scalars['Boolean']>;
  fontType?: InputMaybe<FontType>;
  gameCompleted?: InputMaybe<Scalars['Boolean']>;
  gameCompletedDate?: InputMaybe<Scalars['DateTime']>;
  gamename?: InputMaybe<Scalars['String']>;
  hasRequestedDiploma?: InputMaybe<Scalars['Boolean']>;
  hasRequestedParticipationCertificate?: InputMaybe<Scalars['Boolean']>;
  hideDiamonds?: InputMaybe<Scalars['Boolean']>;
  highestCups?: InputMaybe<Scalars['Int']>;
  introductionCompleted?: InputMaybe<Scalars['Boolean']>;
  kwouwselUpgrades?: InputMaybe<GameUserKwouwselUpgradeUpdateManyWithoutUserInput>;
  lastPlay?: InputMaybe<ChallengeResultUpdateOneInput>;
  lastSuccessfulTestExam?: InputMaybe<ChallengeResultUpdateOneInput>;
  participationCertificateIsSent?: InputMaybe<Scalars['Boolean']>;
  showInterpunct?: InputMaybe<Scalars['Boolean']>;
  startedAt?: InputMaybe<Scalars['DateTime']>;
  usePersonalLevelSettings?: InputMaybe<Scalars['Boolean']>;
  userId?: InputMaybe<Scalars['String']>;
  userLevels?: InputMaybe<UserLevelUpdateManyWithoutUserInput>;
};

export type GameUserUpdateWithoutKwouwselUpgradesDataInput = {
  audioMuted?: InputMaybe<Scalars['Boolean']>;
  charactersPerMinuteStandard?: InputMaybe<Scalars['Int']>;
  diamonds?: InputMaybe<Scalars['Int']>;
  diplomaIsSent?: InputMaybe<Scalars['Boolean']>;
  displayedAlfredoMessages?: InputMaybe<AlfredoMessageGameUserUpdateManyWithoutGameUserInput>;
  earnedDiamonds?: InputMaybe<Scalars['Int']>;
  examState?: InputMaybe<ExamState>;
  exams?: InputMaybe<ChallengeResultUpdateManyInput>;
  firstSuccessfulTestExam?: InputMaybe<ChallengeResultUpdateOneInput>;
  focusMode?: InputMaybe<Scalars['Boolean']>;
  fontType?: InputMaybe<FontType>;
  gameCompleted?: InputMaybe<Scalars['Boolean']>;
  gameCompletedDate?: InputMaybe<Scalars['DateTime']>;
  gamename?: InputMaybe<Scalars['String']>;
  hasRequestedDiploma?: InputMaybe<Scalars['Boolean']>;
  hasRequestedParticipationCertificate?: InputMaybe<Scalars['Boolean']>;
  hideDiamonds?: InputMaybe<Scalars['Boolean']>;
  highestCups?: InputMaybe<Scalars['Int']>;
  introductionCompleted?: InputMaybe<Scalars['Boolean']>;
  kwouwselAccessories?: InputMaybe<GameUserKwouwselAccessoryUpdateManyWithoutUserInput>;
  lastPlay?: InputMaybe<ChallengeResultUpdateOneInput>;
  lastSuccessfulTestExam?: InputMaybe<ChallengeResultUpdateOneInput>;
  participationCertificateIsSent?: InputMaybe<Scalars['Boolean']>;
  showInterpunct?: InputMaybe<Scalars['Boolean']>;
  startedAt?: InputMaybe<Scalars['DateTime']>;
  usePersonalLevelSettings?: InputMaybe<Scalars['Boolean']>;
  userId?: InputMaybe<Scalars['String']>;
  userLevels?: InputMaybe<UserLevelUpdateManyWithoutUserInput>;
};

export type GameUserUpdateWithoutUserLevelsDataInput = {
  audioMuted?: InputMaybe<Scalars['Boolean']>;
  charactersPerMinuteStandard?: InputMaybe<Scalars['Int']>;
  diamonds?: InputMaybe<Scalars['Int']>;
  diplomaIsSent?: InputMaybe<Scalars['Boolean']>;
  displayedAlfredoMessages?: InputMaybe<AlfredoMessageGameUserUpdateManyWithoutGameUserInput>;
  earnedDiamonds?: InputMaybe<Scalars['Int']>;
  examState?: InputMaybe<ExamState>;
  exams?: InputMaybe<ChallengeResultUpdateManyInput>;
  firstSuccessfulTestExam?: InputMaybe<ChallengeResultUpdateOneInput>;
  focusMode?: InputMaybe<Scalars['Boolean']>;
  fontType?: InputMaybe<FontType>;
  gameCompleted?: InputMaybe<Scalars['Boolean']>;
  gameCompletedDate?: InputMaybe<Scalars['DateTime']>;
  gamename?: InputMaybe<Scalars['String']>;
  hasRequestedDiploma?: InputMaybe<Scalars['Boolean']>;
  hasRequestedParticipationCertificate?: InputMaybe<Scalars['Boolean']>;
  hideDiamonds?: InputMaybe<Scalars['Boolean']>;
  highestCups?: InputMaybe<Scalars['Int']>;
  introductionCompleted?: InputMaybe<Scalars['Boolean']>;
  kwouwselAccessories?: InputMaybe<GameUserKwouwselAccessoryUpdateManyWithoutUserInput>;
  kwouwselUpgrades?: InputMaybe<GameUserKwouwselUpgradeUpdateManyWithoutUserInput>;
  lastPlay?: InputMaybe<ChallengeResultUpdateOneInput>;
  lastSuccessfulTestExam?: InputMaybe<ChallengeResultUpdateOneInput>;
  participationCertificateIsSent?: InputMaybe<Scalars['Boolean']>;
  showInterpunct?: InputMaybe<Scalars['Boolean']>;
  startedAt?: InputMaybe<Scalars['DateTime']>;
  usePersonalLevelSettings?: InputMaybe<Scalars['Boolean']>;
  userId?: InputMaybe<Scalars['String']>;
};

export type GameUserUpsertNestedInput = {
  create: GameUserCreateInput;
  update: GameUserUpdateDataInput;
};

export type GameUserUpsertWithoutDisplayedAlfredoMessagesInput = {
  create: GameUserCreateWithoutDisplayedAlfredoMessagesInput;
  update: GameUserUpdateWithoutDisplayedAlfredoMessagesDataInput;
};

export type GameUserUpsertWithoutKwouwselAccessoriesInput = {
  create: GameUserCreateWithoutKwouwselAccessoriesInput;
  update: GameUserUpdateWithoutKwouwselAccessoriesDataInput;
};

export type GameUserUpsertWithoutKwouwselUpgradesInput = {
  create: GameUserCreateWithoutKwouwselUpgradesInput;
  update: GameUserUpdateWithoutKwouwselUpgradesDataInput;
};

export type GameUserUpsertWithoutUserLevelsInput = {
  create: GameUserCreateWithoutUserLevelsInput;
  update: GameUserUpdateWithoutUserLevelsDataInput;
};

export type GameUserWhereInput = {
  AND?: InputMaybe<Array<GameUserWhereInput>>;
  NOT?: InputMaybe<Array<GameUserWhereInput>>;
  OR?: InputMaybe<Array<GameUserWhereInput>>;
  audioMuted?: InputMaybe<Scalars['Boolean']>;
  audioMuted_not?: InputMaybe<Scalars['Boolean']>;
  charactersPerMinuteStandard?: InputMaybe<Scalars['Int']>;
  charactersPerMinuteStandard_gt?: InputMaybe<Scalars['Int']>;
  charactersPerMinuteStandard_gte?: InputMaybe<Scalars['Int']>;
  charactersPerMinuteStandard_in?: InputMaybe<Array<Scalars['Int']>>;
  charactersPerMinuteStandard_lt?: InputMaybe<Scalars['Int']>;
  charactersPerMinuteStandard_lte?: InputMaybe<Scalars['Int']>;
  charactersPerMinuteStandard_not?: InputMaybe<Scalars['Int']>;
  charactersPerMinuteStandard_not_in?: InputMaybe<Array<Scalars['Int']>>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  createdAt_gt?: InputMaybe<Scalars['DateTime']>;
  createdAt_gte?: InputMaybe<Scalars['DateTime']>;
  createdAt_in?: InputMaybe<Array<Scalars['DateTime']>>;
  createdAt_lt?: InputMaybe<Scalars['DateTime']>;
  createdAt_lte?: InputMaybe<Scalars['DateTime']>;
  createdAt_not?: InputMaybe<Scalars['DateTime']>;
  createdAt_not_in?: InputMaybe<Array<Scalars['DateTime']>>;
  diamonds?: InputMaybe<Scalars['Int']>;
  diamonds_gt?: InputMaybe<Scalars['Int']>;
  diamonds_gte?: InputMaybe<Scalars['Int']>;
  diamonds_in?: InputMaybe<Array<Scalars['Int']>>;
  diamonds_lt?: InputMaybe<Scalars['Int']>;
  diamonds_lte?: InputMaybe<Scalars['Int']>;
  diamonds_not?: InputMaybe<Scalars['Int']>;
  diamonds_not_in?: InputMaybe<Array<Scalars['Int']>>;
  diplomaIsSent?: InputMaybe<Scalars['Boolean']>;
  diplomaIsSent_not?: InputMaybe<Scalars['Boolean']>;
  displayedAlfredoMessages_every?: InputMaybe<AlfredoMessageGameUserWhereInput>;
  displayedAlfredoMessages_none?: InputMaybe<AlfredoMessageGameUserWhereInput>;
  displayedAlfredoMessages_some?: InputMaybe<AlfredoMessageGameUserWhereInput>;
  earnedDiamonds?: InputMaybe<Scalars['Int']>;
  earnedDiamonds_gt?: InputMaybe<Scalars['Int']>;
  earnedDiamonds_gte?: InputMaybe<Scalars['Int']>;
  earnedDiamonds_in?: InputMaybe<Array<Scalars['Int']>>;
  earnedDiamonds_lt?: InputMaybe<Scalars['Int']>;
  earnedDiamonds_lte?: InputMaybe<Scalars['Int']>;
  earnedDiamonds_not?: InputMaybe<Scalars['Int']>;
  earnedDiamonds_not_in?: InputMaybe<Array<Scalars['Int']>>;
  examState?: InputMaybe<ExamState>;
  examState_in?: InputMaybe<Array<ExamState>>;
  examState_not?: InputMaybe<ExamState>;
  examState_not_in?: InputMaybe<Array<ExamState>>;
  exams_every?: InputMaybe<ChallengeResultWhereInput>;
  exams_none?: InputMaybe<ChallengeResultWhereInput>;
  exams_some?: InputMaybe<ChallengeResultWhereInput>;
  firstSuccessfulTestExam?: InputMaybe<ChallengeResultWhereInput>;
  focusMode?: InputMaybe<Scalars['Boolean']>;
  focusMode_not?: InputMaybe<Scalars['Boolean']>;
  fontType?: InputMaybe<FontType>;
  fontType_in?: InputMaybe<Array<FontType>>;
  fontType_not?: InputMaybe<FontType>;
  fontType_not_in?: InputMaybe<Array<FontType>>;
  gameCompleted?: InputMaybe<Scalars['Boolean']>;
  gameCompletedDate?: InputMaybe<Scalars['DateTime']>;
  gameCompletedDate_gt?: InputMaybe<Scalars['DateTime']>;
  gameCompletedDate_gte?: InputMaybe<Scalars['DateTime']>;
  gameCompletedDate_in?: InputMaybe<Array<Scalars['DateTime']>>;
  gameCompletedDate_lt?: InputMaybe<Scalars['DateTime']>;
  gameCompletedDate_lte?: InputMaybe<Scalars['DateTime']>;
  gameCompletedDate_not?: InputMaybe<Scalars['DateTime']>;
  gameCompletedDate_not_in?: InputMaybe<Array<Scalars['DateTime']>>;
  gameCompleted_not?: InputMaybe<Scalars['Boolean']>;
  gamename?: InputMaybe<Scalars['String']>;
  gamename_contains?: InputMaybe<Scalars['String']>;
  gamename_ends_with?: InputMaybe<Scalars['String']>;
  gamename_gt?: InputMaybe<Scalars['String']>;
  gamename_gte?: InputMaybe<Scalars['String']>;
  gamename_in?: InputMaybe<Array<Scalars['String']>>;
  gamename_lt?: InputMaybe<Scalars['String']>;
  gamename_lte?: InputMaybe<Scalars['String']>;
  gamename_not?: InputMaybe<Scalars['String']>;
  gamename_not_contains?: InputMaybe<Scalars['String']>;
  gamename_not_ends_with?: InputMaybe<Scalars['String']>;
  gamename_not_in?: InputMaybe<Array<Scalars['String']>>;
  gamename_not_starts_with?: InputMaybe<Scalars['String']>;
  gamename_starts_with?: InputMaybe<Scalars['String']>;
  hasRequestedDiploma?: InputMaybe<Scalars['Boolean']>;
  hasRequestedDiploma_not?: InputMaybe<Scalars['Boolean']>;
  hasRequestedParticipationCertificate?: InputMaybe<Scalars['Boolean']>;
  hasRequestedParticipationCertificate_not?: InputMaybe<Scalars['Boolean']>;
  hideDiamonds?: InputMaybe<Scalars['Boolean']>;
  hideDiamonds_not?: InputMaybe<Scalars['Boolean']>;
  highestCups?: InputMaybe<Scalars['Int']>;
  highestCups_gt?: InputMaybe<Scalars['Int']>;
  highestCups_gte?: InputMaybe<Scalars['Int']>;
  highestCups_in?: InputMaybe<Array<Scalars['Int']>>;
  highestCups_lt?: InputMaybe<Scalars['Int']>;
  highestCups_lte?: InputMaybe<Scalars['Int']>;
  highestCups_not?: InputMaybe<Scalars['Int']>;
  highestCups_not_in?: InputMaybe<Array<Scalars['Int']>>;
  id?: InputMaybe<Scalars['ID']>;
  id_contains?: InputMaybe<Scalars['ID']>;
  id_ends_with?: InputMaybe<Scalars['ID']>;
  id_gt?: InputMaybe<Scalars['ID']>;
  id_gte?: InputMaybe<Scalars['ID']>;
  id_in?: InputMaybe<Array<Scalars['ID']>>;
  id_lt?: InputMaybe<Scalars['ID']>;
  id_lte?: InputMaybe<Scalars['ID']>;
  id_not?: InputMaybe<Scalars['ID']>;
  id_not_contains?: InputMaybe<Scalars['ID']>;
  id_not_ends_with?: InputMaybe<Scalars['ID']>;
  id_not_in?: InputMaybe<Array<Scalars['ID']>>;
  id_not_starts_with?: InputMaybe<Scalars['ID']>;
  id_starts_with?: InputMaybe<Scalars['ID']>;
  introductionCompleted?: InputMaybe<Scalars['Boolean']>;
  introductionCompleted_not?: InputMaybe<Scalars['Boolean']>;
  kwouwselAccessories_every?: InputMaybe<GameUserKwouwselAccessoryWhereInput>;
  kwouwselAccessories_none?: InputMaybe<GameUserKwouwselAccessoryWhereInput>;
  kwouwselAccessories_some?: InputMaybe<GameUserKwouwselAccessoryWhereInput>;
  kwouwselUpgrades_every?: InputMaybe<GameUserKwouwselUpgradeWhereInput>;
  kwouwselUpgrades_none?: InputMaybe<GameUserKwouwselUpgradeWhereInput>;
  kwouwselUpgrades_some?: InputMaybe<GameUserKwouwselUpgradeWhereInput>;
  lastPlay?: InputMaybe<ChallengeResultWhereInput>;
  lastSuccessfulTestExam?: InputMaybe<ChallengeResultWhereInput>;
  participationCertificateIsSent?: InputMaybe<Scalars['Boolean']>;
  participationCertificateIsSent_not?: InputMaybe<Scalars['Boolean']>;
  showInterpunct?: InputMaybe<Scalars['Boolean']>;
  showInterpunct_not?: InputMaybe<Scalars['Boolean']>;
  startedAt?: InputMaybe<Scalars['DateTime']>;
  startedAt_gt?: InputMaybe<Scalars['DateTime']>;
  startedAt_gte?: InputMaybe<Scalars['DateTime']>;
  startedAt_in?: InputMaybe<Array<Scalars['DateTime']>>;
  startedAt_lt?: InputMaybe<Scalars['DateTime']>;
  startedAt_lte?: InputMaybe<Scalars['DateTime']>;
  startedAt_not?: InputMaybe<Scalars['DateTime']>;
  startedAt_not_in?: InputMaybe<Array<Scalars['DateTime']>>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
  updatedAt_gt?: InputMaybe<Scalars['DateTime']>;
  updatedAt_gte?: InputMaybe<Scalars['DateTime']>;
  updatedAt_in?: InputMaybe<Array<Scalars['DateTime']>>;
  updatedAt_lt?: InputMaybe<Scalars['DateTime']>;
  updatedAt_lte?: InputMaybe<Scalars['DateTime']>;
  updatedAt_not?: InputMaybe<Scalars['DateTime']>;
  updatedAt_not_in?: InputMaybe<Array<Scalars['DateTime']>>;
  usePersonalLevelSettings?: InputMaybe<Scalars['Boolean']>;
  usePersonalLevelSettings_not?: InputMaybe<Scalars['Boolean']>;
  userId?: InputMaybe<Scalars['String']>;
  userId_contains?: InputMaybe<Scalars['String']>;
  userId_ends_with?: InputMaybe<Scalars['String']>;
  userId_gt?: InputMaybe<Scalars['String']>;
  userId_gte?: InputMaybe<Scalars['String']>;
  userId_in?: InputMaybe<Array<Scalars['String']>>;
  userId_lt?: InputMaybe<Scalars['String']>;
  userId_lte?: InputMaybe<Scalars['String']>;
  userId_not?: InputMaybe<Scalars['String']>;
  userId_not_contains?: InputMaybe<Scalars['String']>;
  userId_not_ends_with?: InputMaybe<Scalars['String']>;
  userId_not_in?: InputMaybe<Array<Scalars['String']>>;
  userId_not_starts_with?: InputMaybe<Scalars['String']>;
  userId_starts_with?: InputMaybe<Scalars['String']>;
  userLevels_every?: InputMaybe<UserLevelWhereInput>;
  userLevels_none?: InputMaybe<UserLevelWhereInput>;
  userLevels_some?: InputMaybe<UserLevelWhereInput>;
};

export type GameUserWhereUniqueInput = {
  userId?: InputMaybe<Scalars['ID']>;
};

export type Gender = 'Female' | 'Male' | 'Other';

export type IdFilter = {
  equals?: InputMaybe<Scalars['ID']>;
  in?: InputMaybe<Array<Scalars['ID']>>;
};

export type IssStringFilterInput = {
  /** Contains queries are case insensitive */
  contains?: InputMaybe<Scalars['String']>;
  eq?: InputMaybe<Scalars['String']>;
  in?: InputMaybe<Array<Scalars['String']>>;
  notIn?: InputMaybe<Array<Scalars['String']>>;
};

export type ImpersonateUserInput = {
  userId: Scalars['ID'];
};

export type ImpersonateUserPayload = {
  user: User;
};

export type Institution = {
  city: Scalars['String'];
  country: Scalars['String'];
  id: Scalars['String'];
  municipality: Scalars['String'];
  name: Scalars['String'];
  postalCode: Scalars['String'];
  province: Scalars['String'];
  street: Scalars['String'];
  streetNumber: Scalars['String'];
};

export type InstitutionDataSource = 'BRIN' | 'ONDERWIJS_VLAANDEREN';

export type InstitutionInput = {
  dataSource: InstitutionDataSource;
  id: Scalars['String'];
};

export type InstitutionViewModelEdge = {
  cursor: Scalars['String'];
  node: Institution;
};

export type InstitutionsWhereInput = {
  city?: InputMaybe<IssStringFilterInput>;
  country?: InputMaybe<IssStringFilterInput>;
  id?: InputMaybe<IssStringFilterInput>;
  municipality?: InputMaybe<IssStringFilterInput>;
  name?: InputMaybe<IssStringFilterInput>;
  postalCode?: InputMaybe<IssStringFilterInput>;
  province?: InputMaybe<IssStringFilterInput>;
  street?: InputMaybe<IssStringFilterInput>;
  streetNumber?: InputMaybe<IssStringFilterInput>;
};

export type InvoiceInfoUpdateOneInput = {
  delete?: InputMaybe<Scalars['Boolean']>;
  upsert?: InputMaybe<ContactDetailsUpsertNestedInput>;
};

export type KeyboardLayout = 'AZERTY' | 'QWERTY';

export type KeyboardLayoutInput = {
  eq?: InputMaybe<KeyboardLayout>;
  in?: InputMaybe<Array<KeyboardLayout>>;
  notIn?: InputMaybe<Array<KeyboardLayout>>;
};

export type KwouwselAccessory = {
  createdAt: Scalars['DateTime'];
  id: Scalars['ID'];
  level: Level;
  name: Scalars['String'];
  price: Scalars['Int'];
  updatedAt: Scalars['DateTime'];
};

export type KwouwselAccessoryConnection = {
  aggregate: AggregateKwouwselAccessory;
  edges: Array<Maybe<KwouwselAccessoryEdge>>;
  pageInfo: PageInfo;
};

export type KwouwselAccessoryCreateInput = {
  id?: InputMaybe<Scalars['ID']>;
  level: LevelCreateOneWithoutKwouwselAccessoriesInput;
  name: Scalars['String'];
  price: Scalars['Int'];
};

export type KwouwselAccessoryCreateManyWithoutLevelInput = {
  connect?: InputMaybe<Array<KwouwselAccessoryWhereUniqueInput>>;
  create?: InputMaybe<Array<KwouwselAccessoryCreateWithoutLevelInput>>;
};

export type KwouwselAccessoryCreateOneInput = {
  connect?: InputMaybe<KwouwselAccessoryWhereUniqueInput>;
  create?: InputMaybe<KwouwselAccessoryCreateInput>;
};

export type KwouwselAccessoryCreateWithoutLevelInput = {
  id?: InputMaybe<Scalars['ID']>;
  name: Scalars['String'];
  price: Scalars['Int'];
};

export type KwouwselAccessoryEdge = {
  cursor: Scalars['String'];
  node: KwouwselAccessory;
};

export type KwouwselAccessoryOrderByInput =
  | 'createdAt_ASC'
  | 'createdAt_DESC'
  | 'id_ASC'
  | 'id_DESC'
  | 'name_ASC'
  | 'name_DESC'
  | 'price_ASC'
  | 'price_DESC'
  | 'updatedAt_ASC'
  | 'updatedAt_DESC';

export type KwouwselAccessoryScalarWhereInput = {
  AND?: InputMaybe<Array<KwouwselAccessoryScalarWhereInput>>;
  NOT?: InputMaybe<Array<KwouwselAccessoryScalarWhereInput>>;
  OR?: InputMaybe<Array<KwouwselAccessoryScalarWhereInput>>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  createdAt_gt?: InputMaybe<Scalars['DateTime']>;
  createdAt_gte?: InputMaybe<Scalars['DateTime']>;
  createdAt_in?: InputMaybe<Array<Scalars['DateTime']>>;
  createdAt_lt?: InputMaybe<Scalars['DateTime']>;
  createdAt_lte?: InputMaybe<Scalars['DateTime']>;
  createdAt_not?: InputMaybe<Scalars['DateTime']>;
  createdAt_not_in?: InputMaybe<Array<Scalars['DateTime']>>;
  id?: InputMaybe<Scalars['ID']>;
  id_contains?: InputMaybe<Scalars['ID']>;
  id_ends_with?: InputMaybe<Scalars['ID']>;
  id_gt?: InputMaybe<Scalars['ID']>;
  id_gte?: InputMaybe<Scalars['ID']>;
  id_in?: InputMaybe<Array<Scalars['ID']>>;
  id_lt?: InputMaybe<Scalars['ID']>;
  id_lte?: InputMaybe<Scalars['ID']>;
  id_not?: InputMaybe<Scalars['ID']>;
  id_not_contains?: InputMaybe<Scalars['ID']>;
  id_not_ends_with?: InputMaybe<Scalars['ID']>;
  id_not_in?: InputMaybe<Array<Scalars['ID']>>;
  id_not_starts_with?: InputMaybe<Scalars['ID']>;
  id_starts_with?: InputMaybe<Scalars['ID']>;
  name?: InputMaybe<Scalars['String']>;
  name_contains?: InputMaybe<Scalars['String']>;
  name_ends_with?: InputMaybe<Scalars['String']>;
  name_gt?: InputMaybe<Scalars['String']>;
  name_gte?: InputMaybe<Scalars['String']>;
  name_in?: InputMaybe<Array<Scalars['String']>>;
  name_lt?: InputMaybe<Scalars['String']>;
  name_lte?: InputMaybe<Scalars['String']>;
  name_not?: InputMaybe<Scalars['String']>;
  name_not_contains?: InputMaybe<Scalars['String']>;
  name_not_ends_with?: InputMaybe<Scalars['String']>;
  name_not_in?: InputMaybe<Array<Scalars['String']>>;
  name_not_starts_with?: InputMaybe<Scalars['String']>;
  name_starts_with?: InputMaybe<Scalars['String']>;
  price?: InputMaybe<Scalars['Int']>;
  price_gt?: InputMaybe<Scalars['Int']>;
  price_gte?: InputMaybe<Scalars['Int']>;
  price_in?: InputMaybe<Array<Scalars['Int']>>;
  price_lt?: InputMaybe<Scalars['Int']>;
  price_lte?: InputMaybe<Scalars['Int']>;
  price_not?: InputMaybe<Scalars['Int']>;
  price_not_in?: InputMaybe<Array<Scalars['Int']>>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
  updatedAt_gt?: InputMaybe<Scalars['DateTime']>;
  updatedAt_gte?: InputMaybe<Scalars['DateTime']>;
  updatedAt_in?: InputMaybe<Array<Scalars['DateTime']>>;
  updatedAt_lt?: InputMaybe<Scalars['DateTime']>;
  updatedAt_lte?: InputMaybe<Scalars['DateTime']>;
  updatedAt_not?: InputMaybe<Scalars['DateTime']>;
  updatedAt_not_in?: InputMaybe<Array<Scalars['DateTime']>>;
};

export type KwouwselAccessoryUpdateDataInput = {
  level?: InputMaybe<LevelUpdateOneRequiredWithoutKwouwselAccessoriesInput>;
  name?: InputMaybe<Scalars['String']>;
  price?: InputMaybe<Scalars['Int']>;
};

export type KwouwselAccessoryUpdateInput = {
  level?: InputMaybe<LevelUpdateOneRequiredWithoutKwouwselAccessoriesInput>;
  name?: InputMaybe<Scalars['String']>;
  price?: InputMaybe<Scalars['Int']>;
};

export type KwouwselAccessoryUpdateManyDataInput = {
  name?: InputMaybe<Scalars['String']>;
  price?: InputMaybe<Scalars['Int']>;
};

export type KwouwselAccessoryUpdateManyMutationInput = {
  name?: InputMaybe<Scalars['String']>;
  price?: InputMaybe<Scalars['Int']>;
};

export type KwouwselAccessoryUpdateManyWithWhereNestedInput = {
  data: KwouwselAccessoryUpdateManyDataInput;
  where: KwouwselAccessoryScalarWhereInput;
};

export type KwouwselAccessoryUpdateManyWithoutLevelInput = {
  connect?: InputMaybe<Array<KwouwselAccessoryWhereUniqueInput>>;
  create?: InputMaybe<Array<KwouwselAccessoryCreateWithoutLevelInput>>;
  delete?: InputMaybe<Array<KwouwselAccessoryWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<KwouwselAccessoryScalarWhereInput>>;
  disconnect?: InputMaybe<Array<KwouwselAccessoryWhereUniqueInput>>;
  set?: InputMaybe<Array<KwouwselAccessoryWhereUniqueInput>>;
  update?: InputMaybe<
    Array<KwouwselAccessoryUpdateWithWhereUniqueWithoutLevelInput>
  >;
  updateMany?: InputMaybe<
    Array<KwouwselAccessoryUpdateManyWithWhereNestedInput>
  >;
  upsert?: InputMaybe<
    Array<KwouwselAccessoryUpsertWithWhereUniqueWithoutLevelInput>
  >;
};

export type KwouwselAccessoryUpdateOneRequiredInput = {
  connect?: InputMaybe<KwouwselAccessoryWhereUniqueInput>;
  create?: InputMaybe<KwouwselAccessoryCreateInput>;
  update?: InputMaybe<KwouwselAccessoryUpdateDataInput>;
  upsert?: InputMaybe<KwouwselAccessoryUpsertNestedInput>;
};

export type KwouwselAccessoryUpdateWithWhereUniqueWithoutLevelInput = {
  data: KwouwselAccessoryUpdateWithoutLevelDataInput;
  where: KwouwselAccessoryWhereUniqueInput;
};

export type KwouwselAccessoryUpdateWithoutLevelDataInput = {
  name?: InputMaybe<Scalars['String']>;
  price?: InputMaybe<Scalars['Int']>;
};

export type KwouwselAccessoryUpsertNestedInput = {
  create: KwouwselAccessoryCreateInput;
  update: KwouwselAccessoryUpdateDataInput;
};

export type KwouwselAccessoryUpsertWithWhereUniqueWithoutLevelInput = {
  create: KwouwselAccessoryCreateWithoutLevelInput;
  update: KwouwselAccessoryUpdateWithoutLevelDataInput;
  where: KwouwselAccessoryWhereUniqueInput;
};

export type KwouwselAccessoryWhereInput = {
  AND?: InputMaybe<Array<KwouwselAccessoryWhereInput>>;
  NOT?: InputMaybe<Array<KwouwselAccessoryWhereInput>>;
  OR?: InputMaybe<Array<KwouwselAccessoryWhereInput>>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  createdAt_gt?: InputMaybe<Scalars['DateTime']>;
  createdAt_gte?: InputMaybe<Scalars['DateTime']>;
  createdAt_in?: InputMaybe<Array<Scalars['DateTime']>>;
  createdAt_lt?: InputMaybe<Scalars['DateTime']>;
  createdAt_lte?: InputMaybe<Scalars['DateTime']>;
  createdAt_not?: InputMaybe<Scalars['DateTime']>;
  createdAt_not_in?: InputMaybe<Array<Scalars['DateTime']>>;
  id?: InputMaybe<Scalars['ID']>;
  id_contains?: InputMaybe<Scalars['ID']>;
  id_ends_with?: InputMaybe<Scalars['ID']>;
  id_gt?: InputMaybe<Scalars['ID']>;
  id_gte?: InputMaybe<Scalars['ID']>;
  id_in?: InputMaybe<Array<Scalars['ID']>>;
  id_lt?: InputMaybe<Scalars['ID']>;
  id_lte?: InputMaybe<Scalars['ID']>;
  id_not?: InputMaybe<Scalars['ID']>;
  id_not_contains?: InputMaybe<Scalars['ID']>;
  id_not_ends_with?: InputMaybe<Scalars['ID']>;
  id_not_in?: InputMaybe<Array<Scalars['ID']>>;
  id_not_starts_with?: InputMaybe<Scalars['ID']>;
  id_starts_with?: InputMaybe<Scalars['ID']>;
  level?: InputMaybe<LevelWhereInput>;
  name?: InputMaybe<Scalars['String']>;
  name_contains?: InputMaybe<Scalars['String']>;
  name_ends_with?: InputMaybe<Scalars['String']>;
  name_gt?: InputMaybe<Scalars['String']>;
  name_gte?: InputMaybe<Scalars['String']>;
  name_in?: InputMaybe<Array<Scalars['String']>>;
  name_lt?: InputMaybe<Scalars['String']>;
  name_lte?: InputMaybe<Scalars['String']>;
  name_not?: InputMaybe<Scalars['String']>;
  name_not_contains?: InputMaybe<Scalars['String']>;
  name_not_ends_with?: InputMaybe<Scalars['String']>;
  name_not_in?: InputMaybe<Array<Scalars['String']>>;
  name_not_starts_with?: InputMaybe<Scalars['String']>;
  name_starts_with?: InputMaybe<Scalars['String']>;
  price?: InputMaybe<Scalars['Int']>;
  price_gt?: InputMaybe<Scalars['Int']>;
  price_gte?: InputMaybe<Scalars['Int']>;
  price_in?: InputMaybe<Array<Scalars['Int']>>;
  price_lt?: InputMaybe<Scalars['Int']>;
  price_lte?: InputMaybe<Scalars['Int']>;
  price_not?: InputMaybe<Scalars['Int']>;
  price_not_in?: InputMaybe<Array<Scalars['Int']>>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
  updatedAt_gt?: InputMaybe<Scalars['DateTime']>;
  updatedAt_gte?: InputMaybe<Scalars['DateTime']>;
  updatedAt_in?: InputMaybe<Array<Scalars['DateTime']>>;
  updatedAt_lt?: InputMaybe<Scalars['DateTime']>;
  updatedAt_lte?: InputMaybe<Scalars['DateTime']>;
  updatedAt_not?: InputMaybe<Scalars['DateTime']>;
  updatedAt_not_in?: InputMaybe<Array<Scalars['DateTime']>>;
};

export type KwouwselAccessoryWhereUniqueInput = {
  id?: InputMaybe<Scalars['ID']>;
};

export type KwouwselUpgrade = {
  createdAt: Scalars['DateTime'];
  id: Scalars['ID'];
  level: Level;
  name: Scalars['String'];
  price: Scalars['Int'];
  requiredStars: Scalars['Int'];
  updatedAt: Scalars['DateTime'];
};

export type KwouwselUpgradeConnection = {
  aggregate: AggregateKwouwselUpgrade;
  edges: Array<Maybe<KwouwselUpgradeEdge>>;
  pageInfo: PageInfo;
};

export type KwouwselUpgradeCreateInput = {
  id?: InputMaybe<Scalars['ID']>;
  level: LevelCreateOneWithoutKwouwselUpgradesInput;
  name: Scalars['String'];
  price: Scalars['Int'];
  requiredStars?: InputMaybe<Scalars['Int']>;
};

export type KwouwselUpgradeCreateManyWithoutLevelInput = {
  connect?: InputMaybe<Array<KwouwselUpgradeWhereUniqueInput>>;
  create?: InputMaybe<Array<KwouwselUpgradeCreateWithoutLevelInput>>;
};

export type KwouwselUpgradeCreateOneInput = {
  connect?: InputMaybe<KwouwselUpgradeWhereUniqueInput>;
  create?: InputMaybe<KwouwselUpgradeCreateInput>;
};

export type KwouwselUpgradeCreateWithoutLevelInput = {
  id?: InputMaybe<Scalars['ID']>;
  name: Scalars['String'];
  price: Scalars['Int'];
  requiredStars?: InputMaybe<Scalars['Int']>;
};

export type KwouwselUpgradeEdge = {
  cursor: Scalars['String'];
  node: KwouwselUpgrade;
};

export type KwouwselUpgradeOrderByInput =
  | 'createdAt_ASC'
  | 'createdAt_DESC'
  | 'id_ASC'
  | 'id_DESC'
  | 'name_ASC'
  | 'name_DESC'
  | 'price_ASC'
  | 'price_DESC'
  | 'requiredStars_ASC'
  | 'requiredStars_DESC'
  | 'updatedAt_ASC'
  | 'updatedAt_DESC';

export type KwouwselUpgradeScalarWhereInput = {
  AND?: InputMaybe<Array<KwouwselUpgradeScalarWhereInput>>;
  NOT?: InputMaybe<Array<KwouwselUpgradeScalarWhereInput>>;
  OR?: InputMaybe<Array<KwouwselUpgradeScalarWhereInput>>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  createdAt_gt?: InputMaybe<Scalars['DateTime']>;
  createdAt_gte?: InputMaybe<Scalars['DateTime']>;
  createdAt_in?: InputMaybe<Array<Scalars['DateTime']>>;
  createdAt_lt?: InputMaybe<Scalars['DateTime']>;
  createdAt_lte?: InputMaybe<Scalars['DateTime']>;
  createdAt_not?: InputMaybe<Scalars['DateTime']>;
  createdAt_not_in?: InputMaybe<Array<Scalars['DateTime']>>;
  id?: InputMaybe<Scalars['ID']>;
  id_contains?: InputMaybe<Scalars['ID']>;
  id_ends_with?: InputMaybe<Scalars['ID']>;
  id_gt?: InputMaybe<Scalars['ID']>;
  id_gte?: InputMaybe<Scalars['ID']>;
  id_in?: InputMaybe<Array<Scalars['ID']>>;
  id_lt?: InputMaybe<Scalars['ID']>;
  id_lte?: InputMaybe<Scalars['ID']>;
  id_not?: InputMaybe<Scalars['ID']>;
  id_not_contains?: InputMaybe<Scalars['ID']>;
  id_not_ends_with?: InputMaybe<Scalars['ID']>;
  id_not_in?: InputMaybe<Array<Scalars['ID']>>;
  id_not_starts_with?: InputMaybe<Scalars['ID']>;
  id_starts_with?: InputMaybe<Scalars['ID']>;
  name?: InputMaybe<Scalars['String']>;
  name_contains?: InputMaybe<Scalars['String']>;
  name_ends_with?: InputMaybe<Scalars['String']>;
  name_gt?: InputMaybe<Scalars['String']>;
  name_gte?: InputMaybe<Scalars['String']>;
  name_in?: InputMaybe<Array<Scalars['String']>>;
  name_lt?: InputMaybe<Scalars['String']>;
  name_lte?: InputMaybe<Scalars['String']>;
  name_not?: InputMaybe<Scalars['String']>;
  name_not_contains?: InputMaybe<Scalars['String']>;
  name_not_ends_with?: InputMaybe<Scalars['String']>;
  name_not_in?: InputMaybe<Array<Scalars['String']>>;
  name_not_starts_with?: InputMaybe<Scalars['String']>;
  name_starts_with?: InputMaybe<Scalars['String']>;
  price?: InputMaybe<Scalars['Int']>;
  price_gt?: InputMaybe<Scalars['Int']>;
  price_gte?: InputMaybe<Scalars['Int']>;
  price_in?: InputMaybe<Array<Scalars['Int']>>;
  price_lt?: InputMaybe<Scalars['Int']>;
  price_lte?: InputMaybe<Scalars['Int']>;
  price_not?: InputMaybe<Scalars['Int']>;
  price_not_in?: InputMaybe<Array<Scalars['Int']>>;
  requiredStars?: InputMaybe<Scalars['Int']>;
  requiredStars_gt?: InputMaybe<Scalars['Int']>;
  requiredStars_gte?: InputMaybe<Scalars['Int']>;
  requiredStars_in?: InputMaybe<Array<Scalars['Int']>>;
  requiredStars_lt?: InputMaybe<Scalars['Int']>;
  requiredStars_lte?: InputMaybe<Scalars['Int']>;
  requiredStars_not?: InputMaybe<Scalars['Int']>;
  requiredStars_not_in?: InputMaybe<Array<Scalars['Int']>>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
  updatedAt_gt?: InputMaybe<Scalars['DateTime']>;
  updatedAt_gte?: InputMaybe<Scalars['DateTime']>;
  updatedAt_in?: InputMaybe<Array<Scalars['DateTime']>>;
  updatedAt_lt?: InputMaybe<Scalars['DateTime']>;
  updatedAt_lte?: InputMaybe<Scalars['DateTime']>;
  updatedAt_not?: InputMaybe<Scalars['DateTime']>;
  updatedAt_not_in?: InputMaybe<Array<Scalars['DateTime']>>;
};

export type KwouwselUpgradeUpdateDataInput = {
  level?: InputMaybe<LevelUpdateOneRequiredWithoutKwouwselUpgradesInput>;
  name?: InputMaybe<Scalars['String']>;
  price?: InputMaybe<Scalars['Int']>;
  requiredStars?: InputMaybe<Scalars['Int']>;
};

export type KwouwselUpgradeUpdateInput = {
  level?: InputMaybe<LevelUpdateOneRequiredWithoutKwouwselUpgradesInput>;
  name?: InputMaybe<Scalars['String']>;
  price?: InputMaybe<Scalars['Int']>;
  requiredStars?: InputMaybe<Scalars['Int']>;
};

export type KwouwselUpgradeUpdateManyDataInput = {
  name?: InputMaybe<Scalars['String']>;
  price?: InputMaybe<Scalars['Int']>;
  requiredStars?: InputMaybe<Scalars['Int']>;
};

export type KwouwselUpgradeUpdateManyMutationInput = {
  name?: InputMaybe<Scalars['String']>;
  price?: InputMaybe<Scalars['Int']>;
  requiredStars?: InputMaybe<Scalars['Int']>;
};

export type KwouwselUpgradeUpdateManyWithWhereNestedInput = {
  data: KwouwselUpgradeUpdateManyDataInput;
  where: KwouwselUpgradeScalarWhereInput;
};

export type KwouwselUpgradeUpdateManyWithoutLevelInput = {
  connect?: InputMaybe<Array<KwouwselUpgradeWhereUniqueInput>>;
  create?: InputMaybe<Array<KwouwselUpgradeCreateWithoutLevelInput>>;
  delete?: InputMaybe<Array<KwouwselUpgradeWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<KwouwselUpgradeScalarWhereInput>>;
  disconnect?: InputMaybe<Array<KwouwselUpgradeWhereUniqueInput>>;
  set?: InputMaybe<Array<KwouwselUpgradeWhereUniqueInput>>;
  update?: InputMaybe<
    Array<KwouwselUpgradeUpdateWithWhereUniqueWithoutLevelInput>
  >;
  updateMany?: InputMaybe<Array<KwouwselUpgradeUpdateManyWithWhereNestedInput>>;
  upsert?: InputMaybe<
    Array<KwouwselUpgradeUpsertWithWhereUniqueWithoutLevelInput>
  >;
};

export type KwouwselUpgradeUpdateOneRequiredInput = {
  connect?: InputMaybe<KwouwselUpgradeWhereUniqueInput>;
  create?: InputMaybe<KwouwselUpgradeCreateInput>;
  update?: InputMaybe<KwouwselUpgradeUpdateDataInput>;
  upsert?: InputMaybe<KwouwselUpgradeUpsertNestedInput>;
};

export type KwouwselUpgradeUpdateWithWhereUniqueWithoutLevelInput = {
  data: KwouwselUpgradeUpdateWithoutLevelDataInput;
  where: KwouwselUpgradeWhereUniqueInput;
};

export type KwouwselUpgradeUpdateWithoutLevelDataInput = {
  name?: InputMaybe<Scalars['String']>;
  price?: InputMaybe<Scalars['Int']>;
  requiredStars?: InputMaybe<Scalars['Int']>;
};

export type KwouwselUpgradeUpsertNestedInput = {
  create: KwouwselUpgradeCreateInput;
  update: KwouwselUpgradeUpdateDataInput;
};

export type KwouwselUpgradeUpsertWithWhereUniqueWithoutLevelInput = {
  create: KwouwselUpgradeCreateWithoutLevelInput;
  update: KwouwselUpgradeUpdateWithoutLevelDataInput;
  where: KwouwselUpgradeWhereUniqueInput;
};

export type KwouwselUpgradeWhereInput = {
  AND?: InputMaybe<Array<KwouwselUpgradeWhereInput>>;
  NOT?: InputMaybe<Array<KwouwselUpgradeWhereInput>>;
  OR?: InputMaybe<Array<KwouwselUpgradeWhereInput>>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  createdAt_gt?: InputMaybe<Scalars['DateTime']>;
  createdAt_gte?: InputMaybe<Scalars['DateTime']>;
  createdAt_in?: InputMaybe<Array<Scalars['DateTime']>>;
  createdAt_lt?: InputMaybe<Scalars['DateTime']>;
  createdAt_lte?: InputMaybe<Scalars['DateTime']>;
  createdAt_not?: InputMaybe<Scalars['DateTime']>;
  createdAt_not_in?: InputMaybe<Array<Scalars['DateTime']>>;
  id?: InputMaybe<Scalars['ID']>;
  id_contains?: InputMaybe<Scalars['ID']>;
  id_ends_with?: InputMaybe<Scalars['ID']>;
  id_gt?: InputMaybe<Scalars['ID']>;
  id_gte?: InputMaybe<Scalars['ID']>;
  id_in?: InputMaybe<Array<Scalars['ID']>>;
  id_lt?: InputMaybe<Scalars['ID']>;
  id_lte?: InputMaybe<Scalars['ID']>;
  id_not?: InputMaybe<Scalars['ID']>;
  id_not_contains?: InputMaybe<Scalars['ID']>;
  id_not_ends_with?: InputMaybe<Scalars['ID']>;
  id_not_in?: InputMaybe<Array<Scalars['ID']>>;
  id_not_starts_with?: InputMaybe<Scalars['ID']>;
  id_starts_with?: InputMaybe<Scalars['ID']>;
  level?: InputMaybe<LevelWhereInput>;
  name?: InputMaybe<Scalars['String']>;
  name_contains?: InputMaybe<Scalars['String']>;
  name_ends_with?: InputMaybe<Scalars['String']>;
  name_gt?: InputMaybe<Scalars['String']>;
  name_gte?: InputMaybe<Scalars['String']>;
  name_in?: InputMaybe<Array<Scalars['String']>>;
  name_lt?: InputMaybe<Scalars['String']>;
  name_lte?: InputMaybe<Scalars['String']>;
  name_not?: InputMaybe<Scalars['String']>;
  name_not_contains?: InputMaybe<Scalars['String']>;
  name_not_ends_with?: InputMaybe<Scalars['String']>;
  name_not_in?: InputMaybe<Array<Scalars['String']>>;
  name_not_starts_with?: InputMaybe<Scalars['String']>;
  name_starts_with?: InputMaybe<Scalars['String']>;
  price?: InputMaybe<Scalars['Int']>;
  price_gt?: InputMaybe<Scalars['Int']>;
  price_gte?: InputMaybe<Scalars['Int']>;
  price_in?: InputMaybe<Array<Scalars['Int']>>;
  price_lt?: InputMaybe<Scalars['Int']>;
  price_lte?: InputMaybe<Scalars['Int']>;
  price_not?: InputMaybe<Scalars['Int']>;
  price_not_in?: InputMaybe<Array<Scalars['Int']>>;
  requiredStars?: InputMaybe<Scalars['Int']>;
  requiredStars_gt?: InputMaybe<Scalars['Int']>;
  requiredStars_gte?: InputMaybe<Scalars['Int']>;
  requiredStars_in?: InputMaybe<Array<Scalars['Int']>>;
  requiredStars_lt?: InputMaybe<Scalars['Int']>;
  requiredStars_lte?: InputMaybe<Scalars['Int']>;
  requiredStars_not?: InputMaybe<Scalars['Int']>;
  requiredStars_not_in?: InputMaybe<Array<Scalars['Int']>>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
  updatedAt_gt?: InputMaybe<Scalars['DateTime']>;
  updatedAt_gte?: InputMaybe<Scalars['DateTime']>;
  updatedAt_in?: InputMaybe<Array<Scalars['DateTime']>>;
  updatedAt_lt?: InputMaybe<Scalars['DateTime']>;
  updatedAt_lte?: InputMaybe<Scalars['DateTime']>;
  updatedAt_not?: InputMaybe<Scalars['DateTime']>;
  updatedAt_not_in?: InputMaybe<Array<Scalars['DateTime']>>;
};

export type KwouwselUpgradeWhereUniqueInput = {
  id?: InputMaybe<Scalars['ID']>;
};

export type LabelizedOrganisationType = {
  label: Scalars['String'];
  type: OrganisationType;
};

export type LabelizedSchoolOrganisationType = {
  label: Scalars['String'];
  type: SchoolOrganisationType;
};

export type Level = {
  allowBackspace: Scalars['Boolean'];
  amountOfChallengeResultsToPass: Scalars['Int'];
  challenges?: Maybe<Array<Challenge>>;
  characterName: Scalars['String'];
  characterPrefix: Scalars['String'];
  charactersPerMinutePercentage?: Maybe<Scalars['Decimal']>;
  createdAt: Scalars['DateTime'];
  diamonds: Scalars['Int'];
  exercises?: Maybe<Array<Exercise>>;
  id: Scalars['ID'];
  kwouwselAccessories?: Maybe<Array<KwouwselAccessory>>;
  kwouwselUpgrades?: Maybe<Array<KwouwselUpgrade>>;
  lives: Scalars['Int'];
  loop: Scalars['Int'];
  name: Scalars['String'];
  previous: Scalars['String'];
  requiredPercentageOfCpmsForStars?: Maybe<Array<Maybe<Scalars['Decimal']>>>;
  requiredPercentagesOfAccuracyForStars?: Maybe<
    Array<Maybe<Scalars['Decimal']>>
  >;
  sequence: Scalars['Int'];
  timeInMs: Scalars['Int'];
  updatedAt: Scalars['DateTime'];
};

export type LevelChallengesArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<ChallengeOrderByInput>;
  skip?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<ChallengeWhereInput>;
};

export type LevelExercisesArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<ExerciseOrderByInput>;
  skip?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<ExerciseWhereInput>;
};

export type LevelKwouwselAccessoriesArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<KwouwselAccessoryOrderByInput>;
  skip?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<KwouwselAccessoryWhereInput>;
};

export type LevelKwouwselUpgradesArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<KwouwselUpgradeOrderByInput>;
  skip?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<KwouwselUpgradeWhereInput>;
};

export type LevelConnection = {
  aggregate: AggregateLevel;
  edges: Array<Maybe<LevelEdge>>;
  pageInfo: PageInfo;
};

export type LevelCreateInput = {
  allowBackspace?: InputMaybe<Scalars['Boolean']>;
  amountOfChallengeResultsToPass?: InputMaybe<Scalars['Int']>;
  challenges?: InputMaybe<ChallengeCreateManyWithoutLevelInput>;
  characterName?: InputMaybe<Scalars['String']>;
  characterPrefix?: InputMaybe<Scalars['String']>;
  charactersPerMinutePercentage?: InputMaybe<Scalars['Decimal']>;
  diamonds?: InputMaybe<Scalars['Int']>;
  exercises?: InputMaybe<ExerciseCreateManyWithoutLevelInput>;
  id?: InputMaybe<Scalars['ID']>;
  kwouwselAccessories?: InputMaybe<KwouwselAccessoryCreateManyWithoutLevelInput>;
  kwouwselUpgrades?: InputMaybe<KwouwselUpgradeCreateManyWithoutLevelInput>;
  lives?: InputMaybe<Scalars['Int']>;
  loop?: InputMaybe<Scalars['Int']>;
  name: Scalars['String'];
  previous: Scalars['String'];
  requiredPercentageOfCpmsForStars?: InputMaybe<LevelCreaterequiredPercentageOfCpmsForStarsInput>;
  requiredPercentagesOfAccuracyForStars?: InputMaybe<LevelCreaterequiredPercentagesOfAccuracyForStarsInput>;
  sequence: Scalars['Int'];
  timeInMs: Scalars['Int'];
};

export type LevelCreateOneInput = {
  connect?: InputMaybe<LevelWhereUniqueInput>;
  create?: InputMaybe<LevelCreateInput>;
};

export type LevelCreateOneWithoutChallengesInput = {
  connect?: InputMaybe<LevelWhereUniqueInput>;
  create?: InputMaybe<LevelCreateWithoutChallengesInput>;
};

export type LevelCreateOneWithoutExercisesInput = {
  connect?: InputMaybe<LevelWhereUniqueInput>;
  create?: InputMaybe<LevelCreateWithoutExercisesInput>;
};

export type LevelCreateOneWithoutKwouwselAccessoriesInput = {
  connect?: InputMaybe<LevelWhereUniqueInput>;
  create?: InputMaybe<LevelCreateWithoutKwouwselAccessoriesInput>;
};

export type LevelCreateOneWithoutKwouwselUpgradesInput = {
  connect?: InputMaybe<LevelWhereUniqueInput>;
  create?: InputMaybe<LevelCreateWithoutKwouwselUpgradesInput>;
};

export type LevelCreateWithoutChallengesInput = {
  allowBackspace?: InputMaybe<Scalars['Boolean']>;
  amountOfChallengeResultsToPass?: InputMaybe<Scalars['Int']>;
  characterName?: InputMaybe<Scalars['String']>;
  characterPrefix?: InputMaybe<Scalars['String']>;
  charactersPerMinutePercentage?: InputMaybe<Scalars['Decimal']>;
  diamonds?: InputMaybe<Scalars['Int']>;
  exercises?: InputMaybe<ExerciseCreateManyWithoutLevelInput>;
  id?: InputMaybe<Scalars['ID']>;
  kwouwselAccessories?: InputMaybe<KwouwselAccessoryCreateManyWithoutLevelInput>;
  kwouwselUpgrades?: InputMaybe<KwouwselUpgradeCreateManyWithoutLevelInput>;
  lives?: InputMaybe<Scalars['Int']>;
  loop?: InputMaybe<Scalars['Int']>;
  name: Scalars['String'];
  previous: Scalars['String'];
  requiredPercentageOfCpmsForStars?: InputMaybe<LevelCreaterequiredPercentageOfCpmsForStarsInput>;
  requiredPercentagesOfAccuracyForStars?: InputMaybe<LevelCreaterequiredPercentagesOfAccuracyForStarsInput>;
  sequence: Scalars['Int'];
  timeInMs: Scalars['Int'];
};

export type LevelCreateWithoutExercisesInput = {
  allowBackspace?: InputMaybe<Scalars['Boolean']>;
  amountOfChallengeResultsToPass?: InputMaybe<Scalars['Int']>;
  challenges?: InputMaybe<ChallengeCreateManyWithoutLevelInput>;
  characterName?: InputMaybe<Scalars['String']>;
  characterPrefix?: InputMaybe<Scalars['String']>;
  charactersPerMinutePercentage?: InputMaybe<Scalars['Decimal']>;
  diamonds?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['ID']>;
  kwouwselAccessories?: InputMaybe<KwouwselAccessoryCreateManyWithoutLevelInput>;
  kwouwselUpgrades?: InputMaybe<KwouwselUpgradeCreateManyWithoutLevelInput>;
  lives?: InputMaybe<Scalars['Int']>;
  loop?: InputMaybe<Scalars['Int']>;
  name: Scalars['String'];
  previous: Scalars['String'];
  requiredPercentageOfCpmsForStars?: InputMaybe<LevelCreaterequiredPercentageOfCpmsForStarsInput>;
  requiredPercentagesOfAccuracyForStars?: InputMaybe<LevelCreaterequiredPercentagesOfAccuracyForStarsInput>;
  sequence: Scalars['Int'];
  timeInMs: Scalars['Int'];
};

export type LevelCreateWithoutKwouwselAccessoriesInput = {
  allowBackspace?: InputMaybe<Scalars['Boolean']>;
  amountOfChallengeResultsToPass?: InputMaybe<Scalars['Int']>;
  challenges?: InputMaybe<ChallengeCreateManyWithoutLevelInput>;
  characterName?: InputMaybe<Scalars['String']>;
  characterPrefix?: InputMaybe<Scalars['String']>;
  charactersPerMinutePercentage?: InputMaybe<Scalars['Decimal']>;
  diamonds?: InputMaybe<Scalars['Int']>;
  exercises?: InputMaybe<ExerciseCreateManyWithoutLevelInput>;
  id?: InputMaybe<Scalars['ID']>;
  kwouwselUpgrades?: InputMaybe<KwouwselUpgradeCreateManyWithoutLevelInput>;
  lives?: InputMaybe<Scalars['Int']>;
  loop?: InputMaybe<Scalars['Int']>;
  name: Scalars['String'];
  previous: Scalars['String'];
  requiredPercentageOfCpmsForStars?: InputMaybe<LevelCreaterequiredPercentageOfCpmsForStarsInput>;
  requiredPercentagesOfAccuracyForStars?: InputMaybe<LevelCreaterequiredPercentagesOfAccuracyForStarsInput>;
  sequence: Scalars['Int'];
  timeInMs: Scalars['Int'];
};

export type LevelCreateWithoutKwouwselUpgradesInput = {
  allowBackspace?: InputMaybe<Scalars['Boolean']>;
  amountOfChallengeResultsToPass?: InputMaybe<Scalars['Int']>;
  challenges?: InputMaybe<ChallengeCreateManyWithoutLevelInput>;
  characterName?: InputMaybe<Scalars['String']>;
  characterPrefix?: InputMaybe<Scalars['String']>;
  charactersPerMinutePercentage?: InputMaybe<Scalars['Decimal']>;
  diamonds?: InputMaybe<Scalars['Int']>;
  exercises?: InputMaybe<ExerciseCreateManyWithoutLevelInput>;
  id?: InputMaybe<Scalars['ID']>;
  kwouwselAccessories?: InputMaybe<KwouwselAccessoryCreateManyWithoutLevelInput>;
  lives?: InputMaybe<Scalars['Int']>;
  loop?: InputMaybe<Scalars['Int']>;
  name: Scalars['String'];
  previous: Scalars['String'];
  requiredPercentageOfCpmsForStars?: InputMaybe<LevelCreaterequiredPercentageOfCpmsForStarsInput>;
  requiredPercentagesOfAccuracyForStars?: InputMaybe<LevelCreaterequiredPercentagesOfAccuracyForStarsInput>;
  sequence: Scalars['Int'];
  timeInMs: Scalars['Int'];
};

export type LevelCreaterequiredPercentageOfCpmsForStarsInput = {
  set?: InputMaybe<Array<Scalars['Decimal']>>;
};

export type LevelCreaterequiredPercentagesOfAccuracyForStarsInput = {
  set?: InputMaybe<Array<Scalars['Decimal']>>;
};

export type LevelEdge = {
  cursor: Scalars['String'];
  node: Level;
};

export type LevelOrderByInput =
  | 'allowBackspace_ASC'
  | 'allowBackspace_DESC'
  | 'amountOfChallengeResultsToPass_ASC'
  | 'amountOfChallengeResultsToPass_DESC'
  | 'characterName_ASC'
  | 'characterName_DESC'
  | 'characterPrefix_ASC'
  | 'characterPrefix_DESC'
  | 'charactersPerMinutePercentage_ASC'
  | 'charactersPerMinutePercentage_DESC'
  | 'createdAt_ASC'
  | 'createdAt_DESC'
  | 'diamonds_ASC'
  | 'diamonds_DESC'
  | 'id_ASC'
  | 'id_DESC'
  | 'lives_ASC'
  | 'lives_DESC'
  | 'loop_ASC'
  | 'loop_DESC'
  | 'name_ASC'
  | 'name_DESC'
  | 'previous_ASC'
  | 'previous_DESC'
  | 'sequence_ASC'
  | 'sequence_DESC'
  | 'timeInMs_ASC'
  | 'timeInMs_DESC'
  | 'updatedAt_ASC'
  | 'updatedAt_DESC';

export type LevelSetting = {
  courseGroup: CourseGroup;
  id: Scalars['ID'];
  level: Scalars['String'];
  state: LevelState;
};

export type LevelSettingConnection = {
  aggregate: AggregateLevelSetting;
  edges: Array<Maybe<LevelSettingEdge>>;
  pageInfo: PageInfo;
};

export type LevelSettingCreateInput = {
  courseGroup: CourseGroupCreateOneWithoutLevelSettingsInput;
  id?: InputMaybe<Scalars['ID']>;
  level: Scalars['String'];
  state?: InputMaybe<LevelState>;
};

export type LevelSettingCreateManyWithoutCourseGroupInput = {
  connect?: InputMaybe<Array<LevelSettingWhereUniqueInput>>;
  create?: InputMaybe<Array<LevelSettingCreateWithoutCourseGroupInput>>;
};

export type LevelSettingCreateWithoutCourseGroupInput = {
  id?: InputMaybe<Scalars['ID']>;
  level: Scalars['String'];
  state?: InputMaybe<LevelState>;
};

export type LevelSettingEdge = {
  cursor: Scalars['String'];
  node: LevelSetting;
};

export type LevelSettingOrderByInput =
  | 'id_ASC'
  | 'id_DESC'
  | 'level_ASC'
  | 'level_DESC'
  | 'state_ASC'
  | 'state_DESC';

export type LevelSettingPreviousValues = {
  id: Scalars['ID'];
  level: Scalars['String'];
  state: LevelState;
};

export type LevelSettingScalarWhereInput = {
  AND?: InputMaybe<Array<LevelSettingScalarWhereInput>>;
  NOT?: InputMaybe<Array<LevelSettingScalarWhereInput>>;
  OR?: InputMaybe<Array<LevelSettingScalarWhereInput>>;
  id?: InputMaybe<Scalars['ID']>;
  id_contains?: InputMaybe<Scalars['ID']>;
  id_ends_with?: InputMaybe<Scalars['ID']>;
  id_gt?: InputMaybe<Scalars['ID']>;
  id_gte?: InputMaybe<Scalars['ID']>;
  id_in?: InputMaybe<Array<Scalars['ID']>>;
  id_lt?: InputMaybe<Scalars['ID']>;
  id_lte?: InputMaybe<Scalars['ID']>;
  id_not?: InputMaybe<Scalars['ID']>;
  id_not_contains?: InputMaybe<Scalars['ID']>;
  id_not_ends_with?: InputMaybe<Scalars['ID']>;
  id_not_in?: InputMaybe<Array<Scalars['ID']>>;
  id_not_starts_with?: InputMaybe<Scalars['ID']>;
  id_starts_with?: InputMaybe<Scalars['ID']>;
  level?: InputMaybe<Scalars['String']>;
  level_contains?: InputMaybe<Scalars['String']>;
  level_ends_with?: InputMaybe<Scalars['String']>;
  level_gt?: InputMaybe<Scalars['String']>;
  level_gte?: InputMaybe<Scalars['String']>;
  level_in?: InputMaybe<Array<Scalars['String']>>;
  level_lt?: InputMaybe<Scalars['String']>;
  level_lte?: InputMaybe<Scalars['String']>;
  level_not?: InputMaybe<Scalars['String']>;
  level_not_contains?: InputMaybe<Scalars['String']>;
  level_not_ends_with?: InputMaybe<Scalars['String']>;
  level_not_in?: InputMaybe<Array<Scalars['String']>>;
  level_not_starts_with?: InputMaybe<Scalars['String']>;
  level_starts_with?: InputMaybe<Scalars['String']>;
  state?: InputMaybe<LevelState>;
  state_in?: InputMaybe<Array<LevelState>>;
  state_not?: InputMaybe<LevelState>;
  state_not_in?: InputMaybe<Array<LevelState>>;
};

export type LevelSettingSubscriptionPayload = {
  mutation: MutationType;
  node?: Maybe<LevelSetting>;
  previousValues?: Maybe<LevelSettingPreviousValues>;
  updatedFields?: Maybe<Array<Scalars['String']>>;
};

export type LevelSettingSubscriptionWhereInput = {
  AND?: InputMaybe<Array<LevelSettingSubscriptionWhereInput>>;
  NOT?: InputMaybe<Array<LevelSettingSubscriptionWhereInput>>;
  OR?: InputMaybe<Array<LevelSettingSubscriptionWhereInput>>;
  mutation_in?: InputMaybe<Array<MutationType>>;
  node?: InputMaybe<LevelSettingWhereInput>;
  updatedFields_contains?: InputMaybe<Scalars['String']>;
  updatedFields_contains_every?: InputMaybe<Array<Scalars['String']>>;
  updatedFields_contains_some?: InputMaybe<Array<Scalars['String']>>;
};

export type LevelSettingUpdateInput = {
  state: LevelState;
};

export type LevelSettingUpdateManyDataInput = {
  level?: InputMaybe<Scalars['String']>;
  state?: InputMaybe<LevelState>;
};

export type LevelSettingUpdateManyMutationInput = {
  state: LevelState;
};

export type LevelSettingUpdateManyWithWhereNestedInput = {
  data: LevelSettingUpdateManyDataInput;
  where: LevelSettingScalarWhereInput;
};

export type LevelSettingUpdateManyWithoutCourseGroupInput = {
  connect?: InputMaybe<Array<LevelSettingWhereUniqueInput>>;
  create?: InputMaybe<Array<LevelSettingCreateWithoutCourseGroupInput>>;
  delete?: InputMaybe<Array<LevelSettingWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<LevelSettingScalarWhereInput>>;
  disconnect?: InputMaybe<Array<LevelSettingWhereUniqueInput>>;
  set?: InputMaybe<Array<LevelSettingWhereUniqueInput>>;
  update?: InputMaybe<
    Array<LevelSettingUpdateWithWhereUniqueWithoutCourseGroupInput>
  >;
  updateMany?: InputMaybe<Array<LevelSettingUpdateManyWithWhereNestedInput>>;
  upsert?: InputMaybe<
    Array<LevelSettingUpsertWithWhereUniqueWithoutCourseGroupInput>
  >;
};

export type LevelSettingUpdateWithWhereUniqueWithoutCourseGroupInput = {
  data: LevelSettingUpdateWithoutCourseGroupDataInput;
  where: LevelSettingWhereUniqueInput;
};

export type LevelSettingUpdateWithoutCourseGroupDataInput = {
  level?: InputMaybe<Scalars['String']>;
  state?: InputMaybe<LevelState>;
};

export type LevelSettingUpsertWithWhereUniqueWithoutCourseGroupInput = {
  create: LevelSettingCreateWithoutCourseGroupInput;
  update: LevelSettingUpdateWithoutCourseGroupDataInput;
  where: LevelSettingWhereUniqueInput;
};

export type LevelSettingWhereInput = {
  AND?: InputMaybe<Array<LevelSettingWhereInput>>;
  NOT?: InputMaybe<Array<LevelSettingWhereInput>>;
  OR?: InputMaybe<Array<LevelSettingWhereInput>>;
  courseGroup?: InputMaybe<CourseGroupWhereInput>;
  id?: InputMaybe<Scalars['ID']>;
  id_contains?: InputMaybe<Scalars['ID']>;
  id_ends_with?: InputMaybe<Scalars['ID']>;
  id_gt?: InputMaybe<Scalars['ID']>;
  id_gte?: InputMaybe<Scalars['ID']>;
  id_in?: InputMaybe<Array<Scalars['ID']>>;
  id_lt?: InputMaybe<Scalars['ID']>;
  id_lte?: InputMaybe<Scalars['ID']>;
  id_not?: InputMaybe<Scalars['ID']>;
  id_not_contains?: InputMaybe<Scalars['ID']>;
  id_not_ends_with?: InputMaybe<Scalars['ID']>;
  id_not_in?: InputMaybe<Array<Scalars['ID']>>;
  id_not_starts_with?: InputMaybe<Scalars['ID']>;
  id_starts_with?: InputMaybe<Scalars['ID']>;
  level?: InputMaybe<Scalars['String']>;
  level_contains?: InputMaybe<Scalars['String']>;
  level_ends_with?: InputMaybe<Scalars['String']>;
  level_gt?: InputMaybe<Scalars['String']>;
  level_gte?: InputMaybe<Scalars['String']>;
  level_in?: InputMaybe<Array<Scalars['String']>>;
  level_lt?: InputMaybe<Scalars['String']>;
  level_lte?: InputMaybe<Scalars['String']>;
  level_not?: InputMaybe<Scalars['String']>;
  level_not_contains?: InputMaybe<Scalars['String']>;
  level_not_ends_with?: InputMaybe<Scalars['String']>;
  level_not_in?: InputMaybe<Array<Scalars['String']>>;
  level_not_starts_with?: InputMaybe<Scalars['String']>;
  level_starts_with?: InputMaybe<Scalars['String']>;
  state?: InputMaybe<LevelState>;
  state_in?: InputMaybe<Array<LevelState>>;
  state_not?: InputMaybe<LevelState>;
  state_not_in?: InputMaybe<Array<LevelState>>;
};

export type LevelSettingWhereUniqueInput = {
  id?: InputMaybe<Scalars['ID']>;
};

export type LevelSettingsUpdateInput = {
  state: LevelState;
  where: LevelSettingWhereUniqueInput;
};

export type LevelState = 'Disabled' | 'Enabled' | 'None';

export type LevelUpdateDataInput = {
  allowBackspace?: InputMaybe<Scalars['Boolean']>;
  amountOfChallengeResultsToPass?: InputMaybe<Scalars['Int']>;
  challenges?: InputMaybe<ChallengeUpdateManyWithoutLevelInput>;
  characterName?: InputMaybe<Scalars['String']>;
  characterPrefix?: InputMaybe<Scalars['String']>;
  charactersPerMinutePercentage?: InputMaybe<Scalars['Decimal']>;
  diamonds?: InputMaybe<Scalars['Int']>;
  exercises?: InputMaybe<ExerciseUpdateManyWithoutLevelInput>;
  kwouwselAccessories?: InputMaybe<KwouwselAccessoryUpdateManyWithoutLevelInput>;
  kwouwselUpgrades?: InputMaybe<KwouwselUpgradeUpdateManyWithoutLevelInput>;
  lives?: InputMaybe<Scalars['Int']>;
  loop?: InputMaybe<Scalars['Int']>;
  name?: InputMaybe<Scalars['String']>;
  previous?: InputMaybe<Scalars['String']>;
  requiredPercentageOfCpmsForStars?: InputMaybe<LevelUpdaterequiredPercentageOfCpmsForStarsInput>;
  requiredPercentagesOfAccuracyForStars?: InputMaybe<LevelUpdaterequiredPercentagesOfAccuracyForStarsInput>;
  sequence?: InputMaybe<Scalars['Int']>;
  timeInMs?: InputMaybe<Scalars['Int']>;
};

export type LevelUpdateInput = {
  allowBackspace?: InputMaybe<Scalars['Boolean']>;
  amountOfChallengeResultsToPass?: InputMaybe<Scalars['Int']>;
  challenges?: InputMaybe<ChallengeUpdateManyWithoutLevelInput>;
  characterName?: InputMaybe<Scalars['String']>;
  characterPrefix?: InputMaybe<Scalars['String']>;
  charactersPerMinutePercentage?: InputMaybe<Scalars['Decimal']>;
  diamonds?: InputMaybe<Scalars['Int']>;
  exercises?: InputMaybe<ExerciseUpdateManyWithoutLevelInput>;
  kwouwselAccessories?: InputMaybe<KwouwselAccessoryUpdateManyWithoutLevelInput>;
  kwouwselUpgrades?: InputMaybe<KwouwselUpgradeUpdateManyWithoutLevelInput>;
  lives?: InputMaybe<Scalars['Int']>;
  loop?: InputMaybe<Scalars['Int']>;
  name?: InputMaybe<Scalars['String']>;
  previous?: InputMaybe<Scalars['String']>;
  requiredPercentageOfCpmsForStars?: InputMaybe<LevelUpdaterequiredPercentageOfCpmsForStarsInput>;
  requiredPercentagesOfAccuracyForStars?: InputMaybe<LevelUpdaterequiredPercentagesOfAccuracyForStarsInput>;
  sequence?: InputMaybe<Scalars['Int']>;
  timeInMs?: InputMaybe<Scalars['Int']>;
};

export type LevelUpdateManyMutationInput = {
  allowBackspace?: InputMaybe<Scalars['Boolean']>;
  amountOfChallengeResultsToPass?: InputMaybe<Scalars['Int']>;
  characterName?: InputMaybe<Scalars['String']>;
  characterPrefix?: InputMaybe<Scalars['String']>;
  charactersPerMinutePercentage?: InputMaybe<Scalars['Decimal']>;
  diamonds?: InputMaybe<Scalars['Int']>;
  lives?: InputMaybe<Scalars['Int']>;
  loop?: InputMaybe<Scalars['Int']>;
  name?: InputMaybe<Scalars['String']>;
  previous?: InputMaybe<Scalars['String']>;
  requiredPercentageOfCpmsForStars?: InputMaybe<LevelUpdaterequiredPercentageOfCpmsForStarsInput>;
  requiredPercentagesOfAccuracyForStars?: InputMaybe<LevelUpdaterequiredPercentagesOfAccuracyForStarsInput>;
  sequence?: InputMaybe<Scalars['Int']>;
  timeInMs?: InputMaybe<Scalars['Int']>;
};

export type LevelUpdateOneRequiredInput = {
  connect?: InputMaybe<LevelWhereUniqueInput>;
  create?: InputMaybe<LevelCreateInput>;
  update?: InputMaybe<LevelUpdateDataInput>;
  upsert?: InputMaybe<LevelUpsertNestedInput>;
};

export type LevelUpdateOneRequiredWithoutChallengesInput = {
  connect?: InputMaybe<LevelWhereUniqueInput>;
  create?: InputMaybe<LevelCreateWithoutChallengesInput>;
  update?: InputMaybe<LevelUpdateWithoutChallengesDataInput>;
  upsert?: InputMaybe<LevelUpsertWithoutChallengesInput>;
};

export type LevelUpdateOneRequiredWithoutExercisesInput = {
  connect?: InputMaybe<LevelWhereUniqueInput>;
  create?: InputMaybe<LevelCreateWithoutExercisesInput>;
  update?: InputMaybe<LevelUpdateWithoutExercisesDataInput>;
  upsert?: InputMaybe<LevelUpsertWithoutExercisesInput>;
};

export type LevelUpdateOneRequiredWithoutKwouwselAccessoriesInput = {
  connect?: InputMaybe<LevelWhereUniqueInput>;
  create?: InputMaybe<LevelCreateWithoutKwouwselAccessoriesInput>;
  update?: InputMaybe<LevelUpdateWithoutKwouwselAccessoriesDataInput>;
  upsert?: InputMaybe<LevelUpsertWithoutKwouwselAccessoriesInput>;
};

export type LevelUpdateOneRequiredWithoutKwouwselUpgradesInput = {
  connect?: InputMaybe<LevelWhereUniqueInput>;
  create?: InputMaybe<LevelCreateWithoutKwouwselUpgradesInput>;
  update?: InputMaybe<LevelUpdateWithoutKwouwselUpgradesDataInput>;
  upsert?: InputMaybe<LevelUpsertWithoutKwouwselUpgradesInput>;
};

export type LevelUpdateWithoutChallengesDataInput = {
  allowBackspace?: InputMaybe<Scalars['Boolean']>;
  amountOfChallengeResultsToPass?: InputMaybe<Scalars['Int']>;
  characterName?: InputMaybe<Scalars['String']>;
  characterPrefix?: InputMaybe<Scalars['String']>;
  charactersPerMinutePercentage?: InputMaybe<Scalars['Decimal']>;
  diamonds?: InputMaybe<Scalars['Int']>;
  exercises?: InputMaybe<ExerciseUpdateManyWithoutLevelInput>;
  kwouwselAccessories?: InputMaybe<KwouwselAccessoryUpdateManyWithoutLevelInput>;
  kwouwselUpgrades?: InputMaybe<KwouwselUpgradeUpdateManyWithoutLevelInput>;
  lives?: InputMaybe<Scalars['Int']>;
  loop?: InputMaybe<Scalars['Int']>;
  name?: InputMaybe<Scalars['String']>;
  previous?: InputMaybe<Scalars['String']>;
  requiredPercentageOfCpmsForStars?: InputMaybe<LevelUpdaterequiredPercentageOfCpmsForStarsInput>;
  requiredPercentagesOfAccuracyForStars?: InputMaybe<LevelUpdaterequiredPercentagesOfAccuracyForStarsInput>;
  sequence?: InputMaybe<Scalars['Int']>;
  timeInMs?: InputMaybe<Scalars['Int']>;
};

export type LevelUpdateWithoutExercisesDataInput = {
  allowBackspace?: InputMaybe<Scalars['Boolean']>;
  amountOfChallengeResultsToPass?: InputMaybe<Scalars['Int']>;
  challenges?: InputMaybe<ChallengeUpdateManyWithoutLevelInput>;
  characterName?: InputMaybe<Scalars['String']>;
  characterPrefix?: InputMaybe<Scalars['String']>;
  charactersPerMinutePercentage?: InputMaybe<Scalars['Decimal']>;
  diamonds?: InputMaybe<Scalars['Int']>;
  kwouwselAccessories?: InputMaybe<KwouwselAccessoryUpdateManyWithoutLevelInput>;
  kwouwselUpgrades?: InputMaybe<KwouwselUpgradeUpdateManyWithoutLevelInput>;
  lives?: InputMaybe<Scalars['Int']>;
  loop?: InputMaybe<Scalars['Int']>;
  name?: InputMaybe<Scalars['String']>;
  previous?: InputMaybe<Scalars['String']>;
  requiredPercentageOfCpmsForStars?: InputMaybe<LevelUpdaterequiredPercentageOfCpmsForStarsInput>;
  requiredPercentagesOfAccuracyForStars?: InputMaybe<LevelUpdaterequiredPercentagesOfAccuracyForStarsInput>;
  sequence?: InputMaybe<Scalars['Int']>;
  timeInMs?: InputMaybe<Scalars['Int']>;
};

export type LevelUpdateWithoutKwouwselAccessoriesDataInput = {
  allowBackspace?: InputMaybe<Scalars['Boolean']>;
  amountOfChallengeResultsToPass?: InputMaybe<Scalars['Int']>;
  challenges?: InputMaybe<ChallengeUpdateManyWithoutLevelInput>;
  characterName?: InputMaybe<Scalars['String']>;
  characterPrefix?: InputMaybe<Scalars['String']>;
  charactersPerMinutePercentage?: InputMaybe<Scalars['Decimal']>;
  diamonds?: InputMaybe<Scalars['Int']>;
  exercises?: InputMaybe<ExerciseUpdateManyWithoutLevelInput>;
  kwouwselUpgrades?: InputMaybe<KwouwselUpgradeUpdateManyWithoutLevelInput>;
  lives?: InputMaybe<Scalars['Int']>;
  loop?: InputMaybe<Scalars['Int']>;
  name?: InputMaybe<Scalars['String']>;
  previous?: InputMaybe<Scalars['String']>;
  requiredPercentageOfCpmsForStars?: InputMaybe<LevelUpdaterequiredPercentageOfCpmsForStarsInput>;
  requiredPercentagesOfAccuracyForStars?: InputMaybe<LevelUpdaterequiredPercentagesOfAccuracyForStarsInput>;
  sequence?: InputMaybe<Scalars['Int']>;
  timeInMs?: InputMaybe<Scalars['Int']>;
};

export type LevelUpdateWithoutKwouwselUpgradesDataInput = {
  allowBackspace?: InputMaybe<Scalars['Boolean']>;
  amountOfChallengeResultsToPass?: InputMaybe<Scalars['Int']>;
  challenges?: InputMaybe<ChallengeUpdateManyWithoutLevelInput>;
  characterName?: InputMaybe<Scalars['String']>;
  characterPrefix?: InputMaybe<Scalars['String']>;
  charactersPerMinutePercentage?: InputMaybe<Scalars['Decimal']>;
  diamonds?: InputMaybe<Scalars['Int']>;
  exercises?: InputMaybe<ExerciseUpdateManyWithoutLevelInput>;
  kwouwselAccessories?: InputMaybe<KwouwselAccessoryUpdateManyWithoutLevelInput>;
  lives?: InputMaybe<Scalars['Int']>;
  loop?: InputMaybe<Scalars['Int']>;
  name?: InputMaybe<Scalars['String']>;
  previous?: InputMaybe<Scalars['String']>;
  requiredPercentageOfCpmsForStars?: InputMaybe<LevelUpdaterequiredPercentageOfCpmsForStarsInput>;
  requiredPercentagesOfAccuracyForStars?: InputMaybe<LevelUpdaterequiredPercentagesOfAccuracyForStarsInput>;
  sequence?: InputMaybe<Scalars['Int']>;
  timeInMs?: InputMaybe<Scalars['Int']>;
};

export type LevelUpdaterequiredPercentageOfCpmsForStarsInput = {
  set?: InputMaybe<Array<Scalars['Decimal']>>;
};

export type LevelUpdaterequiredPercentagesOfAccuracyForStarsInput = {
  set?: InputMaybe<Array<Scalars['Decimal']>>;
};

export type LevelUpsertNestedInput = {
  create: LevelCreateInput;
  update: LevelUpdateDataInput;
};

export type LevelUpsertWithoutChallengesInput = {
  create: LevelCreateWithoutChallengesInput;
  update: LevelUpdateWithoutChallengesDataInput;
};

export type LevelUpsertWithoutExercisesInput = {
  create: LevelCreateWithoutExercisesInput;
  update: LevelUpdateWithoutExercisesDataInput;
};

export type LevelUpsertWithoutKwouwselAccessoriesInput = {
  create: LevelCreateWithoutKwouwselAccessoriesInput;
  update: LevelUpdateWithoutKwouwselAccessoriesDataInput;
};

export type LevelUpsertWithoutKwouwselUpgradesInput = {
  create: LevelCreateWithoutKwouwselUpgradesInput;
  update: LevelUpdateWithoutKwouwselUpgradesDataInput;
};

export type LevelWhereInput = {
  AND?: InputMaybe<Array<LevelWhereInput>>;
  NOT?: InputMaybe<Array<LevelWhereInput>>;
  OR?: InputMaybe<Array<LevelWhereInput>>;
  allowBackspace?: InputMaybe<Scalars['Boolean']>;
  allowBackspace_not?: InputMaybe<Scalars['Boolean']>;
  amountOfChallengeResultsToPass?: InputMaybe<Scalars['Int']>;
  amountOfChallengeResultsToPass_gt?: InputMaybe<Scalars['Int']>;
  amountOfChallengeResultsToPass_gte?: InputMaybe<Scalars['Int']>;
  amountOfChallengeResultsToPass_in?: InputMaybe<Array<Scalars['Int']>>;
  amountOfChallengeResultsToPass_lt?: InputMaybe<Scalars['Int']>;
  amountOfChallengeResultsToPass_lte?: InputMaybe<Scalars['Int']>;
  amountOfChallengeResultsToPass_not?: InputMaybe<Scalars['Int']>;
  amountOfChallengeResultsToPass_not_in?: InputMaybe<Array<Scalars['Int']>>;
  challenges_every?: InputMaybe<ChallengeWhereInput>;
  challenges_none?: InputMaybe<ChallengeWhereInput>;
  challenges_some?: InputMaybe<ChallengeWhereInput>;
  characterName?: InputMaybe<Scalars['String']>;
  characterName_contains?: InputMaybe<Scalars['String']>;
  characterName_ends_with?: InputMaybe<Scalars['String']>;
  characterName_gt?: InputMaybe<Scalars['String']>;
  characterName_gte?: InputMaybe<Scalars['String']>;
  characterName_in?: InputMaybe<Array<Scalars['String']>>;
  characterName_lt?: InputMaybe<Scalars['String']>;
  characterName_lte?: InputMaybe<Scalars['String']>;
  characterName_not?: InputMaybe<Scalars['String']>;
  characterName_not_contains?: InputMaybe<Scalars['String']>;
  characterName_not_ends_with?: InputMaybe<Scalars['String']>;
  characterName_not_in?: InputMaybe<Array<Scalars['String']>>;
  characterName_not_starts_with?: InputMaybe<Scalars['String']>;
  characterName_starts_with?: InputMaybe<Scalars['String']>;
  characterPrefix?: InputMaybe<Scalars['String']>;
  characterPrefix_contains?: InputMaybe<Scalars['String']>;
  characterPrefix_ends_with?: InputMaybe<Scalars['String']>;
  characterPrefix_gt?: InputMaybe<Scalars['String']>;
  characterPrefix_gte?: InputMaybe<Scalars['String']>;
  characterPrefix_in?: InputMaybe<Array<Scalars['String']>>;
  characterPrefix_lt?: InputMaybe<Scalars['String']>;
  characterPrefix_lte?: InputMaybe<Scalars['String']>;
  characterPrefix_not?: InputMaybe<Scalars['String']>;
  characterPrefix_not_contains?: InputMaybe<Scalars['String']>;
  characterPrefix_not_ends_with?: InputMaybe<Scalars['String']>;
  characterPrefix_not_in?: InputMaybe<Array<Scalars['String']>>;
  characterPrefix_not_starts_with?: InputMaybe<Scalars['String']>;
  characterPrefix_starts_with?: InputMaybe<Scalars['String']>;
  charactersPerMinutePercentage?: InputMaybe<Scalars['Decimal']>;
  charactersPerMinutePercentage_gt?: InputMaybe<Scalars['Decimal']>;
  charactersPerMinutePercentage_gte?: InputMaybe<Scalars['Decimal']>;
  charactersPerMinutePercentage_in?: InputMaybe<Array<Scalars['Decimal']>>;
  charactersPerMinutePercentage_lt?: InputMaybe<Scalars['Decimal']>;
  charactersPerMinutePercentage_lte?: InputMaybe<Scalars['Decimal']>;
  charactersPerMinutePercentage_not?: InputMaybe<Scalars['Decimal']>;
  charactersPerMinutePercentage_not_in?: InputMaybe<Array<Scalars['Decimal']>>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  createdAt_gt?: InputMaybe<Scalars['DateTime']>;
  createdAt_gte?: InputMaybe<Scalars['DateTime']>;
  createdAt_in?: InputMaybe<Array<Scalars['DateTime']>>;
  createdAt_lt?: InputMaybe<Scalars['DateTime']>;
  createdAt_lte?: InputMaybe<Scalars['DateTime']>;
  createdAt_not?: InputMaybe<Scalars['DateTime']>;
  createdAt_not_in?: InputMaybe<Array<Scalars['DateTime']>>;
  diamonds?: InputMaybe<Scalars['Int']>;
  diamonds_gt?: InputMaybe<Scalars['Int']>;
  diamonds_gte?: InputMaybe<Scalars['Int']>;
  diamonds_in?: InputMaybe<Array<Scalars['Int']>>;
  diamonds_lt?: InputMaybe<Scalars['Int']>;
  diamonds_lte?: InputMaybe<Scalars['Int']>;
  diamonds_not?: InputMaybe<Scalars['Int']>;
  diamonds_not_in?: InputMaybe<Array<Scalars['Int']>>;
  exercises_every?: InputMaybe<ExerciseWhereInput>;
  exercises_none?: InputMaybe<ExerciseWhereInput>;
  exercises_some?: InputMaybe<ExerciseWhereInput>;
  id?: InputMaybe<Scalars['ID']>;
  id_contains?: InputMaybe<Scalars['ID']>;
  id_ends_with?: InputMaybe<Scalars['ID']>;
  id_gt?: InputMaybe<Scalars['ID']>;
  id_gte?: InputMaybe<Scalars['ID']>;
  id_in?: InputMaybe<Array<Scalars['ID']>>;
  id_lt?: InputMaybe<Scalars['ID']>;
  id_lte?: InputMaybe<Scalars['ID']>;
  id_not?: InputMaybe<Scalars['ID']>;
  id_not_contains?: InputMaybe<Scalars['ID']>;
  id_not_ends_with?: InputMaybe<Scalars['ID']>;
  id_not_in?: InputMaybe<Array<Scalars['ID']>>;
  id_not_starts_with?: InputMaybe<Scalars['ID']>;
  id_starts_with?: InputMaybe<Scalars['ID']>;
  kwouwselAccessories_every?: InputMaybe<KwouwselAccessoryWhereInput>;
  kwouwselAccessories_none?: InputMaybe<KwouwselAccessoryWhereInput>;
  kwouwselAccessories_some?: InputMaybe<KwouwselAccessoryWhereInput>;
  kwouwselUpgrades_every?: InputMaybe<KwouwselUpgradeWhereInput>;
  kwouwselUpgrades_none?: InputMaybe<KwouwselUpgradeWhereInput>;
  kwouwselUpgrades_some?: InputMaybe<KwouwselUpgradeWhereInput>;
  lives?: InputMaybe<Scalars['Int']>;
  lives_gt?: InputMaybe<Scalars['Int']>;
  lives_gte?: InputMaybe<Scalars['Int']>;
  lives_in?: InputMaybe<Array<Scalars['Int']>>;
  lives_lt?: InputMaybe<Scalars['Int']>;
  lives_lte?: InputMaybe<Scalars['Int']>;
  lives_not?: InputMaybe<Scalars['Int']>;
  lives_not_in?: InputMaybe<Array<Scalars['Int']>>;
  loop?: InputMaybe<Scalars['Int']>;
  loop_gt?: InputMaybe<Scalars['Int']>;
  loop_gte?: InputMaybe<Scalars['Int']>;
  loop_in?: InputMaybe<Array<Scalars['Int']>>;
  loop_lt?: InputMaybe<Scalars['Int']>;
  loop_lte?: InputMaybe<Scalars['Int']>;
  loop_not?: InputMaybe<Scalars['Int']>;
  loop_not_in?: InputMaybe<Array<Scalars['Int']>>;
  name?: InputMaybe<Scalars['String']>;
  name_contains?: InputMaybe<Scalars['String']>;
  name_ends_with?: InputMaybe<Scalars['String']>;
  name_gt?: InputMaybe<Scalars['String']>;
  name_gte?: InputMaybe<Scalars['String']>;
  name_in?: InputMaybe<Array<Scalars['String']>>;
  name_lt?: InputMaybe<Scalars['String']>;
  name_lte?: InputMaybe<Scalars['String']>;
  name_not?: InputMaybe<Scalars['String']>;
  name_not_contains?: InputMaybe<Scalars['String']>;
  name_not_ends_with?: InputMaybe<Scalars['String']>;
  name_not_in?: InputMaybe<Array<Scalars['String']>>;
  name_not_starts_with?: InputMaybe<Scalars['String']>;
  name_starts_with?: InputMaybe<Scalars['String']>;
  previous?: InputMaybe<Scalars['String']>;
  previous_contains?: InputMaybe<Scalars['String']>;
  previous_ends_with?: InputMaybe<Scalars['String']>;
  previous_gt?: InputMaybe<Scalars['String']>;
  previous_gte?: InputMaybe<Scalars['String']>;
  previous_in?: InputMaybe<Array<Scalars['String']>>;
  previous_lt?: InputMaybe<Scalars['String']>;
  previous_lte?: InputMaybe<Scalars['String']>;
  previous_not?: InputMaybe<Scalars['String']>;
  previous_not_contains?: InputMaybe<Scalars['String']>;
  previous_not_ends_with?: InputMaybe<Scalars['String']>;
  previous_not_in?: InputMaybe<Array<Scalars['String']>>;
  previous_not_starts_with?: InputMaybe<Scalars['String']>;
  previous_starts_with?: InputMaybe<Scalars['String']>;
  sequence?: InputMaybe<Scalars['Int']>;
  sequence_gt?: InputMaybe<Scalars['Int']>;
  sequence_gte?: InputMaybe<Scalars['Int']>;
  sequence_in?: InputMaybe<Array<Scalars['Int']>>;
  sequence_lt?: InputMaybe<Scalars['Int']>;
  sequence_lte?: InputMaybe<Scalars['Int']>;
  sequence_not?: InputMaybe<Scalars['Int']>;
  sequence_not_in?: InputMaybe<Array<Scalars['Int']>>;
  timeInMs?: InputMaybe<Scalars['Int']>;
  timeInMs_gt?: InputMaybe<Scalars['Int']>;
  timeInMs_gte?: InputMaybe<Scalars['Int']>;
  timeInMs_in?: InputMaybe<Array<Scalars['Int']>>;
  timeInMs_lt?: InputMaybe<Scalars['Int']>;
  timeInMs_lte?: InputMaybe<Scalars['Int']>;
  timeInMs_not?: InputMaybe<Scalars['Int']>;
  timeInMs_not_in?: InputMaybe<Array<Scalars['Int']>>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
  updatedAt_gt?: InputMaybe<Scalars['DateTime']>;
  updatedAt_gte?: InputMaybe<Scalars['DateTime']>;
  updatedAt_in?: InputMaybe<Array<Scalars['DateTime']>>;
  updatedAt_lt?: InputMaybe<Scalars['DateTime']>;
  updatedAt_lte?: InputMaybe<Scalars['DateTime']>;
  updatedAt_not?: InputMaybe<Scalars['DateTime']>;
  updatedAt_not_in?: InputMaybe<Array<Scalars['DateTime']>>;
};

export type LevelWhereUniqueInput = {
  id?: InputMaybe<Scalars['ID']>;
};

export type License = {
  createdAt: Scalars['DateTime'];
  endDate?: Maybe<Scalars['DateTime']>;
  id: Scalars['ID'];
  pool: LicensePool;
  startDate: Scalars['DateTime'];
  updatedAt: Scalars['DateTime'];
  user?: Maybe<BeheerUser>;
};

export type LicenseConnection = {
  aggregate: AggregateLicense;
  edges: Array<Maybe<LicenseEdge>>;
  pageInfo: PageInfo;
};

export type LicenseCreateInput = {
  endDate?: InputMaybe<Scalars['DateTime']>;
  id?: InputMaybe<Scalars['ID']>;
  pool: LicensePoolCreateOneWithoutLicensesInput;
  startDate: Scalars['DateTime'];
  user?: InputMaybe<BeheerUserCreateOneWithoutLicenseInput>;
};

export type LicenseCreateManyWithoutPoolInput = {
  connect?: InputMaybe<Array<LicenseWhereUniqueInput>>;
  create?: InputMaybe<Array<LicenseCreateWithoutPoolInput>>;
};

export type LicenseCreateOneWithoutUserInput = {
  connect?: InputMaybe<LicenseWhereUniqueInput>;
  create?: InputMaybe<LicenseCreateWithoutUserInput>;
};

export type LicenseCreateWithoutPoolInput = {
  endDate?: InputMaybe<Scalars['DateTime']>;
  id?: InputMaybe<Scalars['ID']>;
  startDate: Scalars['DateTime'];
  user?: InputMaybe<BeheerUserCreateOneWithoutLicenseInput>;
};

export type LicenseCreateWithoutUserInput = {
  endDate?: InputMaybe<Scalars['DateTime']>;
  id?: InputMaybe<Scalars['ID']>;
  pool: LicensePoolCreateOneWithoutLicensesInput;
  startDate: Scalars['DateTime'];
};

export type LicenseEdge = {
  cursor: Scalars['String'];
  node: License;
};

export type LicenseFromPoolInput = {
  schoolId: Scalars['ID'];
};

export type LicenseInfoInput = {
  amount: Scalars['Int'];
  couponCode?: InputMaybe<Scalars['String']>;
  startDate: Scalars['DateTime'];
};

export type LicenseInfoUpdateOneInput = {
  update: LicenseSubscriptionInfoUpdateDataInput;
};

export type LicenseOrderByInput =
  | 'createdAt_ASC'
  | 'createdAt_DESC'
  | 'endDate_ASC'
  | 'endDate_DESC'
  | 'id_ASC'
  | 'id_DESC'
  | 'startDate_ASC'
  | 'startDate_DESC'
  | 'updatedAt_ASC'
  | 'updatedAt_DESC';

export type LicensePool = {
  childPools: Array<LicensePool>;
  createdAt: Scalars['DateTime'];
  id: Scalars['ID'];
  licenses: Array<License>;
  licensesDistributed: Scalars['Int'];
  licensesIdle: Scalars['Int'];
  licensesInUse: Scalars['Int'];
  licensesRemaining: Scalars['Int'];
  parentPool?: Maybe<LicensePool>;
  subscription?: Maybe<LicenseSubscriptionInfo>;
  updatedAt: Scalars['DateTime'];
};

export type LicensePoolChildInput = {
  id: Scalars['ID'];
  resource?: InputMaybe<LicensePoolChildResource>;
};

export type LicensePoolChildResource = 'SCHOOL' | 'SCHOOL_DISTRICT';

export type LicensePoolConnection = {
  aggregate: AggregateLicensePool;
  edges: Array<Maybe<LicensePoolEdge>>;
  pageInfo: PageInfo;
};

export type LicensePoolCreateInput = {
  childPools?: InputMaybe<LicensePoolCreateManyWithoutParentPoolInput>;
  id?: InputMaybe<Scalars['ID']>;
  licenseSubscription?: InputMaybe<LicenseSubscriptionInfoCreateOneInput>;
  licenses?: InputMaybe<LicenseCreateManyWithoutPoolInput>;
  parentPool?: InputMaybe<LicensePoolCreateOneWithoutChildPoolsInput>;
};

export type LicensePoolCreateManyWithoutParentPoolInput = {
  connect?: InputMaybe<Array<LicensePoolWhereUniqueInput>>;
  create?: InputMaybe<Array<LicensePoolCreateWithoutParentPoolInput>>;
};

export type LicensePoolCreateOneInput = {
  connect?: InputMaybe<LicensePoolWhereUniqueInput>;
  create?: InputMaybe<LicensePoolCreateInput>;
};

export type LicensePoolCreateOneWithoutChildPoolsInput = {
  connect?: InputMaybe<LicensePoolWhereUniqueInput>;
  create?: InputMaybe<LicensePoolCreateWithoutChildPoolsInput>;
};

export type LicensePoolCreateOneWithoutLicensesInput = {
  connect?: InputMaybe<LicensePoolWhereUniqueInput>;
  create?: InputMaybe<LicensePoolCreateWithoutLicensesInput>;
};

export type LicensePoolCreateWithoutChildPoolsInput = {
  id?: InputMaybe<Scalars['ID']>;
  licenseSubscription?: InputMaybe<LicenseSubscriptionInfoCreateOneInput>;
  licenses?: InputMaybe<LicenseCreateManyWithoutPoolInput>;
  parentPool?: InputMaybe<LicensePoolCreateOneWithoutChildPoolsInput>;
};

export type LicensePoolCreateWithoutLicensesInput = {
  childPools?: InputMaybe<LicensePoolCreateManyWithoutParentPoolInput>;
  id?: InputMaybe<Scalars['ID']>;
  licenseSubscription?: InputMaybe<LicenseSubscriptionInfoCreateOneInput>;
  parentPool?: InputMaybe<LicensePoolCreateOneWithoutChildPoolsInput>;
};

export type LicensePoolCreateWithoutParentPoolInput = {
  childPools?: InputMaybe<LicensePoolCreateManyWithoutParentPoolInput>;
  id?: InputMaybe<Scalars['ID']>;
  licenseSubscription?: InputMaybe<LicenseSubscriptionInfoCreateOneInput>;
  licenses?: InputMaybe<LicenseCreateManyWithoutPoolInput>;
};

export type LicensePoolEdge = {
  cursor: Scalars['String'];
  node: LicensePool;
};

export type LicensePoolOrderByInput =
  | 'createdAt_ASC'
  | 'createdAt_DESC'
  | 'id_ASC'
  | 'id_DESC'
  | 'updatedAt_ASC'
  | 'updatedAt_DESC';

export type LicensePoolParentInput = {
  id: Scalars['ID'];
  resource?: InputMaybe<LicensePoolParentResource>;
};

export type LicensePoolParentResource = 'PARTNER' | 'SCHOOL_DISTRICT';

export type LicensePoolPreviousValues = {
  createdAt: Scalars['DateTime'];
  id: Scalars['ID'];
  updatedAt: Scalars['DateTime'];
};

export type LicensePoolScalarWhereInput = {
  AND?: InputMaybe<Array<LicensePoolScalarWhereInput>>;
  NOT?: InputMaybe<Array<LicensePoolScalarWhereInput>>;
  OR?: InputMaybe<Array<LicensePoolScalarWhereInput>>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  createdAt_gt?: InputMaybe<Scalars['DateTime']>;
  createdAt_gte?: InputMaybe<Scalars['DateTime']>;
  createdAt_in?: InputMaybe<Array<Scalars['DateTime']>>;
  createdAt_lt?: InputMaybe<Scalars['DateTime']>;
  createdAt_lte?: InputMaybe<Scalars['DateTime']>;
  createdAt_not?: InputMaybe<Scalars['DateTime']>;
  createdAt_not_in?: InputMaybe<Array<Scalars['DateTime']>>;
  id?: InputMaybe<Scalars['ID']>;
  id_contains?: InputMaybe<Scalars['ID']>;
  id_ends_with?: InputMaybe<Scalars['ID']>;
  id_gt?: InputMaybe<Scalars['ID']>;
  id_gte?: InputMaybe<Scalars['ID']>;
  id_in?: InputMaybe<Array<Scalars['ID']>>;
  id_lt?: InputMaybe<Scalars['ID']>;
  id_lte?: InputMaybe<Scalars['ID']>;
  id_not?: InputMaybe<Scalars['ID']>;
  id_not_contains?: InputMaybe<Scalars['ID']>;
  id_not_ends_with?: InputMaybe<Scalars['ID']>;
  id_not_in?: InputMaybe<Array<Scalars['ID']>>;
  id_not_starts_with?: InputMaybe<Scalars['ID']>;
  id_starts_with?: InputMaybe<Scalars['ID']>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
  updatedAt_gt?: InputMaybe<Scalars['DateTime']>;
  updatedAt_gte?: InputMaybe<Scalars['DateTime']>;
  updatedAt_in?: InputMaybe<Array<Scalars['DateTime']>>;
  updatedAt_lt?: InputMaybe<Scalars['DateTime']>;
  updatedAt_lte?: InputMaybe<Scalars['DateTime']>;
  updatedAt_not?: InputMaybe<Scalars['DateTime']>;
  updatedAt_not_in?: InputMaybe<Array<Scalars['DateTime']>>;
};

export type LicensePoolSubscriptionPayload = {
  mutation: MutationType;
  node?: Maybe<LicensePool>;
  previousValues?: Maybe<LicensePoolPreviousValues>;
  updatedFields?: Maybe<Array<Scalars['String']>>;
};

export type LicensePoolSubscriptionWhereInput = {
  AND?: InputMaybe<Array<LicensePoolSubscriptionWhereInput>>;
  NOT?: InputMaybe<Array<LicensePoolSubscriptionWhereInput>>;
  OR?: InputMaybe<Array<LicensePoolSubscriptionWhereInput>>;
  mutation_in?: InputMaybe<Array<MutationType>>;
  node?: InputMaybe<LicensePoolWhereInput>;
  updatedFields_contains?: InputMaybe<Scalars['String']>;
  updatedFields_contains_every?: InputMaybe<Array<Scalars['String']>>;
  updatedFields_contains_some?: InputMaybe<Array<Scalars['String']>>;
};

export type LicensePoolUpdateDataInput = {
  childPools?: InputMaybe<LicensePoolUpdateManyWithoutParentPoolInput>;
  licenseSubscription?: InputMaybe<LicenseSubscriptionInfoUpdateOneInput>;
  licenses?: InputMaybe<LicenseUpdateManyWithoutPoolInput>;
  parentPool?: InputMaybe<LicensePoolUpdateOneWithoutChildPoolsInput>;
};

export type LicensePoolUpdateInput = {
  childPools?: InputMaybe<LicensePoolUpdateManyWithoutParentPoolInput>;
  licenseSubscription?: InputMaybe<LicenseSubscriptionInfoUpdateOneInput>;
  licenses?: InputMaybe<LicenseUpdateManyWithoutPoolInput>;
  parentPool?: InputMaybe<LicensePoolUpdateOneWithoutChildPoolsInput>;
};

export type LicensePoolUpdateManyWithoutParentPoolInput = {
  connect?: InputMaybe<Array<LicensePoolWhereUniqueInput>>;
  create?: InputMaybe<Array<LicensePoolCreateWithoutParentPoolInput>>;
  delete?: InputMaybe<Array<LicensePoolWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<LicensePoolScalarWhereInput>>;
  disconnect?: InputMaybe<Array<LicensePoolWhereUniqueInput>>;
  set?: InputMaybe<Array<LicensePoolWhereUniqueInput>>;
  update?: InputMaybe<
    Array<LicensePoolUpdateWithWhereUniqueWithoutParentPoolInput>
  >;
  upsert?: InputMaybe<
    Array<LicensePoolUpsertWithWhereUniqueWithoutParentPoolInput>
  >;
};

export type LicensePoolUpdateOneRequiredInput = {
  connect?: InputMaybe<LicensePoolWhereUniqueInput>;
  create?: InputMaybe<LicensePoolCreateInput>;
  update?: InputMaybe<LicensePoolUpdateDataInput>;
  upsert?: InputMaybe<LicensePoolUpsertNestedInput>;
};

export type LicensePoolUpdateOneRequiredWithoutLicensesInput = {
  connect?: InputMaybe<LicensePoolWhereUniqueInput>;
  create?: InputMaybe<LicensePoolCreateWithoutLicensesInput>;
  update?: InputMaybe<LicensePoolUpdateWithoutLicensesDataInput>;
  upsert?: InputMaybe<LicensePoolUpsertWithoutLicensesInput>;
};

export type LicensePoolUpdateOneWithoutChildPoolsInput = {
  connect?: InputMaybe<LicensePoolWhereUniqueInput>;
  create?: InputMaybe<LicensePoolCreateWithoutChildPoolsInput>;
  delete?: InputMaybe<Scalars['Boolean']>;
  disconnect?: InputMaybe<Scalars['Boolean']>;
  update?: InputMaybe<LicensePoolUpdateWithoutChildPoolsDataInput>;
  upsert?: InputMaybe<LicensePoolUpsertWithoutChildPoolsInput>;
};

export type LicensePoolUpdateWithWhereUniqueWithoutParentPoolInput = {
  data: LicensePoolUpdateWithoutParentPoolDataInput;
  where: LicensePoolWhereUniqueInput;
};

export type LicensePoolUpdateWithoutChildPoolsDataInput = {
  licenseSubscription?: InputMaybe<LicenseSubscriptionInfoUpdateOneInput>;
  licenses?: InputMaybe<LicenseUpdateManyWithoutPoolInput>;
  parentPool?: InputMaybe<LicensePoolUpdateOneWithoutChildPoolsInput>;
};

export type LicensePoolUpdateWithoutLicensesDataInput = {
  childPools?: InputMaybe<LicensePoolUpdateManyWithoutParentPoolInput>;
  licenseSubscription?: InputMaybe<LicenseSubscriptionInfoUpdateOneInput>;
  parentPool?: InputMaybe<LicensePoolUpdateOneWithoutChildPoolsInput>;
};

export type LicensePoolUpdateWithoutParentPoolDataInput = {
  childPools?: InputMaybe<LicensePoolUpdateManyWithoutParentPoolInput>;
  licenseSubscription?: InputMaybe<LicenseSubscriptionInfoUpdateOneInput>;
  licenses?: InputMaybe<LicenseUpdateManyWithoutPoolInput>;
};

export type LicensePoolUpsertNestedInput = {
  create: LicensePoolCreateInput;
  update: LicensePoolUpdateDataInput;
};

export type LicensePoolUpsertWithWhereUniqueWithoutParentPoolInput = {
  create: LicensePoolCreateWithoutParentPoolInput;
  update: LicensePoolUpdateWithoutParentPoolDataInput;
  where: LicensePoolWhereUniqueInput;
};

export type LicensePoolUpsertWithoutChildPoolsInput = {
  create: LicensePoolCreateWithoutChildPoolsInput;
  update: LicensePoolUpdateWithoutChildPoolsDataInput;
};

export type LicensePoolUpsertWithoutLicensesInput = {
  create: LicensePoolCreateWithoutLicensesInput;
  update: LicensePoolUpdateWithoutLicensesDataInput;
};

export type LicensePoolWhereInput = {
  AND?: InputMaybe<Array<LicensePoolWhereInput>>;
  NOT?: InputMaybe<Array<LicensePoolWhereInput>>;
  OR?: InputMaybe<Array<LicensePoolWhereInput>>;
  childPools_every?: InputMaybe<LicensePoolWhereInput>;
  childPools_none?: InputMaybe<LicensePoolWhereInput>;
  childPools_some?: InputMaybe<LicensePoolWhereInput>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  createdAt_gt?: InputMaybe<Scalars['DateTime']>;
  createdAt_gte?: InputMaybe<Scalars['DateTime']>;
  createdAt_in?: InputMaybe<Array<Scalars['DateTime']>>;
  createdAt_lt?: InputMaybe<Scalars['DateTime']>;
  createdAt_lte?: InputMaybe<Scalars['DateTime']>;
  createdAt_not?: InputMaybe<Scalars['DateTime']>;
  createdAt_not_in?: InputMaybe<Array<Scalars['DateTime']>>;
  id?: InputMaybe<Scalars['ID']>;
  id_contains?: InputMaybe<Scalars['ID']>;
  id_ends_with?: InputMaybe<Scalars['ID']>;
  id_gt?: InputMaybe<Scalars['ID']>;
  id_gte?: InputMaybe<Scalars['ID']>;
  id_in?: InputMaybe<Array<Scalars['ID']>>;
  id_lt?: InputMaybe<Scalars['ID']>;
  id_lte?: InputMaybe<Scalars['ID']>;
  id_not?: InputMaybe<Scalars['ID']>;
  id_not_contains?: InputMaybe<Scalars['ID']>;
  id_not_ends_with?: InputMaybe<Scalars['ID']>;
  id_not_in?: InputMaybe<Array<Scalars['ID']>>;
  id_not_starts_with?: InputMaybe<Scalars['ID']>;
  id_starts_with?: InputMaybe<Scalars['ID']>;
  licenseSubscription?: InputMaybe<LicenseSubscriptionInfoWhereInput>;
  licenses_every?: InputMaybe<LicenseWhereInput>;
  licenses_none?: InputMaybe<LicenseWhereInput>;
  licenses_some?: InputMaybe<LicenseWhereInput>;
  parentPool?: InputMaybe<LicensePoolWhereInput>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
  updatedAt_gt?: InputMaybe<Scalars['DateTime']>;
  updatedAt_gte?: InputMaybe<Scalars['DateTime']>;
  updatedAt_in?: InputMaybe<Array<Scalars['DateTime']>>;
  updatedAt_lt?: InputMaybe<Scalars['DateTime']>;
  updatedAt_lte?: InputMaybe<Scalars['DateTime']>;
  updatedAt_not?: InputMaybe<Scalars['DateTime']>;
  updatedAt_not_in?: InputMaybe<Array<Scalars['DateTime']>>;
};

export type LicensePoolWhereUniqueInput = {
  id?: InputMaybe<Scalars['ID']>;
};

export type LicensePreviousValues = {
  createdAt: Scalars['DateTime'];
  endDate?: Maybe<Scalars['DateTime']>;
  id: Scalars['ID'];
  startDate: Scalars['DateTime'];
  updatedAt: Scalars['DateTime'];
};

export type LicenseScalarWhereInput = {
  AND?: InputMaybe<Array<LicenseScalarWhereInput>>;
  NOT?: InputMaybe<Array<LicenseScalarWhereInput>>;
  OR?: InputMaybe<Array<LicenseScalarWhereInput>>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  createdAt_gt?: InputMaybe<Scalars['DateTime']>;
  createdAt_gte?: InputMaybe<Scalars['DateTime']>;
  createdAt_in?: InputMaybe<Array<Scalars['DateTime']>>;
  createdAt_lt?: InputMaybe<Scalars['DateTime']>;
  createdAt_lte?: InputMaybe<Scalars['DateTime']>;
  createdAt_not?: InputMaybe<Scalars['DateTime']>;
  createdAt_not_in?: InputMaybe<Array<Scalars['DateTime']>>;
  endDate?: InputMaybe<Scalars['DateTime']>;
  endDate_gt?: InputMaybe<Scalars['DateTime']>;
  endDate_gte?: InputMaybe<Scalars['DateTime']>;
  endDate_in?: InputMaybe<Array<Scalars['DateTime']>>;
  endDate_lt?: InputMaybe<Scalars['DateTime']>;
  endDate_lte?: InputMaybe<Scalars['DateTime']>;
  endDate_not?: InputMaybe<Scalars['DateTime']>;
  endDate_not_in?: InputMaybe<Array<Scalars['DateTime']>>;
  id?: InputMaybe<Scalars['ID']>;
  id_contains?: InputMaybe<Scalars['ID']>;
  id_ends_with?: InputMaybe<Scalars['ID']>;
  id_gt?: InputMaybe<Scalars['ID']>;
  id_gte?: InputMaybe<Scalars['ID']>;
  id_in?: InputMaybe<Array<Scalars['ID']>>;
  id_lt?: InputMaybe<Scalars['ID']>;
  id_lte?: InputMaybe<Scalars['ID']>;
  id_not?: InputMaybe<Scalars['ID']>;
  id_not_contains?: InputMaybe<Scalars['ID']>;
  id_not_ends_with?: InputMaybe<Scalars['ID']>;
  id_not_in?: InputMaybe<Array<Scalars['ID']>>;
  id_not_starts_with?: InputMaybe<Scalars['ID']>;
  id_starts_with?: InputMaybe<Scalars['ID']>;
  startDate?: InputMaybe<Scalars['DateTime']>;
  startDate_gt?: InputMaybe<Scalars['DateTime']>;
  startDate_gte?: InputMaybe<Scalars['DateTime']>;
  startDate_in?: InputMaybe<Array<Scalars['DateTime']>>;
  startDate_lt?: InputMaybe<Scalars['DateTime']>;
  startDate_lte?: InputMaybe<Scalars['DateTime']>;
  startDate_not?: InputMaybe<Scalars['DateTime']>;
  startDate_not_in?: InputMaybe<Array<Scalars['DateTime']>>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
  updatedAt_gt?: InputMaybe<Scalars['DateTime']>;
  updatedAt_gte?: InputMaybe<Scalars['DateTime']>;
  updatedAt_in?: InputMaybe<Array<Scalars['DateTime']>>;
  updatedAt_lt?: InputMaybe<Scalars['DateTime']>;
  updatedAt_lte?: InputMaybe<Scalars['DateTime']>;
  updatedAt_not?: InputMaybe<Scalars['DateTime']>;
  updatedAt_not_in?: InputMaybe<Array<Scalars['DateTime']>>;
};

export type LicenseStatus =
  | 'EXPIRED'
  | 'INVALID'
  | 'NO_LICENSE'
  | 'UPCOMING'
  | 'VALID';

export type LicenseStatusInput = {
  eq?: InputMaybe<LicenseStatus>;
  in?: InputMaybe<Array<LicenseStatus>>;
  notIn?: InputMaybe<Array<LicenseStatus>>;
};

export type LicenseSubscriptionInfo = {
  active: Scalars['Boolean'];
  amount: Scalars['Int'];
  couponCode?: Maybe<Scalars['String']>;
  extendDate: Scalars['DateTime'];
  extensionInvoiceId?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  invoiceId?: Maybe<Scalars['String']>;
  startDate: Scalars['DateTime'];
};

export type LicenseSubscriptionInfoConnection = {
  aggregate: AggregateLicenseSubscriptionInfo;
  edges: Array<Maybe<LicenseSubscriptionInfoEdge>>;
  pageInfo: PageInfo;
};

export type LicenseSubscriptionInfoCreateInput = {
  active?: InputMaybe<Scalars['Boolean']>;
  amount: Scalars['Int'];
  couponCode?: InputMaybe<Scalars['String']>;
  extendDate: Scalars['DateTime'];
  extensionInvoiceId?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['ID']>;
  invoiceId?: InputMaybe<Scalars['String']>;
  startDate: Scalars['DateTime'];
};

export type LicenseSubscriptionInfoCreateManyInput = {
  connect?: InputMaybe<Array<LicenseSubscriptionInfoWhereUniqueInput>>;
  create?: InputMaybe<Array<LicenseSubscriptionInfoCreateInput>>;
};

export type LicenseSubscriptionInfoCreateOneInput = {
  connect?: InputMaybe<LicenseSubscriptionInfoWhereUniqueInput>;
  create?: InputMaybe<LicenseSubscriptionInfoCreateInput>;
};

export type LicenseSubscriptionInfoEdge = {
  cursor: Scalars['String'];
  node: LicenseSubscriptionInfo;
};

export type LicenseSubscriptionInfoOrderByInput =
  | 'active_ASC'
  | 'active_DESC'
  | 'amount_ASC'
  | 'amount_DESC'
  | 'couponCode_ASC'
  | 'couponCode_DESC'
  | 'extendDate_ASC'
  | 'extendDate_DESC'
  | 'extensionInvoiceId_ASC'
  | 'extensionInvoiceId_DESC'
  | 'id_ASC'
  | 'id_DESC'
  | 'invoiceId_ASC'
  | 'invoiceId_DESC'
  | 'startDate_ASC'
  | 'startDate_DESC';

export type LicenseSubscriptionInfoPreviousValues = {
  active: Scalars['Boolean'];
  amount: Scalars['Int'];
  couponCode?: Maybe<Scalars['String']>;
  extendDate: Scalars['DateTime'];
  extensionInvoiceId?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  invoiceId?: Maybe<Scalars['String']>;
  startDate: Scalars['DateTime'];
};

export type LicenseSubscriptionInfoScalarWhereInput = {
  AND?: InputMaybe<Array<LicenseSubscriptionInfoScalarWhereInput>>;
  NOT?: InputMaybe<Array<LicenseSubscriptionInfoScalarWhereInput>>;
  OR?: InputMaybe<Array<LicenseSubscriptionInfoScalarWhereInput>>;
  active?: InputMaybe<Scalars['Boolean']>;
  active_not?: InputMaybe<Scalars['Boolean']>;
  amount?: InputMaybe<Scalars['Int']>;
  amount_gt?: InputMaybe<Scalars['Int']>;
  amount_gte?: InputMaybe<Scalars['Int']>;
  amount_in?: InputMaybe<Array<Scalars['Int']>>;
  amount_lt?: InputMaybe<Scalars['Int']>;
  amount_lte?: InputMaybe<Scalars['Int']>;
  amount_not?: InputMaybe<Scalars['Int']>;
  amount_not_in?: InputMaybe<Array<Scalars['Int']>>;
  couponCode?: InputMaybe<Scalars['String']>;
  couponCode_contains?: InputMaybe<Scalars['String']>;
  couponCode_ends_with?: InputMaybe<Scalars['String']>;
  couponCode_gt?: InputMaybe<Scalars['String']>;
  couponCode_gte?: InputMaybe<Scalars['String']>;
  couponCode_in?: InputMaybe<Array<Scalars['String']>>;
  couponCode_lt?: InputMaybe<Scalars['String']>;
  couponCode_lte?: InputMaybe<Scalars['String']>;
  couponCode_not?: InputMaybe<Scalars['String']>;
  couponCode_not_contains?: InputMaybe<Scalars['String']>;
  couponCode_not_ends_with?: InputMaybe<Scalars['String']>;
  couponCode_not_in?: InputMaybe<Array<Scalars['String']>>;
  couponCode_not_starts_with?: InputMaybe<Scalars['String']>;
  couponCode_starts_with?: InputMaybe<Scalars['String']>;
  extendDate?: InputMaybe<Scalars['DateTime']>;
  extendDate_gt?: InputMaybe<Scalars['DateTime']>;
  extendDate_gte?: InputMaybe<Scalars['DateTime']>;
  extendDate_in?: InputMaybe<Array<Scalars['DateTime']>>;
  extendDate_lt?: InputMaybe<Scalars['DateTime']>;
  extendDate_lte?: InputMaybe<Scalars['DateTime']>;
  extendDate_not?: InputMaybe<Scalars['DateTime']>;
  extendDate_not_in?: InputMaybe<Array<Scalars['DateTime']>>;
  extensionInvoiceId?: InputMaybe<Scalars['String']>;
  extensionInvoiceId_contains?: InputMaybe<Scalars['String']>;
  extensionInvoiceId_ends_with?: InputMaybe<Scalars['String']>;
  extensionInvoiceId_gt?: InputMaybe<Scalars['String']>;
  extensionInvoiceId_gte?: InputMaybe<Scalars['String']>;
  extensionInvoiceId_in?: InputMaybe<Array<Scalars['String']>>;
  extensionInvoiceId_lt?: InputMaybe<Scalars['String']>;
  extensionInvoiceId_lte?: InputMaybe<Scalars['String']>;
  extensionInvoiceId_not?: InputMaybe<Scalars['String']>;
  extensionInvoiceId_not_contains?: InputMaybe<Scalars['String']>;
  extensionInvoiceId_not_ends_with?: InputMaybe<Scalars['String']>;
  extensionInvoiceId_not_in?: InputMaybe<Array<Scalars['String']>>;
  extensionInvoiceId_not_starts_with?: InputMaybe<Scalars['String']>;
  extensionInvoiceId_starts_with?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['ID']>;
  id_contains?: InputMaybe<Scalars['ID']>;
  id_ends_with?: InputMaybe<Scalars['ID']>;
  id_gt?: InputMaybe<Scalars['ID']>;
  id_gte?: InputMaybe<Scalars['ID']>;
  id_in?: InputMaybe<Array<Scalars['ID']>>;
  id_lt?: InputMaybe<Scalars['ID']>;
  id_lte?: InputMaybe<Scalars['ID']>;
  id_not?: InputMaybe<Scalars['ID']>;
  id_not_contains?: InputMaybe<Scalars['ID']>;
  id_not_ends_with?: InputMaybe<Scalars['ID']>;
  id_not_in?: InputMaybe<Array<Scalars['ID']>>;
  id_not_starts_with?: InputMaybe<Scalars['ID']>;
  id_starts_with?: InputMaybe<Scalars['ID']>;
  invoiceId?: InputMaybe<Scalars['String']>;
  invoiceId_contains?: InputMaybe<Scalars['String']>;
  invoiceId_ends_with?: InputMaybe<Scalars['String']>;
  invoiceId_gt?: InputMaybe<Scalars['String']>;
  invoiceId_gte?: InputMaybe<Scalars['String']>;
  invoiceId_in?: InputMaybe<Array<Scalars['String']>>;
  invoiceId_lt?: InputMaybe<Scalars['String']>;
  invoiceId_lte?: InputMaybe<Scalars['String']>;
  invoiceId_not?: InputMaybe<Scalars['String']>;
  invoiceId_not_contains?: InputMaybe<Scalars['String']>;
  invoiceId_not_ends_with?: InputMaybe<Scalars['String']>;
  invoiceId_not_in?: InputMaybe<Array<Scalars['String']>>;
  invoiceId_not_starts_with?: InputMaybe<Scalars['String']>;
  invoiceId_starts_with?: InputMaybe<Scalars['String']>;
  startDate?: InputMaybe<Scalars['DateTime']>;
  startDate_gt?: InputMaybe<Scalars['DateTime']>;
  startDate_gte?: InputMaybe<Scalars['DateTime']>;
  startDate_in?: InputMaybe<Array<Scalars['DateTime']>>;
  startDate_lt?: InputMaybe<Scalars['DateTime']>;
  startDate_lte?: InputMaybe<Scalars['DateTime']>;
  startDate_not?: InputMaybe<Scalars['DateTime']>;
  startDate_not_in?: InputMaybe<Array<Scalars['DateTime']>>;
};

export type LicenseSubscriptionInfoSubscriptionPayload = {
  mutation: MutationType;
  node?: Maybe<LicenseSubscriptionInfo>;
  previousValues?: Maybe<LicenseSubscriptionInfoPreviousValues>;
  updatedFields?: Maybe<Array<Scalars['String']>>;
};

export type LicenseSubscriptionInfoSubscriptionWhereInput = {
  AND?: InputMaybe<Array<LicenseSubscriptionInfoSubscriptionWhereInput>>;
  NOT?: InputMaybe<Array<LicenseSubscriptionInfoSubscriptionWhereInput>>;
  OR?: InputMaybe<Array<LicenseSubscriptionInfoSubscriptionWhereInput>>;
  mutation_in?: InputMaybe<Array<MutationType>>;
  node?: InputMaybe<LicenseSubscriptionInfoWhereInput>;
  updatedFields_contains?: InputMaybe<Scalars['String']>;
  updatedFields_contains_every?: InputMaybe<Array<Scalars['String']>>;
  updatedFields_contains_some?: InputMaybe<Array<Scalars['String']>>;
};

export type LicenseSubscriptionInfoUpdateDataInput = {
  active?: InputMaybe<Scalars['Boolean']>;
  amount?: InputMaybe<Scalars['Int']>;
  couponCode?: InputMaybe<Scalars['String']>;
  extendDate?: InputMaybe<Scalars['DateTime']>;
  extensionInvoiceId?: InputMaybe<Scalars['String']>;
  invoiceId?: InputMaybe<Scalars['String']>;
  startDate?: InputMaybe<Scalars['DateTime']>;
};

export type LicenseSubscriptionInfoUpdateInput = {
  active?: InputMaybe<Scalars['Boolean']>;
  amount?: InputMaybe<Scalars['Int']>;
  couponCode?: InputMaybe<Scalars['String']>;
  extendDate?: InputMaybe<Scalars['DateTime']>;
  extensionInvoiceId?: InputMaybe<Scalars['String']>;
  invoiceId?: InputMaybe<Scalars['String']>;
  startDate?: InputMaybe<Scalars['DateTime']>;
};

export type LicenseSubscriptionInfoUpdateManyDataInput = {
  active?: InputMaybe<Scalars['Boolean']>;
  amount?: InputMaybe<Scalars['Int']>;
  couponCode?: InputMaybe<Scalars['String']>;
  extendDate?: InputMaybe<Scalars['DateTime']>;
  extensionInvoiceId?: InputMaybe<Scalars['String']>;
  invoiceId?: InputMaybe<Scalars['String']>;
  startDate?: InputMaybe<Scalars['DateTime']>;
};

export type LicenseSubscriptionInfoUpdateManyInput = {
  connect?: InputMaybe<Array<LicenseSubscriptionInfoWhereUniqueInput>>;
  create?: InputMaybe<Array<LicenseSubscriptionInfoCreateInput>>;
  delete?: InputMaybe<Array<LicenseSubscriptionInfoWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<LicenseSubscriptionInfoScalarWhereInput>>;
  disconnect?: InputMaybe<Array<LicenseSubscriptionInfoWhereUniqueInput>>;
  set?: InputMaybe<Array<LicenseSubscriptionInfoWhereUniqueInput>>;
  update?: InputMaybe<
    Array<LicenseSubscriptionInfoUpdateWithWhereUniqueNestedInput>
  >;
  updateMany?: InputMaybe<
    Array<LicenseSubscriptionInfoUpdateManyWithWhereNestedInput>
  >;
  upsert?: InputMaybe<
    Array<LicenseSubscriptionInfoUpsertWithWhereUniqueNestedInput>
  >;
};

export type LicenseSubscriptionInfoUpdateManyMutationInput = {
  active?: InputMaybe<Scalars['Boolean']>;
  amount?: InputMaybe<Scalars['Int']>;
  couponCode?: InputMaybe<Scalars['String']>;
  extendDate?: InputMaybe<Scalars['DateTime']>;
  extensionInvoiceId?: InputMaybe<Scalars['String']>;
  invoiceId?: InputMaybe<Scalars['String']>;
  startDate?: InputMaybe<Scalars['DateTime']>;
};

export type LicenseSubscriptionInfoUpdateManyWithWhereNestedInput = {
  data: LicenseSubscriptionInfoUpdateManyDataInput;
  where: LicenseSubscriptionInfoScalarWhereInput;
};

export type LicenseSubscriptionInfoUpdateOneInput = {
  connect?: InputMaybe<LicenseSubscriptionInfoWhereUniqueInput>;
  create?: InputMaybe<LicenseSubscriptionInfoCreateInput>;
  delete?: InputMaybe<Scalars['Boolean']>;
  disconnect?: InputMaybe<Scalars['Boolean']>;
  update?: InputMaybe<LicenseSubscriptionInfoUpdateDataInput>;
  upsert?: InputMaybe<LicenseSubscriptionInfoUpsertNestedInput>;
};

export type LicenseSubscriptionInfoUpdateOneRequiredInput = {
  connect?: InputMaybe<LicenseSubscriptionInfoWhereUniqueInput>;
  create?: InputMaybe<LicenseSubscriptionInfoCreateInput>;
  update?: InputMaybe<LicenseSubscriptionInfoUpdateDataInput>;
  upsert?: InputMaybe<LicenseSubscriptionInfoUpsertNestedInput>;
};

export type LicenseSubscriptionInfoUpdateWithWhereUniqueNestedInput = {
  data: LicenseSubscriptionInfoUpdateDataInput;
  where: LicenseSubscriptionInfoWhereUniqueInput;
};

export type LicenseSubscriptionInfoUpsertNestedInput = {
  create: LicenseSubscriptionInfoCreateInput;
  update: LicenseSubscriptionInfoUpdateDataInput;
};

export type LicenseSubscriptionInfoUpsertWithWhereUniqueNestedInput = {
  create: LicenseSubscriptionInfoCreateInput;
  update: LicenseSubscriptionInfoUpdateDataInput;
  where: LicenseSubscriptionInfoWhereUniqueInput;
};

export type LicenseSubscriptionInfoWhereInput = {
  AND?: InputMaybe<Array<LicenseSubscriptionInfoWhereInput>>;
  NOT?: InputMaybe<Array<LicenseSubscriptionInfoWhereInput>>;
  OR?: InputMaybe<Array<LicenseSubscriptionInfoWhereInput>>;
  active?: InputMaybe<Scalars['Boolean']>;
  active_not?: InputMaybe<Scalars['Boolean']>;
  amount?: InputMaybe<Scalars['Int']>;
  amount_gt?: InputMaybe<Scalars['Int']>;
  amount_gte?: InputMaybe<Scalars['Int']>;
  amount_in?: InputMaybe<Array<Scalars['Int']>>;
  amount_lt?: InputMaybe<Scalars['Int']>;
  amount_lte?: InputMaybe<Scalars['Int']>;
  amount_not?: InputMaybe<Scalars['Int']>;
  amount_not_in?: InputMaybe<Array<Scalars['Int']>>;
  couponCode?: InputMaybe<Scalars['String']>;
  couponCode_contains?: InputMaybe<Scalars['String']>;
  couponCode_ends_with?: InputMaybe<Scalars['String']>;
  couponCode_gt?: InputMaybe<Scalars['String']>;
  couponCode_gte?: InputMaybe<Scalars['String']>;
  couponCode_in?: InputMaybe<Array<Scalars['String']>>;
  couponCode_lt?: InputMaybe<Scalars['String']>;
  couponCode_lte?: InputMaybe<Scalars['String']>;
  couponCode_not?: InputMaybe<Scalars['String']>;
  couponCode_not_contains?: InputMaybe<Scalars['String']>;
  couponCode_not_ends_with?: InputMaybe<Scalars['String']>;
  couponCode_not_in?: InputMaybe<Array<Scalars['String']>>;
  couponCode_not_starts_with?: InputMaybe<Scalars['String']>;
  couponCode_starts_with?: InputMaybe<Scalars['String']>;
  extendDate?: InputMaybe<Scalars['DateTime']>;
  extendDate_gt?: InputMaybe<Scalars['DateTime']>;
  extendDate_gte?: InputMaybe<Scalars['DateTime']>;
  extendDate_in?: InputMaybe<Array<Scalars['DateTime']>>;
  extendDate_lt?: InputMaybe<Scalars['DateTime']>;
  extendDate_lte?: InputMaybe<Scalars['DateTime']>;
  extendDate_not?: InputMaybe<Scalars['DateTime']>;
  extendDate_not_in?: InputMaybe<Array<Scalars['DateTime']>>;
  extensionInvoiceId?: InputMaybe<Scalars['String']>;
  extensionInvoiceId_contains?: InputMaybe<Scalars['String']>;
  extensionInvoiceId_ends_with?: InputMaybe<Scalars['String']>;
  extensionInvoiceId_gt?: InputMaybe<Scalars['String']>;
  extensionInvoiceId_gte?: InputMaybe<Scalars['String']>;
  extensionInvoiceId_in?: InputMaybe<Array<Scalars['String']>>;
  extensionInvoiceId_lt?: InputMaybe<Scalars['String']>;
  extensionInvoiceId_lte?: InputMaybe<Scalars['String']>;
  extensionInvoiceId_not?: InputMaybe<Scalars['String']>;
  extensionInvoiceId_not_contains?: InputMaybe<Scalars['String']>;
  extensionInvoiceId_not_ends_with?: InputMaybe<Scalars['String']>;
  extensionInvoiceId_not_in?: InputMaybe<Array<Scalars['String']>>;
  extensionInvoiceId_not_starts_with?: InputMaybe<Scalars['String']>;
  extensionInvoiceId_starts_with?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['ID']>;
  id_contains?: InputMaybe<Scalars['ID']>;
  id_ends_with?: InputMaybe<Scalars['ID']>;
  id_gt?: InputMaybe<Scalars['ID']>;
  id_gte?: InputMaybe<Scalars['ID']>;
  id_in?: InputMaybe<Array<Scalars['ID']>>;
  id_lt?: InputMaybe<Scalars['ID']>;
  id_lte?: InputMaybe<Scalars['ID']>;
  id_not?: InputMaybe<Scalars['ID']>;
  id_not_contains?: InputMaybe<Scalars['ID']>;
  id_not_ends_with?: InputMaybe<Scalars['ID']>;
  id_not_in?: InputMaybe<Array<Scalars['ID']>>;
  id_not_starts_with?: InputMaybe<Scalars['ID']>;
  id_starts_with?: InputMaybe<Scalars['ID']>;
  invoiceId?: InputMaybe<Scalars['String']>;
  invoiceId_contains?: InputMaybe<Scalars['String']>;
  invoiceId_ends_with?: InputMaybe<Scalars['String']>;
  invoiceId_gt?: InputMaybe<Scalars['String']>;
  invoiceId_gte?: InputMaybe<Scalars['String']>;
  invoiceId_in?: InputMaybe<Array<Scalars['String']>>;
  invoiceId_lt?: InputMaybe<Scalars['String']>;
  invoiceId_lte?: InputMaybe<Scalars['String']>;
  invoiceId_not?: InputMaybe<Scalars['String']>;
  invoiceId_not_contains?: InputMaybe<Scalars['String']>;
  invoiceId_not_ends_with?: InputMaybe<Scalars['String']>;
  invoiceId_not_in?: InputMaybe<Array<Scalars['String']>>;
  invoiceId_not_starts_with?: InputMaybe<Scalars['String']>;
  invoiceId_starts_with?: InputMaybe<Scalars['String']>;
  startDate?: InputMaybe<Scalars['DateTime']>;
  startDate_gt?: InputMaybe<Scalars['DateTime']>;
  startDate_gte?: InputMaybe<Scalars['DateTime']>;
  startDate_in?: InputMaybe<Array<Scalars['DateTime']>>;
  startDate_lt?: InputMaybe<Scalars['DateTime']>;
  startDate_lte?: InputMaybe<Scalars['DateTime']>;
  startDate_not?: InputMaybe<Scalars['DateTime']>;
  startDate_not_in?: InputMaybe<Array<Scalars['DateTime']>>;
};

export type LicenseSubscriptionInfoWhereUniqueInput = {
  id?: InputMaybe<Scalars['ID']>;
};

export type LicenseSubscriptionPayload = {
  mutation: MutationType;
  node?: Maybe<License>;
  previousValues?: Maybe<LicensePreviousValues>;
  updatedFields?: Maybe<Array<Scalars['String']>>;
};

export type LicenseSubscriptionWhereInput = {
  AND?: InputMaybe<Array<LicenseSubscriptionWhereInput>>;
  NOT?: InputMaybe<Array<LicenseSubscriptionWhereInput>>;
  OR?: InputMaybe<Array<LicenseSubscriptionWhereInput>>;
  mutation_in?: InputMaybe<Array<MutationType>>;
  node?: InputMaybe<LicenseWhereInput>;
  updatedFields_contains?: InputMaybe<Scalars['String']>;
  updatedFields_contains_every?: InputMaybe<Array<Scalars['String']>>;
  updatedFields_contains_some?: InputMaybe<Array<Scalars['String']>>;
};

export type LicenseUpdateInput = {
  endDate?: InputMaybe<Scalars['DateTime']>;
  startDate?: InputMaybe<Scalars['DateTime']>;
};

export type LicenseUpdateManyDataInput = {
  endDate?: InputMaybe<Scalars['DateTime']>;
  startDate?: InputMaybe<Scalars['DateTime']>;
};

export type LicenseUpdateManyMutationInput = {
  endDate?: InputMaybe<Scalars['DateTime']>;
  startDate?: InputMaybe<Scalars['DateTime']>;
};

export type LicenseUpdateManyWithWhereNestedInput = {
  data: LicenseUpdateManyDataInput;
  where: LicenseScalarWhereInput;
};

export type LicenseUpdateManyWithoutPoolInput = {
  connect?: InputMaybe<Array<LicenseWhereUniqueInput>>;
  create?: InputMaybe<Array<LicenseCreateWithoutPoolInput>>;
  delete?: InputMaybe<Array<LicenseWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<LicenseScalarWhereInput>>;
  disconnect?: InputMaybe<Array<LicenseWhereUniqueInput>>;
  set?: InputMaybe<Array<LicenseWhereUniqueInput>>;
  update?: InputMaybe<Array<LicenseUpdateWithWhereUniqueWithoutPoolInput>>;
  updateMany?: InputMaybe<Array<LicenseUpdateManyWithWhereNestedInput>>;
  upsert?: InputMaybe<Array<LicenseUpsertWithWhereUniqueWithoutPoolInput>>;
};

export type LicenseUpdateOneWithoutUserInput = {
  connect?: InputMaybe<LicenseWhereUniqueInput>;
  create?: InputMaybe<LicenseCreateWithoutUserInput>;
  delete?: InputMaybe<Scalars['Boolean']>;
  disconnect?: InputMaybe<Scalars['Boolean']>;
  update?: InputMaybe<LicenseUpdateWithoutUserDataInput>;
  upsert?: InputMaybe<LicenseUpsertWithoutUserInput>;
};

export type LicenseUpdateWithWhereUniqueWithoutPoolInput = {
  data: LicenseUpdateWithoutPoolDataInput;
  where: LicenseWhereUniqueInput;
};

export type LicenseUpdateWithoutPoolDataInput = {
  endDate?: InputMaybe<Scalars['DateTime']>;
  startDate?: InputMaybe<Scalars['DateTime']>;
  user?: InputMaybe<BeheerUserUpdateOneWithoutLicenseInput>;
};

export type LicenseUpdateWithoutUserDataInput = {
  endDate?: InputMaybe<Scalars['DateTime']>;
  pool?: InputMaybe<LicensePoolUpdateOneRequiredWithoutLicensesInput>;
  startDate?: InputMaybe<Scalars['DateTime']>;
};

export type LicenseUpsertWithWhereUniqueWithoutPoolInput = {
  create: LicenseCreateWithoutPoolInput;
  update: LicenseUpdateWithoutPoolDataInput;
  where: LicenseWhereUniqueInput;
};

export type LicenseUpsertWithoutUserInput = {
  create: LicenseCreateWithoutUserInput;
  update: LicenseUpdateWithoutUserDataInput;
};

export type LicenseUsage = {
  distributed: Scalars['Int'];
  idle: Scalars['Int'];
  inUse: Scalars['Int'];
};

export type LicenseWhereInput = {
  AND?: InputMaybe<Array<LicenseWhereInput>>;
  NOT?: InputMaybe<Array<LicenseWhereInput>>;
  OR?: InputMaybe<Array<LicenseWhereInput>>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  createdAt_gt?: InputMaybe<Scalars['DateTime']>;
  createdAt_gte?: InputMaybe<Scalars['DateTime']>;
  createdAt_in?: InputMaybe<Array<Scalars['DateTime']>>;
  createdAt_lt?: InputMaybe<Scalars['DateTime']>;
  createdAt_lte?: InputMaybe<Scalars['DateTime']>;
  createdAt_not?: InputMaybe<Scalars['DateTime']>;
  createdAt_not_in?: InputMaybe<Array<Scalars['DateTime']>>;
  endDate?: InputMaybe<Scalars['DateTime']>;
  endDate_gt?: InputMaybe<Scalars['DateTime']>;
  endDate_gte?: InputMaybe<Scalars['DateTime']>;
  endDate_in?: InputMaybe<Array<Scalars['DateTime']>>;
  endDate_lt?: InputMaybe<Scalars['DateTime']>;
  endDate_lte?: InputMaybe<Scalars['DateTime']>;
  endDate_not?: InputMaybe<Scalars['DateTime']>;
  endDate_not_in?: InputMaybe<Array<Scalars['DateTime']>>;
  id?: InputMaybe<Scalars['ID']>;
  id_contains?: InputMaybe<Scalars['ID']>;
  id_ends_with?: InputMaybe<Scalars['ID']>;
  id_gt?: InputMaybe<Scalars['ID']>;
  id_gte?: InputMaybe<Scalars['ID']>;
  id_in?: InputMaybe<Array<Scalars['ID']>>;
  id_lt?: InputMaybe<Scalars['ID']>;
  id_lte?: InputMaybe<Scalars['ID']>;
  id_not?: InputMaybe<Scalars['ID']>;
  id_not_contains?: InputMaybe<Scalars['ID']>;
  id_not_ends_with?: InputMaybe<Scalars['ID']>;
  id_not_in?: InputMaybe<Array<Scalars['ID']>>;
  id_not_starts_with?: InputMaybe<Scalars['ID']>;
  id_starts_with?: InputMaybe<Scalars['ID']>;
  pool?: InputMaybe<LicensePoolWhereInput>;
  startDate?: InputMaybe<Scalars['DateTime']>;
  startDate_gt?: InputMaybe<Scalars['DateTime']>;
  startDate_gte?: InputMaybe<Scalars['DateTime']>;
  startDate_in?: InputMaybe<Array<Scalars['DateTime']>>;
  startDate_lt?: InputMaybe<Scalars['DateTime']>;
  startDate_lte?: InputMaybe<Scalars['DateTime']>;
  startDate_not?: InputMaybe<Scalars['DateTime']>;
  startDate_not_in?: InputMaybe<Array<Scalars['DateTime']>>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
  updatedAt_gt?: InputMaybe<Scalars['DateTime']>;
  updatedAt_gte?: InputMaybe<Scalars['DateTime']>;
  updatedAt_in?: InputMaybe<Array<Scalars['DateTime']>>;
  updatedAt_lt?: InputMaybe<Scalars['DateTime']>;
  updatedAt_lte?: InputMaybe<Scalars['DateTime']>;
  updatedAt_not?: InputMaybe<Scalars['DateTime']>;
  updatedAt_not_in?: InputMaybe<Array<Scalars['DateTime']>>;
  user?: InputMaybe<BeheerUserWhereInput>;
};

export type LicenseWhereUniqueInput = {
  id?: InputMaybe<Scalars['ID']>;
};

export type LoginByUsername = {
  login: Scalars['String'];
  password: Scalars['String'];
};

export type ManageSchoolUsersInput = {
  coaches: Array<Scalars['ID']>;
  schoolId: Scalars['ID'];
};

export type MarkMessageAsReadInput = {
  messageId: Scalars['String'];
};

export type Message = {
  archived: Scalars['Boolean'];
  content: Scalars['String'];
  id: Scalars['String'];
  lastReplyAt?: Maybe<Scalars['DateTime']>;
  recipients: Array<Recipient>;
  replies: Array<Message>;
  replyTo?: Maybe<Message>;
  sender?: Maybe<User>;
  sentAt: Scalars['DateTime'];
  subject?: Maybe<Scalars['String']>;
  type?: Maybe<MessageType>;
};

export type MessageRepliesArgs = {
  orderBy?: InputMaybe<MessageOrderByInput>;
};

export type MessageConnection = {
  aggregate: Aggregate;
  edges: Array<Maybe<MessageEdge>>;
  pageInfo: PageInfo;
};

export type MessageCountInput = {
  where?: InputMaybe<MessageCountWhereInput>;
};

export type MessageCountWhereInput = {
  AND?: InputMaybe<Array<NestedMessageCountWhereInput>>;
  NOT?: InputMaybe<Array<NestedMessageCountWhereInput>>;
  OR?: InputMaybe<Array<NestedMessageCountWhereInput>>;
  archived?: InputMaybe<Scalars['Boolean']>;
  sentAt?: InputMaybe<Scalars['DateTime']>;
  type?: InputMaybe<TypeEnumFilter>;
};

export type MessageEdge = {
  cursor: Scalars['String'];
  node: Message;
};

export type MessageFilterInput = {
  first?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<MessageOrderByInput>;
  skip?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<MessageWithUserWhereInput>;
};

export type MessageIdFilter = {
  in?: InputMaybe<Array<Scalars['String']>>;
};

export type MessageOrderByInput =
  | 'lastReplyAt_ASC'
  | 'lastReplyAt_DESC'
  | 'sentAt_ASC'
  | 'sentAt_DESC';

export type MessagePreferences = {
  autoReplyContent: Scalars['String'];
  autoReplyEnabled: Scalars['Boolean'];
};

export type MessagePreferencesUpdateInput = {
  autoReplyContent?: InputMaybe<Scalars['String']>;
  autoReplyEnabled?: InputMaybe<Scalars['Boolean']>;
};

export type MessagePreferencesWhereUniqueInput = {
  userId: Scalars['ID'];
};

export type MessageType = 'AUTOMATED' | 'SYSTEM';

export type MessageUserWhereInput = {
  firstName?: InputMaybe<Scalars['String']>;
  firstName_contains?: InputMaybe<Scalars['String']>;
  firstName_ends_with?: InputMaybe<Scalars['String']>;
  firstName_gt?: InputMaybe<Scalars['String']>;
  firstName_gte?: InputMaybe<Scalars['String']>;
  firstName_in?: InputMaybe<Array<Scalars['String']>>;
  firstName_lt?: InputMaybe<Scalars['String']>;
  firstName_lte?: InputMaybe<Scalars['String']>;
  firstName_not?: InputMaybe<Scalars['String']>;
  firstName_not_contains?: InputMaybe<Scalars['String']>;
  firstName_not_ends_with?: InputMaybe<Scalars['String']>;
  firstName_not_in?: InputMaybe<Array<Scalars['String']>>;
  firstName_not_starts_with?: InputMaybe<Scalars['String']>;
  firstName_starts_with?: InputMaybe<Scalars['String']>;
  lastName?: InputMaybe<Scalars['String']>;
  lastName_contains?: InputMaybe<Scalars['String']>;
  lastName_ends_with?: InputMaybe<Scalars['String']>;
  lastName_gt?: InputMaybe<Scalars['String']>;
  lastName_gte?: InputMaybe<Scalars['String']>;
  lastName_in?: InputMaybe<Array<Scalars['String']>>;
  lastName_lt?: InputMaybe<Scalars['String']>;
  lastName_lte?: InputMaybe<Scalars['String']>;
  lastName_not?: InputMaybe<Scalars['String']>;
  lastName_not_contains?: InputMaybe<Scalars['String']>;
  lastName_not_ends_with?: InputMaybe<Scalars['String']>;
  lastName_not_in?: InputMaybe<Array<Scalars['String']>>;
  lastName_not_starts_with?: InputMaybe<Scalars['String']>;
  lastName_starts_with?: InputMaybe<Scalars['String']>;
  prefix?: InputMaybe<Scalars['String']>;
  prefix_contains?: InputMaybe<Scalars['String']>;
  prefix_ends_with?: InputMaybe<Scalars['String']>;
  prefix_gt?: InputMaybe<Scalars['String']>;
  prefix_gte?: InputMaybe<Scalars['String']>;
  prefix_in?: InputMaybe<Array<Scalars['String']>>;
  prefix_lt?: InputMaybe<Scalars['String']>;
  prefix_lte?: InputMaybe<Scalars['String']>;
  prefix_not?: InputMaybe<Scalars['String']>;
  prefix_not_contains?: InputMaybe<Scalars['String']>;
  prefix_not_ends_with?: InputMaybe<Scalars['String']>;
  prefix_not_in?: InputMaybe<Array<Scalars['String']>>;
  prefix_not_starts_with?: InputMaybe<Scalars['String']>;
  prefix_starts_with?: InputMaybe<Scalars['String']>;
};

export type MessageUserWhereUniqueInput = {
  id: Scalars['ID'];
};

export type MessageWhereInput = {
  AND?: InputMaybe<Array<MessageWhereInput>>;
  NOT?: InputMaybe<Array<MessageWhereInput>>;
  OR?: InputMaybe<Array<MessageWhereInput>>;
  content?: InputMaybe<StringFilter>;
  id?: InputMaybe<Scalars['String']>;
  recipients?: InputMaybe<RecipientsFilter>;
  sender_id?: InputMaybe<Scalars['String']>;
  sentAt?: InputMaybe<Scalars['DateTime']>;
  subject?: InputMaybe<StringFilter>;
  type?: InputMaybe<TypeEnumFilter>;
};

export type MessageWithUserWhereInput = {
  AND?: InputMaybe<Array<NestedMessageWithUserWhereInput>>;
  NOT?: InputMaybe<Array<NestedMessageWithUserWhereInput>>;
  OR?: InputMaybe<Array<NestedMessageWithUserWhereInput>>;
  archived?: InputMaybe<Scalars['Boolean']>;
  content?: InputMaybe<StringFilter>;
  courseGroupId?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['String']>;
  recipients?: InputMaybe<RecipientsFilter>;
  replies?: InputMaybe<RepliesFilter>;
  sender_id?: InputMaybe<Scalars['String']>;
  sentAt?: InputMaybe<Scalars['DateTime']>;
  students?: InputMaybe<Scalars['Boolean']>;
  subject?: InputMaybe<StringFilter>;
  type?: InputMaybe<TypeEnumFilter>;
  unread?: InputMaybe<Scalars['Boolean']>;
  user?: InputMaybe<MessageUserWhereInput>;
};

export type MessagesResponse = {
  messages: Array<Message>;
};

export type MigrateSchoolDistrictInput = {
  disconnect?: InputMaybe<Scalars['Boolean']>;
  partnerId?: InputMaybe<Scalars['ID']>;
};

export type MigrateSchoolInput = {
  disconnect?: InputMaybe<Scalars['Boolean']>;
  partnerId?: InputMaybe<Scalars['ID']>;
  schoolDistrictId?: InputMaybe<Scalars['ID']>;
};

export type MiniGameState = 'Locked' | 'Unlocked';

export type MiniGamesStates = {
  first: MiniGameState;
  second: MiniGameState;
  third: MiniGameState;
};

export type MostRecentResource = Partner | School | SchoolDistrict;

export type MoveUserToSchoolInput = {
  schoolId: Scalars['ID'];
  userId: Scalars['ID'];
};

export type Mutation = {
  activateKwouwselAccessory: GameUserKwouwselAccessory;
  activateKwouwselUpgrade: GameUserKwouwselUpgrade;
  addCourseGroupsToCoach: User;
  addUsersToCourseGroup: CourseGroup;
  addUsersToSchool: School;
  /**
   * Adjusting licenses with the amount argument.
   * Positive values mean your are adding licenses to the Partner.
   * Negative values mean you are subtracting from the Partner.
   */
  adjustPartnerLicenses: Partner;
  adjustSubscriptionLicenses: LicenseSubscriptionInfo;
  archiveMessages: Scalars['Boolean'];
  archiveMessagesByUser: BatchPayload;
  archiveUsers: Scalars['Boolean'];
  assignLicenses: Scalars['Boolean'];
  authenticateTeamleader?: Maybe<Teamleader>;
  buyKwouwselAccessory: GameUserKwouwselAccessory;
  buyKwouwselUpgrade: GameUserKwouwselUpgrade;
  cancelSubscription: LicenseSubscriptionInfo;
  changePassword: AuthResponsePayload;
  changeRenewalDate: LicenseSubscriptionInfo;
  confirmUser?: Maybe<User>;
  createAccessRequest: AccessRequest;
  createAlfredoMessage: AlfredoMessage;
  createAlfredoMessageGameUser: AlfredoMessageGameUser;
  createBeheerUser: BeheerUser;
  createChallenge: Challenge;
  createChallengeRequest: ChallengeRequest;
  createChallengeResult: ChallengeResult;
  createContactDetails: ContactDetails;
  createCoupon: Coupon;
  createCourseGroup: CourseGroup;
  createDraftInvoiceForSubscription: LicenseSubscriptionInfo;
  createExercise: Exercise;
  createGameUser: GameUser;
  createGameUserKwouwselAccessory: GameUserKwouwselAccessory;
  createGameUserKwouwselUpgrade: GameUserKwouwselUpgrade;
  createKwouwselAccessory: KwouwselAccessory;
  createKwouwselUpgrade: KwouwselUpgrade;
  createLevel: Level;
  createLevelSetting: LevelSetting;
  createLicense: License;
  createLicensePool: LicensePool;
  createLicenseSubscriptionInfo: LicenseSubscriptionInfo;
  createNote: Note;
  createPartner: Partner;
  createSchool: School;
  createSchoolDistrict: SchoolDistrict;
  createSkillCourse: SkillCourse;
  createUser: User;
  createUserLevel: UserLevel;
  deactivateKwouwselAccessory: GameUserKwouwselAccessory;
  deactivateKwouwselUpgrade: GameUserKwouwselUpgrade;
  deleteAccessRequest?: Maybe<AccessRequest>;
  deleteAlfredoMessage?: Maybe<AlfredoMessage>;
  deleteAlfredoMessageGameUser?: Maybe<AlfredoMessageGameUser>;
  deleteArchivedUsers: Scalars['Boolean'];
  deleteBeheerUser?: Maybe<BeheerUser>;
  deleteChallenge?: Maybe<Challenge>;
  deleteChallengeRequest?: Maybe<ChallengeRequest>;
  deleteChallengeResult?: Maybe<ChallengeResult>;
  deleteContactDetails?: Maybe<ContactDetails>;
  deleteCoupon?: Maybe<Coupon>;
  deleteCourseGroup?: Maybe<CourseGroup>;
  deleteExercise?: Maybe<Exercise>;
  deleteGameUser?: Maybe<GameUser>;
  deleteGameUserKwouwselAccessory?: Maybe<GameUserKwouwselAccessory>;
  deleteGameUserKwouwselUpgrade?: Maybe<GameUserKwouwselUpgrade>;
  deleteKwouwselAccessory?: Maybe<KwouwselAccessory>;
  deleteKwouwselUpgrade?: Maybe<KwouwselUpgrade>;
  deleteLevel?: Maybe<Level>;
  deleteLevelSetting?: Maybe<LevelSetting>;
  deleteLicense?: Maybe<License>;
  deleteLicensePool?: Maybe<LicensePool>;
  deleteLicenseSubscriptionInfo?: Maybe<LicenseSubscriptionInfo>;
  deleteManyAccessRequests: BatchPayload;
  deleteManyAlfredoMessageGameUsers: BatchPayload;
  deleteManyAlfredoMessages: BatchPayload;
  deleteManyBeheerUsers: BatchPayload;
  deleteManyChallengeRequests: BatchPayload;
  deleteManyChallengeResults: BatchPayload;
  deleteManyChallenges: BatchPayload;
  deleteManyContactDetailses: BatchPayload;
  deleteManyCoupons: BatchPayload;
  deleteManyCourseGroups: BatchPayload;
  deleteManyExercises: BatchPayload;
  deleteManyGameUserKwouwselAccessories: BatchPayload;
  deleteManyGameUserKwouwselUpgrades: BatchPayload;
  deleteManyGameUsers: BatchPayload;
  deleteManyKwouwselAccessories: BatchPayload;
  deleteManyKwouwselUpgrades: BatchPayload;
  deleteManyLevelSettings: BatchPayload;
  deleteManyLevels: BatchPayload;
  deleteManyLicensePools: BatchPayload;
  deleteManyLicenseSubscriptionInfoes: BatchPayload;
  deleteManyLicenses: BatchPayload;
  deleteManyMessages: BatchPayload;
  deleteManyNotes: BatchPayload;
  deleteManyPartners: BatchPayload;
  deleteManySchoolDistricts: BatchPayload;
  deleteManySchools: BatchPayload;
  deleteManySkillCourses: BatchPayload;
  deleteManyUserLevels: BatchPayload;
  deleteMessage: Message;
  deleteNote?: Maybe<Note>;
  deletePartner?: Maybe<Partner>;
  deleteSchool?: Maybe<School>;
  deleteSchoolDistrict?: Maybe<SchoolDistrict>;
  deleteSkillCourse?: Maybe<SkillCourse>;
  deleteUserLevel?: Maybe<UserLevel>;
  displayedAlfredoMessage: GameUser;
  forgotPassword: AuthResponsePayload;
  forgotUsernames: AuthResponsePayload;
  impersonateUser: ImpersonateUserPayload;
  logUserOut: AuthResponsePayload;
  loginUser?: Maybe<SuccessfulLoginPayLoad>;
  markMessageAsRead?: Maybe<Message>;
  mergeSchools: Scalars['Boolean'];
  migrateSchool: School;
  migrateSchoolDistrict: SchoolDistrict;
  modifySubscription: LicenseSubscriptionInfo;
  moveUserToSchool: User;
  overrideUserPassword: AuthResponsePayload;
  reactivateSubscription: LicenseSubscriptionInfo;
  refreshSchoolBasispoortAuth: School;
  refreshToken?: Maybe<SuccessfulLoginPayLoad>;
  registerDemoUser?: Maybe<SuccessfulLoginPayLoad>;
  registerOrganisation: RegisterOrganisationResult;
  registerPartner: Partner;
  registerSchool: School;
  registerSchoolDistrict: SchoolDistrict;
  removeCourseGroupsFromCoach: User;
  removeUsersFromCourseGroup: CourseGroup;
  removeUsersFromSchool: School;
  replyToMessage?: Maybe<Message>;
  requestChallenge: ChallengeRequest;
  requestChallenges: Array<Maybe<ChallengeRequest>>;
  resetExam?: Maybe<GameUser>;
  resetExams?: Maybe<GameUser>;
  revokeBasispoortSync: School;
  sellKwouwselAccessory: GameUserKwouwselAccessory;
  sellKwouwselUpgrade: GameUserKwouwselUpgrade;
  sendMessage?: Maybe<SendMessageResponse>;
  sendSystemMessage: Message;
  startInitialSchoolBasispoortSync: School;
  submitChallengeResult?: Maybe<SubmitChallengeResult>;
  switchContext: SuccessfulLoginPayLoad;
  /**
   * When transferring licenses with the amount argument.
   * Positive values mean your are giving licenses to the child.
   * Negative values mean you are subtracing from the child.
   */
  transferIdleLicenses: Scalars['Boolean'];
  unarchiveMessages: Scalars['Boolean'];
  unarchiveUsers: Scalars['Boolean'];
  unassignLicenses: Scalars['Boolean'];
  updateAccessRequest?: Maybe<AccessRequest>;
  updateAlfredoMessage?: Maybe<AlfredoMessage>;
  updateAlfredoMessageGameUser?: Maybe<AlfredoMessageGameUser>;
  updateBeheerUser?: Maybe<BeheerUser>;
  updateChallenge?: Maybe<Challenge>;
  updateChallengeRequest?: Maybe<ChallengeRequest>;
  updateChallengeResult?: Maybe<ChallengeResult>;
  updateContactDetails?: Maybe<ContactDetails>;
  updateCoupon?: Maybe<Coupon>;
  updateCourseGroup?: Maybe<CourseGroup>;
  updateEmailPreferences: User;
  updateExercise?: Maybe<Exercise>;
  updateGameUser?: Maybe<GameUser>;
  updateGameUserKwouwselAccessory?: Maybe<GameUserKwouwselAccessory>;
  updateGameUserKwouwselUpgrade?: Maybe<GameUserKwouwselUpgrade>;
  updateKwouwselAccessory?: Maybe<KwouwselAccessory>;
  updateKwouwselUpgrade?: Maybe<KwouwselUpgrade>;
  updateLevel?: Maybe<Level>;
  updateLevelSetting?: Maybe<LevelSetting>;
  updateLevelSettings?: Maybe<Array<LevelSetting>>;
  updateLicense?: Maybe<License>;
  updateLicensePool?: Maybe<LicensePool>;
  updateLicenseSubscriptionInfo?: Maybe<LicenseSubscriptionInfo>;
  updateManyAccessRequests: BatchPayload;
  updateManyAlfredoMessages: BatchPayload;
  updateManyBeheerUsers: BatchPayload;
  updateManyChallengeRequests: BatchPayload;
  updateManyChallengeResults: BatchPayload;
  updateManyChallenges: BatchPayload;
  updateManyContactDetailses: BatchPayload;
  updateManyCoupons: BatchPayload;
  updateManyCourseGroups: BatchPayload;
  updateManyExercises: BatchPayload;
  updateManyGameUserKwouwselAccessories: BatchPayload;
  updateManyGameUserKwouwselUpgrades: BatchPayload;
  updateManyGameUsers: BatchPayload;
  updateManyKwouwselAccessories: BatchPayload;
  updateManyKwouwselUpgrades: BatchPayload;
  updateManyLevelSettings: BatchPayload;
  updateManyLevels: BatchPayload;
  updateManyLicenseSubscriptionInfoes: BatchPayload;
  updateManyLicenses: BatchPayload;
  updateManyNotes: BatchPayload;
  updateManyPartners: BatchPayload;
  updateManySchoolDistricts: BatchPayload;
  updateManySchools: BatchPayload;
  updateManySkillCourses: BatchPayload;
  updateManyUserLevelStates?: Maybe<Array<UserLevel>>;
  updateManyUserLevels: BatchPayload;
  updateManyUsers: AuthBatchPayload;
  updateMessagePreferences: User;
  updateNote?: Maybe<Note>;
  updatePartner?: Maybe<Partner>;
  updateSchool?: Maybe<School>;
  updateSchoolDistrict?: Maybe<SchoolDistrict>;
  updateSelf?: Maybe<User>;
  updateSkillCourse?: Maybe<SkillCourse>;
  updateUser?: Maybe<User>;
  updateUserLevel?: Maybe<UserLevel>;
  upsertAccessRequest: AccessRequest;
  upsertAlfredoMessage: AlfredoMessage;
  upsertAlfredoMessageGameUser: AlfredoMessageGameUser;
  upsertBeheerUser: BeheerUser;
  upsertChallenge: Challenge;
  upsertChallengeRequest: ChallengeRequest;
  upsertChallengeResult: ChallengeResult;
  upsertContactDetails: ContactDetails;
  upsertCoupon: Coupon;
  upsertCourseGroup: CourseGroup;
  upsertExercise: Exercise;
  upsertGameUser: GameUser;
  upsertGameUserKwouwselAccessory: GameUserKwouwselAccessory;
  upsertGameUserKwouwselUpgrade: GameUserKwouwselUpgrade;
  upsertKwouwselAccessory: KwouwselAccessory;
  upsertKwouwselUpgrade: KwouwselUpgrade;
  upsertLevel: Level;
  upsertLevelSetting: LevelSetting;
  upsertLicense: License;
  upsertLicensePool: LicensePool;
  upsertLicenseSubscriptionInfo: LicenseSubscriptionInfo;
  upsertNote: Note;
  upsertPartner: Partner;
  upsertSchool: School;
  upsertSchoolDistrict: SchoolDistrict;
  upsertSkillCourse: SkillCourse;
  upsertUserLevel: UserLevel;
};

export type MutationActivateKwouwselAccessoryArgs = {
  where?: InputMaybe<KwouwselAccessoryWhereUniqueInput>;
};

export type MutationActivateKwouwselUpgradeArgs = {
  where?: InputMaybe<KwouwselUpgradeWhereUniqueInput>;
};

export type MutationAddCourseGroupsToCoachArgs = {
  data: CourseGroupCoachInput;
};

export type MutationAddUsersToCourseGroupArgs = {
  data: UserCourseGroupInput;
};

export type MutationAddUsersToSchoolArgs = {
  data: ManageSchoolUsersInput;
};

export type MutationAdjustPartnerLicensesArgs = {
  amount: Scalars['Int'];
  partnerId: Scalars['ID'];
};

export type MutationAdjustSubscriptionLicensesArgs = {
  data: AdjustSubscriptionLicenses;
};

export type MutationArchiveMessagesArgs = {
  messageIds: Array<Scalars['String']>;
};

export type MutationArchiveMessagesByUserArgs = {
  where: MessageUserWhereUniqueInput;
};

export type MutationArchiveUsersArgs = {
  userIds: Array<Scalars['ID']>;
};

export type MutationAssignLicensesArgs = {
  from?: InputMaybe<LicenseFromPoolInput>;
  to: ConnectLicenseInput;
};

export type MutationAuthenticateTeamleaderArgs = {
  data: TeamleaderAccessCodeInput;
};

export type MutationBuyKwouwselAccessoryArgs = {
  where?: InputMaybe<KwouwselAccessoryWhereUniqueInput>;
};

export type MutationBuyKwouwselUpgradeArgs = {
  where?: InputMaybe<KwouwselUpgradeWhereUniqueInput>;
};

export type MutationChangePasswordArgs = {
  data?: InputMaybe<ChangePasswordInput>;
};

export type MutationChangeRenewalDateArgs = {
  data: ChangeRenewalDateInput;
};

export type MutationConfirmUserArgs = {
  data?: InputMaybe<ConfirmUserInput>;
};

export type MutationCreateAccessRequestArgs = {
  data: AccessRequestCreateInput;
};

export type MutationCreateAlfredoMessageArgs = {
  data: AlfredoMessageCreateInput;
};

export type MutationCreateAlfredoMessageGameUserArgs = {
  data: AlfredoMessageGameUserCreateInput;
};

export type MutationCreateBeheerUserArgs = {
  data: BeheerUserCreateInput;
};

export type MutationCreateChallengeArgs = {
  data: ChallengeCreateInput;
};

export type MutationCreateChallengeRequestArgs = {
  data: ChallengeRequestCreateInput;
};

export type MutationCreateChallengeResultArgs = {
  data: ChallengeResultCreateInput;
};

export type MutationCreateContactDetailsArgs = {
  data: ContactDetailsCreateInput;
};

export type MutationCreateCouponArgs = {
  data: CouponCreateInput;
};

export type MutationCreateCourseGroupArgs = {
  data: CourseGroupCreateInput;
};

export type MutationCreateDraftInvoiceForSubscriptionArgs = {
  subscriptionId: Scalars['ID'];
};

export type MutationCreateExerciseArgs = {
  data: ExerciseCreateInput;
};

export type MutationCreateGameUserArgs = {
  data: GameUserCreateInput;
};

export type MutationCreateGameUserKwouwselAccessoryArgs = {
  data: GameUserKwouwselAccessoryCreateInput;
};

export type MutationCreateGameUserKwouwselUpgradeArgs = {
  data: GameUserKwouwselUpgradeCreateInput;
};

export type MutationCreateKwouwselAccessoryArgs = {
  data: KwouwselAccessoryCreateInput;
};

export type MutationCreateKwouwselUpgradeArgs = {
  data: KwouwselUpgradeCreateInput;
};

export type MutationCreateLevelArgs = {
  data: LevelCreateInput;
};

export type MutationCreateLevelSettingArgs = {
  data: LevelSettingCreateInput;
};

export type MutationCreateLicenseArgs = {
  data: LicenseCreateInput;
};

export type MutationCreateLicensePoolArgs = {
  data: LicensePoolCreateInput;
};

export type MutationCreateLicenseSubscriptionInfoArgs = {
  data: LicenseSubscriptionInfoCreateInput;
};

export type MutationCreateNoteArgs = {
  data: NoteCreateInput;
};

export type MutationCreatePartnerArgs = {
  data: PartnerCreateInput;
};

export type MutationCreateSchoolArgs = {
  data: SchoolCreateInput;
};

export type MutationCreateSchoolDistrictArgs = {
  data: SchoolDistrictCreateInput;
};

export type MutationCreateSkillCourseArgs = {
  data: SkillCourseCreateInput;
};

export type MutationCreateUserArgs = {
  data: UserCreateInput;
};

export type MutationCreateUserLevelArgs = {
  data: UserLevelCreateInput;
};

export type MutationDeactivateKwouwselAccessoryArgs = {
  where?: InputMaybe<KwouwselAccessoryWhereUniqueInput>;
};

export type MutationDeactivateKwouwselUpgradeArgs = {
  where?: InputMaybe<KwouwselUpgradeWhereUniqueInput>;
};

export type MutationDeleteAccessRequestArgs = {
  where: AccessRequestWhereUniqueInput;
};

export type MutationDeleteAlfredoMessageArgs = {
  where: AlfredoMessageWhereUniqueInput;
};

export type MutationDeleteAlfredoMessageGameUserArgs = {
  where: AlfredoMessageGameUserWhereUniqueInput;
};

export type MutationDeleteArchivedUsersArgs = {
  userIds: Array<Scalars['ID']>;
};

export type MutationDeleteBeheerUserArgs = {
  where: BeheerUserWhereUniqueInput;
};

export type MutationDeleteChallengeArgs = {
  where: ChallengeWhereUniqueInput;
};

export type MutationDeleteChallengeRequestArgs = {
  where: ChallengeRequestWhereUniqueInput;
};

export type MutationDeleteChallengeResultArgs = {
  where: ChallengeResultWhereUniqueInput;
};

export type MutationDeleteContactDetailsArgs = {
  where: ContactDetailsWhereUniqueInput;
};

export type MutationDeleteCouponArgs = {
  where: CouponWhereUniqueInput;
};

export type MutationDeleteCourseGroupArgs = {
  where: CourseGroupWhereUniqueInput;
};

export type MutationDeleteExerciseArgs = {
  where: ExerciseWhereUniqueInput;
};

export type MutationDeleteGameUserArgs = {
  where: GameUserWhereUniqueInput;
};

export type MutationDeleteGameUserKwouwselAccessoryArgs = {
  where: GameUserKwouwselAccessoryWhereUniqueInput;
};

export type MutationDeleteGameUserKwouwselUpgradeArgs = {
  where: GameUserKwouwselUpgradeWhereUniqueInput;
};

export type MutationDeleteKwouwselAccessoryArgs = {
  where: KwouwselAccessoryWhereUniqueInput;
};

export type MutationDeleteKwouwselUpgradeArgs = {
  where: KwouwselUpgradeWhereUniqueInput;
};

export type MutationDeleteLevelArgs = {
  where: LevelWhereUniqueInput;
};

export type MutationDeleteLevelSettingArgs = {
  where: LevelSettingWhereUniqueInput;
};

export type MutationDeleteLicenseArgs = {
  where: LicenseWhereUniqueInput;
};

export type MutationDeleteLicensePoolArgs = {
  where: LicensePoolWhereUniqueInput;
};

export type MutationDeleteLicenseSubscriptionInfoArgs = {
  where: LicenseSubscriptionInfoWhereUniqueInput;
};

export type MutationDeleteManyAccessRequestsArgs = {
  where?: InputMaybe<AccessRequestWhereInput>;
};

export type MutationDeleteManyAlfredoMessageGameUsersArgs = {
  where?: InputMaybe<AlfredoMessageGameUserWhereInput>;
};

export type MutationDeleteManyAlfredoMessagesArgs = {
  where?: InputMaybe<AlfredoMessageWhereInput>;
};

export type MutationDeleteManyBeheerUsersArgs = {
  where?: InputMaybe<BeheerUserWhereInput>;
};

export type MutationDeleteManyChallengeRequestsArgs = {
  where?: InputMaybe<ChallengeRequestWhereInput>;
};

export type MutationDeleteManyChallengeResultsArgs = {
  where?: InputMaybe<ChallengeResultWhereInput>;
};

export type MutationDeleteManyChallengesArgs = {
  where?: InputMaybe<ChallengeWhereInput>;
};

export type MutationDeleteManyContactDetailsesArgs = {
  where?: InputMaybe<ContactDetailsWhereInput>;
};

export type MutationDeleteManyCouponsArgs = {
  where?: InputMaybe<CouponWhereInput>;
};

export type MutationDeleteManyCourseGroupsArgs = {
  where?: InputMaybe<CourseGroupWhereInput>;
};

export type MutationDeleteManyExercisesArgs = {
  where?: InputMaybe<ExerciseWhereInput>;
};

export type MutationDeleteManyGameUserKwouwselAccessoriesArgs = {
  where?: InputMaybe<GameUserKwouwselAccessoryWhereInput>;
};

export type MutationDeleteManyGameUserKwouwselUpgradesArgs = {
  where?: InputMaybe<GameUserKwouwselUpgradeWhereInput>;
};

export type MutationDeleteManyGameUsersArgs = {
  where?: InputMaybe<GameUserWhereInput>;
};

export type MutationDeleteManyKwouwselAccessoriesArgs = {
  where?: InputMaybe<KwouwselAccessoryWhereInput>;
};

export type MutationDeleteManyKwouwselUpgradesArgs = {
  where?: InputMaybe<KwouwselUpgradeWhereInput>;
};

export type MutationDeleteManyLevelSettingsArgs = {
  where?: InputMaybe<LevelSettingWhereInput>;
};

export type MutationDeleteManyLevelsArgs = {
  where?: InputMaybe<LevelWhereInput>;
};

export type MutationDeleteManyLicensePoolsArgs = {
  where?: InputMaybe<LicensePoolWhereInput>;
};

export type MutationDeleteManyLicenseSubscriptionInfoesArgs = {
  where?: InputMaybe<LicenseSubscriptionInfoWhereInput>;
};

export type MutationDeleteManyLicensesArgs = {
  where?: InputMaybe<LicenseWhereInput>;
};

export type MutationDeleteManyMessagesArgs = {
  data: DeleteManyMessagesInput;
};

export type MutationDeleteManyNotesArgs = {
  where?: InputMaybe<NoteWhereInput>;
};

export type MutationDeleteManyPartnersArgs = {
  where?: InputMaybe<PartnerWhereInput>;
};

export type MutationDeleteManySchoolDistrictsArgs = {
  where?: InputMaybe<SchoolDistrictWhereInput>;
};

export type MutationDeleteManySchoolsArgs = {
  where?: InputMaybe<SchoolWhereInput>;
};

export type MutationDeleteManySkillCoursesArgs = {
  where?: InputMaybe<SkillCourseWhereInput>;
};

export type MutationDeleteManyUserLevelsArgs = {
  where?: InputMaybe<UserLevelWhereInput>;
};

export type MutationDeleteMessageArgs = {
  data?: InputMaybe<DeleteMessageInput>;
};

export type MutationDeleteNoteArgs = {
  where: NoteWhereUniqueInput;
};

export type MutationDeletePartnerArgs = {
  where: PartnerWhereUniqueInput;
};

export type MutationDeleteSchoolArgs = {
  where: SchoolWhereUniqueInput;
};

export type MutationDeleteSchoolDistrictArgs = {
  where: SchoolDistrictWhereUniqueInput;
};

export type MutationDeleteSkillCourseArgs = {
  where: SkillCourseWhereUniqueInput;
};

export type MutationDeleteUserLevelArgs = {
  where: UserLevelWhereUniqueInput;
};

export type MutationDisplayedAlfredoMessageArgs = {
  where: AlfredoMessageWhereUniqueInput;
};

export type MutationForgotPasswordArgs = {
  data?: InputMaybe<ForgotPasswordInput>;
};

export type MutationForgotUsernamesArgs = {
  data?: InputMaybe<ForgotUsernamesInput>;
};

export type MutationImpersonateUserArgs = {
  data?: InputMaybe<ImpersonateUserInput>;
};

export type MutationLoginUserArgs = {
  data?: InputMaybe<LoginByUsername>;
};

export type MutationMarkMessageAsReadArgs = {
  data?: InputMaybe<MarkMessageAsReadInput>;
};

export type MutationMergeSchoolsArgs = {
  source: Scalars['ID'];
  target: Scalars['ID'];
};

export type MutationMigrateSchoolArgs = {
  data: MigrateSchoolInput;
  schoolId: Scalars['String'];
};

export type MutationMigrateSchoolDistrictArgs = {
  data: MigrateSchoolDistrictInput;
  schoolDistrictId: Scalars['String'];
};

export type MutationModifySubscriptionArgs = {
  couponCode?: InputMaybe<Scalars['String']>;
  quantity: Scalars['Int'];
};

export type MutationMoveUserToSchoolArgs = {
  data: MoveUserToSchoolInput;
};

export type MutationOverrideUserPasswordArgs = {
  data?: InputMaybe<OverRideUserPasswordInput>;
};

export type MutationReactivateSubscriptionArgs = {
  where?: InputMaybe<ReactivateSubscriptionInput>;
};

export type MutationRefreshSchoolBasispoortAuthArgs = {
  schoolId: Scalars['ID'];
};

export type MutationRefreshTokenArgs = {
  data?: InputMaybe<RefreshTokenInput>;
};

export type MutationRegisterDemoUserArgs = {
  data?: InputMaybe<RegisterDemoUserInput>;
};

export type MutationRegisterOrganisationArgs = {
  data: RegisterOrganisationInput;
};

export type MutationRegisterPartnerArgs = {
  data?: InputMaybe<RegisterPartnerInput>;
};

export type MutationRegisterSchoolArgs = {
  data: RegisterSchoolInput;
};

export type MutationRegisterSchoolDistrictArgs = {
  data: RegisterSchoolDistrictInput;
};

export type MutationRemoveCourseGroupsFromCoachArgs = {
  data: CourseGroupCoachInput;
};

export type MutationRemoveUsersFromCourseGroupArgs = {
  data: UserCourseGroupInput;
};

export type MutationRemoveUsersFromSchoolArgs = {
  data: ManageSchoolUsersInput;
};

export type MutationReplyToMessageArgs = {
  data?: InputMaybe<ReplyToMessageInput>;
};

export type MutationRequestChallengeArgs = {
  where?: InputMaybe<ExerciseWhereUniqueInput>;
};

export type MutationRequestChallengesArgs = {
  where?: InputMaybe<ExerciseWhereUniqueInput>;
};

export type MutationResetExamArgs = {
  input: ResetExamInput;
};

export type MutationResetExamsArgs = {
  where: GameUserWhereUniqueInput;
};

export type MutationRevokeBasispoortSyncArgs = {
  schoolId: Scalars['ID'];
};

export type MutationSellKwouwselAccessoryArgs = {
  where?: InputMaybe<KwouwselAccessoryWhereUniqueInput>;
};

export type MutationSellKwouwselUpgradeArgs = {
  where?: InputMaybe<KwouwselUpgradeWhereUniqueInput>;
};

export type MutationSendMessageArgs = {
  data?: InputMaybe<SendMessageInput>;
};

export type MutationSendSystemMessageArgs = {
  data?: InputMaybe<SendSystemMessageInput>;
};

export type MutationStartInitialSchoolBasispoortSyncArgs = {
  schoolId: Scalars['ID'];
};

export type MutationSubmitChallengeResultArgs = {
  data: ChallengeResultCreateInput;
};

export type MutationSwitchContextArgs = {
  data?: InputMaybe<SwitchContextInput>;
};

export type MutationTransferIdleLicensesArgs = {
  amount: Scalars['Int'];
  child: LicensePoolChildInput;
  parent: LicensePoolParentInput;
};

export type MutationUnarchiveMessagesArgs = {
  messageIds: Array<Scalars['String']>;
};

export type MutationUnarchiveUsersArgs = {
  userIds: Array<Scalars['ID']>;
};

export type MutationUnassignLicensesArgs = {
  from: ConnectLicenseInput;
};

export type MutationUpdateAccessRequestArgs = {
  data: AccessRequestUpdateInput;
  where: AccessRequestWhereUniqueInput;
};

export type MutationUpdateAlfredoMessageArgs = {
  data: AlfredoMessageUpdateInput;
  where: AlfredoMessageWhereUniqueInput;
};

export type MutationUpdateAlfredoMessageGameUserArgs = {
  data: AlfredoMessageGameUserUpdateInput;
  where: AlfredoMessageGameUserWhereUniqueInput;
};

export type MutationUpdateBeheerUserArgs = {
  data: BeheerUserUpdateInput;
  where: BeheerUserWhereUniqueInput;
};

export type MutationUpdateChallengeArgs = {
  data: ChallengeUpdateInput;
  where: ChallengeWhereUniqueInput;
};

export type MutationUpdateChallengeRequestArgs = {
  data: ChallengeRequestUpdateInput;
  where: ChallengeRequestWhereUniqueInput;
};

export type MutationUpdateChallengeResultArgs = {
  data: ChallengeResultUpdateInput;
  where: ChallengeResultWhereUniqueInput;
};

export type MutationUpdateContactDetailsArgs = {
  data: ContactDetailsUpdateInput;
  where: ContactDetailsWhereUniqueInput;
};

export type MutationUpdateCouponArgs = {
  data: CouponUpdateInput;
  where: CouponWhereUniqueInput;
};

export type MutationUpdateCourseGroupArgs = {
  data: CourseGroupUpdateInput;
  where: CourseGroupWhereUniqueInput;
};

export type MutationUpdateEmailPreferencesArgs = {
  data: EmailPreferencesUpdateInput;
  where: EmailPreferencesWhereUniqueInput;
};

export type MutationUpdateExerciseArgs = {
  data: ExerciseUpdateInput;
  where: ExerciseWhereUniqueInput;
};

export type MutationUpdateGameUserArgs = {
  data: GameUserUpdateInput;
  where: GameUserWhereUniqueInput;
};

export type MutationUpdateGameUserKwouwselAccessoryArgs = {
  data: GameUserKwouwselAccessoryUpdateInput;
  where: GameUserKwouwselAccessoryWhereUniqueInput;
};

export type MutationUpdateGameUserKwouwselUpgradeArgs = {
  data: GameUserKwouwselUpgradeUpdateInput;
  where: GameUserKwouwselUpgradeWhereUniqueInput;
};

export type MutationUpdateKwouwselAccessoryArgs = {
  data: KwouwselAccessoryUpdateInput;
  where: KwouwselAccessoryWhereUniqueInput;
};

export type MutationUpdateKwouwselUpgradeArgs = {
  data: KwouwselUpgradeUpdateInput;
  where: KwouwselUpgradeWhereUniqueInput;
};

export type MutationUpdateLevelArgs = {
  data: LevelUpdateInput;
  where: LevelWhereUniqueInput;
};

export type MutationUpdateLevelSettingArgs = {
  data: LevelSettingUpdateInput;
  where: LevelSettingWhereUniqueInput;
};

export type MutationUpdateLevelSettingsArgs = {
  data: Array<LevelSettingsUpdateInput>;
};

export type MutationUpdateLicenseArgs = {
  data: LicenseUpdateInput;
  where: LicenseWhereUniqueInput;
};

export type MutationUpdateLicensePoolArgs = {
  data: LicensePoolUpdateInput;
  where: LicensePoolWhereUniqueInput;
};

export type MutationUpdateLicenseSubscriptionInfoArgs = {
  data: LicenseSubscriptionInfoUpdateInput;
  where: LicenseSubscriptionInfoWhereUniqueInput;
};

export type MutationUpdateManyAccessRequestsArgs = {
  data: AccessRequestUpdateManyMutationInput;
  where?: InputMaybe<AccessRequestWhereInput>;
};

export type MutationUpdateManyAlfredoMessagesArgs = {
  data: AlfredoMessageUpdateManyMutationInput;
  where?: InputMaybe<AlfredoMessageWhereInput>;
};

export type MutationUpdateManyBeheerUsersArgs = {
  data: BeheerUserUpdateManyMutationInput;
  where?: InputMaybe<BeheerUserWhereInput>;
};

export type MutationUpdateManyChallengeRequestsArgs = {
  data: ChallengeRequestUpdateManyMutationInput;
  where?: InputMaybe<ChallengeRequestWhereInput>;
};

export type MutationUpdateManyChallengeResultsArgs = {
  data: ChallengeResultUpdateManyMutationInput;
  where?: InputMaybe<ChallengeResultWhereInput>;
};

export type MutationUpdateManyChallengesArgs = {
  data: ChallengeUpdateManyMutationInput;
  where?: InputMaybe<ChallengeWhereInput>;
};

export type MutationUpdateManyContactDetailsesArgs = {
  data: ContactDetailsUpdateManyMutationInput;
  where?: InputMaybe<ContactDetailsWhereInput>;
};

export type MutationUpdateManyCouponsArgs = {
  data: CouponUpdateManyMutationInput;
  where?: InputMaybe<CouponWhereInput>;
};

export type MutationUpdateManyCourseGroupsArgs = {
  data: CourseGroupUpdateManyMutationInput;
  where?: InputMaybe<CourseGroupWhereInput>;
};

export type MutationUpdateManyExercisesArgs = {
  data: ExerciseUpdateManyMutationInput;
  where?: InputMaybe<ExerciseWhereInput>;
};

export type MutationUpdateManyGameUserKwouwselAccessoriesArgs = {
  data: GameUserKwouwselAccessoryUpdateManyMutationInput;
  where?: InputMaybe<GameUserKwouwselAccessoryWhereInput>;
};

export type MutationUpdateManyGameUserKwouwselUpgradesArgs = {
  data: GameUserKwouwselUpgradeUpdateManyMutationInput;
  where?: InputMaybe<GameUserKwouwselUpgradeWhereInput>;
};

export type MutationUpdateManyGameUsersArgs = {
  data: GameUserUpdateManyMutationInput;
  where?: InputMaybe<GameUserWhereInput>;
};

export type MutationUpdateManyKwouwselAccessoriesArgs = {
  data: KwouwselAccessoryUpdateManyMutationInput;
  where?: InputMaybe<KwouwselAccessoryWhereInput>;
};

export type MutationUpdateManyKwouwselUpgradesArgs = {
  data: KwouwselUpgradeUpdateManyMutationInput;
  where?: InputMaybe<KwouwselUpgradeWhereInput>;
};

export type MutationUpdateManyLevelSettingsArgs = {
  data: LevelSettingUpdateManyMutationInput;
  where?: InputMaybe<LevelSettingWhereInput>;
};

export type MutationUpdateManyLevelsArgs = {
  data: LevelUpdateManyMutationInput;
  where?: InputMaybe<LevelWhereInput>;
};

export type MutationUpdateManyLicenseSubscriptionInfoesArgs = {
  data: LicenseSubscriptionInfoUpdateManyMutationInput;
  where?: InputMaybe<LicenseSubscriptionInfoWhereInput>;
};

export type MutationUpdateManyLicensesArgs = {
  data: LicenseUpdateManyMutationInput;
  where?: InputMaybe<LicenseWhereInput>;
};

export type MutationUpdateManyNotesArgs = {
  data: NoteUpdateManyMutationInput;
  where?: InputMaybe<NoteWhereInput>;
};

export type MutationUpdateManyPartnersArgs = {
  data: PartnerUpdateManyMutationInput;
  where?: InputMaybe<PartnerWhereInput>;
};

export type MutationUpdateManySchoolDistrictsArgs = {
  data: SchoolDistrictUpdateManyMutationInput;
  where?: InputMaybe<SchoolDistrictWhereInput>;
};

export type MutationUpdateManySchoolsArgs = {
  data: SchoolUpdateManyMutationInput;
  where?: InputMaybe<SchoolWhereInput>;
};

export type MutationUpdateManySkillCoursesArgs = {
  data: SkillCourseUpdateManyMutationInput;
  where?: InputMaybe<SkillCourseWhereInput>;
};

export type MutationUpdateManyUserLevelStatesArgs = {
  data: Array<UserLevelUpdateUserLevelState>;
};

export type MutationUpdateManyUserLevelsArgs = {
  data: UserLevelUpdateManyMutationInput;
  where?: InputMaybe<UserLevelWhereInput>;
};

export type MutationUpdateManyUsersArgs = {
  data: UserUpdateManyInput;
  where: UserWhereInput;
};

export type MutationUpdateMessagePreferencesArgs = {
  data: MessagePreferencesUpdateInput;
  where: MessagePreferencesWhereUniqueInput;
};

export type MutationUpdateNoteArgs = {
  data: NoteUpdateInput;
  where: NoteWhereUniqueInput;
};

export type MutationUpdatePartnerArgs = {
  data: PartnerUpdateInput;
  where: PartnerWhereUniqueInput;
};

export type MutationUpdateSchoolArgs = {
  data: SchoolUpdateInput;
  where: SchoolWhereUniqueInput;
};

export type MutationUpdateSchoolDistrictArgs = {
  data: SchoolDistrictUpdateInput;
  where: SchoolDistrictWhereUniqueInput;
};

export type MutationUpdateSelfArgs = {
  data: UserUpdateSelfInput;
};

export type MutationUpdateSkillCourseArgs = {
  data: SkillCourseUpdateInput;
  where: SkillCourseWhereUniqueInput;
};

export type MutationUpdateUserArgs = {
  data: UserUpdateInput;
  where: UserWhereUniqueInput;
};

export type MutationUpdateUserLevelArgs = {
  data: UserLevelUpdateInput;
  where: UserLevelWhereUniqueInput;
};

export type MutationUpsertAccessRequestArgs = {
  create: AccessRequestCreateInput;
  update: AccessRequestUpdateInput;
  where: AccessRequestWhereUniqueInput;
};

export type MutationUpsertAlfredoMessageArgs = {
  create: AlfredoMessageCreateInput;
  update: AlfredoMessageUpdateInput;
  where: AlfredoMessageWhereUniqueInput;
};

export type MutationUpsertAlfredoMessageGameUserArgs = {
  create: AlfredoMessageGameUserCreateInput;
  update: AlfredoMessageGameUserUpdateInput;
  where: AlfredoMessageGameUserWhereUniqueInput;
};

export type MutationUpsertBeheerUserArgs = {
  create: BeheerUserCreateInput;
  update: BeheerUserUpdateInput;
  where: BeheerUserWhereUniqueInput;
};

export type MutationUpsertChallengeArgs = {
  create: ChallengeCreateInput;
  update: ChallengeUpdateInput;
  where: ChallengeWhereUniqueInput;
};

export type MutationUpsertChallengeRequestArgs = {
  create: ChallengeRequestCreateInput;
  update: ChallengeRequestUpdateInput;
  where: ChallengeRequestWhereUniqueInput;
};

export type MutationUpsertChallengeResultArgs = {
  create: ChallengeResultCreateInput;
  update: ChallengeResultUpdateInput;
  where: ChallengeResultWhereUniqueInput;
};

export type MutationUpsertContactDetailsArgs = {
  create: ContactDetailsCreateInput;
  update: ContactDetailsUpdateInput;
  where: ContactDetailsWhereUniqueInput;
};

export type MutationUpsertCouponArgs = {
  create: CouponCreateInput;
  update: CouponUpdateInput;
  where: CouponWhereUniqueInput;
};

export type MutationUpsertCourseGroupArgs = {
  create: CourseGroupCreateInput;
  update: CourseGroupUpdateInput;
  where: CourseGroupWhereUniqueInput;
};

export type MutationUpsertExerciseArgs = {
  create: ExerciseCreateInput;
  update: ExerciseUpdateInput;
  where: ExerciseWhereUniqueInput;
};

export type MutationUpsertGameUserArgs = {
  create: GameUserCreateInput;
  update: GameUserUpdateInput;
  where: GameUserWhereUniqueInput;
};

export type MutationUpsertGameUserKwouwselAccessoryArgs = {
  create: GameUserKwouwselAccessoryCreateInput;
  update: GameUserKwouwselAccessoryUpdateInput;
  where: GameUserKwouwselAccessoryWhereUniqueInput;
};

export type MutationUpsertGameUserKwouwselUpgradeArgs = {
  create: GameUserKwouwselUpgradeCreateInput;
  update: GameUserKwouwselUpgradeUpdateInput;
  where: GameUserKwouwselUpgradeWhereUniqueInput;
};

export type MutationUpsertKwouwselAccessoryArgs = {
  create: KwouwselAccessoryCreateInput;
  update: KwouwselAccessoryUpdateInput;
  where: KwouwselAccessoryWhereUniqueInput;
};

export type MutationUpsertKwouwselUpgradeArgs = {
  create: KwouwselUpgradeCreateInput;
  update: KwouwselUpgradeUpdateInput;
  where: KwouwselUpgradeWhereUniqueInput;
};

export type MutationUpsertLevelArgs = {
  create: LevelCreateInput;
  update: LevelUpdateInput;
  where: LevelWhereUniqueInput;
};

export type MutationUpsertLevelSettingArgs = {
  create: LevelSettingCreateInput;
  update: LevelSettingUpdateInput;
  where: LevelSettingWhereUniqueInput;
};

export type MutationUpsertLicenseArgs = {
  create: LicenseCreateInput;
  update: LicenseUpdateInput;
  where: LicenseWhereUniqueInput;
};

export type MutationUpsertLicensePoolArgs = {
  create: LicensePoolCreateInput;
  update: LicensePoolUpdateInput;
  where: LicensePoolWhereUniqueInput;
};

export type MutationUpsertLicenseSubscriptionInfoArgs = {
  create: LicenseSubscriptionInfoCreateInput;
  update: LicenseSubscriptionInfoUpdateInput;
  where: LicenseSubscriptionInfoWhereUniqueInput;
};

export type MutationUpsertNoteArgs = {
  data?: InputMaybe<UpsertNoteInput>;
  where?: InputMaybe<UpsertNoteWhereInput>;
};

export type MutationUpsertPartnerArgs = {
  create: PartnerCreateInput;
  update: PartnerUpdateInput;
  where: PartnerWhereUniqueInput;
};

export type MutationUpsertSchoolArgs = {
  create: SchoolCreateInput;
  update: SchoolUpdateInput;
  where: SchoolWhereUniqueInput;
};

export type MutationUpsertSchoolDistrictArgs = {
  create: SchoolDistrictCreateInput;
  update: SchoolDistrictUpdateInput;
  where: SchoolDistrictWhereUniqueInput;
};

export type MutationUpsertSkillCourseArgs = {
  create: SkillCourseCreateInput;
  update: SkillCourseUpdateInput;
  where: SkillCourseWhereUniqueInput;
};

export type MutationUpsertUserLevelArgs = {
  create: UserLevelCreateInput;
  update: UserLevelUpdateInput;
  where: UserLevelWhereUniqueInput;
};

export type MutationType = 'CREATED' | 'DELETED' | 'UPDATED';

export type NestedMessageCountWhereInput = {
  AND?: InputMaybe<Array<NestedMessageCountWhereInput>>;
  NOT?: InputMaybe<Array<NestedMessageCountWhereInput>>;
  OR?: InputMaybe<Array<NestedMessageCountWhereInput>>;
  sentAt?: InputMaybe<Scalars['DateTime']>;
  type?: InputMaybe<TypeEnumFilter>;
};

export type NestedMessageWithUserWhereInput = {
  AND?: InputMaybe<Array<NestedMessageWithUserWhereInput>>;
  NOT?: InputMaybe<Array<NestedMessageWithUserWhereInput>>;
  OR?: InputMaybe<Array<NestedMessageWithUserWhereInput>>;
  content?: InputMaybe<StringFilter>;
  id?: InputMaybe<Scalars['String']>;
  recipients?: InputMaybe<RecipientsFilter>;
  replies?: InputMaybe<RepliesFilter>;
  sender_id?: InputMaybe<Scalars['String']>;
  sentAt?: InputMaybe<Scalars['DateTime']>;
  subject?: InputMaybe<StringFilter>;
  type?: InputMaybe<TypeEnumFilter>;
  user?: InputMaybe<MessageUserWhereInput>;
};

export type Note = {
  content: Scalars['String'];
  createdAt: Scalars['DateTime'];
  game: Game;
  id: Scalars['ID'];
  updatedAt: Scalars['DateTime'];
};

export type NoteConnection = {
  aggregate: AggregateNote;
  edges: Array<Maybe<NoteEdge>>;
  pageInfo: PageInfo;
};

export type NoteCreateInput = {
  content: Scalars['String'];
  game?: InputMaybe<Game>;
  id?: InputMaybe<Scalars['ID']>;
  userId: Scalars['String'];
};

export type NoteEdge = {
  cursor: Scalars['String'];
  node: Note;
};

export type NoteOrderByInput =
  | 'content_ASC'
  | 'content_DESC'
  | 'createdAt_ASC'
  | 'createdAt_DESC'
  | 'game_ASC'
  | 'game_DESC'
  | 'id_ASC'
  | 'id_DESC'
  | 'updatedAt_ASC'
  | 'updatedAt_DESC'
  | 'userId_ASC'
  | 'userId_DESC';

export type NotePreviousValues = {
  content: Scalars['String'];
  createdAt: Scalars['DateTime'];
  game: Game;
  id: Scalars['ID'];
  updatedAt: Scalars['DateTime'];
  userId: Scalars['String'];
};

export type NoteSubscriptionPayload = {
  mutation: MutationType;
  node?: Maybe<Note>;
  previousValues?: Maybe<NotePreviousValues>;
  updatedFields?: Maybe<Array<Scalars['String']>>;
};

export type NoteSubscriptionWhereInput = {
  AND?: InputMaybe<Array<NoteSubscriptionWhereInput>>;
  NOT?: InputMaybe<Array<NoteSubscriptionWhereInput>>;
  OR?: InputMaybe<Array<NoteSubscriptionWhereInput>>;
  mutation_in?: InputMaybe<Array<MutationType>>;
  node?: InputMaybe<NoteWhereInput>;
  updatedFields_contains?: InputMaybe<Scalars['String']>;
  updatedFields_contains_every?: InputMaybe<Array<Scalars['String']>>;
  updatedFields_contains_some?: InputMaybe<Array<Scalars['String']>>;
};

export type NoteUpdateInput = {
  content?: InputMaybe<Scalars['String']>;
  game?: InputMaybe<Game>;
  userId?: InputMaybe<Scalars['String']>;
};

export type NoteUpdateManyMutationInput = {
  content?: InputMaybe<Scalars['String']>;
  game?: InputMaybe<Game>;
  userId?: InputMaybe<Scalars['String']>;
};

export type NoteWhereInput = {
  AND?: InputMaybe<Array<NoteWhereInput>>;
  NOT?: InputMaybe<Array<NoteWhereInput>>;
  OR?: InputMaybe<Array<NoteWhereInput>>;
  content?: InputMaybe<Scalars['String']>;
  content_contains?: InputMaybe<Scalars['String']>;
  content_ends_with?: InputMaybe<Scalars['String']>;
  content_gt?: InputMaybe<Scalars['String']>;
  content_gte?: InputMaybe<Scalars['String']>;
  content_in?: InputMaybe<Array<Scalars['String']>>;
  content_lt?: InputMaybe<Scalars['String']>;
  content_lte?: InputMaybe<Scalars['String']>;
  content_not?: InputMaybe<Scalars['String']>;
  content_not_contains?: InputMaybe<Scalars['String']>;
  content_not_ends_with?: InputMaybe<Scalars['String']>;
  content_not_in?: InputMaybe<Array<Scalars['String']>>;
  content_not_starts_with?: InputMaybe<Scalars['String']>;
  content_starts_with?: InputMaybe<Scalars['String']>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  createdAt_gt?: InputMaybe<Scalars['DateTime']>;
  createdAt_gte?: InputMaybe<Scalars['DateTime']>;
  createdAt_in?: InputMaybe<Array<Scalars['DateTime']>>;
  createdAt_lt?: InputMaybe<Scalars['DateTime']>;
  createdAt_lte?: InputMaybe<Scalars['DateTime']>;
  createdAt_not?: InputMaybe<Scalars['DateTime']>;
  createdAt_not_in?: InputMaybe<Array<Scalars['DateTime']>>;
  game?: InputMaybe<Game>;
  game_in?: InputMaybe<Array<Game>>;
  game_not?: InputMaybe<Game>;
  game_not_in?: InputMaybe<Array<Game>>;
  id?: InputMaybe<Scalars['ID']>;
  id_contains?: InputMaybe<Scalars['ID']>;
  id_ends_with?: InputMaybe<Scalars['ID']>;
  id_gt?: InputMaybe<Scalars['ID']>;
  id_gte?: InputMaybe<Scalars['ID']>;
  id_in?: InputMaybe<Array<Scalars['ID']>>;
  id_lt?: InputMaybe<Scalars['ID']>;
  id_lte?: InputMaybe<Scalars['ID']>;
  id_not?: InputMaybe<Scalars['ID']>;
  id_not_contains?: InputMaybe<Scalars['ID']>;
  id_not_ends_with?: InputMaybe<Scalars['ID']>;
  id_not_in?: InputMaybe<Array<Scalars['ID']>>;
  id_not_starts_with?: InputMaybe<Scalars['ID']>;
  id_starts_with?: InputMaybe<Scalars['ID']>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
  updatedAt_gt?: InputMaybe<Scalars['DateTime']>;
  updatedAt_gte?: InputMaybe<Scalars['DateTime']>;
  updatedAt_in?: InputMaybe<Array<Scalars['DateTime']>>;
  updatedAt_lt?: InputMaybe<Scalars['DateTime']>;
  updatedAt_lte?: InputMaybe<Scalars['DateTime']>;
  updatedAt_not?: InputMaybe<Scalars['DateTime']>;
  updatedAt_not_in?: InputMaybe<Array<Scalars['DateTime']>>;
  userId?: InputMaybe<Scalars['String']>;
  userId_contains?: InputMaybe<Scalars['String']>;
  userId_ends_with?: InputMaybe<Scalars['String']>;
  userId_gt?: InputMaybe<Scalars['String']>;
  userId_gte?: InputMaybe<Scalars['String']>;
  userId_in?: InputMaybe<Array<Scalars['String']>>;
  userId_lt?: InputMaybe<Scalars['String']>;
  userId_lte?: InputMaybe<Scalars['String']>;
  userId_not?: InputMaybe<Scalars['String']>;
  userId_not_contains?: InputMaybe<Scalars['String']>;
  userId_not_ends_with?: InputMaybe<Scalars['String']>;
  userId_not_in?: InputMaybe<Array<Scalars['String']>>;
  userId_not_starts_with?: InputMaybe<Scalars['String']>;
  userId_starts_with?: InputMaybe<Scalars['String']>;
};

export type NoteWhereUniqueInput = {
  id?: InputMaybe<Scalars['ID']>;
};

export type NumberFilterInput = {
  eq?: InputMaybe<Scalars['Int']>;
  gt?: InputMaybe<Scalars['Int']>;
  gte?: InputMaybe<Scalars['Int']>;
  in?: InputMaybe<Array<Scalars['Int']>>;
  lt?: InputMaybe<Scalars['Int']>;
  lte?: InputMaybe<Scalars['Int']>;
  neq?: InputMaybe<Scalars['Int']>;
  notIn?: InputMaybe<Array<Scalars['Int']>>;
};

export type OrganisationType =
  | 'HIGHER_EDUCATION'
  | 'HIGH_SCHOOL'
  | 'OTHER'
  | 'PRIMARY_SCHOOL'
  | 'REMEDIAL_TEACHING'
  | 'SCHOOL_DISTRICT';

export type OrganisationUserInput = {
  email: Scalars['String'];
  firstName: Scalars['String'];
  lastName: Scalars['String'];
  prefix?: InputMaybe<Scalars['String']>;
  username?: InputMaybe<Scalars['String']>;
};

export type OverRideUserPasswordInput = {
  isTemp: Scalars['Boolean'];
  password: Scalars['String'];
  passwordConfirmation: Scalars['String'];
  userId: Scalars['String'];
};

export type PageInfo = {
  endCursor?: Maybe<Scalars['String']>;
  hasNextPage: Scalars['Boolean'];
  hasPreviousPage: Scalars['Boolean'];
  startCursor?: Maybe<Scalars['String']>;
};

export type PaginatedInstitution = {
  edges?: Maybe<Array<InstitutionViewModelEdge>>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int'];
};

export type Partner = {
  acceptsDataProcessingAgreement: Scalars['Boolean'];
  activated: Scalars['Boolean'];
  activeSubscription: Scalars['Boolean'];
  address: ContactDetails;
  chamberOfCommerceNumber?: Maybe<Scalars['String']>;
  copyEmail?: Maybe<Scalars['String']>;
  createdAt: Scalars['DateTime'];
  email: Scalars['String'];
  id: Scalars['ID'];
  invoiceInfo?: Maybe<ContactDetails>;
  licensePool: LicensePool;
  licenseSubscription: LicenseSubscriptionInfo;
  managers?: Maybe<UsersFilterMessage>;
  name: Scalars['String'];
  phone: Scalars['String'];
  receivedSignedDataProcessingAgreement: Scalars['Boolean'];
  schoolDistricts: SchoolDistrictSearchResult;
  schools: SchoolSearchResult;
  teamleaderID: Scalars['String'];
  updatedAt: Scalars['DateTime'];
};

export type PartnerManagersArgs = {
  filter?: InputMaybe<UsersFilterArguments>;
};

export type PartnerSchoolDistrictsArgs = {
  filter?: InputMaybe<SchoolDistrictSearchFilterInput>;
};

export type PartnerSchoolsArgs = {
  filter?: InputMaybe<SchoolSearchFilterInput>;
};

export type PartnerConnection = {
  aggregate: AggregatePartner;
  edges: Array<Maybe<PartnerEdge>>;
  pageInfo: PageInfo;
};

export type PartnerCreateInput = {
  acceptsDataProcessingAgreement: Scalars['Boolean'];
  activated?: InputMaybe<Scalars['Boolean']>;
  activeSubscription: Scalars['Boolean'];
  address: ContactDetailsCreateOneInput;
  chamberOfCommerceNumber?: InputMaybe<Scalars['String']>;
  copyEmail?: InputMaybe<Scalars['String']>;
  email: Scalars['String'];
  id?: InputMaybe<Scalars['ID']>;
  invoiceInfo?: InputMaybe<ContactDetailsCreateOneInput>;
  licensePool: LicensePoolCreateOneInput;
  licenseSubscription: LicenseSubscriptionInfoCreateOneInput;
  name: Scalars['String'];
  phone: Scalars['String'];
  previousSubscriptions?: InputMaybe<LicenseSubscriptionInfoCreateManyInput>;
  receivedSignedDataProcessingAgreement?: InputMaybe<Scalars['Boolean']>;
  schoolDistricts?: InputMaybe<SchoolDistrictCreateManyWithoutPartnerInput>;
  schools?: InputMaybe<SchoolCreateManyWithoutPartnerInput>;
  teamleaderID: Scalars['String'];
  users?: InputMaybe<BeheerUserCreateManyWithoutPartnersInput>;
};

export type PartnerCreateManyWithoutUsersInput = {
  connect?: InputMaybe<Array<PartnerWhereUniqueInput>>;
  create?: InputMaybe<Array<PartnerCreateWithoutUsersInput>>;
};

export type PartnerCreateOneWithoutSchoolDistrictsInput = {
  connect?: InputMaybe<PartnerWhereUniqueInput>;
  create?: InputMaybe<PartnerCreateWithoutSchoolDistrictsInput>;
};

export type PartnerCreateOneWithoutSchoolsInput = {
  connect?: InputMaybe<PartnerWhereUniqueInput>;
  create?: InputMaybe<PartnerCreateWithoutSchoolsInput>;
};

export type PartnerCreateWithoutSchoolDistrictsInput = {
  acceptsDataProcessingAgreement: Scalars['Boolean'];
  activated?: InputMaybe<Scalars['Boolean']>;
  activeSubscription: Scalars['Boolean'];
  address: ContactDetailsCreateOneInput;
  chamberOfCommerceNumber?: InputMaybe<Scalars['String']>;
  copyEmail?: InputMaybe<Scalars['String']>;
  email: Scalars['String'];
  id?: InputMaybe<Scalars['ID']>;
  invoiceInfo?: InputMaybe<ContactDetailsCreateOneInput>;
  licensePool: LicensePoolCreateOneInput;
  licenseSubscription: LicenseSubscriptionInfoCreateOneInput;
  name: Scalars['String'];
  phone: Scalars['String'];
  previousSubscriptions?: InputMaybe<LicenseSubscriptionInfoCreateManyInput>;
  receivedSignedDataProcessingAgreement?: InputMaybe<Scalars['Boolean']>;
  schools?: InputMaybe<SchoolCreateManyWithoutPartnerInput>;
  teamleaderID: Scalars['String'];
  users?: InputMaybe<BeheerUserCreateManyWithoutPartnersInput>;
};

export type PartnerCreateWithoutSchoolsInput = {
  acceptsDataProcessingAgreement: Scalars['Boolean'];
  activated?: InputMaybe<Scalars['Boolean']>;
  activeSubscription: Scalars['Boolean'];
  address: ContactDetailsCreateOneInput;
  chamberOfCommerceNumber?: InputMaybe<Scalars['String']>;
  copyEmail?: InputMaybe<Scalars['String']>;
  email: Scalars['String'];
  id?: InputMaybe<Scalars['ID']>;
  invoiceInfo?: InputMaybe<ContactDetailsCreateOneInput>;
  licensePool: LicensePoolCreateOneInput;
  licenseSubscription: LicenseSubscriptionInfoCreateOneInput;
  name: Scalars['String'];
  phone: Scalars['String'];
  previousSubscriptions?: InputMaybe<LicenseSubscriptionInfoCreateManyInput>;
  receivedSignedDataProcessingAgreement?: InputMaybe<Scalars['Boolean']>;
  schoolDistricts?: InputMaybe<SchoolDistrictCreateManyWithoutPartnerInput>;
  teamleaderID: Scalars['String'];
  users?: InputMaybe<BeheerUserCreateManyWithoutPartnersInput>;
};

export type PartnerCreateWithoutUsersInput = {
  acceptsDataProcessingAgreement: Scalars['Boolean'];
  activated?: InputMaybe<Scalars['Boolean']>;
  activeSubscription: Scalars['Boolean'];
  address: ContactDetailsCreateOneInput;
  chamberOfCommerceNumber?: InputMaybe<Scalars['String']>;
  copyEmail?: InputMaybe<Scalars['String']>;
  email: Scalars['String'];
  id?: InputMaybe<Scalars['ID']>;
  invoiceInfo?: InputMaybe<ContactDetailsCreateOneInput>;
  licensePool: LicensePoolCreateOneInput;
  licenseSubscription: LicenseSubscriptionInfoCreateOneInput;
  name: Scalars['String'];
  phone: Scalars['String'];
  previousSubscriptions?: InputMaybe<LicenseSubscriptionInfoCreateManyInput>;
  receivedSignedDataProcessingAgreement?: InputMaybe<Scalars['Boolean']>;
  schoolDistricts?: InputMaybe<SchoolDistrictCreateManyWithoutPartnerInput>;
  schools?: InputMaybe<SchoolCreateManyWithoutPartnerInput>;
  teamleaderID: Scalars['String'];
};

export type PartnerEdge = {
  cursor: Scalars['String'];
  node: Partner;
};

export type PartnerOrderByColumns =
  | 'city'
  | 'contact'
  | 'email'
  | 'id'
  | 'licensesInUse'
  | 'licensesRemaining'
  | 'licensesTotal'
  | 'name'
  | 'renewalDate';

export type PartnerOrderByInput =
  | 'acceptsDataProcessingAgreement_ASC'
  | 'acceptsDataProcessingAgreement_DESC'
  | 'activated_ASC'
  | 'activated_DESC'
  | 'activeSubscription_ASC'
  | 'activeSubscription_DESC'
  | 'chamberOfCommerceNumber_ASC'
  | 'chamberOfCommerceNumber_DESC'
  | 'copyEmail_ASC'
  | 'copyEmail_DESC'
  | 'createdAt_ASC'
  | 'createdAt_DESC'
  | 'email_ASC'
  | 'email_DESC'
  | 'id_ASC'
  | 'id_DESC'
  | 'name_ASC'
  | 'name_DESC'
  | 'phone_ASC'
  | 'phone_DESC'
  | 'receivedSignedDataProcessingAgreement_ASC'
  | 'receivedSignedDataProcessingAgreement_DESC'
  | 'teamleaderID_ASC'
  | 'teamleaderID_DESC'
  | 'updatedAt_ASC'
  | 'updatedAt_DESC';

export type PartnerPreviousValues = {
  acceptsDataProcessingAgreement: Scalars['Boolean'];
  activated: Scalars['Boolean'];
  activeSubscription: Scalars['Boolean'];
  chamberOfCommerceNumber?: Maybe<Scalars['String']>;
  copyEmail?: Maybe<Scalars['String']>;
  createdAt: Scalars['DateTime'];
  email: Scalars['String'];
  id: Scalars['ID'];
  name: Scalars['String'];
  phone: Scalars['String'];
  receivedSignedDataProcessingAgreement: Scalars['Boolean'];
  teamleaderID: Scalars['String'];
  updatedAt: Scalars['DateTime'];
};

export type PartnerScalarWhereInput = {
  AND?: InputMaybe<Array<PartnerScalarWhereInput>>;
  NOT?: InputMaybe<Array<PartnerScalarWhereInput>>;
  OR?: InputMaybe<Array<PartnerScalarWhereInput>>;
  acceptsDataProcessingAgreement?: InputMaybe<Scalars['Boolean']>;
  acceptsDataProcessingAgreement_not?: InputMaybe<Scalars['Boolean']>;
  activated?: InputMaybe<Scalars['Boolean']>;
  activated_not?: InputMaybe<Scalars['Boolean']>;
  activeSubscription?: InputMaybe<Scalars['Boolean']>;
  activeSubscription_not?: InputMaybe<Scalars['Boolean']>;
  chamberOfCommerceNumber?: InputMaybe<Scalars['String']>;
  chamberOfCommerceNumber_contains?: InputMaybe<Scalars['String']>;
  chamberOfCommerceNumber_ends_with?: InputMaybe<Scalars['String']>;
  chamberOfCommerceNumber_gt?: InputMaybe<Scalars['String']>;
  chamberOfCommerceNumber_gte?: InputMaybe<Scalars['String']>;
  chamberOfCommerceNumber_in?: InputMaybe<Array<Scalars['String']>>;
  chamberOfCommerceNumber_lt?: InputMaybe<Scalars['String']>;
  chamberOfCommerceNumber_lte?: InputMaybe<Scalars['String']>;
  chamberOfCommerceNumber_not?: InputMaybe<Scalars['String']>;
  chamberOfCommerceNumber_not_contains?: InputMaybe<Scalars['String']>;
  chamberOfCommerceNumber_not_ends_with?: InputMaybe<Scalars['String']>;
  chamberOfCommerceNumber_not_in?: InputMaybe<Array<Scalars['String']>>;
  chamberOfCommerceNumber_not_starts_with?: InputMaybe<Scalars['String']>;
  chamberOfCommerceNumber_starts_with?: InputMaybe<Scalars['String']>;
  copyEmail?: InputMaybe<Scalars['String']>;
  copyEmail_contains?: InputMaybe<Scalars['String']>;
  copyEmail_ends_with?: InputMaybe<Scalars['String']>;
  copyEmail_gt?: InputMaybe<Scalars['String']>;
  copyEmail_gte?: InputMaybe<Scalars['String']>;
  copyEmail_in?: InputMaybe<Array<Scalars['String']>>;
  copyEmail_lt?: InputMaybe<Scalars['String']>;
  copyEmail_lte?: InputMaybe<Scalars['String']>;
  copyEmail_not?: InputMaybe<Scalars['String']>;
  copyEmail_not_contains?: InputMaybe<Scalars['String']>;
  copyEmail_not_ends_with?: InputMaybe<Scalars['String']>;
  copyEmail_not_in?: InputMaybe<Array<Scalars['String']>>;
  copyEmail_not_starts_with?: InputMaybe<Scalars['String']>;
  copyEmail_starts_with?: InputMaybe<Scalars['String']>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  createdAt_gt?: InputMaybe<Scalars['DateTime']>;
  createdAt_gte?: InputMaybe<Scalars['DateTime']>;
  createdAt_in?: InputMaybe<Array<Scalars['DateTime']>>;
  createdAt_lt?: InputMaybe<Scalars['DateTime']>;
  createdAt_lte?: InputMaybe<Scalars['DateTime']>;
  createdAt_not?: InputMaybe<Scalars['DateTime']>;
  createdAt_not_in?: InputMaybe<Array<Scalars['DateTime']>>;
  email?: InputMaybe<Scalars['String']>;
  email_contains?: InputMaybe<Scalars['String']>;
  email_ends_with?: InputMaybe<Scalars['String']>;
  email_gt?: InputMaybe<Scalars['String']>;
  email_gte?: InputMaybe<Scalars['String']>;
  email_in?: InputMaybe<Array<Scalars['String']>>;
  email_lt?: InputMaybe<Scalars['String']>;
  email_lte?: InputMaybe<Scalars['String']>;
  email_not?: InputMaybe<Scalars['String']>;
  email_not_contains?: InputMaybe<Scalars['String']>;
  email_not_ends_with?: InputMaybe<Scalars['String']>;
  email_not_in?: InputMaybe<Array<Scalars['String']>>;
  email_not_starts_with?: InputMaybe<Scalars['String']>;
  email_starts_with?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['ID']>;
  id_contains?: InputMaybe<Scalars['ID']>;
  id_ends_with?: InputMaybe<Scalars['ID']>;
  id_gt?: InputMaybe<Scalars['ID']>;
  id_gte?: InputMaybe<Scalars['ID']>;
  id_in?: InputMaybe<Array<Scalars['ID']>>;
  id_lt?: InputMaybe<Scalars['ID']>;
  id_lte?: InputMaybe<Scalars['ID']>;
  id_not?: InputMaybe<Scalars['ID']>;
  id_not_contains?: InputMaybe<Scalars['ID']>;
  id_not_ends_with?: InputMaybe<Scalars['ID']>;
  id_not_in?: InputMaybe<Array<Scalars['ID']>>;
  id_not_starts_with?: InputMaybe<Scalars['ID']>;
  id_starts_with?: InputMaybe<Scalars['ID']>;
  name?: InputMaybe<Scalars['String']>;
  name_contains?: InputMaybe<Scalars['String']>;
  name_ends_with?: InputMaybe<Scalars['String']>;
  name_gt?: InputMaybe<Scalars['String']>;
  name_gte?: InputMaybe<Scalars['String']>;
  name_in?: InputMaybe<Array<Scalars['String']>>;
  name_lt?: InputMaybe<Scalars['String']>;
  name_lte?: InputMaybe<Scalars['String']>;
  name_not?: InputMaybe<Scalars['String']>;
  name_not_contains?: InputMaybe<Scalars['String']>;
  name_not_ends_with?: InputMaybe<Scalars['String']>;
  name_not_in?: InputMaybe<Array<Scalars['String']>>;
  name_not_starts_with?: InputMaybe<Scalars['String']>;
  name_starts_with?: InputMaybe<Scalars['String']>;
  phone?: InputMaybe<Scalars['String']>;
  phone_contains?: InputMaybe<Scalars['String']>;
  phone_ends_with?: InputMaybe<Scalars['String']>;
  phone_gt?: InputMaybe<Scalars['String']>;
  phone_gte?: InputMaybe<Scalars['String']>;
  phone_in?: InputMaybe<Array<Scalars['String']>>;
  phone_lt?: InputMaybe<Scalars['String']>;
  phone_lte?: InputMaybe<Scalars['String']>;
  phone_not?: InputMaybe<Scalars['String']>;
  phone_not_contains?: InputMaybe<Scalars['String']>;
  phone_not_ends_with?: InputMaybe<Scalars['String']>;
  phone_not_in?: InputMaybe<Array<Scalars['String']>>;
  phone_not_starts_with?: InputMaybe<Scalars['String']>;
  phone_starts_with?: InputMaybe<Scalars['String']>;
  receivedSignedDataProcessingAgreement?: InputMaybe<Scalars['Boolean']>;
  receivedSignedDataProcessingAgreement_not?: InputMaybe<Scalars['Boolean']>;
  teamleaderID?: InputMaybe<Scalars['String']>;
  teamleaderID_contains?: InputMaybe<Scalars['String']>;
  teamleaderID_ends_with?: InputMaybe<Scalars['String']>;
  teamleaderID_gt?: InputMaybe<Scalars['String']>;
  teamleaderID_gte?: InputMaybe<Scalars['String']>;
  teamleaderID_in?: InputMaybe<Array<Scalars['String']>>;
  teamleaderID_lt?: InputMaybe<Scalars['String']>;
  teamleaderID_lte?: InputMaybe<Scalars['String']>;
  teamleaderID_not?: InputMaybe<Scalars['String']>;
  teamleaderID_not_contains?: InputMaybe<Scalars['String']>;
  teamleaderID_not_ends_with?: InputMaybe<Scalars['String']>;
  teamleaderID_not_in?: InputMaybe<Array<Scalars['String']>>;
  teamleaderID_not_starts_with?: InputMaybe<Scalars['String']>;
  teamleaderID_starts_with?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
  updatedAt_gt?: InputMaybe<Scalars['DateTime']>;
  updatedAt_gte?: InputMaybe<Scalars['DateTime']>;
  updatedAt_in?: InputMaybe<Array<Scalars['DateTime']>>;
  updatedAt_lt?: InputMaybe<Scalars['DateTime']>;
  updatedAt_lte?: InputMaybe<Scalars['DateTime']>;
  updatedAt_not?: InputMaybe<Scalars['DateTime']>;
  updatedAt_not_in?: InputMaybe<Array<Scalars['DateTime']>>;
};

export type PartnerSearchFilterInput = {
  first?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<PartnerSearchOrderByInput>;
  skip?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<PartnerSearchWhereInput>;
};

export type PartnerSearchOrderByInput = {
  columnName?: InputMaybe<PartnerOrderByColumns>;
  order?: InputMaybe<SortOrder>;
};

export type PartnerSearchResult = {
  aggregate: AggregatePartner;
  edges: Array<Maybe<PartnerEdge>>;
};

export type PartnerSearchWhereInput = {
  city?: InputMaybe<StringFilterInput>;
  contact?: InputMaybe<StringFilterInput>;
  email?: InputMaybe<StringFilterInput>;
  id?: InputMaybe<StringFilterInput>;
  licensesInUse?: InputMaybe<NumberFilterInput>;
  licensesRemaining?: InputMaybe<NumberFilterInput>;
  licensesTotal?: InputMaybe<NumberFilterInput>;
  name?: InputMaybe<StringFilterInput>;
  renewalDate?: InputMaybe<DateFilterInput>;
};

export type PartnerSubscriptionPayload = {
  mutation: MutationType;
  node?: Maybe<Partner>;
  previousValues?: Maybe<PartnerPreviousValues>;
  updatedFields?: Maybe<Array<Scalars['String']>>;
};

export type PartnerSubscriptionWhereInput = {
  AND?: InputMaybe<Array<PartnerSubscriptionWhereInput>>;
  NOT?: InputMaybe<Array<PartnerSubscriptionWhereInput>>;
  OR?: InputMaybe<Array<PartnerSubscriptionWhereInput>>;
  mutation_in?: InputMaybe<Array<MutationType>>;
  node?: InputMaybe<PartnerWhereInput>;
  updatedFields_contains?: InputMaybe<Scalars['String']>;
  updatedFields_contains_every?: InputMaybe<Array<Scalars['String']>>;
  updatedFields_contains_some?: InputMaybe<Array<Scalars['String']>>;
};

export type PartnerUpdateInput = {
  acceptsDataProcessingAgreement?: InputMaybe<Scalars['Boolean']>;
  activated?: InputMaybe<Scalars['Boolean']>;
  activeSubscription?: InputMaybe<Scalars['Boolean']>;
  address?: InputMaybe<AddressUpdateOneRequiredInput>;
  chamberOfCommerceNumber?: InputMaybe<Scalars['String']>;
  copyEmail?: InputMaybe<Scalars['String']>;
  email?: InputMaybe<Scalars['String']>;
  invoiceInfo?: InputMaybe<InvoiceInfoUpdateOneInput>;
  name?: InputMaybe<Scalars['String']>;
  phone?: InputMaybe<Scalars['String']>;
  receivedSignedDataProcessingAgreement?: InputMaybe<Scalars['Boolean']>;
  schoolDistricts?: InputMaybe<SbSchoolDistrictUpdateManyWithoutPartnerInput>;
  schools?: InputMaybe<SbSchoolUpdateManyWithoutPartnerInput>;
  teamleaderID?: InputMaybe<Scalars['String']>;
  users?: InputMaybe<BeheerUserUpdateManyWithoutPartnersInput>;
};

export type PartnerUpdateManyDataInput = {
  acceptsDataProcessingAgreement?: InputMaybe<Scalars['Boolean']>;
  activated?: InputMaybe<Scalars['Boolean']>;
  activeSubscription?: InputMaybe<Scalars['Boolean']>;
  chamberOfCommerceNumber?: InputMaybe<Scalars['String']>;
  copyEmail?: InputMaybe<Scalars['String']>;
  email?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  phone?: InputMaybe<Scalars['String']>;
  receivedSignedDataProcessingAgreement?: InputMaybe<Scalars['Boolean']>;
  teamleaderID?: InputMaybe<Scalars['String']>;
};

export type PartnerUpdateManyMutationInput = {
  acceptsDataProcessingAgreement?: InputMaybe<Scalars['Boolean']>;
  activated?: InputMaybe<Scalars['Boolean']>;
  activeSubscription?: InputMaybe<Scalars['Boolean']>;
  chamberOfCommerceNumber?: InputMaybe<Scalars['String']>;
  copyEmail?: InputMaybe<Scalars['String']>;
  email?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  phone?: InputMaybe<Scalars['String']>;
  receivedSignedDataProcessingAgreement?: InputMaybe<Scalars['Boolean']>;
  teamleaderID?: InputMaybe<Scalars['String']>;
};

export type PartnerUpdateManyWithWhereNestedInput = {
  data: PartnerUpdateManyDataInput;
  where: PartnerScalarWhereInput;
};

export type PartnerUpdateManyWithoutUsersInput = {
  connect?: InputMaybe<Array<PartnerWhereUniqueInput>>;
  create?: InputMaybe<Array<PartnerCreateWithoutUsersInput>>;
  delete?: InputMaybe<Array<PartnerWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<PartnerScalarWhereInput>>;
  disconnect?: InputMaybe<Array<PartnerWhereUniqueInput>>;
  set?: InputMaybe<Array<PartnerWhereUniqueInput>>;
  update?: InputMaybe<Array<PartnerUpdateWithWhereUniqueWithoutUsersInput>>;
  updateMany?: InputMaybe<Array<PartnerUpdateManyWithWhereNestedInput>>;
  upsert?: InputMaybe<Array<PartnerUpsertWithWhereUniqueWithoutUsersInput>>;
};

export type PartnerUpdateOneWithoutSchoolDistrictsInput = {
  connect?: InputMaybe<PartnerWhereUniqueInput>;
  create?: InputMaybe<PartnerCreateWithoutSchoolDistrictsInput>;
  delete?: InputMaybe<Scalars['Boolean']>;
  disconnect?: InputMaybe<Scalars['Boolean']>;
  update?: InputMaybe<PartnerUpdateWithoutSchoolDistrictsDataInput>;
  upsert?: InputMaybe<PartnerUpsertWithoutSchoolDistrictsInput>;
};

export type PartnerUpdateOneWithoutSchoolsInput = {
  connect?: InputMaybe<PartnerWhereUniqueInput>;
  create?: InputMaybe<PartnerCreateWithoutSchoolsInput>;
  delete?: InputMaybe<Scalars['Boolean']>;
  disconnect?: InputMaybe<Scalars['Boolean']>;
  update?: InputMaybe<PartnerUpdateWithoutSchoolsDataInput>;
  upsert?: InputMaybe<PartnerUpsertWithoutSchoolsInput>;
};

export type PartnerUpdateWithWhereUniqueWithoutUsersInput = {
  data: PartnerUpdateWithoutUsersDataInput;
  where: PartnerWhereUniqueInput;
};

export type PartnerUpdateWithoutSchoolDistrictsDataInput = {
  acceptsDataProcessingAgreement?: InputMaybe<Scalars['Boolean']>;
  activated?: InputMaybe<Scalars['Boolean']>;
  activeSubscription?: InputMaybe<Scalars['Boolean']>;
  address?: InputMaybe<ContactDetailsUpdateOneRequiredInput>;
  chamberOfCommerceNumber?: InputMaybe<Scalars['String']>;
  copyEmail?: InputMaybe<Scalars['String']>;
  email?: InputMaybe<Scalars['String']>;
  invoiceInfo?: InputMaybe<ContactDetailsUpdateOneInput>;
  licensePool?: InputMaybe<LicensePoolUpdateOneRequiredInput>;
  licenseSubscription?: InputMaybe<LicenseSubscriptionInfoUpdateOneRequiredInput>;
  name?: InputMaybe<Scalars['String']>;
  phone?: InputMaybe<Scalars['String']>;
  previousSubscriptions?: InputMaybe<LicenseSubscriptionInfoUpdateManyInput>;
  receivedSignedDataProcessingAgreement?: InputMaybe<Scalars['Boolean']>;
  schools?: InputMaybe<SchoolUpdateManyWithoutPartnerInput>;
  teamleaderID?: InputMaybe<Scalars['String']>;
  users?: InputMaybe<BeheerUserUpdateManyWithoutPartnersInput>;
};

export type PartnerUpdateWithoutSchoolsDataInput = {
  acceptsDataProcessingAgreement?: InputMaybe<Scalars['Boolean']>;
  activated?: InputMaybe<Scalars['Boolean']>;
  activeSubscription?: InputMaybe<Scalars['Boolean']>;
  address?: InputMaybe<ContactDetailsUpdateOneRequiredInput>;
  chamberOfCommerceNumber?: InputMaybe<Scalars['String']>;
  copyEmail?: InputMaybe<Scalars['String']>;
  email?: InputMaybe<Scalars['String']>;
  invoiceInfo?: InputMaybe<ContactDetailsUpdateOneInput>;
  licensePool?: InputMaybe<LicensePoolUpdateOneRequiredInput>;
  licenseSubscription?: InputMaybe<LicenseSubscriptionInfoUpdateOneRequiredInput>;
  name?: InputMaybe<Scalars['String']>;
  phone?: InputMaybe<Scalars['String']>;
  previousSubscriptions?: InputMaybe<LicenseSubscriptionInfoUpdateManyInput>;
  receivedSignedDataProcessingAgreement?: InputMaybe<Scalars['Boolean']>;
  schoolDistricts?: InputMaybe<SchoolDistrictUpdateManyWithoutPartnerInput>;
  teamleaderID?: InputMaybe<Scalars['String']>;
  users?: InputMaybe<BeheerUserUpdateManyWithoutPartnersInput>;
};

export type PartnerUpdateWithoutUsersDataInput = {
  acceptsDataProcessingAgreement?: InputMaybe<Scalars['Boolean']>;
  activated?: InputMaybe<Scalars['Boolean']>;
  activeSubscription?: InputMaybe<Scalars['Boolean']>;
  address?: InputMaybe<ContactDetailsUpdateOneRequiredInput>;
  chamberOfCommerceNumber?: InputMaybe<Scalars['String']>;
  copyEmail?: InputMaybe<Scalars['String']>;
  email?: InputMaybe<Scalars['String']>;
  invoiceInfo?: InputMaybe<ContactDetailsUpdateOneInput>;
  licensePool?: InputMaybe<LicensePoolUpdateOneRequiredInput>;
  licenseSubscription?: InputMaybe<LicenseSubscriptionInfoUpdateOneRequiredInput>;
  name?: InputMaybe<Scalars['String']>;
  phone?: InputMaybe<Scalars['String']>;
  previousSubscriptions?: InputMaybe<LicenseSubscriptionInfoUpdateManyInput>;
  receivedSignedDataProcessingAgreement?: InputMaybe<Scalars['Boolean']>;
  schoolDistricts?: InputMaybe<SchoolDistrictUpdateManyWithoutPartnerInput>;
  schools?: InputMaybe<SchoolUpdateManyWithoutPartnerInput>;
  teamleaderID?: InputMaybe<Scalars['String']>;
};

export type PartnerUpsertWithWhereUniqueWithoutUsersInput = {
  create: PartnerCreateWithoutUsersInput;
  update: PartnerUpdateWithoutUsersDataInput;
  where: PartnerWhereUniqueInput;
};

export type PartnerUpsertWithoutSchoolDistrictsInput = {
  create: PartnerCreateWithoutSchoolDistrictsInput;
  update: PartnerUpdateWithoutSchoolDistrictsDataInput;
};

export type PartnerUpsertWithoutSchoolsInput = {
  create: PartnerCreateWithoutSchoolsInput;
  update: PartnerUpdateWithoutSchoolsDataInput;
};

export type PartnerWhereInput = {
  AND?: InputMaybe<Array<PartnerWhereInput>>;
  NOT?: InputMaybe<Array<PartnerWhereInput>>;
  OR?: InputMaybe<Array<PartnerWhereInput>>;
  acceptsDataProcessingAgreement?: InputMaybe<Scalars['Boolean']>;
  acceptsDataProcessingAgreement_not?: InputMaybe<Scalars['Boolean']>;
  activated?: InputMaybe<Scalars['Boolean']>;
  activated_not?: InputMaybe<Scalars['Boolean']>;
  activeSubscription?: InputMaybe<Scalars['Boolean']>;
  activeSubscription_not?: InputMaybe<Scalars['Boolean']>;
  address?: InputMaybe<ContactDetailsWhereInput>;
  chamberOfCommerceNumber?: InputMaybe<Scalars['String']>;
  chamberOfCommerceNumber_contains?: InputMaybe<Scalars['String']>;
  chamberOfCommerceNumber_ends_with?: InputMaybe<Scalars['String']>;
  chamberOfCommerceNumber_gt?: InputMaybe<Scalars['String']>;
  chamberOfCommerceNumber_gte?: InputMaybe<Scalars['String']>;
  chamberOfCommerceNumber_in?: InputMaybe<Array<Scalars['String']>>;
  chamberOfCommerceNumber_lt?: InputMaybe<Scalars['String']>;
  chamberOfCommerceNumber_lte?: InputMaybe<Scalars['String']>;
  chamberOfCommerceNumber_not?: InputMaybe<Scalars['String']>;
  chamberOfCommerceNumber_not_contains?: InputMaybe<Scalars['String']>;
  chamberOfCommerceNumber_not_ends_with?: InputMaybe<Scalars['String']>;
  chamberOfCommerceNumber_not_in?: InputMaybe<Array<Scalars['String']>>;
  chamberOfCommerceNumber_not_starts_with?: InputMaybe<Scalars['String']>;
  chamberOfCommerceNumber_starts_with?: InputMaybe<Scalars['String']>;
  copyEmail?: InputMaybe<Scalars['String']>;
  copyEmail_contains?: InputMaybe<Scalars['String']>;
  copyEmail_ends_with?: InputMaybe<Scalars['String']>;
  copyEmail_gt?: InputMaybe<Scalars['String']>;
  copyEmail_gte?: InputMaybe<Scalars['String']>;
  copyEmail_in?: InputMaybe<Array<Scalars['String']>>;
  copyEmail_lt?: InputMaybe<Scalars['String']>;
  copyEmail_lte?: InputMaybe<Scalars['String']>;
  copyEmail_not?: InputMaybe<Scalars['String']>;
  copyEmail_not_contains?: InputMaybe<Scalars['String']>;
  copyEmail_not_ends_with?: InputMaybe<Scalars['String']>;
  copyEmail_not_in?: InputMaybe<Array<Scalars['String']>>;
  copyEmail_not_starts_with?: InputMaybe<Scalars['String']>;
  copyEmail_starts_with?: InputMaybe<Scalars['String']>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  createdAt_gt?: InputMaybe<Scalars['DateTime']>;
  createdAt_gte?: InputMaybe<Scalars['DateTime']>;
  createdAt_in?: InputMaybe<Array<Scalars['DateTime']>>;
  createdAt_lt?: InputMaybe<Scalars['DateTime']>;
  createdAt_lte?: InputMaybe<Scalars['DateTime']>;
  createdAt_not?: InputMaybe<Scalars['DateTime']>;
  createdAt_not_in?: InputMaybe<Array<Scalars['DateTime']>>;
  email?: InputMaybe<Scalars['String']>;
  email_contains?: InputMaybe<Scalars['String']>;
  email_ends_with?: InputMaybe<Scalars['String']>;
  email_gt?: InputMaybe<Scalars['String']>;
  email_gte?: InputMaybe<Scalars['String']>;
  email_in?: InputMaybe<Array<Scalars['String']>>;
  email_lt?: InputMaybe<Scalars['String']>;
  email_lte?: InputMaybe<Scalars['String']>;
  email_not?: InputMaybe<Scalars['String']>;
  email_not_contains?: InputMaybe<Scalars['String']>;
  email_not_ends_with?: InputMaybe<Scalars['String']>;
  email_not_in?: InputMaybe<Array<Scalars['String']>>;
  email_not_starts_with?: InputMaybe<Scalars['String']>;
  email_starts_with?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['ID']>;
  id_contains?: InputMaybe<Scalars['ID']>;
  id_ends_with?: InputMaybe<Scalars['ID']>;
  id_gt?: InputMaybe<Scalars['ID']>;
  id_gte?: InputMaybe<Scalars['ID']>;
  id_in?: InputMaybe<Array<Scalars['ID']>>;
  id_lt?: InputMaybe<Scalars['ID']>;
  id_lte?: InputMaybe<Scalars['ID']>;
  id_not?: InputMaybe<Scalars['ID']>;
  id_not_contains?: InputMaybe<Scalars['ID']>;
  id_not_ends_with?: InputMaybe<Scalars['ID']>;
  id_not_in?: InputMaybe<Array<Scalars['ID']>>;
  id_not_starts_with?: InputMaybe<Scalars['ID']>;
  id_starts_with?: InputMaybe<Scalars['ID']>;
  invoiceInfo?: InputMaybe<ContactDetailsWhereInput>;
  licensePool?: InputMaybe<LicensePoolWhereInput>;
  licenseSubscription?: InputMaybe<LicenseSubscriptionInfoWhereInput>;
  name?: InputMaybe<Scalars['String']>;
  name_contains?: InputMaybe<Scalars['String']>;
  name_ends_with?: InputMaybe<Scalars['String']>;
  name_gt?: InputMaybe<Scalars['String']>;
  name_gte?: InputMaybe<Scalars['String']>;
  name_in?: InputMaybe<Array<Scalars['String']>>;
  name_lt?: InputMaybe<Scalars['String']>;
  name_lte?: InputMaybe<Scalars['String']>;
  name_not?: InputMaybe<Scalars['String']>;
  name_not_contains?: InputMaybe<Scalars['String']>;
  name_not_ends_with?: InputMaybe<Scalars['String']>;
  name_not_in?: InputMaybe<Array<Scalars['String']>>;
  name_not_starts_with?: InputMaybe<Scalars['String']>;
  name_starts_with?: InputMaybe<Scalars['String']>;
  phone?: InputMaybe<Scalars['String']>;
  phone_contains?: InputMaybe<Scalars['String']>;
  phone_ends_with?: InputMaybe<Scalars['String']>;
  phone_gt?: InputMaybe<Scalars['String']>;
  phone_gte?: InputMaybe<Scalars['String']>;
  phone_in?: InputMaybe<Array<Scalars['String']>>;
  phone_lt?: InputMaybe<Scalars['String']>;
  phone_lte?: InputMaybe<Scalars['String']>;
  phone_not?: InputMaybe<Scalars['String']>;
  phone_not_contains?: InputMaybe<Scalars['String']>;
  phone_not_ends_with?: InputMaybe<Scalars['String']>;
  phone_not_in?: InputMaybe<Array<Scalars['String']>>;
  phone_not_starts_with?: InputMaybe<Scalars['String']>;
  phone_starts_with?: InputMaybe<Scalars['String']>;
  previousSubscriptions_every?: InputMaybe<LicenseSubscriptionInfoWhereInput>;
  previousSubscriptions_none?: InputMaybe<LicenseSubscriptionInfoWhereInput>;
  previousSubscriptions_some?: InputMaybe<LicenseSubscriptionInfoWhereInput>;
  receivedSignedDataProcessingAgreement?: InputMaybe<Scalars['Boolean']>;
  receivedSignedDataProcessingAgreement_not?: InputMaybe<Scalars['Boolean']>;
  schoolDistricts_every?: InputMaybe<SchoolDistrictWhereInput>;
  schoolDistricts_none?: InputMaybe<SchoolDistrictWhereInput>;
  schoolDistricts_some?: InputMaybe<SchoolDistrictWhereInput>;
  schools_every?: InputMaybe<SchoolWhereInput>;
  schools_none?: InputMaybe<SchoolWhereInput>;
  schools_some?: InputMaybe<SchoolWhereInput>;
  teamleaderID?: InputMaybe<Scalars['String']>;
  teamleaderID_contains?: InputMaybe<Scalars['String']>;
  teamleaderID_ends_with?: InputMaybe<Scalars['String']>;
  teamleaderID_gt?: InputMaybe<Scalars['String']>;
  teamleaderID_gte?: InputMaybe<Scalars['String']>;
  teamleaderID_in?: InputMaybe<Array<Scalars['String']>>;
  teamleaderID_lt?: InputMaybe<Scalars['String']>;
  teamleaderID_lte?: InputMaybe<Scalars['String']>;
  teamleaderID_not?: InputMaybe<Scalars['String']>;
  teamleaderID_not_contains?: InputMaybe<Scalars['String']>;
  teamleaderID_not_ends_with?: InputMaybe<Scalars['String']>;
  teamleaderID_not_in?: InputMaybe<Array<Scalars['String']>>;
  teamleaderID_not_starts_with?: InputMaybe<Scalars['String']>;
  teamleaderID_starts_with?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
  updatedAt_gt?: InputMaybe<Scalars['DateTime']>;
  updatedAt_gte?: InputMaybe<Scalars['DateTime']>;
  updatedAt_in?: InputMaybe<Array<Scalars['DateTime']>>;
  updatedAt_lt?: InputMaybe<Scalars['DateTime']>;
  updatedAt_lte?: InputMaybe<Scalars['DateTime']>;
  updatedAt_not?: InputMaybe<Scalars['DateTime']>;
  updatedAt_not_in?: InputMaybe<Array<Scalars['DateTime']>>;
  users_every?: InputMaybe<BeheerUserWhereInput>;
  users_none?: InputMaybe<BeheerUserWhereInput>;
  users_some?: InputMaybe<BeheerUserWhereInput>;
};

export type PartnerWhereUniqueInput = {
  chamberOfCommerceNumber?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['ID']>;
  teamleaderID?: InputMaybe<Scalars['String']>;
};

export type PracticeTimeBucket = {
  duration: Scalars['Decimal'];
  from: Scalars['DateTime'];
  to: Scalars['DateTime'];
};

export type Product = {
  code: Scalars['String'];
  isLicense: Scalars['Boolean'];
  name: Scalars['String'];
  price?: Maybe<Scalars['Float']>;
  quantity: Scalars['Int'];
};

export type Query = {
  accessRequest?: Maybe<AccessRequest>;
  accessRequests: Array<Maybe<AccessRequest>>;
  accessRequestsConnection: AccessRequestConnection;
  alfredoMessage?: Maybe<AlfredoMessage>;
  alfredoMessageGameUser?: Maybe<AlfredoMessageGameUser>;
  alfredoMessageGameUsers: Array<Maybe<AlfredoMessageGameUser>>;
  alfredoMessageGameUsersConnection: AlfredoMessageGameUserConnection;
  alfredoMessages: Array<Maybe<AlfredoMessage>>;
  alfredoMessagesConnection: AlfredoMessageConnection;
  archivedUsersByResource: Array<ArchivedUser>;
  archivedUsersConnection: ArchivedUserConnection;
  beheerUser?: Maybe<BeheerUser>;
  beheerUsers: Array<Maybe<BeheerUser>>;
  beheerUsersConnection: BeheerUserConnection;
  calcLicenses: CalcLicensesPayload;
  calcLicensesExtend: CalcLicensesExtendPayload;
  challenge?: Maybe<Challenge>;
  challengeRequest?: Maybe<ChallengeRequest>;
  challengeRequests: Array<Maybe<ChallengeRequest>>;
  challengeRequestsConnection: ChallengeRequestConnection;
  challengeResult?: Maybe<ChallengeResult>;
  challengeResults: Array<Maybe<ChallengeResult>>;
  challengeResultsConnection: ChallengeResultConnection;
  challenges: Array<Maybe<Challenge>>;
  challengesConnection: ChallengeConnection;
  coaches?: Maybe<UsersFilterMessage>;
  contactDetails?: Maybe<ContactDetails>;
  contactDetailses: Array<Maybe<ContactDetails>>;
  contactDetailsesConnection: ContactDetailsConnection;
  countries: Array<Country>;
  coupon?: Maybe<Coupon>;
  coupons: Array<Maybe<Coupon>>;
  couponsConnection: CouponConnection;
  courseGroup?: Maybe<CourseGroup>;
  courseGroups: Array<Maybe<CourseGroup>>;
  courseGroupsConnection: CourseGroupConnection;
  courseGroupsSearch: CourseGroupSearchResult;
  currentPartner: Partner;
  currentResource?: Maybe<CurrentResource>;
  currentSchool: School;
  currentSchoolDistrict: SchoolDistrict;
  demoStudents?: Maybe<UsersFilterMessage>;
  educationGroup?: Maybe<EducationGroup>;
  educationGroups: Array<Maybe<EducationGroup>>;
  exercise?: Maybe<Exercise>;
  exercises: Array<Maybe<Exercise>>;
  exercisesConnection: ExerciseConnection;
  gameUser?: Maybe<GameUser>;
  gameUserKwouwselAccessories: Array<Maybe<GameUserKwouwselAccessory>>;
  gameUserKwouwselAccessoriesConnection: GameUserKwouwselAccessoryConnection;
  gameUserKwouwselAccessory?: Maybe<GameUserKwouwselAccessory>;
  gameUserKwouwselUpgrade?: Maybe<GameUserKwouwselUpgrade>;
  gameUserKwouwselUpgrades: Array<Maybe<GameUserKwouwselUpgrade>>;
  gameUserKwouwselUpgradesConnection: GameUserKwouwselUpgradeConnection;
  gameUsers: Array<Maybe<GameUser>>;
  gameUsersConnection: GameUserConnection;
  institutions: PaginatedInstitution;
  kwouwselAccessories: Array<Maybe<KwouwselAccessory>>;
  kwouwselAccessoriesConnection: KwouwselAccessoryConnection;
  kwouwselAccessory?: Maybe<KwouwselAccessory>;
  kwouwselUpgrade?: Maybe<KwouwselUpgrade>;
  kwouwselUpgrades: Array<Maybe<KwouwselUpgrade>>;
  kwouwselUpgradesConnection: KwouwselUpgradeConnection;
  level?: Maybe<Level>;
  levelSetting?: Maybe<LevelSetting>;
  levelSettings: Array<Maybe<LevelSetting>>;
  levelSettingsConnection: LevelSettingConnection;
  levels: Array<Maybe<Level>>;
  levelsConnection: LevelConnection;
  license?: Maybe<License>;
  licensePool?: Maybe<LicensePool>;
  licensePools: Array<Maybe<LicensePool>>;
  licensePoolsConnection: LicensePoolConnection;
  licenseSubscriptionInfo?: Maybe<LicenseSubscriptionInfo>;
  licenseSubscriptionInfoes: Array<Maybe<LicenseSubscriptionInfo>>;
  licenseSubscriptionInfoesConnection: LicenseSubscriptionInfoConnection;
  licenseUsage: LicenseUsage;
  licenses: Array<Maybe<License>>;
  licensesConnection: LicenseConnection;
  lowerThan40Accuracy: Array<StudentReportAccuracy>;
  lowerThan50CPM: Array<StudentReportCpm>;
  me?: Maybe<User>;
  message?: Maybe<Message>;
  notPlayed3Days: Array<StudentReportNotPlayed>;
  note?: Maybe<Note>;
  notes: Array<Maybe<Note>>;
  notesConnection: NoteConnection;
  organisationTypes: Array<LabelizedOrganisationType>;
  partner?: Maybe<Partner>;
  partnerManagers?: Maybe<UsersFilterMessage>;
  partners: Array<Maybe<Partner>>;
  partnersConnection: PartnerConnection;
  partnersSearch: PartnerSearchResult;
  products: Array<Product>;
  school?: Maybe<School>;
  schoolDistrict?: Maybe<SchoolDistrict>;
  schoolDistrictManagers?: Maybe<UsersFilterMessage>;
  schoolDistricts: Array<Maybe<SchoolDistrict>>;
  schoolDistrictsConnection: SchoolDistrictConnection;
  schoolDistrictsSearch: SchoolDistrictSearchResult;
  schoolManagers?: Maybe<UsersFilterMessage>;
  schoolOrganisationTypes: Array<LabelizedSchoolOrganisationType>;
  schools: Array<Maybe<School>>;
  schoolsConnection: SchoolConnection;
  schoolsSearch: SchoolSearchResult;
  searchBasispoortSchools: Array<Maybe<BasispoortSchoolSearchResult>>;
  searchSchoolAddress: Array<BrinSearchResult>;
  searchStudents: Array<AnonymousUser>;
  skillCourse?: Maybe<SkillCourse>;
  skillCourses: Array<Maybe<SkillCourse>>;
  skillCoursesConnection: SkillCourseConnection;
  students?: Maybe<UsersFilterMessage>;
  systemMessages: MessageConnection;
  teamleader: Teamleader;
  teamleaderCompanies: Array<TeamleaderCompany>;
  top5Accuracy: Array<StudentReportAccuracy>;
  top5CPM: Array<StudentReportCpm>;
  top5Playtime: Array<StudentReportPlaytime>;
  user?: Maybe<User>;
  userLevel?: Maybe<UserLevel>;
  userLevels: Array<Maybe<UserLevel>>;
  userLevelsConnection: UserLevelConnection;
  usernameExists: Scalars['Boolean'];
  validateCoupon?: Maybe<CouponValidationResult>;
};

export type QueryAccessRequestArgs = {
  where: AccessRequestWhereUniqueInput;
};

export type QueryAccessRequestsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<AccessRequestOrderByInput>;
  skip?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<AccessRequestWhereInput>;
};

export type QueryAccessRequestsConnectionArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<AccessRequestOrderByInput>;
  skip?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<AccessRequestWhereInput>;
};

export type QueryAlfredoMessageArgs = {
  where: AlfredoMessageWhereUniqueInput;
};

export type QueryAlfredoMessageGameUserArgs = {
  where: AlfredoMessageGameUserWhereUniqueInput;
};

export type QueryAlfredoMessageGameUsersArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<AlfredoMessageGameUserOrderByInput>;
  skip?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<AlfredoMessageGameUserWhereInput>;
};

export type QueryAlfredoMessageGameUsersConnectionArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<AlfredoMessageGameUserOrderByInput>;
  skip?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<AlfredoMessageGameUserWhereInput>;
};

export type QueryAlfredoMessagesArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<AlfredoMessageOrderByInput>;
  skip?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<AlfredoMessageWhereInput>;
};

export type QueryAlfredoMessagesConnectionArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<AlfredoMessageOrderByInput>;
  skip?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<AlfredoMessageWhereInput>;
};

export type QueryArchivedUsersByResourceArgs = {
  resource: ResourceInput;
};

export type QueryArchivedUsersConnectionArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<ArchivedUserOrderByInput>;
  skip?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<ArchivedUserWhereInput>;
};

export type QueryBeheerUserArgs = {
  where: BeheerUserWhereUniqueInput;
};

export type QueryBeheerUsersArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<BeheerUserOrderByInput>;
  skip?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<BeheerUserWhereInput>;
};

export type QueryBeheerUsersConnectionArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<BeheerUserOrderByInput>;
  skip?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<BeheerUserWhereInput>;
};

export type QueryCalcLicensesArgs = {
  couponCode?: InputMaybe<Scalars['String']>;
  quantity: Scalars['Int'];
};

export type QueryCalcLicensesExtendArgs = {
  couponCode?: InputMaybe<Scalars['String']>;
  quantity: Scalars['Int'];
};

export type QueryChallengeArgs = {
  where: ChallengeWhereUniqueInput;
};

export type QueryChallengeRequestArgs = {
  where: ChallengeRequestWhereUniqueInput;
};

export type QueryChallengeRequestsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<ChallengeRequestOrderByInput>;
  skip?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<ChallengeRequestWhereInput>;
};

export type QueryChallengeRequestsConnectionArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<ChallengeRequestOrderByInput>;
  skip?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<ChallengeRequestWhereInput>;
};

export type QueryChallengeResultArgs = {
  where: ChallengeResultWhereUniqueInput;
};

export type QueryChallengeResultsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<ChallengeResultOrderByInput>;
  skip?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<ChallengeResultWhereInput>;
};

export type QueryChallengeResultsConnectionArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<ChallengeResultOrderByInput>;
  skip?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<ChallengeResultWhereInput>;
};

export type QueryChallengesArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<ChallengeOrderByInput>;
  skip?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<ChallengeWhereInput>;
};

export type QueryChallengesConnectionArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<ChallengeOrderByInput>;
  skip?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<ChallengeWhereInput>;
};

export type QueryCoachesArgs = {
  filter?: InputMaybe<UsersFilterArguments>;
};

export type QueryContactDetailsArgs = {
  where: ContactDetailsWhereUniqueInput;
};

export type QueryContactDetailsesArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<ContactDetailsOrderByInput>;
  skip?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<ContactDetailsWhereInput>;
};

export type QueryContactDetailsesConnectionArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<ContactDetailsOrderByInput>;
  skip?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<ContactDetailsWhereInput>;
};

export type QueryCouponArgs = {
  where: CouponWhereUniqueInput;
};

export type QueryCouponsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<CouponOrderByInput>;
  skip?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<CouponWhereInput>;
};

export type QueryCouponsConnectionArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<CouponOrderByInput>;
  skip?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<CouponWhereInput>;
};

export type QueryCourseGroupArgs = {
  where: CourseGroupWhereUniqueInput;
};

export type QueryCourseGroupsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<CourseGroupOrderByInput>;
  skip?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<CourseGroupWhereInput>;
};

export type QueryCourseGroupsConnectionArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<CourseGroupOrderByInput>;
  skip?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<CourseGroupWhereInput>;
};

export type QueryCourseGroupsSearchArgs = {
  filter?: InputMaybe<CourseGroupsFilterInput>;
};

export type QueryDemoStudentsArgs = {
  filter?: InputMaybe<UsersFilterArguments>;
};

export type QueryEducationGroupArgs = {
  where: EducationGroupWhereUniqueInput;
};

export type QueryEducationGroupsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<EducationGroupOrderByInput>;
  skip?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<EducationGroupWhereInput>;
};

export type QueryExerciseArgs = {
  where: ExerciseWhereUniqueInput;
};

export type QueryExercisesArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<ExerciseOrderByInput>;
  skip?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<ExerciseWhereInput>;
};

export type QueryExercisesConnectionArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<ExerciseOrderByInput>;
  skip?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<ExerciseWhereInput>;
};

export type QueryGameUserArgs = {
  where: GameUserWhereUniqueInput;
};

export type QueryGameUserKwouwselAccessoriesArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<GameUserKwouwselAccessoryOrderByInput>;
  skip?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<GameUserKwouwselAccessoryWhereInput>;
};

export type QueryGameUserKwouwselAccessoriesConnectionArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<GameUserKwouwselAccessoryOrderByInput>;
  skip?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<GameUserKwouwselAccessoryWhereInput>;
};

export type QueryGameUserKwouwselAccessoryArgs = {
  where: GameUserKwouwselAccessoryWhereUniqueInput;
};

export type QueryGameUserKwouwselUpgradeArgs = {
  where: GameUserKwouwselUpgradeWhereUniqueInput;
};

export type QueryGameUserKwouwselUpgradesArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<GameUserKwouwselUpgradeOrderByInput>;
  skip?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<GameUserKwouwselUpgradeWhereInput>;
};

export type QueryGameUserKwouwselUpgradesConnectionArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<GameUserKwouwselUpgradeOrderByInput>;
  skip?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<GameUserKwouwselUpgradeWhereInput>;
};

export type QueryGameUsersArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<GameUserOrderByInput>;
  skip?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<GameUserWhereInput>;
};

export type QueryGameUsersConnectionArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<GameUserOrderByInput>;
  skip?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<GameUserWhereInput>;
};

export type QueryInstitutionsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  skip?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<InstitutionsWhereInput>;
};

export type QueryKwouwselAccessoriesArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<KwouwselAccessoryOrderByInput>;
  skip?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<KwouwselAccessoryWhereInput>;
};

export type QueryKwouwselAccessoriesConnectionArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<KwouwselAccessoryOrderByInput>;
  skip?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<KwouwselAccessoryWhereInput>;
};

export type QueryKwouwselAccessoryArgs = {
  where: KwouwselAccessoryWhereUniqueInput;
};

export type QueryKwouwselUpgradeArgs = {
  where: KwouwselUpgradeWhereUniqueInput;
};

export type QueryKwouwselUpgradesArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<KwouwselUpgradeOrderByInput>;
  skip?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<KwouwselUpgradeWhereInput>;
};

export type QueryKwouwselUpgradesConnectionArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<KwouwselUpgradeOrderByInput>;
  skip?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<KwouwselUpgradeWhereInput>;
};

export type QueryLevelArgs = {
  where: LevelWhereUniqueInput;
};

export type QueryLevelSettingArgs = {
  where: LevelSettingWhereUniqueInput;
};

export type QueryLevelSettingsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<LevelSettingOrderByInput>;
  skip?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<LevelSettingWhereInput>;
};

export type QueryLevelSettingsConnectionArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<LevelSettingOrderByInput>;
  skip?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<LevelSettingWhereInput>;
};

export type QueryLevelsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<LevelOrderByInput>;
  skip?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<LevelWhereInput>;
};

export type QueryLevelsConnectionArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<LevelOrderByInput>;
  skip?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<LevelWhereInput>;
};

export type QueryLicenseArgs = {
  where: LicenseWhereUniqueInput;
};

export type QueryLicensePoolArgs = {
  where: LicensePoolWhereUniqueInput;
};

export type QueryLicensePoolsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<LicensePoolOrderByInput>;
  skip?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<LicensePoolWhereInput>;
};

export type QueryLicensePoolsConnectionArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<LicensePoolOrderByInput>;
  skip?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<LicensePoolWhereInput>;
};

export type QueryLicenseSubscriptionInfoArgs = {
  where: LicenseSubscriptionInfoWhereUniqueInput;
};

export type QueryLicenseSubscriptionInfoesArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<LicenseSubscriptionInfoOrderByInput>;
  skip?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<LicenseSubscriptionInfoWhereInput>;
};

export type QueryLicenseSubscriptionInfoesConnectionArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<LicenseSubscriptionInfoOrderByInput>;
  skip?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<LicenseSubscriptionInfoWhereInput>;
};

export type QueryLicensesArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<LicenseOrderByInput>;
  skip?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<LicenseWhereInput>;
};

export type QueryLicensesConnectionArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<LicenseOrderByInput>;
  skip?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<LicenseWhereInput>;
};

export type QueryLowerThan40AccuracyArgs = {
  courseGroupId?: InputMaybe<Scalars['ID']>;
};

export type QueryLowerThan50CpmArgs = {
  courseGroupId?: InputMaybe<Scalars['ID']>;
};

export type QueryMessageArgs = {
  id: Scalars['String'];
};

export type QueryNotPlayed3DaysArgs = {
  courseGroupId?: InputMaybe<Scalars['ID']>;
};

export type QueryNoteArgs = {
  where: NoteWhereUniqueInput;
};

export type QueryNotesArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<NoteOrderByInput>;
  skip?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<NoteWhereInput>;
};

export type QueryNotesConnectionArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<NoteOrderByInput>;
  skip?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<NoteWhereInput>;
};

export type QueryPartnerArgs = {
  where: PartnerWhereUniqueInput;
};

export type QueryPartnerManagersArgs = {
  filter?: InputMaybe<UsersFilterArguments>;
};

export type QueryPartnersArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<PartnerOrderByInput>;
  skip?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<PartnerWhereInput>;
};

export type QueryPartnersConnectionArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<PartnerOrderByInput>;
  skip?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<PartnerWhereInput>;
};

export type QueryPartnersSearchArgs = {
  filter?: InputMaybe<PartnerSearchFilterInput>;
};

export type QuerySchoolArgs = {
  where: SchoolWhereUniqueInput;
};

export type QuerySchoolDistrictArgs = {
  where: SchoolDistrictWhereUniqueInput;
};

export type QuerySchoolDistrictManagersArgs = {
  filter?: InputMaybe<UsersFilterArguments>;
};

export type QuerySchoolDistrictsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<SchoolDistrictOrderByInput>;
  skip?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<SchoolDistrictWhereInput>;
};

export type QuerySchoolDistrictsConnectionArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<SchoolDistrictOrderByInput>;
  skip?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<SchoolDistrictWhereInput>;
};

export type QuerySchoolDistrictsSearchArgs = {
  filter?: InputMaybe<SchoolDistrictSearchFilterInput>;
};

export type QuerySchoolManagersArgs = {
  filter?: InputMaybe<UsersFilterArguments>;
};

export type QuerySchoolsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<SchoolOrderByInput>;
  skip?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<SchoolWhereInput>;
};

export type QuerySchoolsConnectionArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<SchoolOrderByInput>;
  skip?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<SchoolWhereInput>;
};

export type QuerySchoolsSearchArgs = {
  filter?: InputMaybe<SchoolSearchFilterInput>;
};

export type QuerySearchBasispoortSchoolsArgs = {
  where?: InputMaybe<BasispoortSchoolWhereInput>;
};

export type QuerySearchSchoolAddressArgs = {
  addressContains?: InputMaybe<Scalars['String']>;
  brinNumberIs?: InputMaybe<Scalars['String']>;
  nameContains?: InputMaybe<Scalars['String']>;
  postalCodeContains?: InputMaybe<Scalars['String']>;
};

export type QuerySearchStudentsArgs = {
  data: SearchUsersInput;
};

export type QuerySkillCourseArgs = {
  where: SkillCourseWhereUniqueInput;
};

export type QuerySkillCoursesArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<SkillCourseOrderByInput>;
  skip?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<SkillCourseWhereInput>;
};

export type QuerySkillCoursesConnectionArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<SkillCourseOrderByInput>;
  skip?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<SkillCourseWhereInput>;
};

export type QueryStudentsArgs = {
  filter?: InputMaybe<UsersFilterArguments>;
};

export type QuerySystemMessagesArgs = {
  first?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<MessageOrderByInput>;
  skip?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<SystemMessageWhereInput>;
};

export type QueryTeamleaderCompaniesArgs = {
  where?: InputMaybe<TeamleaderCompaniesWhereInput>;
};

export type QueryTop5AccuracyArgs = {
  courseGroupId?: InputMaybe<Scalars['ID']>;
};

export type QueryTop5CpmArgs = {
  courseGroupId?: InputMaybe<Scalars['ID']>;
};

export type QueryTop5PlaytimeArgs = {
  courseGroupId?: InputMaybe<Scalars['ID']>;
};

export type QueryUserArgs = {
  where: UserWhereUniqueInput;
};

export type QueryUserLevelArgs = {
  where: UserLevelWhereUniqueInput;
};

export type QueryUserLevelsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<UserLevelOrderByInput>;
  skip?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<UserLevelWhereInput>;
};

export type QueryUserLevelsConnectionArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<UserLevelOrderByInput>;
  skip?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<UserLevelWhereInput>;
};

export type QueryUsernameExistsArgs = {
  data?: InputMaybe<UsernameExistsInput>;
};

export type QueryValidateCouponArgs = {
  slug: Scalars['String'];
};

export type ReactivateSubscriptionInput = {
  resource?: InputMaybe<ResourceInput>;
};

export type Recipient = {
  readAt?: Maybe<Scalars['DateTime']>;
  user?: Maybe<User>;
};

export type RecipientWhereInput = {
  AND?: InputMaybe<Array<RecipientWhereInput>>;
  NOT?: InputMaybe<Array<RecipientWhereInput>>;
  OR?: InputMaybe<Array<RecipientWhereInput>>;
  message?: InputMaybe<MessageWhereInput>;
  message_id?: InputMaybe<Scalars['String']>;
  recipient_id?: InputMaybe<Scalars['String']>;
};

export type RecipientsFilter = {
  every?: InputMaybe<RecipientWhereInput>;
  none?: InputMaybe<RecipientWhereInput>;
  some?: InputMaybe<RecipientWhereInput>;
};

export type RefreshTokenInput = {
  userId: Scalars['String'];
};

export type RegisterDemoUserInput = {
  keyboardLayout?: InputMaybe<KeyboardLayout>;
};

export type RegisterOrganisationInput = {
  acceptsDataProcessingAgreement: Scalars['Boolean'];
  acceptsTermsAndConditions: Scalars['Boolean'];
  address: RequiredContactDetailsInput;
  brinNumber?: InputMaybe<Scalars['String']>;
  chamberOfCommerceNumber?: InputMaybe<Scalars['String']>;
  copyEmail?: InputMaybe<Scalars['String']>;
  defaultKeyboardLayout?: InputMaybe<KeyboardLayout>;
  email: Scalars['String'];
  institution?: InputMaybe<InstitutionInput>;
  invoiceInfo?: InputMaybe<ContactDetailsInput>;
  /**
   * Required if organisation type is SCHOOL_DISTRICT
   * If false licenseSubscription is ignored.
   */
  invoiceSelf?: InputMaybe<Scalars['Boolean']>;
  licenseSubscription?: InputMaybe<LicenseInfoInput>;
  name: Scalars['String'];
  organisationType: OrganisationType;
  phone: Scalars['String'];
  requestsBasispoortConnection?: InputMaybe<Scalars['Boolean']>;
  user: OrganisationUserInput;
};

export type RegisterOrganisationResult = School | SchoolDistrict;

export type RegisterPartnerInput = {
  acceptsDataProcessingAgreement: Scalars['Boolean'];
  activeSubscription: Scalars['Boolean'];
  address: ContactDetailsInput;
  amountOfLicenses: Scalars['Int'];
  chamberOfCommerceNumber?: InputMaybe<Scalars['String']>;
  copyEmail?: InputMaybe<Scalars['String']>;
  email: Scalars['String'];
  invoiceInfo?: InputMaybe<ContactDetailsInput>;
  name: Scalars['String'];
  phone: Scalars['String'];
  user: OrganisationUserInput;
};

export type RegisterSchoolDistrictInput = {
  acceptsDataProcessingAgreement: Scalars['Boolean'];
  acceptsTermsAndConditions: Scalars['Boolean'];
  address: RequiredContactDetailsInput;
  brinNumber?: InputMaybe<Scalars['String']>;
  chamberOfCommerceNumber?: InputMaybe<Scalars['String']>;
  copyEmail?: InputMaybe<Scalars['String']>;
  email: Scalars['String'];
  institution?: InputMaybe<InstitutionInput>;
  invoiceInfo?: InputMaybe<ContactDetailsInput>;
  /**
   * Required if organisation type is SCHOOL_DISTRICT
   * If false licensesubscription is ignored.
   */
  invoiceSelf?: InputMaybe<Scalars['Boolean']>;
  licenseSubscription: LicenseInfoInput;
  name: Scalars['String'];
  partnerId?: InputMaybe<Scalars['String']>;
  phone: Scalars['String'];
  user: OrganisationUserInput;
};

export type RegisterSchoolInput = {
  acceptsDataProcessingAgreement: Scalars['Boolean'];
  acceptsTermsAndConditions: Scalars['Boolean'];
  address: RequiredContactDetailsInput;
  basispoortId?: InputMaybe<Scalars['Int']>;
  brinNumber?: InputMaybe<Scalars['String']>;
  canEditKeyboardLayout?: InputMaybe<Scalars['Boolean']>;
  chamberOfCommerceNumber?: InputMaybe<Scalars['String']>;
  copyEmail?: InputMaybe<Scalars['String']>;
  defaultKeyboardLayout?: InputMaybe<KeyboardLayout>;
  email: Scalars['String'];
  generalEmailForEmailNotifications?: InputMaybe<Scalars['String']>;
  institution?: InputMaybe<InstitutionInput>;
  invoiceInfo?: InputMaybe<ContactDetailsInput>;
  licenseSubscription: LicenseInfoInput;
  name: Scalars['String'];
  organisationType: SchoolOrganisationType;
  partnerId?: InputMaybe<Scalars['String']>;
  phone: Scalars['String'];
  schoolDistrictId?: InputMaybe<Scalars['String']>;
  subscribedToDiplomaEmails?: InputMaybe<Scalars['Boolean']>;
  subscribedToEmails?: InputMaybe<Scalars['Boolean']>;
  subscribedToStudentReportEmails?: InputMaybe<Scalars['Boolean']>;
  user: OrganisationUserInput;
};

export type RepliesFilter = {
  every?: InputMaybe<MessageWhereInput>;
  none?: InputMaybe<MessageWhereInput>;
  some?: InputMaybe<MessageWhereInput>;
};

export type ReplyToMessageInput = {
  content: Scalars['String'];
  messageId: Scalars['String'];
  sendAs?: InputMaybe<Scalars['ID']>;
};

export type RequiredContactDetailsInput = {
  city: Scalars['String'];
  companyName?: InputMaybe<Scalars['String']>;
  contact?: InputMaybe<Scalars['String']>;
  country: Scalars['String'];
  number: Scalars['String'];
  phone?: InputMaybe<Scalars['String']>;
  postalCode: Scalars['String'];
  street: Scalars['String'];
};

export type ResetExamInput = {
  challengeRequestId: Scalars['ID'];
  user: GameUserWhereUniqueInput;
};

export type ResourceInput = {
  resource?: InputMaybe<ResourceType>;
  resourceId: Scalars['String'];
};

export type ResourceType = 'PARTNER' | 'SCHOOL' | 'SCHOOL_DISTRICT';

export type ResponseTimePerCharacter = {
  set: Array<Maybe<Scalars['Float']>>;
};

export type ResponseTimePerCharacterInput = {
  set: Array<InputMaybe<Scalars['Float']>>;
};

export type Role =
  | 'ADMIN'
  | 'COACH'
  | 'DEMO_STUDENT'
  | 'MANAGER'
  | 'PARTNER_MANAGER'
  | 'SCHOOL_DISTRICT_MANAGER'
  | 'STUDENT';

export type SbPartnerUpdateOneWithoutSchoolDistrictsInput = {
  connect?: InputMaybe<PartnerWhereUniqueInput>;
  disconnect?: InputMaybe<Scalars['Boolean']>;
};

export type SbPartnerUpdateOneWithoutSchoolsInput = {
  connect?: InputMaybe<PartnerWhereUniqueInput>;
  disconnect?: InputMaybe<Scalars['Boolean']>;
};

export type SbSchoolDistrictUpdateManyWithoutPartnerInput = {
  connect?: InputMaybe<Array<SchoolDistrictWhereUniqueInput>>;
  disconnect?: InputMaybe<Array<SchoolDistrictWhereUniqueInput>>;
  set?: InputMaybe<Array<SchoolDistrictWhereUniqueInput>>;
};

export type SbSchoolUpdateManyWithoutPartnerInput = {
  connect?: InputMaybe<Array<SchoolWhereUniqueInput>>;
  disconnect?: InputMaybe<Array<SchoolWhereUniqueInput>>;
  set?: InputMaybe<Array<SchoolWhereUniqueInput>>;
};

export type SbSchoolUpdateManyWithoutSchoolDistrictInput = {
  connect?: InputMaybe<Array<SchoolWhereUniqueInput>>;
  disconnect?: InputMaybe<Array<SchoolWhereUniqueInput>>;
  set?: InputMaybe<Array<SchoolWhereUniqueInput>>;
};

export type School = {
  acceptsDataProcessingAgreement: Scalars['Boolean'];
  acceptsTermsAndConditions: Scalars['Boolean'];
  accessRequests: Array<AccessRequest>;
  activated: Scalars['Boolean'];
  address: ContactDetails;
  archivedUsers: ArchivedUsersWithCount;
  basispoortId?: Maybe<Scalars['Int']>;
  basispoortSyncStartedAt?: Maybe<Scalars['DateTime']>;
  brinNumber?: Maybe<Scalars['String']>;
  canEditKeyboardLayout: Scalars['Boolean'];
  chamberOfCommerceNumber?: Maybe<Scalars['String']>;
  coaches?: Maybe<UsersFilterMessage>;
  copyEmail?: Maybe<Scalars['String']>;
  courseGroups: CourseGroupSearchResult;
  createdAt: Scalars['DateTime'];
  defaultKeyboardLayout: KeyboardLayout;
  email: Scalars['String'];
  generalEmailForEmailNotifications?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  institutionDataSource?: Maybe<InstitutionDataSource>;
  institutionId?: Maybe<Scalars['String']>;
  invoiceInfo?: Maybe<ContactDetails>;
  isAuthorisedByBasispoort?: Maybe<Scalars['Boolean']>;
  isSyncedWithBasispoort: Scalars['Boolean'];
  licensePool: LicensePool;
  licenseSubscription?: Maybe<LicenseSubscriptionInfo>;
  managers?: Maybe<UsersFilterMessage>;
  name: Scalars['String'];
  organisationType: SchoolOrganisationType;
  partner?: Maybe<Partner>;
  phone: Scalars['String'];
  receivedSignedDataProcessingAgreement: Scalars['Boolean'];
  requestsBasispoortConnection?: Maybe<Scalars['Boolean']>;
  schoolDistrict?: Maybe<SchoolDistrict>;
  students?: Maybe<UsersFilterMessage>;
  subscribedToDiplomaEmails: Scalars['Boolean'];
  subscribedToEmails: Scalars['Boolean'];
  subscribedToStudentReportEmails: Scalars['Boolean'];
  teamleaderID: Scalars['String'];
  updatedAt: Scalars['DateTime'];
  userLastLoginCount?: Maybe<Scalars['Int']>;
};

export type SchoolArchivedUsersArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<ArchivedUserOrderByInput>;
  skip?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<ArchivedUserWhereInput>;
};

export type SchoolCoachesArgs = {
  filter?: InputMaybe<UsersFilterArguments>;
};

export type SchoolCourseGroupsArgs = {
  filter?: InputMaybe<CourseGroupsFilterInput>;
};

export type SchoolManagersArgs = {
  filter?: InputMaybe<UsersFilterArguments>;
};

export type SchoolStudentsArgs = {
  filter?: InputMaybe<UsersFilterArguments>;
};

export type SchoolConnection = {
  aggregate: AggregateSchool;
  edges: Array<Maybe<SchoolEdge>>;
  pageInfo: PageInfo;
};

export type SchoolCreateInput = {
  acceptsDataProcessingAgreement: Scalars['Boolean'];
  acceptsTermsAndConditions: Scalars['Boolean'];
  accessRequests?: InputMaybe<AccessRequestCreateManyWithoutSchoolInput>;
  activated?: InputMaybe<Scalars['Boolean']>;
  address: ContactDetailsCreateOneInput;
  brinNumber?: InputMaybe<Scalars['String']>;
  canEditKeyboardLayout?: InputMaybe<Scalars['Boolean']>;
  chamberOfCommerceNumber?: InputMaybe<Scalars['String']>;
  copyEmail?: InputMaybe<Scalars['String']>;
  courseGroups?: InputMaybe<CourseGroupCreateManyWithoutSchoolInput>;
  defaultKeyboardLayout?: InputMaybe<KeyboardLayout>;
  email: Scalars['String'];
  id?: InputMaybe<Scalars['ID']>;
  institutionDataSource?: InputMaybe<InstitutionDataSource>;
  institutionId?: InputMaybe<Scalars['String']>;
  invoiceInfo?: InputMaybe<ContactDetailsCreateOneInput>;
  licensePool: LicensePoolCreateOneInput;
  licenseSubscription?: InputMaybe<LicenseSubscriptionInfoCreateOneInput>;
  name: Scalars['String'];
  organisationType: SchoolOrganisationType;
  partner?: InputMaybe<PartnerCreateOneWithoutSchoolsInput>;
  phone: Scalars['String'];
  previousSubscriptions?: InputMaybe<LicenseSubscriptionInfoCreateManyInput>;
  receivedSignedDataProcessingAgreement?: InputMaybe<Scalars['Boolean']>;
  schoolDistrict?: InputMaybe<SchoolDistrictCreateOneWithoutSchoolsInput>;
  subscribedToEmails?: InputMaybe<Scalars['Boolean']>;
  teamleaderID: Scalars['String'];
  users?: InputMaybe<BeheerUserCreateManyWithoutSchoolsInput>;
};

export type SchoolCreateManyWithoutPartnerInput = {
  connect?: InputMaybe<Array<SchoolWhereUniqueInput>>;
  create?: InputMaybe<Array<SchoolCreateWithoutPartnerInput>>;
};

export type SchoolCreateManyWithoutSchoolDistrictInput = {
  connect?: InputMaybe<Array<SchoolWhereUniqueInput>>;
  create?: InputMaybe<Array<SchoolCreateWithoutSchoolDistrictInput>>;
};

export type SchoolCreateManyWithoutUsersInput = {
  connect?: InputMaybe<Array<SchoolWhereUniqueInput>>;
  create?: InputMaybe<Array<SchoolCreateWithoutUsersInput>>;
};

export type SchoolCreateOneWithoutAccessRequestsInput = {
  connect?: InputMaybe<SchoolWhereUniqueInput>;
  create?: InputMaybe<SchoolCreateWithoutAccessRequestsInput>;
};

export type SchoolCreateOneWithoutCourseGroupsInput = {
  connect?: InputMaybe<SchoolWhereUniqueInput>;
  create?: InputMaybe<SchoolCreateWithoutCourseGroupsInput>;
};

export type SchoolCreateWithoutAccessRequestsInput = {
  acceptsDataProcessingAgreement: Scalars['Boolean'];
  acceptsTermsAndConditions: Scalars['Boolean'];
  activated?: InputMaybe<Scalars['Boolean']>;
  address: ContactDetailsCreateOneInput;
  brinNumber?: InputMaybe<Scalars['String']>;
  canEditKeyboardLayout?: InputMaybe<Scalars['Boolean']>;
  chamberOfCommerceNumber?: InputMaybe<Scalars['String']>;
  copyEmail?: InputMaybe<Scalars['String']>;
  courseGroups?: InputMaybe<CourseGroupCreateManyWithoutSchoolInput>;
  defaultKeyboardLayout?: InputMaybe<KeyboardLayout>;
  email: Scalars['String'];
  id?: InputMaybe<Scalars['ID']>;
  institutionDataSource?: InputMaybe<InstitutionDataSource>;
  institutionId?: InputMaybe<Scalars['String']>;
  invoiceInfo?: InputMaybe<ContactDetailsCreateOneInput>;
  licensePool: LicensePoolCreateOneInput;
  licenseSubscription?: InputMaybe<LicenseSubscriptionInfoCreateOneInput>;
  name: Scalars['String'];
  organisationType: SchoolOrganisationType;
  partner?: InputMaybe<PartnerCreateOneWithoutSchoolsInput>;
  phone: Scalars['String'];
  previousSubscriptions?: InputMaybe<LicenseSubscriptionInfoCreateManyInput>;
  receivedSignedDataProcessingAgreement?: InputMaybe<Scalars['Boolean']>;
  schoolDistrict?: InputMaybe<SchoolDistrictCreateOneWithoutSchoolsInput>;
  subscribedToEmails?: InputMaybe<Scalars['Boolean']>;
  teamleaderID: Scalars['String'];
  users?: InputMaybe<BeheerUserCreateManyWithoutSchoolsInput>;
};

export type SchoolCreateWithoutCourseGroupsInput = {
  acceptsDataProcessingAgreement: Scalars['Boolean'];
  acceptsTermsAndConditions: Scalars['Boolean'];
  accessRequests?: InputMaybe<AccessRequestCreateManyWithoutSchoolInput>;
  activated?: InputMaybe<Scalars['Boolean']>;
  address: ContactDetailsCreateOneInput;
  brinNumber?: InputMaybe<Scalars['String']>;
  canEditKeyboardLayout?: InputMaybe<Scalars['Boolean']>;
  chamberOfCommerceNumber?: InputMaybe<Scalars['String']>;
  copyEmail?: InputMaybe<Scalars['String']>;
  defaultKeyboardLayout?: InputMaybe<KeyboardLayout>;
  email: Scalars['String'];
  id?: InputMaybe<Scalars['ID']>;
  institutionDataSource?: InputMaybe<InstitutionDataSource>;
  institutionId?: InputMaybe<Scalars['String']>;
  invoiceInfo?: InputMaybe<ContactDetailsCreateOneInput>;
  licensePool: LicensePoolCreateOneInput;
  licenseSubscription?: InputMaybe<LicenseSubscriptionInfoCreateOneInput>;
  name: Scalars['String'];
  organisationType: SchoolOrganisationType;
  partner?: InputMaybe<PartnerCreateOneWithoutSchoolsInput>;
  phone: Scalars['String'];
  previousSubscriptions?: InputMaybe<LicenseSubscriptionInfoCreateManyInput>;
  receivedSignedDataProcessingAgreement?: InputMaybe<Scalars['Boolean']>;
  schoolDistrict?: InputMaybe<SchoolDistrictCreateOneWithoutSchoolsInput>;
  subscribedToEmails?: InputMaybe<Scalars['Boolean']>;
  teamleaderID: Scalars['String'];
  users?: InputMaybe<BeheerUserCreateManyWithoutSchoolsInput>;
};

export type SchoolCreateWithoutPartnerInput = {
  acceptsDataProcessingAgreement: Scalars['Boolean'];
  acceptsTermsAndConditions: Scalars['Boolean'];
  accessRequests?: InputMaybe<AccessRequestCreateManyWithoutSchoolInput>;
  activated?: InputMaybe<Scalars['Boolean']>;
  address: ContactDetailsCreateOneInput;
  brinNumber?: InputMaybe<Scalars['String']>;
  canEditKeyboardLayout?: InputMaybe<Scalars['Boolean']>;
  chamberOfCommerceNumber?: InputMaybe<Scalars['String']>;
  copyEmail?: InputMaybe<Scalars['String']>;
  courseGroups?: InputMaybe<CourseGroupCreateManyWithoutSchoolInput>;
  defaultKeyboardLayout?: InputMaybe<KeyboardLayout>;
  email: Scalars['String'];
  id?: InputMaybe<Scalars['ID']>;
  institutionDataSource?: InputMaybe<InstitutionDataSource>;
  institutionId?: InputMaybe<Scalars['String']>;
  invoiceInfo?: InputMaybe<ContactDetailsCreateOneInput>;
  licensePool: LicensePoolCreateOneInput;
  licenseSubscription?: InputMaybe<LicenseSubscriptionInfoCreateOneInput>;
  name: Scalars['String'];
  organisationType: SchoolOrganisationType;
  phone: Scalars['String'];
  previousSubscriptions?: InputMaybe<LicenseSubscriptionInfoCreateManyInput>;
  receivedSignedDataProcessingAgreement?: InputMaybe<Scalars['Boolean']>;
  schoolDistrict?: InputMaybe<SchoolDistrictCreateOneWithoutSchoolsInput>;
  subscribedToEmails?: InputMaybe<Scalars['Boolean']>;
  teamleaderID: Scalars['String'];
  users?: InputMaybe<BeheerUserCreateManyWithoutSchoolsInput>;
};

export type SchoolCreateWithoutSchoolDistrictInput = {
  acceptsDataProcessingAgreement: Scalars['Boolean'];
  acceptsTermsAndConditions: Scalars['Boolean'];
  accessRequests?: InputMaybe<AccessRequestCreateManyWithoutSchoolInput>;
  activated?: InputMaybe<Scalars['Boolean']>;
  address: ContactDetailsCreateOneInput;
  brinNumber?: InputMaybe<Scalars['String']>;
  canEditKeyboardLayout?: InputMaybe<Scalars['Boolean']>;
  chamberOfCommerceNumber?: InputMaybe<Scalars['String']>;
  copyEmail?: InputMaybe<Scalars['String']>;
  courseGroups?: InputMaybe<CourseGroupCreateManyWithoutSchoolInput>;
  defaultKeyboardLayout?: InputMaybe<KeyboardLayout>;
  email: Scalars['String'];
  id?: InputMaybe<Scalars['ID']>;
  institutionDataSource?: InputMaybe<InstitutionDataSource>;
  institutionId?: InputMaybe<Scalars['String']>;
  invoiceInfo?: InputMaybe<ContactDetailsCreateOneInput>;
  licensePool: LicensePoolCreateOneInput;
  licenseSubscription?: InputMaybe<LicenseSubscriptionInfoCreateOneInput>;
  name: Scalars['String'];
  organisationType: SchoolOrganisationType;
  partner?: InputMaybe<PartnerCreateOneWithoutSchoolsInput>;
  phone: Scalars['String'];
  previousSubscriptions?: InputMaybe<LicenseSubscriptionInfoCreateManyInput>;
  receivedSignedDataProcessingAgreement?: InputMaybe<Scalars['Boolean']>;
  subscribedToEmails?: InputMaybe<Scalars['Boolean']>;
  teamleaderID: Scalars['String'];
  users?: InputMaybe<BeheerUserCreateManyWithoutSchoolsInput>;
};

export type SchoolCreateWithoutUsersInput = {
  acceptsDataProcessingAgreement: Scalars['Boolean'];
  acceptsTermsAndConditions: Scalars['Boolean'];
  accessRequests?: InputMaybe<AccessRequestCreateManyWithoutSchoolInput>;
  activated?: InputMaybe<Scalars['Boolean']>;
  address: ContactDetailsCreateOneInput;
  brinNumber?: InputMaybe<Scalars['String']>;
  canEditKeyboardLayout?: InputMaybe<Scalars['Boolean']>;
  chamberOfCommerceNumber?: InputMaybe<Scalars['String']>;
  copyEmail?: InputMaybe<Scalars['String']>;
  courseGroups?: InputMaybe<CourseGroupCreateManyWithoutSchoolInput>;
  defaultKeyboardLayout?: InputMaybe<KeyboardLayout>;
  email: Scalars['String'];
  id?: InputMaybe<Scalars['ID']>;
  institutionDataSource?: InputMaybe<InstitutionDataSource>;
  institutionId?: InputMaybe<Scalars['String']>;
  invoiceInfo?: InputMaybe<ContactDetailsCreateOneInput>;
  licensePool: LicensePoolCreateOneInput;
  licenseSubscription?: InputMaybe<LicenseSubscriptionInfoCreateOneInput>;
  name: Scalars['String'];
  organisationType: SchoolOrganisationType;
  partner?: InputMaybe<PartnerCreateOneWithoutSchoolsInput>;
  phone: Scalars['String'];
  previousSubscriptions?: InputMaybe<LicenseSubscriptionInfoCreateManyInput>;
  receivedSignedDataProcessingAgreement?: InputMaybe<Scalars['Boolean']>;
  schoolDistrict?: InputMaybe<SchoolDistrictCreateOneWithoutSchoolsInput>;
  subscribedToEmails?: InputMaybe<Scalars['Boolean']>;
  teamleaderID: Scalars['String'];
};

export type SchoolDistrict = {
  acceptsDataProcessingAgreement: Scalars['Boolean'];
  acceptsTermsAndConditions: Scalars['Boolean'];
  activated: Scalars['Boolean'];
  address: ContactDetails;
  brinNumber?: Maybe<Scalars['String']>;
  chamberOfCommerceNumber?: Maybe<Scalars['String']>;
  copyEmail?: Maybe<Scalars['String']>;
  createdAt: Scalars['DateTime'];
  email: Scalars['String'];
  id: Scalars['ID'];
  institutionDataSource?: Maybe<InstitutionDataSource>;
  institutionId?: Maybe<Scalars['String']>;
  invoiceInfo?: Maybe<ContactDetails>;
  invoiceSelf: Scalars['Boolean'];
  licensePool: LicensePool;
  licenseSubscription?: Maybe<LicenseSubscriptionInfo>;
  managers?: Maybe<UsersFilterMessage>;
  name: Scalars['String'];
  partner?: Maybe<Partner>;
  phone: Scalars['String'];
  receivedSignedDataProcessingAgreement: Scalars['Boolean'];
  schools: SchoolSearchResult;
  teamleaderID: Scalars['String'];
  updatedAt: Scalars['DateTime'];
};

export type SchoolDistrictManagersArgs = {
  filter?: InputMaybe<UsersFilterArguments>;
};

export type SchoolDistrictSchoolsArgs = {
  filter?: InputMaybe<SchoolSearchFilterInput>;
};

export type SchoolDistrictConnection = {
  aggregate: AggregateSchoolDistrict;
  edges: Array<Maybe<SchoolDistrictEdge>>;
  pageInfo: PageInfo;
};

export type SchoolDistrictCreateInput = {
  acceptsDataProcessingAgreement: Scalars['Boolean'];
  acceptsTermsAndConditions: Scalars['Boolean'];
  activated?: InputMaybe<Scalars['Boolean']>;
  address: ContactDetailsCreateOneInput;
  brinNumber?: InputMaybe<Scalars['String']>;
  chamberOfCommerceNumber?: InputMaybe<Scalars['String']>;
  copyEmail?: InputMaybe<Scalars['String']>;
  email: Scalars['String'];
  id?: InputMaybe<Scalars['ID']>;
  institutionDataSource?: InputMaybe<InstitutionDataSource>;
  institutionId?: InputMaybe<Scalars['String']>;
  invoiceInfo?: InputMaybe<ContactDetailsCreateOneInput>;
  invoiceSelf?: InputMaybe<Scalars['Boolean']>;
  licensePool: LicensePoolCreateOneInput;
  licenseSubscription?: InputMaybe<LicenseSubscriptionInfoCreateOneInput>;
  name: Scalars['String'];
  partner?: InputMaybe<PartnerCreateOneWithoutSchoolDistrictsInput>;
  phone: Scalars['String'];
  previousSubscriptions?: InputMaybe<LicenseSubscriptionInfoCreateManyInput>;
  receivedSignedDataProcessingAgreement?: InputMaybe<Scalars['Boolean']>;
  schools?: InputMaybe<SchoolCreateManyWithoutSchoolDistrictInput>;
  teamleaderID: Scalars['String'];
  users?: InputMaybe<BeheerUserCreateManyWithoutSchoolDistrictsInput>;
};

export type SchoolDistrictCreateManyWithoutPartnerInput = {
  connect?: InputMaybe<Array<SchoolDistrictWhereUniqueInput>>;
  create?: InputMaybe<Array<SchoolDistrictCreateWithoutPartnerInput>>;
};

export type SchoolDistrictCreateManyWithoutUsersInput = {
  connect?: InputMaybe<Array<SchoolDistrictWhereUniqueInput>>;
  create?: InputMaybe<Array<SchoolDistrictCreateWithoutUsersInput>>;
};

export type SchoolDistrictCreateOneWithoutSchoolsInput = {
  connect?: InputMaybe<SchoolDistrictWhereUniqueInput>;
  create?: InputMaybe<SchoolDistrictCreateWithoutSchoolsInput>;
};

export type SchoolDistrictCreateWithoutPartnerInput = {
  acceptsDataProcessingAgreement: Scalars['Boolean'];
  acceptsTermsAndConditions: Scalars['Boolean'];
  activated?: InputMaybe<Scalars['Boolean']>;
  address: ContactDetailsCreateOneInput;
  brinNumber?: InputMaybe<Scalars['String']>;
  chamberOfCommerceNumber?: InputMaybe<Scalars['String']>;
  copyEmail?: InputMaybe<Scalars['String']>;
  email: Scalars['String'];
  id?: InputMaybe<Scalars['ID']>;
  institutionDataSource?: InputMaybe<InstitutionDataSource>;
  institutionId?: InputMaybe<Scalars['String']>;
  invoiceInfo?: InputMaybe<ContactDetailsCreateOneInput>;
  invoiceSelf?: InputMaybe<Scalars['Boolean']>;
  licensePool: LicensePoolCreateOneInput;
  licenseSubscription?: InputMaybe<LicenseSubscriptionInfoCreateOneInput>;
  name: Scalars['String'];
  phone: Scalars['String'];
  previousSubscriptions?: InputMaybe<LicenseSubscriptionInfoCreateManyInput>;
  receivedSignedDataProcessingAgreement?: InputMaybe<Scalars['Boolean']>;
  schools?: InputMaybe<SchoolCreateManyWithoutSchoolDistrictInput>;
  teamleaderID: Scalars['String'];
  users?: InputMaybe<BeheerUserCreateManyWithoutSchoolDistrictsInput>;
};

export type SchoolDistrictCreateWithoutSchoolsInput = {
  acceptsDataProcessingAgreement: Scalars['Boolean'];
  acceptsTermsAndConditions: Scalars['Boolean'];
  activated?: InputMaybe<Scalars['Boolean']>;
  address: ContactDetailsCreateOneInput;
  brinNumber?: InputMaybe<Scalars['String']>;
  chamberOfCommerceNumber?: InputMaybe<Scalars['String']>;
  copyEmail?: InputMaybe<Scalars['String']>;
  email: Scalars['String'];
  id?: InputMaybe<Scalars['ID']>;
  institutionDataSource?: InputMaybe<InstitutionDataSource>;
  institutionId?: InputMaybe<Scalars['String']>;
  invoiceInfo?: InputMaybe<ContactDetailsCreateOneInput>;
  invoiceSelf?: InputMaybe<Scalars['Boolean']>;
  licensePool: LicensePoolCreateOneInput;
  licenseSubscription?: InputMaybe<LicenseSubscriptionInfoCreateOneInput>;
  name: Scalars['String'];
  partner?: InputMaybe<PartnerCreateOneWithoutSchoolDistrictsInput>;
  phone: Scalars['String'];
  previousSubscriptions?: InputMaybe<LicenseSubscriptionInfoCreateManyInput>;
  receivedSignedDataProcessingAgreement?: InputMaybe<Scalars['Boolean']>;
  teamleaderID: Scalars['String'];
  users?: InputMaybe<BeheerUserCreateManyWithoutSchoolDistrictsInput>;
};

export type SchoolDistrictCreateWithoutUsersInput = {
  acceptsDataProcessingAgreement: Scalars['Boolean'];
  acceptsTermsAndConditions: Scalars['Boolean'];
  activated?: InputMaybe<Scalars['Boolean']>;
  address: ContactDetailsCreateOneInput;
  brinNumber?: InputMaybe<Scalars['String']>;
  chamberOfCommerceNumber?: InputMaybe<Scalars['String']>;
  copyEmail?: InputMaybe<Scalars['String']>;
  email: Scalars['String'];
  id?: InputMaybe<Scalars['ID']>;
  institutionDataSource?: InputMaybe<InstitutionDataSource>;
  institutionId?: InputMaybe<Scalars['String']>;
  invoiceInfo?: InputMaybe<ContactDetailsCreateOneInput>;
  invoiceSelf?: InputMaybe<Scalars['Boolean']>;
  licensePool: LicensePoolCreateOneInput;
  licenseSubscription?: InputMaybe<LicenseSubscriptionInfoCreateOneInput>;
  name: Scalars['String'];
  partner?: InputMaybe<PartnerCreateOneWithoutSchoolDistrictsInput>;
  phone: Scalars['String'];
  previousSubscriptions?: InputMaybe<LicenseSubscriptionInfoCreateManyInput>;
  receivedSignedDataProcessingAgreement?: InputMaybe<Scalars['Boolean']>;
  schools?: InputMaybe<SchoolCreateManyWithoutSchoolDistrictInput>;
  teamleaderID: Scalars['String'];
};

export type SchoolDistrictEdge = {
  cursor: Scalars['String'];
  node: SchoolDistrict;
};

export type SchoolDistrictOrderByColumns =
  | 'city'
  | 'contact'
  | 'email'
  | 'id'
  | 'invoiceSelf'
  | 'licenseSubscriptionActive'
  | 'licensesInUse'
  | 'licensesRemaining'
  | 'licensesTotal'
  | 'name'
  | 'renewalDate';

export type SchoolDistrictOrderByInput =
  | 'acceptsDataProcessingAgreement_ASC'
  | 'acceptsDataProcessingAgreement_DESC'
  | 'acceptsTermsAndConditions_ASC'
  | 'acceptsTermsAndConditions_DESC'
  | 'activated_ASC'
  | 'activated_DESC'
  | 'brinNumber_ASC'
  | 'brinNumber_DESC'
  | 'chamberOfCommerceNumber_ASC'
  | 'chamberOfCommerceNumber_DESC'
  | 'copyEmail_ASC'
  | 'copyEmail_DESC'
  | 'createdAt_ASC'
  | 'createdAt_DESC'
  | 'email_ASC'
  | 'email_DESC'
  | 'id_ASC'
  | 'id_DESC'
  | 'institutionDataSource_ASC'
  | 'institutionDataSource_DESC'
  | 'institutionId_ASC'
  | 'institutionId_DESC'
  | 'invoiceSelf_ASC'
  | 'invoiceSelf_DESC'
  | 'name_ASC'
  | 'name_DESC'
  | 'phone_ASC'
  | 'phone_DESC'
  | 'receivedSignedDataProcessingAgreement_ASC'
  | 'receivedSignedDataProcessingAgreement_DESC'
  | 'teamleaderID_ASC'
  | 'teamleaderID_DESC'
  | 'updatedAt_ASC'
  | 'updatedAt_DESC';

export type SchoolDistrictPreviousValues = {
  acceptsDataProcessingAgreement: Scalars['Boolean'];
  acceptsTermsAndConditions: Scalars['Boolean'];
  activated: Scalars['Boolean'];
  brinNumber?: Maybe<Scalars['String']>;
  chamberOfCommerceNumber?: Maybe<Scalars['String']>;
  copyEmail?: Maybe<Scalars['String']>;
  createdAt: Scalars['DateTime'];
  email: Scalars['String'];
  id: Scalars['ID'];
  institutionDataSource?: Maybe<InstitutionDataSource>;
  institutionId?: Maybe<Scalars['String']>;
  invoiceSelf: Scalars['Boolean'];
  name: Scalars['String'];
  phone: Scalars['String'];
  receivedSignedDataProcessingAgreement: Scalars['Boolean'];
  teamleaderID: Scalars['String'];
  updatedAt: Scalars['DateTime'];
};

export type SchoolDistrictScalarWhereInput = {
  AND?: InputMaybe<Array<SchoolDistrictScalarWhereInput>>;
  NOT?: InputMaybe<Array<SchoolDistrictScalarWhereInput>>;
  OR?: InputMaybe<Array<SchoolDistrictScalarWhereInput>>;
  acceptsDataProcessingAgreement?: InputMaybe<Scalars['Boolean']>;
  acceptsDataProcessingAgreement_not?: InputMaybe<Scalars['Boolean']>;
  acceptsTermsAndConditions?: InputMaybe<Scalars['Boolean']>;
  acceptsTermsAndConditions_not?: InputMaybe<Scalars['Boolean']>;
  activated?: InputMaybe<Scalars['Boolean']>;
  activated_not?: InputMaybe<Scalars['Boolean']>;
  brinNumber?: InputMaybe<Scalars['String']>;
  brinNumber_contains?: InputMaybe<Scalars['String']>;
  brinNumber_ends_with?: InputMaybe<Scalars['String']>;
  brinNumber_gt?: InputMaybe<Scalars['String']>;
  brinNumber_gte?: InputMaybe<Scalars['String']>;
  brinNumber_in?: InputMaybe<Array<Scalars['String']>>;
  brinNumber_lt?: InputMaybe<Scalars['String']>;
  brinNumber_lte?: InputMaybe<Scalars['String']>;
  brinNumber_not?: InputMaybe<Scalars['String']>;
  brinNumber_not_contains?: InputMaybe<Scalars['String']>;
  brinNumber_not_ends_with?: InputMaybe<Scalars['String']>;
  brinNumber_not_in?: InputMaybe<Array<Scalars['String']>>;
  brinNumber_not_starts_with?: InputMaybe<Scalars['String']>;
  brinNumber_starts_with?: InputMaybe<Scalars['String']>;
  chamberOfCommerceNumber?: InputMaybe<Scalars['String']>;
  chamberOfCommerceNumber_contains?: InputMaybe<Scalars['String']>;
  chamberOfCommerceNumber_ends_with?: InputMaybe<Scalars['String']>;
  chamberOfCommerceNumber_gt?: InputMaybe<Scalars['String']>;
  chamberOfCommerceNumber_gte?: InputMaybe<Scalars['String']>;
  chamberOfCommerceNumber_in?: InputMaybe<Array<Scalars['String']>>;
  chamberOfCommerceNumber_lt?: InputMaybe<Scalars['String']>;
  chamberOfCommerceNumber_lte?: InputMaybe<Scalars['String']>;
  chamberOfCommerceNumber_not?: InputMaybe<Scalars['String']>;
  chamberOfCommerceNumber_not_contains?: InputMaybe<Scalars['String']>;
  chamberOfCommerceNumber_not_ends_with?: InputMaybe<Scalars['String']>;
  chamberOfCommerceNumber_not_in?: InputMaybe<Array<Scalars['String']>>;
  chamberOfCommerceNumber_not_starts_with?: InputMaybe<Scalars['String']>;
  chamberOfCommerceNumber_starts_with?: InputMaybe<Scalars['String']>;
  copyEmail?: InputMaybe<Scalars['String']>;
  copyEmail_contains?: InputMaybe<Scalars['String']>;
  copyEmail_ends_with?: InputMaybe<Scalars['String']>;
  copyEmail_gt?: InputMaybe<Scalars['String']>;
  copyEmail_gte?: InputMaybe<Scalars['String']>;
  copyEmail_in?: InputMaybe<Array<Scalars['String']>>;
  copyEmail_lt?: InputMaybe<Scalars['String']>;
  copyEmail_lte?: InputMaybe<Scalars['String']>;
  copyEmail_not?: InputMaybe<Scalars['String']>;
  copyEmail_not_contains?: InputMaybe<Scalars['String']>;
  copyEmail_not_ends_with?: InputMaybe<Scalars['String']>;
  copyEmail_not_in?: InputMaybe<Array<Scalars['String']>>;
  copyEmail_not_starts_with?: InputMaybe<Scalars['String']>;
  copyEmail_starts_with?: InputMaybe<Scalars['String']>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  createdAt_gt?: InputMaybe<Scalars['DateTime']>;
  createdAt_gte?: InputMaybe<Scalars['DateTime']>;
  createdAt_in?: InputMaybe<Array<Scalars['DateTime']>>;
  createdAt_lt?: InputMaybe<Scalars['DateTime']>;
  createdAt_lte?: InputMaybe<Scalars['DateTime']>;
  createdAt_not?: InputMaybe<Scalars['DateTime']>;
  createdAt_not_in?: InputMaybe<Array<Scalars['DateTime']>>;
  email?: InputMaybe<Scalars['String']>;
  email_contains?: InputMaybe<Scalars['String']>;
  email_ends_with?: InputMaybe<Scalars['String']>;
  email_gt?: InputMaybe<Scalars['String']>;
  email_gte?: InputMaybe<Scalars['String']>;
  email_in?: InputMaybe<Array<Scalars['String']>>;
  email_lt?: InputMaybe<Scalars['String']>;
  email_lte?: InputMaybe<Scalars['String']>;
  email_not?: InputMaybe<Scalars['String']>;
  email_not_contains?: InputMaybe<Scalars['String']>;
  email_not_ends_with?: InputMaybe<Scalars['String']>;
  email_not_in?: InputMaybe<Array<Scalars['String']>>;
  email_not_starts_with?: InputMaybe<Scalars['String']>;
  email_starts_with?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['ID']>;
  id_contains?: InputMaybe<Scalars['ID']>;
  id_ends_with?: InputMaybe<Scalars['ID']>;
  id_gt?: InputMaybe<Scalars['ID']>;
  id_gte?: InputMaybe<Scalars['ID']>;
  id_in?: InputMaybe<Array<Scalars['ID']>>;
  id_lt?: InputMaybe<Scalars['ID']>;
  id_lte?: InputMaybe<Scalars['ID']>;
  id_not?: InputMaybe<Scalars['ID']>;
  id_not_contains?: InputMaybe<Scalars['ID']>;
  id_not_ends_with?: InputMaybe<Scalars['ID']>;
  id_not_in?: InputMaybe<Array<Scalars['ID']>>;
  id_not_starts_with?: InputMaybe<Scalars['ID']>;
  id_starts_with?: InputMaybe<Scalars['ID']>;
  institutionDataSource?: InputMaybe<InstitutionDataSource>;
  institutionDataSource_in?: InputMaybe<Array<InstitutionDataSource>>;
  institutionDataSource_not?: InputMaybe<InstitutionDataSource>;
  institutionDataSource_not_in?: InputMaybe<Array<InstitutionDataSource>>;
  institutionId?: InputMaybe<Scalars['String']>;
  institutionId_contains?: InputMaybe<Scalars['String']>;
  institutionId_ends_with?: InputMaybe<Scalars['String']>;
  institutionId_gt?: InputMaybe<Scalars['String']>;
  institutionId_gte?: InputMaybe<Scalars['String']>;
  institutionId_in?: InputMaybe<Array<Scalars['String']>>;
  institutionId_lt?: InputMaybe<Scalars['String']>;
  institutionId_lte?: InputMaybe<Scalars['String']>;
  institutionId_not?: InputMaybe<Scalars['String']>;
  institutionId_not_contains?: InputMaybe<Scalars['String']>;
  institutionId_not_ends_with?: InputMaybe<Scalars['String']>;
  institutionId_not_in?: InputMaybe<Array<Scalars['String']>>;
  institutionId_not_starts_with?: InputMaybe<Scalars['String']>;
  institutionId_starts_with?: InputMaybe<Scalars['String']>;
  invoiceSelf?: InputMaybe<Scalars['Boolean']>;
  invoiceSelf_not?: InputMaybe<Scalars['Boolean']>;
  name?: InputMaybe<Scalars['String']>;
  name_contains?: InputMaybe<Scalars['String']>;
  name_ends_with?: InputMaybe<Scalars['String']>;
  name_gt?: InputMaybe<Scalars['String']>;
  name_gte?: InputMaybe<Scalars['String']>;
  name_in?: InputMaybe<Array<Scalars['String']>>;
  name_lt?: InputMaybe<Scalars['String']>;
  name_lte?: InputMaybe<Scalars['String']>;
  name_not?: InputMaybe<Scalars['String']>;
  name_not_contains?: InputMaybe<Scalars['String']>;
  name_not_ends_with?: InputMaybe<Scalars['String']>;
  name_not_in?: InputMaybe<Array<Scalars['String']>>;
  name_not_starts_with?: InputMaybe<Scalars['String']>;
  name_starts_with?: InputMaybe<Scalars['String']>;
  phone?: InputMaybe<Scalars['String']>;
  phone_contains?: InputMaybe<Scalars['String']>;
  phone_ends_with?: InputMaybe<Scalars['String']>;
  phone_gt?: InputMaybe<Scalars['String']>;
  phone_gte?: InputMaybe<Scalars['String']>;
  phone_in?: InputMaybe<Array<Scalars['String']>>;
  phone_lt?: InputMaybe<Scalars['String']>;
  phone_lte?: InputMaybe<Scalars['String']>;
  phone_not?: InputMaybe<Scalars['String']>;
  phone_not_contains?: InputMaybe<Scalars['String']>;
  phone_not_ends_with?: InputMaybe<Scalars['String']>;
  phone_not_in?: InputMaybe<Array<Scalars['String']>>;
  phone_not_starts_with?: InputMaybe<Scalars['String']>;
  phone_starts_with?: InputMaybe<Scalars['String']>;
  receivedSignedDataProcessingAgreement?: InputMaybe<Scalars['Boolean']>;
  receivedSignedDataProcessingAgreement_not?: InputMaybe<Scalars['Boolean']>;
  teamleaderID?: InputMaybe<Scalars['String']>;
  teamleaderID_contains?: InputMaybe<Scalars['String']>;
  teamleaderID_ends_with?: InputMaybe<Scalars['String']>;
  teamleaderID_gt?: InputMaybe<Scalars['String']>;
  teamleaderID_gte?: InputMaybe<Scalars['String']>;
  teamleaderID_in?: InputMaybe<Array<Scalars['String']>>;
  teamleaderID_lt?: InputMaybe<Scalars['String']>;
  teamleaderID_lte?: InputMaybe<Scalars['String']>;
  teamleaderID_not?: InputMaybe<Scalars['String']>;
  teamleaderID_not_contains?: InputMaybe<Scalars['String']>;
  teamleaderID_not_ends_with?: InputMaybe<Scalars['String']>;
  teamleaderID_not_in?: InputMaybe<Array<Scalars['String']>>;
  teamleaderID_not_starts_with?: InputMaybe<Scalars['String']>;
  teamleaderID_starts_with?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
  updatedAt_gt?: InputMaybe<Scalars['DateTime']>;
  updatedAt_gte?: InputMaybe<Scalars['DateTime']>;
  updatedAt_in?: InputMaybe<Array<Scalars['DateTime']>>;
  updatedAt_lt?: InputMaybe<Scalars['DateTime']>;
  updatedAt_lte?: InputMaybe<Scalars['DateTime']>;
  updatedAt_not?: InputMaybe<Scalars['DateTime']>;
  updatedAt_not_in?: InputMaybe<Array<Scalars['DateTime']>>;
};

export type SchoolDistrictSearchFilterInput = {
  first?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<SchoolDistrictSearchOrderByInput>;
  skip?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<SchoolDistrictSearchWhereInput>;
};

export type SchoolDistrictSearchOrderByInput = {
  columnName?: InputMaybe<SchoolDistrictOrderByColumns>;
  order?: InputMaybe<SortOrder>;
};

export type SchoolDistrictSearchResult = {
  aggregate: AggregateSchoolDistrict;
  edges: Array<Maybe<SchoolDistrictEdge>>;
};

export type SchoolDistrictSearchWhereInput = {
  city?: InputMaybe<StringFilterInput>;
  contact?: InputMaybe<StringFilterInput>;
  email?: InputMaybe<StringFilterInput>;
  id?: InputMaybe<StringFilterInput>;
  invoiceSelf?: InputMaybe<Scalars['Boolean']>;
  licenseSubscriptionActive?: InputMaybe<Scalars['Boolean']>;
  licensesInUse?: InputMaybe<NumberFilterInput>;
  licensesRemaining?: InputMaybe<NumberFilterInput>;
  licensesTotal?: InputMaybe<NumberFilterInput>;
  name?: InputMaybe<StringFilterInput>;
  renewalDate?: InputMaybe<DateFilterInput>;
};

export type SchoolDistrictSubscriptionPayload = {
  mutation: MutationType;
  node?: Maybe<SchoolDistrict>;
  previousValues?: Maybe<SchoolDistrictPreviousValues>;
  updatedFields?: Maybe<Array<Scalars['String']>>;
};

export type SchoolDistrictSubscriptionWhereInput = {
  AND?: InputMaybe<Array<SchoolDistrictSubscriptionWhereInput>>;
  NOT?: InputMaybe<Array<SchoolDistrictSubscriptionWhereInput>>;
  OR?: InputMaybe<Array<SchoolDistrictSubscriptionWhereInput>>;
  mutation_in?: InputMaybe<Array<MutationType>>;
  node?: InputMaybe<SchoolDistrictWhereInput>;
  updatedFields_contains?: InputMaybe<Scalars['String']>;
  updatedFields_contains_every?: InputMaybe<Array<Scalars['String']>>;
  updatedFields_contains_some?: InputMaybe<Array<Scalars['String']>>;
};

export type SchoolDistrictUpdateInput = {
  acceptsDataProcessingAgreement?: InputMaybe<Scalars['Boolean']>;
  acceptsTermsAndConditions?: InputMaybe<Scalars['Boolean']>;
  activated?: InputMaybe<Scalars['Boolean']>;
  address?: InputMaybe<AddressUpdateOneRequiredInput>;
  brinNumber?: InputMaybe<Scalars['String']>;
  chamberOfCommerceNumber?: InputMaybe<Scalars['String']>;
  copyEmail?: InputMaybe<Scalars['String']>;
  email?: InputMaybe<Scalars['String']>;
  institution?: InputMaybe<InstitutionInput>;
  invoiceInfo?: InputMaybe<InvoiceInfoUpdateOneInput>;
  licenseSubscription?: InputMaybe<LicenseInfoUpdateOneInput>;
  name?: InputMaybe<Scalars['String']>;
  partner?: InputMaybe<SbPartnerUpdateOneWithoutSchoolDistrictsInput>;
  phone?: InputMaybe<Scalars['String']>;
  receivedSignedDataProcessingAgreement?: InputMaybe<Scalars['Boolean']>;
  schools?: InputMaybe<SbSchoolUpdateManyWithoutSchoolDistrictInput>;
  teamleaderID?: InputMaybe<Scalars['String']>;
};

export type SchoolDistrictUpdateManyDataInput = {
  acceptsDataProcessingAgreement?: InputMaybe<Scalars['Boolean']>;
  acceptsTermsAndConditions?: InputMaybe<Scalars['Boolean']>;
  activated?: InputMaybe<Scalars['Boolean']>;
  brinNumber?: InputMaybe<Scalars['String']>;
  chamberOfCommerceNumber?: InputMaybe<Scalars['String']>;
  copyEmail?: InputMaybe<Scalars['String']>;
  email?: InputMaybe<Scalars['String']>;
  institutionDataSource?: InputMaybe<InstitutionDataSource>;
  institutionId?: InputMaybe<Scalars['String']>;
  invoiceSelf?: InputMaybe<Scalars['Boolean']>;
  name?: InputMaybe<Scalars['String']>;
  phone?: InputMaybe<Scalars['String']>;
  receivedSignedDataProcessingAgreement?: InputMaybe<Scalars['Boolean']>;
  teamleaderID?: InputMaybe<Scalars['String']>;
};

export type SchoolDistrictUpdateManyMutationInput = {
  acceptsDataProcessingAgreement?: InputMaybe<Scalars['Boolean']>;
  acceptsTermsAndConditions?: InputMaybe<Scalars['Boolean']>;
  activated?: InputMaybe<Scalars['Boolean']>;
  brinNumber?: InputMaybe<Scalars['String']>;
  chamberOfCommerceNumber?: InputMaybe<Scalars['String']>;
  copyEmail?: InputMaybe<Scalars['String']>;
  email?: InputMaybe<Scalars['String']>;
  institutionDataSource?: InputMaybe<InstitutionDataSource>;
  institutionId?: InputMaybe<Scalars['String']>;
  invoiceSelf?: InputMaybe<Scalars['Boolean']>;
  name?: InputMaybe<Scalars['String']>;
  phone?: InputMaybe<Scalars['String']>;
  receivedSignedDataProcessingAgreement?: InputMaybe<Scalars['Boolean']>;
  teamleaderID?: InputMaybe<Scalars['String']>;
};

export type SchoolDistrictUpdateManyWithWhereNestedInput = {
  data: SchoolDistrictUpdateManyDataInput;
  where: SchoolDistrictScalarWhereInput;
};

export type SchoolDistrictUpdateManyWithoutPartnerInput = {
  connect?: InputMaybe<Array<SchoolDistrictWhereUniqueInput>>;
  create?: InputMaybe<Array<SchoolDistrictCreateWithoutPartnerInput>>;
  delete?: InputMaybe<Array<SchoolDistrictWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<SchoolDistrictScalarWhereInput>>;
  disconnect?: InputMaybe<Array<SchoolDistrictWhereUniqueInput>>;
  set?: InputMaybe<Array<SchoolDistrictWhereUniqueInput>>;
  update?: InputMaybe<
    Array<SchoolDistrictUpdateWithWhereUniqueWithoutPartnerInput>
  >;
  updateMany?: InputMaybe<Array<SchoolDistrictUpdateManyWithWhereNestedInput>>;
  upsert?: InputMaybe<
    Array<SchoolDistrictUpsertWithWhereUniqueWithoutPartnerInput>
  >;
};

export type SchoolDistrictUpdateManyWithoutUsersInput = {
  connect?: InputMaybe<Array<SchoolDistrictWhereUniqueInput>>;
  create?: InputMaybe<Array<SchoolDistrictCreateWithoutUsersInput>>;
  delete?: InputMaybe<Array<SchoolDistrictWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<SchoolDistrictScalarWhereInput>>;
  disconnect?: InputMaybe<Array<SchoolDistrictWhereUniqueInput>>;
  set?: InputMaybe<Array<SchoolDistrictWhereUniqueInput>>;
  update?: InputMaybe<
    Array<SchoolDistrictUpdateWithWhereUniqueWithoutUsersInput>
  >;
  updateMany?: InputMaybe<Array<SchoolDistrictUpdateManyWithWhereNestedInput>>;
  upsert?: InputMaybe<
    Array<SchoolDistrictUpsertWithWhereUniqueWithoutUsersInput>
  >;
};

export type SchoolDistrictUpdateOneWithoutSchoolsInput = {
  connect?: InputMaybe<SchoolDistrictWhereUniqueInput>;
  create?: InputMaybe<SchoolDistrictCreateWithoutSchoolsInput>;
  delete?: InputMaybe<Scalars['Boolean']>;
  disconnect?: InputMaybe<Scalars['Boolean']>;
  update?: InputMaybe<SchoolDistrictUpdateWithoutSchoolsDataInput>;
  upsert?: InputMaybe<SchoolDistrictUpsertWithoutSchoolsInput>;
};

export type SchoolDistrictUpdateWithWhereUniqueWithoutPartnerInput = {
  data: SchoolDistrictUpdateWithoutPartnerDataInput;
  where: SchoolDistrictWhereUniqueInput;
};

export type SchoolDistrictUpdateWithWhereUniqueWithoutUsersInput = {
  data: SchoolDistrictUpdateWithoutUsersDataInput;
  where: SchoolDistrictWhereUniqueInput;
};

export type SchoolDistrictUpdateWithoutPartnerDataInput = {
  acceptsDataProcessingAgreement?: InputMaybe<Scalars['Boolean']>;
  acceptsTermsAndConditions?: InputMaybe<Scalars['Boolean']>;
  activated?: InputMaybe<Scalars['Boolean']>;
  address?: InputMaybe<ContactDetailsUpdateOneRequiredInput>;
  brinNumber?: InputMaybe<Scalars['String']>;
  chamberOfCommerceNumber?: InputMaybe<Scalars['String']>;
  copyEmail?: InputMaybe<Scalars['String']>;
  email?: InputMaybe<Scalars['String']>;
  institutionDataSource?: InputMaybe<InstitutionDataSource>;
  institutionId?: InputMaybe<Scalars['String']>;
  invoiceInfo?: InputMaybe<ContactDetailsUpdateOneInput>;
  invoiceSelf?: InputMaybe<Scalars['Boolean']>;
  licensePool?: InputMaybe<LicensePoolUpdateOneRequiredInput>;
  licenseSubscription?: InputMaybe<LicenseSubscriptionInfoUpdateOneInput>;
  name?: InputMaybe<Scalars['String']>;
  phone?: InputMaybe<Scalars['String']>;
  previousSubscriptions?: InputMaybe<LicenseSubscriptionInfoUpdateManyInput>;
  receivedSignedDataProcessingAgreement?: InputMaybe<Scalars['Boolean']>;
  schools?: InputMaybe<SchoolUpdateManyWithoutSchoolDistrictInput>;
  teamleaderID?: InputMaybe<Scalars['String']>;
  users?: InputMaybe<BeheerUserUpdateManyWithoutSchoolDistrictsInput>;
};

export type SchoolDistrictUpdateWithoutSchoolsDataInput = {
  acceptsDataProcessingAgreement?: InputMaybe<Scalars['Boolean']>;
  acceptsTermsAndConditions?: InputMaybe<Scalars['Boolean']>;
  activated?: InputMaybe<Scalars['Boolean']>;
  address?: InputMaybe<ContactDetailsUpdateOneRequiredInput>;
  brinNumber?: InputMaybe<Scalars['String']>;
  chamberOfCommerceNumber?: InputMaybe<Scalars['String']>;
  copyEmail?: InputMaybe<Scalars['String']>;
  email?: InputMaybe<Scalars['String']>;
  institutionDataSource?: InputMaybe<InstitutionDataSource>;
  institutionId?: InputMaybe<Scalars['String']>;
  invoiceInfo?: InputMaybe<ContactDetailsUpdateOneInput>;
  invoiceSelf?: InputMaybe<Scalars['Boolean']>;
  licensePool?: InputMaybe<LicensePoolUpdateOneRequiredInput>;
  licenseSubscription?: InputMaybe<LicenseSubscriptionInfoUpdateOneInput>;
  name?: InputMaybe<Scalars['String']>;
  partner?: InputMaybe<PartnerUpdateOneWithoutSchoolDistrictsInput>;
  phone?: InputMaybe<Scalars['String']>;
  previousSubscriptions?: InputMaybe<LicenseSubscriptionInfoUpdateManyInput>;
  receivedSignedDataProcessingAgreement?: InputMaybe<Scalars['Boolean']>;
  teamleaderID?: InputMaybe<Scalars['String']>;
  users?: InputMaybe<BeheerUserUpdateManyWithoutSchoolDistrictsInput>;
};

export type SchoolDistrictUpdateWithoutUsersDataInput = {
  acceptsDataProcessingAgreement?: InputMaybe<Scalars['Boolean']>;
  acceptsTermsAndConditions?: InputMaybe<Scalars['Boolean']>;
  activated?: InputMaybe<Scalars['Boolean']>;
  address?: InputMaybe<ContactDetailsUpdateOneRequiredInput>;
  brinNumber?: InputMaybe<Scalars['String']>;
  chamberOfCommerceNumber?: InputMaybe<Scalars['String']>;
  copyEmail?: InputMaybe<Scalars['String']>;
  email?: InputMaybe<Scalars['String']>;
  institutionDataSource?: InputMaybe<InstitutionDataSource>;
  institutionId?: InputMaybe<Scalars['String']>;
  invoiceInfo?: InputMaybe<ContactDetailsUpdateOneInput>;
  invoiceSelf?: InputMaybe<Scalars['Boolean']>;
  licensePool?: InputMaybe<LicensePoolUpdateOneRequiredInput>;
  licenseSubscription?: InputMaybe<LicenseSubscriptionInfoUpdateOneInput>;
  name?: InputMaybe<Scalars['String']>;
  partner?: InputMaybe<PartnerUpdateOneWithoutSchoolDistrictsInput>;
  phone?: InputMaybe<Scalars['String']>;
  previousSubscriptions?: InputMaybe<LicenseSubscriptionInfoUpdateManyInput>;
  receivedSignedDataProcessingAgreement?: InputMaybe<Scalars['Boolean']>;
  schools?: InputMaybe<SchoolUpdateManyWithoutSchoolDistrictInput>;
  teamleaderID?: InputMaybe<Scalars['String']>;
};

export type SchoolDistrictUpsertWithWhereUniqueWithoutPartnerInput = {
  create: SchoolDistrictCreateWithoutPartnerInput;
  update: SchoolDistrictUpdateWithoutPartnerDataInput;
  where: SchoolDistrictWhereUniqueInput;
};

export type SchoolDistrictUpsertWithWhereUniqueWithoutUsersInput = {
  create: SchoolDistrictCreateWithoutUsersInput;
  update: SchoolDistrictUpdateWithoutUsersDataInput;
  where: SchoolDistrictWhereUniqueInput;
};

export type SchoolDistrictUpsertWithoutSchoolsInput = {
  create: SchoolDistrictCreateWithoutSchoolsInput;
  update: SchoolDistrictUpdateWithoutSchoolsDataInput;
};

export type SchoolDistrictWhereInput = {
  AND?: InputMaybe<Array<SchoolDistrictWhereInput>>;
  NOT?: InputMaybe<Array<SchoolDistrictWhereInput>>;
  OR?: InputMaybe<Array<SchoolDistrictWhereInput>>;
  acceptsDataProcessingAgreement?: InputMaybe<Scalars['Boolean']>;
  acceptsDataProcessingAgreement_not?: InputMaybe<Scalars['Boolean']>;
  acceptsTermsAndConditions?: InputMaybe<Scalars['Boolean']>;
  acceptsTermsAndConditions_not?: InputMaybe<Scalars['Boolean']>;
  activated?: InputMaybe<Scalars['Boolean']>;
  activated_not?: InputMaybe<Scalars['Boolean']>;
  address?: InputMaybe<ContactDetailsWhereInput>;
  brinNumber?: InputMaybe<Scalars['String']>;
  brinNumber_contains?: InputMaybe<Scalars['String']>;
  brinNumber_ends_with?: InputMaybe<Scalars['String']>;
  brinNumber_gt?: InputMaybe<Scalars['String']>;
  brinNumber_gte?: InputMaybe<Scalars['String']>;
  brinNumber_in?: InputMaybe<Array<Scalars['String']>>;
  brinNumber_lt?: InputMaybe<Scalars['String']>;
  brinNumber_lte?: InputMaybe<Scalars['String']>;
  brinNumber_not?: InputMaybe<Scalars['String']>;
  brinNumber_not_contains?: InputMaybe<Scalars['String']>;
  brinNumber_not_ends_with?: InputMaybe<Scalars['String']>;
  brinNumber_not_in?: InputMaybe<Array<Scalars['String']>>;
  brinNumber_not_starts_with?: InputMaybe<Scalars['String']>;
  brinNumber_starts_with?: InputMaybe<Scalars['String']>;
  chamberOfCommerceNumber?: InputMaybe<Scalars['String']>;
  chamberOfCommerceNumber_contains?: InputMaybe<Scalars['String']>;
  chamberOfCommerceNumber_ends_with?: InputMaybe<Scalars['String']>;
  chamberOfCommerceNumber_gt?: InputMaybe<Scalars['String']>;
  chamberOfCommerceNumber_gte?: InputMaybe<Scalars['String']>;
  chamberOfCommerceNumber_in?: InputMaybe<Array<Scalars['String']>>;
  chamberOfCommerceNumber_lt?: InputMaybe<Scalars['String']>;
  chamberOfCommerceNumber_lte?: InputMaybe<Scalars['String']>;
  chamberOfCommerceNumber_not?: InputMaybe<Scalars['String']>;
  chamberOfCommerceNumber_not_contains?: InputMaybe<Scalars['String']>;
  chamberOfCommerceNumber_not_ends_with?: InputMaybe<Scalars['String']>;
  chamberOfCommerceNumber_not_in?: InputMaybe<Array<Scalars['String']>>;
  chamberOfCommerceNumber_not_starts_with?: InputMaybe<Scalars['String']>;
  chamberOfCommerceNumber_starts_with?: InputMaybe<Scalars['String']>;
  copyEmail?: InputMaybe<Scalars['String']>;
  copyEmail_contains?: InputMaybe<Scalars['String']>;
  copyEmail_ends_with?: InputMaybe<Scalars['String']>;
  copyEmail_gt?: InputMaybe<Scalars['String']>;
  copyEmail_gte?: InputMaybe<Scalars['String']>;
  copyEmail_in?: InputMaybe<Array<Scalars['String']>>;
  copyEmail_lt?: InputMaybe<Scalars['String']>;
  copyEmail_lte?: InputMaybe<Scalars['String']>;
  copyEmail_not?: InputMaybe<Scalars['String']>;
  copyEmail_not_contains?: InputMaybe<Scalars['String']>;
  copyEmail_not_ends_with?: InputMaybe<Scalars['String']>;
  copyEmail_not_in?: InputMaybe<Array<Scalars['String']>>;
  copyEmail_not_starts_with?: InputMaybe<Scalars['String']>;
  copyEmail_starts_with?: InputMaybe<Scalars['String']>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  createdAt_gt?: InputMaybe<Scalars['DateTime']>;
  createdAt_gte?: InputMaybe<Scalars['DateTime']>;
  createdAt_in?: InputMaybe<Array<Scalars['DateTime']>>;
  createdAt_lt?: InputMaybe<Scalars['DateTime']>;
  createdAt_lte?: InputMaybe<Scalars['DateTime']>;
  createdAt_not?: InputMaybe<Scalars['DateTime']>;
  createdAt_not_in?: InputMaybe<Array<Scalars['DateTime']>>;
  email?: InputMaybe<Scalars['String']>;
  email_contains?: InputMaybe<Scalars['String']>;
  email_ends_with?: InputMaybe<Scalars['String']>;
  email_gt?: InputMaybe<Scalars['String']>;
  email_gte?: InputMaybe<Scalars['String']>;
  email_in?: InputMaybe<Array<Scalars['String']>>;
  email_lt?: InputMaybe<Scalars['String']>;
  email_lte?: InputMaybe<Scalars['String']>;
  email_not?: InputMaybe<Scalars['String']>;
  email_not_contains?: InputMaybe<Scalars['String']>;
  email_not_ends_with?: InputMaybe<Scalars['String']>;
  email_not_in?: InputMaybe<Array<Scalars['String']>>;
  email_not_starts_with?: InputMaybe<Scalars['String']>;
  email_starts_with?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['ID']>;
  id_contains?: InputMaybe<Scalars['ID']>;
  id_ends_with?: InputMaybe<Scalars['ID']>;
  id_gt?: InputMaybe<Scalars['ID']>;
  id_gte?: InputMaybe<Scalars['ID']>;
  id_in?: InputMaybe<Array<Scalars['ID']>>;
  id_lt?: InputMaybe<Scalars['ID']>;
  id_lte?: InputMaybe<Scalars['ID']>;
  id_not?: InputMaybe<Scalars['ID']>;
  id_not_contains?: InputMaybe<Scalars['ID']>;
  id_not_ends_with?: InputMaybe<Scalars['ID']>;
  id_not_in?: InputMaybe<Array<Scalars['ID']>>;
  id_not_starts_with?: InputMaybe<Scalars['ID']>;
  id_starts_with?: InputMaybe<Scalars['ID']>;
  institutionDataSource?: InputMaybe<InstitutionDataSource>;
  institutionDataSource_in?: InputMaybe<Array<InstitutionDataSource>>;
  institutionDataSource_not?: InputMaybe<InstitutionDataSource>;
  institutionDataSource_not_in?: InputMaybe<Array<InstitutionDataSource>>;
  institutionId?: InputMaybe<Scalars['String']>;
  institutionId_contains?: InputMaybe<Scalars['String']>;
  institutionId_ends_with?: InputMaybe<Scalars['String']>;
  institutionId_gt?: InputMaybe<Scalars['String']>;
  institutionId_gte?: InputMaybe<Scalars['String']>;
  institutionId_in?: InputMaybe<Array<Scalars['String']>>;
  institutionId_lt?: InputMaybe<Scalars['String']>;
  institutionId_lte?: InputMaybe<Scalars['String']>;
  institutionId_not?: InputMaybe<Scalars['String']>;
  institutionId_not_contains?: InputMaybe<Scalars['String']>;
  institutionId_not_ends_with?: InputMaybe<Scalars['String']>;
  institutionId_not_in?: InputMaybe<Array<Scalars['String']>>;
  institutionId_not_starts_with?: InputMaybe<Scalars['String']>;
  institutionId_starts_with?: InputMaybe<Scalars['String']>;
  invoiceInfo?: InputMaybe<ContactDetailsWhereInput>;
  invoiceSelf?: InputMaybe<Scalars['Boolean']>;
  invoiceSelf_not?: InputMaybe<Scalars['Boolean']>;
  licensePool?: InputMaybe<LicensePoolWhereInput>;
  licenseSubscription?: InputMaybe<LicenseSubscriptionInfoWhereInput>;
  name?: InputMaybe<Scalars['String']>;
  name_contains?: InputMaybe<Scalars['String']>;
  name_ends_with?: InputMaybe<Scalars['String']>;
  name_gt?: InputMaybe<Scalars['String']>;
  name_gte?: InputMaybe<Scalars['String']>;
  name_in?: InputMaybe<Array<Scalars['String']>>;
  name_lt?: InputMaybe<Scalars['String']>;
  name_lte?: InputMaybe<Scalars['String']>;
  name_not?: InputMaybe<Scalars['String']>;
  name_not_contains?: InputMaybe<Scalars['String']>;
  name_not_ends_with?: InputMaybe<Scalars['String']>;
  name_not_in?: InputMaybe<Array<Scalars['String']>>;
  name_not_starts_with?: InputMaybe<Scalars['String']>;
  name_starts_with?: InputMaybe<Scalars['String']>;
  partner?: InputMaybe<PartnerWhereInput>;
  phone?: InputMaybe<Scalars['String']>;
  phone_contains?: InputMaybe<Scalars['String']>;
  phone_ends_with?: InputMaybe<Scalars['String']>;
  phone_gt?: InputMaybe<Scalars['String']>;
  phone_gte?: InputMaybe<Scalars['String']>;
  phone_in?: InputMaybe<Array<Scalars['String']>>;
  phone_lt?: InputMaybe<Scalars['String']>;
  phone_lte?: InputMaybe<Scalars['String']>;
  phone_not?: InputMaybe<Scalars['String']>;
  phone_not_contains?: InputMaybe<Scalars['String']>;
  phone_not_ends_with?: InputMaybe<Scalars['String']>;
  phone_not_in?: InputMaybe<Array<Scalars['String']>>;
  phone_not_starts_with?: InputMaybe<Scalars['String']>;
  phone_starts_with?: InputMaybe<Scalars['String']>;
  previousSubscriptions_every?: InputMaybe<LicenseSubscriptionInfoWhereInput>;
  previousSubscriptions_none?: InputMaybe<LicenseSubscriptionInfoWhereInput>;
  previousSubscriptions_some?: InputMaybe<LicenseSubscriptionInfoWhereInput>;
  receivedSignedDataProcessingAgreement?: InputMaybe<Scalars['Boolean']>;
  receivedSignedDataProcessingAgreement_not?: InputMaybe<Scalars['Boolean']>;
  schools_every?: InputMaybe<SchoolWhereInput>;
  schools_none?: InputMaybe<SchoolWhereInput>;
  schools_some?: InputMaybe<SchoolWhereInput>;
  teamleaderID?: InputMaybe<Scalars['String']>;
  teamleaderID_contains?: InputMaybe<Scalars['String']>;
  teamleaderID_ends_with?: InputMaybe<Scalars['String']>;
  teamleaderID_gt?: InputMaybe<Scalars['String']>;
  teamleaderID_gte?: InputMaybe<Scalars['String']>;
  teamleaderID_in?: InputMaybe<Array<Scalars['String']>>;
  teamleaderID_lt?: InputMaybe<Scalars['String']>;
  teamleaderID_lte?: InputMaybe<Scalars['String']>;
  teamleaderID_not?: InputMaybe<Scalars['String']>;
  teamleaderID_not_contains?: InputMaybe<Scalars['String']>;
  teamleaderID_not_ends_with?: InputMaybe<Scalars['String']>;
  teamleaderID_not_in?: InputMaybe<Array<Scalars['String']>>;
  teamleaderID_not_starts_with?: InputMaybe<Scalars['String']>;
  teamleaderID_starts_with?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
  updatedAt_gt?: InputMaybe<Scalars['DateTime']>;
  updatedAt_gte?: InputMaybe<Scalars['DateTime']>;
  updatedAt_in?: InputMaybe<Array<Scalars['DateTime']>>;
  updatedAt_lt?: InputMaybe<Scalars['DateTime']>;
  updatedAt_lte?: InputMaybe<Scalars['DateTime']>;
  updatedAt_not?: InputMaybe<Scalars['DateTime']>;
  updatedAt_not_in?: InputMaybe<Array<Scalars['DateTime']>>;
  users_every?: InputMaybe<BeheerUserWhereInput>;
  users_none?: InputMaybe<BeheerUserWhereInput>;
  users_some?: InputMaybe<BeheerUserWhereInput>;
};

export type SchoolDistrictWhereUniqueInput = {
  chamberOfCommerceNumber?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['ID']>;
  teamleaderID?: InputMaybe<Scalars['String']>;
};

export type SchoolDistrictsFilterInput = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<SchoolDistrictOrderByInput>;
  skip?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<SchoolDistrictWhereInput>;
};

export type SchoolEdge = {
  cursor: Scalars['String'];
  node: School;
};

export type SchoolOrderByColumns =
  | 'city'
  | 'contact'
  | 'defaultKeyboardLayout'
  | 'email'
  | 'id'
  | 'invoiceToDistrict'
  | 'licenseSubscriptionActive'
  | 'licensesInUse'
  | 'licensesRemaining'
  | 'licensesTotal'
  | 'name'
  | 'renewalDate'
  | 'schoolDistrictId'
  | 'schoolDistrictName';

export type SchoolOrderByInput =
  | 'acceptsDataProcessingAgreement_ASC'
  | 'acceptsDataProcessingAgreement_DESC'
  | 'acceptsTermsAndConditions_ASC'
  | 'acceptsTermsAndConditions_DESC'
  | 'activated_ASC'
  | 'activated_DESC'
  | 'brinNumber_ASC'
  | 'brinNumber_DESC'
  | 'canEditKeyboardLayout_ASC'
  | 'canEditKeyboardLayout_DESC'
  | 'chamberOfCommerceNumber_ASC'
  | 'chamberOfCommerceNumber_DESC'
  | 'copyEmail_ASC'
  | 'copyEmail_DESC'
  | 'createdAt_ASC'
  | 'createdAt_DESC'
  | 'defaultKeyboardLayout_ASC'
  | 'defaultKeyboardLayout_DESC'
  | 'email_ASC'
  | 'email_DESC'
  | 'id_ASC'
  | 'id_DESC'
  | 'institutionDataSource_ASC'
  | 'institutionDataSource_DESC'
  | 'institutionId_ASC'
  | 'institutionId_DESC'
  | 'name_ASC'
  | 'name_DESC'
  | 'organisationType_ASC'
  | 'organisationType_DESC'
  | 'phone_ASC'
  | 'phone_DESC'
  | 'receivedSignedDataProcessingAgreement_ASC'
  | 'receivedSignedDataProcessingAgreement_DESC'
  | 'subscribedToEmails_ASC'
  | 'subscribedToEmails_DESC'
  | 'teamleaderID_ASC'
  | 'teamleaderID_DESC'
  | 'updatedAt_ASC'
  | 'updatedAt_DESC';

export type SchoolOrganisationType =
  | 'HIGHER_EDUCATION'
  | 'HIGH_SCHOOL'
  | 'OTHER'
  | 'PRIMARY_SCHOOL'
  | 'REMEDIAL_TEACHING';

export type SchoolPreviousValues = {
  acceptsDataProcessingAgreement: Scalars['Boolean'];
  acceptsTermsAndConditions: Scalars['Boolean'];
  activated: Scalars['Boolean'];
  brinNumber?: Maybe<Scalars['String']>;
  canEditKeyboardLayout: Scalars['Boolean'];
  chamberOfCommerceNumber?: Maybe<Scalars['String']>;
  copyEmail?: Maybe<Scalars['String']>;
  createdAt: Scalars['DateTime'];
  defaultKeyboardLayout: KeyboardLayout;
  email: Scalars['String'];
  id: Scalars['ID'];
  institutionDataSource?: Maybe<InstitutionDataSource>;
  institutionId?: Maybe<Scalars['String']>;
  name: Scalars['String'];
  organisationType: SchoolOrganisationType;
  phone: Scalars['String'];
  receivedSignedDataProcessingAgreement: Scalars['Boolean'];
  subscribedToEmails: Scalars['Boolean'];
  teamleaderID: Scalars['String'];
  updatedAt: Scalars['DateTime'];
};

export type SchoolScalarWhereInput = {
  AND?: InputMaybe<Array<SchoolScalarWhereInput>>;
  NOT?: InputMaybe<Array<SchoolScalarWhereInput>>;
  OR?: InputMaybe<Array<SchoolScalarWhereInput>>;
  acceptsDataProcessingAgreement?: InputMaybe<Scalars['Boolean']>;
  acceptsDataProcessingAgreement_not?: InputMaybe<Scalars['Boolean']>;
  acceptsTermsAndConditions?: InputMaybe<Scalars['Boolean']>;
  acceptsTermsAndConditions_not?: InputMaybe<Scalars['Boolean']>;
  activated?: InputMaybe<Scalars['Boolean']>;
  activated_not?: InputMaybe<Scalars['Boolean']>;
  brinNumber?: InputMaybe<Scalars['String']>;
  brinNumber_contains?: InputMaybe<Scalars['String']>;
  brinNumber_ends_with?: InputMaybe<Scalars['String']>;
  brinNumber_gt?: InputMaybe<Scalars['String']>;
  brinNumber_gte?: InputMaybe<Scalars['String']>;
  brinNumber_in?: InputMaybe<Array<Scalars['String']>>;
  brinNumber_lt?: InputMaybe<Scalars['String']>;
  brinNumber_lte?: InputMaybe<Scalars['String']>;
  brinNumber_not?: InputMaybe<Scalars['String']>;
  brinNumber_not_contains?: InputMaybe<Scalars['String']>;
  brinNumber_not_ends_with?: InputMaybe<Scalars['String']>;
  brinNumber_not_in?: InputMaybe<Array<Scalars['String']>>;
  brinNumber_not_starts_with?: InputMaybe<Scalars['String']>;
  brinNumber_starts_with?: InputMaybe<Scalars['String']>;
  canEditKeyboardLayout?: InputMaybe<Scalars['Boolean']>;
  canEditKeyboardLayout_not?: InputMaybe<Scalars['Boolean']>;
  chamberOfCommerceNumber?: InputMaybe<Scalars['String']>;
  chamberOfCommerceNumber_contains?: InputMaybe<Scalars['String']>;
  chamberOfCommerceNumber_ends_with?: InputMaybe<Scalars['String']>;
  chamberOfCommerceNumber_gt?: InputMaybe<Scalars['String']>;
  chamberOfCommerceNumber_gte?: InputMaybe<Scalars['String']>;
  chamberOfCommerceNumber_in?: InputMaybe<Array<Scalars['String']>>;
  chamberOfCommerceNumber_lt?: InputMaybe<Scalars['String']>;
  chamberOfCommerceNumber_lte?: InputMaybe<Scalars['String']>;
  chamberOfCommerceNumber_not?: InputMaybe<Scalars['String']>;
  chamberOfCommerceNumber_not_contains?: InputMaybe<Scalars['String']>;
  chamberOfCommerceNumber_not_ends_with?: InputMaybe<Scalars['String']>;
  chamberOfCommerceNumber_not_in?: InputMaybe<Array<Scalars['String']>>;
  chamberOfCommerceNumber_not_starts_with?: InputMaybe<Scalars['String']>;
  chamberOfCommerceNumber_starts_with?: InputMaybe<Scalars['String']>;
  copyEmail?: InputMaybe<Scalars['String']>;
  copyEmail_contains?: InputMaybe<Scalars['String']>;
  copyEmail_ends_with?: InputMaybe<Scalars['String']>;
  copyEmail_gt?: InputMaybe<Scalars['String']>;
  copyEmail_gte?: InputMaybe<Scalars['String']>;
  copyEmail_in?: InputMaybe<Array<Scalars['String']>>;
  copyEmail_lt?: InputMaybe<Scalars['String']>;
  copyEmail_lte?: InputMaybe<Scalars['String']>;
  copyEmail_not?: InputMaybe<Scalars['String']>;
  copyEmail_not_contains?: InputMaybe<Scalars['String']>;
  copyEmail_not_ends_with?: InputMaybe<Scalars['String']>;
  copyEmail_not_in?: InputMaybe<Array<Scalars['String']>>;
  copyEmail_not_starts_with?: InputMaybe<Scalars['String']>;
  copyEmail_starts_with?: InputMaybe<Scalars['String']>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  createdAt_gt?: InputMaybe<Scalars['DateTime']>;
  createdAt_gte?: InputMaybe<Scalars['DateTime']>;
  createdAt_in?: InputMaybe<Array<Scalars['DateTime']>>;
  createdAt_lt?: InputMaybe<Scalars['DateTime']>;
  createdAt_lte?: InputMaybe<Scalars['DateTime']>;
  createdAt_not?: InputMaybe<Scalars['DateTime']>;
  createdAt_not_in?: InputMaybe<Array<Scalars['DateTime']>>;
  defaultKeyboardLayout?: InputMaybe<KeyboardLayout>;
  defaultKeyboardLayout_in?: InputMaybe<Array<KeyboardLayout>>;
  defaultKeyboardLayout_not?: InputMaybe<KeyboardLayout>;
  defaultKeyboardLayout_not_in?: InputMaybe<Array<KeyboardLayout>>;
  email?: InputMaybe<Scalars['String']>;
  email_contains?: InputMaybe<Scalars['String']>;
  email_ends_with?: InputMaybe<Scalars['String']>;
  email_gt?: InputMaybe<Scalars['String']>;
  email_gte?: InputMaybe<Scalars['String']>;
  email_in?: InputMaybe<Array<Scalars['String']>>;
  email_lt?: InputMaybe<Scalars['String']>;
  email_lte?: InputMaybe<Scalars['String']>;
  email_not?: InputMaybe<Scalars['String']>;
  email_not_contains?: InputMaybe<Scalars['String']>;
  email_not_ends_with?: InputMaybe<Scalars['String']>;
  email_not_in?: InputMaybe<Array<Scalars['String']>>;
  email_not_starts_with?: InputMaybe<Scalars['String']>;
  email_starts_with?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['ID']>;
  id_contains?: InputMaybe<Scalars['ID']>;
  id_ends_with?: InputMaybe<Scalars['ID']>;
  id_gt?: InputMaybe<Scalars['ID']>;
  id_gte?: InputMaybe<Scalars['ID']>;
  id_in?: InputMaybe<Array<Scalars['ID']>>;
  id_lt?: InputMaybe<Scalars['ID']>;
  id_lte?: InputMaybe<Scalars['ID']>;
  id_not?: InputMaybe<Scalars['ID']>;
  id_not_contains?: InputMaybe<Scalars['ID']>;
  id_not_ends_with?: InputMaybe<Scalars['ID']>;
  id_not_in?: InputMaybe<Array<Scalars['ID']>>;
  id_not_starts_with?: InputMaybe<Scalars['ID']>;
  id_starts_with?: InputMaybe<Scalars['ID']>;
  institutionDataSource?: InputMaybe<InstitutionDataSource>;
  institutionDataSource_in?: InputMaybe<Array<InstitutionDataSource>>;
  institutionDataSource_not?: InputMaybe<InstitutionDataSource>;
  institutionDataSource_not_in?: InputMaybe<Array<InstitutionDataSource>>;
  institutionId?: InputMaybe<Scalars['String']>;
  institutionId_contains?: InputMaybe<Scalars['String']>;
  institutionId_ends_with?: InputMaybe<Scalars['String']>;
  institutionId_gt?: InputMaybe<Scalars['String']>;
  institutionId_gte?: InputMaybe<Scalars['String']>;
  institutionId_in?: InputMaybe<Array<Scalars['String']>>;
  institutionId_lt?: InputMaybe<Scalars['String']>;
  institutionId_lte?: InputMaybe<Scalars['String']>;
  institutionId_not?: InputMaybe<Scalars['String']>;
  institutionId_not_contains?: InputMaybe<Scalars['String']>;
  institutionId_not_ends_with?: InputMaybe<Scalars['String']>;
  institutionId_not_in?: InputMaybe<Array<Scalars['String']>>;
  institutionId_not_starts_with?: InputMaybe<Scalars['String']>;
  institutionId_starts_with?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  name_contains?: InputMaybe<Scalars['String']>;
  name_ends_with?: InputMaybe<Scalars['String']>;
  name_gt?: InputMaybe<Scalars['String']>;
  name_gte?: InputMaybe<Scalars['String']>;
  name_in?: InputMaybe<Array<Scalars['String']>>;
  name_lt?: InputMaybe<Scalars['String']>;
  name_lte?: InputMaybe<Scalars['String']>;
  name_not?: InputMaybe<Scalars['String']>;
  name_not_contains?: InputMaybe<Scalars['String']>;
  name_not_ends_with?: InputMaybe<Scalars['String']>;
  name_not_in?: InputMaybe<Array<Scalars['String']>>;
  name_not_starts_with?: InputMaybe<Scalars['String']>;
  name_starts_with?: InputMaybe<Scalars['String']>;
  organisationType?: InputMaybe<SchoolOrganisationType>;
  organisationType_in?: InputMaybe<Array<SchoolOrganisationType>>;
  organisationType_not?: InputMaybe<SchoolOrganisationType>;
  organisationType_not_in?: InputMaybe<Array<SchoolOrganisationType>>;
  phone?: InputMaybe<Scalars['String']>;
  phone_contains?: InputMaybe<Scalars['String']>;
  phone_ends_with?: InputMaybe<Scalars['String']>;
  phone_gt?: InputMaybe<Scalars['String']>;
  phone_gte?: InputMaybe<Scalars['String']>;
  phone_in?: InputMaybe<Array<Scalars['String']>>;
  phone_lt?: InputMaybe<Scalars['String']>;
  phone_lte?: InputMaybe<Scalars['String']>;
  phone_not?: InputMaybe<Scalars['String']>;
  phone_not_contains?: InputMaybe<Scalars['String']>;
  phone_not_ends_with?: InputMaybe<Scalars['String']>;
  phone_not_in?: InputMaybe<Array<Scalars['String']>>;
  phone_not_starts_with?: InputMaybe<Scalars['String']>;
  phone_starts_with?: InputMaybe<Scalars['String']>;
  receivedSignedDataProcessingAgreement?: InputMaybe<Scalars['Boolean']>;
  receivedSignedDataProcessingAgreement_not?: InputMaybe<Scalars['Boolean']>;
  subscribedToEmails?: InputMaybe<Scalars['Boolean']>;
  subscribedToEmails_not?: InputMaybe<Scalars['Boolean']>;
  teamleaderID?: InputMaybe<Scalars['String']>;
  teamleaderID_contains?: InputMaybe<Scalars['String']>;
  teamleaderID_ends_with?: InputMaybe<Scalars['String']>;
  teamleaderID_gt?: InputMaybe<Scalars['String']>;
  teamleaderID_gte?: InputMaybe<Scalars['String']>;
  teamleaderID_in?: InputMaybe<Array<Scalars['String']>>;
  teamleaderID_lt?: InputMaybe<Scalars['String']>;
  teamleaderID_lte?: InputMaybe<Scalars['String']>;
  teamleaderID_not?: InputMaybe<Scalars['String']>;
  teamleaderID_not_contains?: InputMaybe<Scalars['String']>;
  teamleaderID_not_ends_with?: InputMaybe<Scalars['String']>;
  teamleaderID_not_in?: InputMaybe<Array<Scalars['String']>>;
  teamleaderID_not_starts_with?: InputMaybe<Scalars['String']>;
  teamleaderID_starts_with?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
  updatedAt_gt?: InputMaybe<Scalars['DateTime']>;
  updatedAt_gte?: InputMaybe<Scalars['DateTime']>;
  updatedAt_in?: InputMaybe<Array<Scalars['DateTime']>>;
  updatedAt_lt?: InputMaybe<Scalars['DateTime']>;
  updatedAt_lte?: InputMaybe<Scalars['DateTime']>;
  updatedAt_not?: InputMaybe<Scalars['DateTime']>;
  updatedAt_not_in?: InputMaybe<Array<Scalars['DateTime']>>;
};

export type SchoolSearchFilterInput = {
  first?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<SchoolSearchOrderByInput>;
  skip?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<SchoolSearchWhereInput>;
};

export type SchoolSearchOrderByInput = {
  columnName?: InputMaybe<SchoolOrderByColumns>;
  order?: InputMaybe<SortOrder>;
};

export type SchoolSearchResult = {
  aggregate: AggregateSchool;
  edges: Array<Maybe<SchoolEdge>>;
};

export type SchoolSearchWhereInput = {
  basispoortId?: InputMaybe<NumberFilterInput>;
  city?: InputMaybe<StringFilterInput>;
  contact?: InputMaybe<StringFilterInput>;
  defaultKeyboardLayout?: InputMaybe<KeyboardLayoutInput>;
  email?: InputMaybe<StringFilterInput>;
  id?: InputMaybe<StringFilterInput>;
  invoiceToDistrict?: InputMaybe<Scalars['Boolean']>;
  isAuthorisedByBasispoort?: InputMaybe<Scalars['Boolean']>;
  isSyncedWithBasispoort?: InputMaybe<Scalars['Boolean']>;
  licenseSubscriptionActive?: InputMaybe<Scalars['Boolean']>;
  licensesInUse?: InputMaybe<NumberFilterInput>;
  licensesRemaining?: InputMaybe<NumberFilterInput>;
  licensesTotal?: InputMaybe<NumberFilterInput>;
  name?: InputMaybe<StringFilterInput>;
  renewalDate?: InputMaybe<DateFilterInput>;
  requestsBasispoortConnection?: InputMaybe<Scalars['Boolean']>;
  schoolDistrictId?: InputMaybe<StringFilterInput>;
  schoolDistrictName?: InputMaybe<StringFilterInput>;
  userLastLoginCount?: InputMaybe<DateFilterInput>;
};

export type SchoolSubscriptionPayload = {
  mutation: MutationType;
  node?: Maybe<School>;
  previousValues?: Maybe<SchoolPreviousValues>;
  updatedFields?: Maybe<Array<Scalars['String']>>;
};

export type SchoolSubscriptionWhereInput = {
  AND?: InputMaybe<Array<SchoolSubscriptionWhereInput>>;
  NOT?: InputMaybe<Array<SchoolSubscriptionWhereInput>>;
  OR?: InputMaybe<Array<SchoolSubscriptionWhereInput>>;
  mutation_in?: InputMaybe<Array<MutationType>>;
  node?: InputMaybe<SchoolWhereInput>;
  updatedFields_contains?: InputMaybe<Scalars['String']>;
  updatedFields_contains_every?: InputMaybe<Array<Scalars['String']>>;
  updatedFields_contains_some?: InputMaybe<Array<Scalars['String']>>;
};

export type SchoolUpdateInput = {
  acceptsDataProcessingAgreement?: InputMaybe<Scalars['Boolean']>;
  acceptsTermsAndConditions?: InputMaybe<Scalars['Boolean']>;
  activated?: InputMaybe<Scalars['Boolean']>;
  address?: InputMaybe<AddressUpdateOneRequiredInput>;
  basispoortId?: InputMaybe<Scalars['Int']>;
  brinNumber?: InputMaybe<Scalars['String']>;
  canEditKeyboardLayout?: InputMaybe<Scalars['Boolean']>;
  chamberOfCommerceNumber?: InputMaybe<Scalars['String']>;
  copyEmail?: InputMaybe<Scalars['String']>;
  defaultKeyboardLayout?: InputMaybe<KeyboardLayout>;
  email?: InputMaybe<Scalars['String']>;
  generalEmailForEmailNotifications?: InputMaybe<Scalars['String']>;
  institution?: InputMaybe<InstitutionInput>;
  invoiceInfo?: InputMaybe<InvoiceInfoUpdateOneInput>;
  licenseSubscription?: InputMaybe<LicenseInfoUpdateOneInput>;
  name?: InputMaybe<Scalars['String']>;
  organisationType?: InputMaybe<SchoolOrganisationType>;
  phone?: InputMaybe<Scalars['String']>;
  receivedSignedDataProcessingAgreement?: InputMaybe<Scalars['Boolean']>;
  requestsBasispoortConnection?: InputMaybe<Scalars['Boolean']>;
  subscribedToDiplomaEmails?: InputMaybe<Scalars['Boolean']>;
  subscribedToEmails?: InputMaybe<Scalars['Boolean']>;
  subscribedToStudentReportEmails?: InputMaybe<Scalars['Boolean']>;
  teamleaderID?: InputMaybe<Scalars['String']>;
};

export type SchoolUpdateManyDataInput = {
  acceptsDataProcessingAgreement?: InputMaybe<Scalars['Boolean']>;
  acceptsTermsAndConditions?: InputMaybe<Scalars['Boolean']>;
  activated?: InputMaybe<Scalars['Boolean']>;
  brinNumber?: InputMaybe<Scalars['String']>;
  canEditKeyboardLayout?: InputMaybe<Scalars['Boolean']>;
  chamberOfCommerceNumber?: InputMaybe<Scalars['String']>;
  copyEmail?: InputMaybe<Scalars['String']>;
  defaultKeyboardLayout?: InputMaybe<KeyboardLayout>;
  email?: InputMaybe<Scalars['String']>;
  institutionDataSource?: InputMaybe<InstitutionDataSource>;
  institutionId?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  organisationType?: InputMaybe<SchoolOrganisationType>;
  phone?: InputMaybe<Scalars['String']>;
  receivedSignedDataProcessingAgreement?: InputMaybe<Scalars['Boolean']>;
  subscribedToEmails?: InputMaybe<Scalars['Boolean']>;
  teamleaderID?: InputMaybe<Scalars['String']>;
};

export type SchoolUpdateManyMutationInput = {
  acceptsDataProcessingAgreement?: InputMaybe<Scalars['Boolean']>;
  acceptsTermsAndConditions?: InputMaybe<Scalars['Boolean']>;
  activated?: InputMaybe<Scalars['Boolean']>;
  brinNumber?: InputMaybe<Scalars['String']>;
  canEditKeyboardLayout?: InputMaybe<Scalars['Boolean']>;
  chamberOfCommerceNumber?: InputMaybe<Scalars['String']>;
  copyEmail?: InputMaybe<Scalars['String']>;
  defaultKeyboardLayout?: InputMaybe<KeyboardLayout>;
  email?: InputMaybe<Scalars['String']>;
  institutionDataSource?: InputMaybe<InstitutionDataSource>;
  institutionId?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  organisationType?: InputMaybe<SchoolOrganisationType>;
  phone?: InputMaybe<Scalars['String']>;
  receivedSignedDataProcessingAgreement?: InputMaybe<Scalars['Boolean']>;
  subscribedToEmails?: InputMaybe<Scalars['Boolean']>;
  teamleaderID?: InputMaybe<Scalars['String']>;
};

export type SchoolUpdateManyWithWhereNestedInput = {
  data: SchoolUpdateManyDataInput;
  where: SchoolScalarWhereInput;
};

export type SchoolUpdateManyWithoutPartnerInput = {
  connect?: InputMaybe<Array<SchoolWhereUniqueInput>>;
  create?: InputMaybe<Array<SchoolCreateWithoutPartnerInput>>;
  delete?: InputMaybe<Array<SchoolWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<SchoolScalarWhereInput>>;
  disconnect?: InputMaybe<Array<SchoolWhereUniqueInput>>;
  set?: InputMaybe<Array<SchoolWhereUniqueInput>>;
  update?: InputMaybe<Array<SchoolUpdateWithWhereUniqueWithoutPartnerInput>>;
  updateMany?: InputMaybe<Array<SchoolUpdateManyWithWhereNestedInput>>;
  upsert?: InputMaybe<Array<SchoolUpsertWithWhereUniqueWithoutPartnerInput>>;
};

export type SchoolUpdateManyWithoutSchoolDistrictInput = {
  connect?: InputMaybe<Array<SchoolWhereUniqueInput>>;
  create?: InputMaybe<Array<SchoolCreateWithoutSchoolDistrictInput>>;
  delete?: InputMaybe<Array<SchoolWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<SchoolScalarWhereInput>>;
  disconnect?: InputMaybe<Array<SchoolWhereUniqueInput>>;
  set?: InputMaybe<Array<SchoolWhereUniqueInput>>;
  update?: InputMaybe<
    Array<SchoolUpdateWithWhereUniqueWithoutSchoolDistrictInput>
  >;
  updateMany?: InputMaybe<Array<SchoolUpdateManyWithWhereNestedInput>>;
  upsert?: InputMaybe<
    Array<SchoolUpsertWithWhereUniqueWithoutSchoolDistrictInput>
  >;
};

export type SchoolUpdateManyWithoutUsersInput = {
  connect?: InputMaybe<Array<SchoolWhereUniqueInput>>;
  create?: InputMaybe<Array<SchoolCreateWithoutUsersInput>>;
  delete?: InputMaybe<Array<SchoolWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<SchoolScalarWhereInput>>;
  disconnect?: InputMaybe<Array<SchoolWhereUniqueInput>>;
  set?: InputMaybe<Array<SchoolWhereUniqueInput>>;
  update?: InputMaybe<Array<SchoolUpdateWithWhereUniqueWithoutUsersInput>>;
  updateMany?: InputMaybe<Array<SchoolUpdateManyWithWhereNestedInput>>;
  upsert?: InputMaybe<Array<SchoolUpsertWithWhereUniqueWithoutUsersInput>>;
};

export type SchoolUpdateOneRequiredWithoutAccessRequestsInput = {
  connect?: InputMaybe<SchoolWhereUniqueInput>;
  create?: InputMaybe<SchoolCreateWithoutAccessRequestsInput>;
  update?: InputMaybe<SchoolUpdateWithoutAccessRequestsDataInput>;
  upsert?: InputMaybe<SchoolUpsertWithoutAccessRequestsInput>;
};

export type SchoolUpdateOneWithoutCourseGroupsInput = {
  connect?: InputMaybe<SchoolWhereUniqueInput>;
  create?: InputMaybe<SchoolCreateWithoutCourseGroupsInput>;
  delete?: InputMaybe<Scalars['Boolean']>;
  disconnect?: InputMaybe<Scalars['Boolean']>;
  update?: InputMaybe<SchoolUpdateWithoutCourseGroupsDataInput>;
  upsert?: InputMaybe<SchoolUpsertWithoutCourseGroupsInput>;
};

export type SchoolUpdateWithWhereUniqueWithoutPartnerInput = {
  data: SchoolUpdateWithoutPartnerDataInput;
  where: SchoolWhereUniqueInput;
};

export type SchoolUpdateWithWhereUniqueWithoutSchoolDistrictInput = {
  data: SchoolUpdateWithoutSchoolDistrictDataInput;
  where: SchoolWhereUniqueInput;
};

export type SchoolUpdateWithWhereUniqueWithoutUsersInput = {
  data: SchoolUpdateWithoutUsersDataInput;
  where: SchoolWhereUniqueInput;
};

export type SchoolUpdateWithoutAccessRequestsDataInput = {
  acceptsDataProcessingAgreement?: InputMaybe<Scalars['Boolean']>;
  acceptsTermsAndConditions?: InputMaybe<Scalars['Boolean']>;
  activated?: InputMaybe<Scalars['Boolean']>;
  address?: InputMaybe<ContactDetailsUpdateOneRequiredInput>;
  brinNumber?: InputMaybe<Scalars['String']>;
  canEditKeyboardLayout?: InputMaybe<Scalars['Boolean']>;
  chamberOfCommerceNumber?: InputMaybe<Scalars['String']>;
  copyEmail?: InputMaybe<Scalars['String']>;
  courseGroups?: InputMaybe<CourseGroupUpdateManyWithoutSchoolInput>;
  defaultKeyboardLayout?: InputMaybe<KeyboardLayout>;
  email?: InputMaybe<Scalars['String']>;
  institutionDataSource?: InputMaybe<InstitutionDataSource>;
  institutionId?: InputMaybe<Scalars['String']>;
  invoiceInfo?: InputMaybe<ContactDetailsUpdateOneInput>;
  licensePool?: InputMaybe<LicensePoolUpdateOneRequiredInput>;
  licenseSubscription?: InputMaybe<LicenseSubscriptionInfoUpdateOneInput>;
  name?: InputMaybe<Scalars['String']>;
  organisationType?: InputMaybe<SchoolOrganisationType>;
  partner?: InputMaybe<PartnerUpdateOneWithoutSchoolsInput>;
  phone?: InputMaybe<Scalars['String']>;
  previousSubscriptions?: InputMaybe<LicenseSubscriptionInfoUpdateManyInput>;
  receivedSignedDataProcessingAgreement?: InputMaybe<Scalars['Boolean']>;
  schoolDistrict?: InputMaybe<SchoolDistrictUpdateOneWithoutSchoolsInput>;
  subscribedToEmails?: InputMaybe<Scalars['Boolean']>;
  teamleaderID?: InputMaybe<Scalars['String']>;
  users?: InputMaybe<BeheerUserUpdateManyWithoutSchoolsInput>;
};

export type SchoolUpdateWithoutCourseGroupsDataInput = {
  acceptsDataProcessingAgreement?: InputMaybe<Scalars['Boolean']>;
  acceptsTermsAndConditions?: InputMaybe<Scalars['Boolean']>;
  accessRequests?: InputMaybe<AccessRequestUpdateManyWithoutSchoolInput>;
  activated?: InputMaybe<Scalars['Boolean']>;
  address?: InputMaybe<ContactDetailsUpdateOneRequiredInput>;
  brinNumber?: InputMaybe<Scalars['String']>;
  canEditKeyboardLayout?: InputMaybe<Scalars['Boolean']>;
  chamberOfCommerceNumber?: InputMaybe<Scalars['String']>;
  copyEmail?: InputMaybe<Scalars['String']>;
  defaultKeyboardLayout?: InputMaybe<KeyboardLayout>;
  email?: InputMaybe<Scalars['String']>;
  institutionDataSource?: InputMaybe<InstitutionDataSource>;
  institutionId?: InputMaybe<Scalars['String']>;
  invoiceInfo?: InputMaybe<ContactDetailsUpdateOneInput>;
  licensePool?: InputMaybe<LicensePoolUpdateOneRequiredInput>;
  licenseSubscription?: InputMaybe<LicenseSubscriptionInfoUpdateOneInput>;
  name?: InputMaybe<Scalars['String']>;
  organisationType?: InputMaybe<SchoolOrganisationType>;
  partner?: InputMaybe<PartnerUpdateOneWithoutSchoolsInput>;
  phone?: InputMaybe<Scalars['String']>;
  previousSubscriptions?: InputMaybe<LicenseSubscriptionInfoUpdateManyInput>;
  receivedSignedDataProcessingAgreement?: InputMaybe<Scalars['Boolean']>;
  schoolDistrict?: InputMaybe<SchoolDistrictUpdateOneWithoutSchoolsInput>;
  subscribedToEmails?: InputMaybe<Scalars['Boolean']>;
  teamleaderID?: InputMaybe<Scalars['String']>;
  users?: InputMaybe<BeheerUserUpdateManyWithoutSchoolsInput>;
};

export type SchoolUpdateWithoutPartnerDataInput = {
  acceptsDataProcessingAgreement?: InputMaybe<Scalars['Boolean']>;
  acceptsTermsAndConditions?: InputMaybe<Scalars['Boolean']>;
  accessRequests?: InputMaybe<AccessRequestUpdateManyWithoutSchoolInput>;
  activated?: InputMaybe<Scalars['Boolean']>;
  address?: InputMaybe<ContactDetailsUpdateOneRequiredInput>;
  brinNumber?: InputMaybe<Scalars['String']>;
  canEditKeyboardLayout?: InputMaybe<Scalars['Boolean']>;
  chamberOfCommerceNumber?: InputMaybe<Scalars['String']>;
  copyEmail?: InputMaybe<Scalars['String']>;
  courseGroups?: InputMaybe<CourseGroupUpdateManyWithoutSchoolInput>;
  defaultKeyboardLayout?: InputMaybe<KeyboardLayout>;
  email?: InputMaybe<Scalars['String']>;
  institutionDataSource?: InputMaybe<InstitutionDataSource>;
  institutionId?: InputMaybe<Scalars['String']>;
  invoiceInfo?: InputMaybe<ContactDetailsUpdateOneInput>;
  licensePool?: InputMaybe<LicensePoolUpdateOneRequiredInput>;
  licenseSubscription?: InputMaybe<LicenseSubscriptionInfoUpdateOneInput>;
  name?: InputMaybe<Scalars['String']>;
  organisationType?: InputMaybe<SchoolOrganisationType>;
  phone?: InputMaybe<Scalars['String']>;
  previousSubscriptions?: InputMaybe<LicenseSubscriptionInfoUpdateManyInput>;
  receivedSignedDataProcessingAgreement?: InputMaybe<Scalars['Boolean']>;
  schoolDistrict?: InputMaybe<SchoolDistrictUpdateOneWithoutSchoolsInput>;
  subscribedToEmails?: InputMaybe<Scalars['Boolean']>;
  teamleaderID?: InputMaybe<Scalars['String']>;
  users?: InputMaybe<BeheerUserUpdateManyWithoutSchoolsInput>;
};

export type SchoolUpdateWithoutSchoolDistrictDataInput = {
  acceptsDataProcessingAgreement?: InputMaybe<Scalars['Boolean']>;
  acceptsTermsAndConditions?: InputMaybe<Scalars['Boolean']>;
  accessRequests?: InputMaybe<AccessRequestUpdateManyWithoutSchoolInput>;
  activated?: InputMaybe<Scalars['Boolean']>;
  address?: InputMaybe<ContactDetailsUpdateOneRequiredInput>;
  brinNumber?: InputMaybe<Scalars['String']>;
  canEditKeyboardLayout?: InputMaybe<Scalars['Boolean']>;
  chamberOfCommerceNumber?: InputMaybe<Scalars['String']>;
  copyEmail?: InputMaybe<Scalars['String']>;
  courseGroups?: InputMaybe<CourseGroupUpdateManyWithoutSchoolInput>;
  defaultKeyboardLayout?: InputMaybe<KeyboardLayout>;
  email?: InputMaybe<Scalars['String']>;
  institutionDataSource?: InputMaybe<InstitutionDataSource>;
  institutionId?: InputMaybe<Scalars['String']>;
  invoiceInfo?: InputMaybe<ContactDetailsUpdateOneInput>;
  licensePool?: InputMaybe<LicensePoolUpdateOneRequiredInput>;
  licenseSubscription?: InputMaybe<LicenseSubscriptionInfoUpdateOneInput>;
  name?: InputMaybe<Scalars['String']>;
  organisationType?: InputMaybe<SchoolOrganisationType>;
  partner?: InputMaybe<PartnerUpdateOneWithoutSchoolsInput>;
  phone?: InputMaybe<Scalars['String']>;
  previousSubscriptions?: InputMaybe<LicenseSubscriptionInfoUpdateManyInput>;
  receivedSignedDataProcessingAgreement?: InputMaybe<Scalars['Boolean']>;
  subscribedToEmails?: InputMaybe<Scalars['Boolean']>;
  teamleaderID?: InputMaybe<Scalars['String']>;
  users?: InputMaybe<BeheerUserUpdateManyWithoutSchoolsInput>;
};

export type SchoolUpdateWithoutUsersDataInput = {
  acceptsDataProcessingAgreement?: InputMaybe<Scalars['Boolean']>;
  acceptsTermsAndConditions?: InputMaybe<Scalars['Boolean']>;
  accessRequests?: InputMaybe<AccessRequestUpdateManyWithoutSchoolInput>;
  activated?: InputMaybe<Scalars['Boolean']>;
  address?: InputMaybe<ContactDetailsUpdateOneRequiredInput>;
  brinNumber?: InputMaybe<Scalars['String']>;
  canEditKeyboardLayout?: InputMaybe<Scalars['Boolean']>;
  chamberOfCommerceNumber?: InputMaybe<Scalars['String']>;
  copyEmail?: InputMaybe<Scalars['String']>;
  courseGroups?: InputMaybe<CourseGroupUpdateManyWithoutSchoolInput>;
  defaultKeyboardLayout?: InputMaybe<KeyboardLayout>;
  email?: InputMaybe<Scalars['String']>;
  institutionDataSource?: InputMaybe<InstitutionDataSource>;
  institutionId?: InputMaybe<Scalars['String']>;
  invoiceInfo?: InputMaybe<ContactDetailsUpdateOneInput>;
  licensePool?: InputMaybe<LicensePoolUpdateOneRequiredInput>;
  licenseSubscription?: InputMaybe<LicenseSubscriptionInfoUpdateOneInput>;
  name?: InputMaybe<Scalars['String']>;
  organisationType?: InputMaybe<SchoolOrganisationType>;
  partner?: InputMaybe<PartnerUpdateOneWithoutSchoolsInput>;
  phone?: InputMaybe<Scalars['String']>;
  previousSubscriptions?: InputMaybe<LicenseSubscriptionInfoUpdateManyInput>;
  receivedSignedDataProcessingAgreement?: InputMaybe<Scalars['Boolean']>;
  schoolDistrict?: InputMaybe<SchoolDistrictUpdateOneWithoutSchoolsInput>;
  subscribedToEmails?: InputMaybe<Scalars['Boolean']>;
  teamleaderID?: InputMaybe<Scalars['String']>;
};

export type SchoolUpsertWithWhereUniqueWithoutPartnerInput = {
  create: SchoolCreateWithoutPartnerInput;
  update: SchoolUpdateWithoutPartnerDataInput;
  where: SchoolWhereUniqueInput;
};

export type SchoolUpsertWithWhereUniqueWithoutSchoolDistrictInput = {
  create: SchoolCreateWithoutSchoolDistrictInput;
  update: SchoolUpdateWithoutSchoolDistrictDataInput;
  where: SchoolWhereUniqueInput;
};

export type SchoolUpsertWithWhereUniqueWithoutUsersInput = {
  create: SchoolCreateWithoutUsersInput;
  update: SchoolUpdateWithoutUsersDataInput;
  where: SchoolWhereUniqueInput;
};

export type SchoolUpsertWithoutAccessRequestsInput = {
  create: SchoolCreateWithoutAccessRequestsInput;
  update: SchoolUpdateWithoutAccessRequestsDataInput;
};

export type SchoolUpsertWithoutCourseGroupsInput = {
  create: SchoolCreateWithoutCourseGroupsInput;
  update: SchoolUpdateWithoutCourseGroupsDataInput;
};

export type SchoolWhereInput = {
  AND?: InputMaybe<Array<SchoolWhereInput>>;
  NOT?: InputMaybe<Array<SchoolWhereInput>>;
  OR?: InputMaybe<Array<SchoolWhereInput>>;
  acceptsDataProcessingAgreement?: InputMaybe<Scalars['Boolean']>;
  acceptsDataProcessingAgreement_not?: InputMaybe<Scalars['Boolean']>;
  acceptsTermsAndConditions?: InputMaybe<Scalars['Boolean']>;
  acceptsTermsAndConditions_not?: InputMaybe<Scalars['Boolean']>;
  accessRequests_every?: InputMaybe<AccessRequestWhereInput>;
  accessRequests_none?: InputMaybe<AccessRequestWhereInput>;
  accessRequests_some?: InputMaybe<AccessRequestWhereInput>;
  activated?: InputMaybe<Scalars['Boolean']>;
  activated_not?: InputMaybe<Scalars['Boolean']>;
  address?: InputMaybe<ContactDetailsWhereInput>;
  brinNumber?: InputMaybe<Scalars['String']>;
  brinNumber_contains?: InputMaybe<Scalars['String']>;
  brinNumber_ends_with?: InputMaybe<Scalars['String']>;
  brinNumber_gt?: InputMaybe<Scalars['String']>;
  brinNumber_gte?: InputMaybe<Scalars['String']>;
  brinNumber_in?: InputMaybe<Array<Scalars['String']>>;
  brinNumber_lt?: InputMaybe<Scalars['String']>;
  brinNumber_lte?: InputMaybe<Scalars['String']>;
  brinNumber_not?: InputMaybe<Scalars['String']>;
  brinNumber_not_contains?: InputMaybe<Scalars['String']>;
  brinNumber_not_ends_with?: InputMaybe<Scalars['String']>;
  brinNumber_not_in?: InputMaybe<Array<Scalars['String']>>;
  brinNumber_not_starts_with?: InputMaybe<Scalars['String']>;
  brinNumber_starts_with?: InputMaybe<Scalars['String']>;
  canEditKeyboardLayout?: InputMaybe<Scalars['Boolean']>;
  canEditKeyboardLayout_not?: InputMaybe<Scalars['Boolean']>;
  chamberOfCommerceNumber?: InputMaybe<Scalars['String']>;
  chamberOfCommerceNumber_contains?: InputMaybe<Scalars['String']>;
  chamberOfCommerceNumber_ends_with?: InputMaybe<Scalars['String']>;
  chamberOfCommerceNumber_gt?: InputMaybe<Scalars['String']>;
  chamberOfCommerceNumber_gte?: InputMaybe<Scalars['String']>;
  chamberOfCommerceNumber_in?: InputMaybe<Array<Scalars['String']>>;
  chamberOfCommerceNumber_lt?: InputMaybe<Scalars['String']>;
  chamberOfCommerceNumber_lte?: InputMaybe<Scalars['String']>;
  chamberOfCommerceNumber_not?: InputMaybe<Scalars['String']>;
  chamberOfCommerceNumber_not_contains?: InputMaybe<Scalars['String']>;
  chamberOfCommerceNumber_not_ends_with?: InputMaybe<Scalars['String']>;
  chamberOfCommerceNumber_not_in?: InputMaybe<Array<Scalars['String']>>;
  chamberOfCommerceNumber_not_starts_with?: InputMaybe<Scalars['String']>;
  chamberOfCommerceNumber_starts_with?: InputMaybe<Scalars['String']>;
  copyEmail?: InputMaybe<Scalars['String']>;
  copyEmail_contains?: InputMaybe<Scalars['String']>;
  copyEmail_ends_with?: InputMaybe<Scalars['String']>;
  copyEmail_gt?: InputMaybe<Scalars['String']>;
  copyEmail_gte?: InputMaybe<Scalars['String']>;
  copyEmail_in?: InputMaybe<Array<Scalars['String']>>;
  copyEmail_lt?: InputMaybe<Scalars['String']>;
  copyEmail_lte?: InputMaybe<Scalars['String']>;
  copyEmail_not?: InputMaybe<Scalars['String']>;
  copyEmail_not_contains?: InputMaybe<Scalars['String']>;
  copyEmail_not_ends_with?: InputMaybe<Scalars['String']>;
  copyEmail_not_in?: InputMaybe<Array<Scalars['String']>>;
  copyEmail_not_starts_with?: InputMaybe<Scalars['String']>;
  copyEmail_starts_with?: InputMaybe<Scalars['String']>;
  courseGroups_every?: InputMaybe<CourseGroupWhereInput>;
  courseGroups_none?: InputMaybe<CourseGroupWhereInput>;
  courseGroups_some?: InputMaybe<CourseGroupWhereInput>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  createdAt_gt?: InputMaybe<Scalars['DateTime']>;
  createdAt_gte?: InputMaybe<Scalars['DateTime']>;
  createdAt_in?: InputMaybe<Array<Scalars['DateTime']>>;
  createdAt_lt?: InputMaybe<Scalars['DateTime']>;
  createdAt_lte?: InputMaybe<Scalars['DateTime']>;
  createdAt_not?: InputMaybe<Scalars['DateTime']>;
  createdAt_not_in?: InputMaybe<Array<Scalars['DateTime']>>;
  defaultKeyboardLayout?: InputMaybe<KeyboardLayout>;
  defaultKeyboardLayout_in?: InputMaybe<Array<KeyboardLayout>>;
  defaultKeyboardLayout_not?: InputMaybe<KeyboardLayout>;
  defaultKeyboardLayout_not_in?: InputMaybe<Array<KeyboardLayout>>;
  email?: InputMaybe<Scalars['String']>;
  email_contains?: InputMaybe<Scalars['String']>;
  email_ends_with?: InputMaybe<Scalars['String']>;
  email_gt?: InputMaybe<Scalars['String']>;
  email_gte?: InputMaybe<Scalars['String']>;
  email_in?: InputMaybe<Array<Scalars['String']>>;
  email_lt?: InputMaybe<Scalars['String']>;
  email_lte?: InputMaybe<Scalars['String']>;
  email_not?: InputMaybe<Scalars['String']>;
  email_not_contains?: InputMaybe<Scalars['String']>;
  email_not_ends_with?: InputMaybe<Scalars['String']>;
  email_not_in?: InputMaybe<Array<Scalars['String']>>;
  email_not_starts_with?: InputMaybe<Scalars['String']>;
  email_starts_with?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['ID']>;
  id_contains?: InputMaybe<Scalars['ID']>;
  id_ends_with?: InputMaybe<Scalars['ID']>;
  id_gt?: InputMaybe<Scalars['ID']>;
  id_gte?: InputMaybe<Scalars['ID']>;
  id_in?: InputMaybe<Array<Scalars['ID']>>;
  id_lt?: InputMaybe<Scalars['ID']>;
  id_lte?: InputMaybe<Scalars['ID']>;
  id_not?: InputMaybe<Scalars['ID']>;
  id_not_contains?: InputMaybe<Scalars['ID']>;
  id_not_ends_with?: InputMaybe<Scalars['ID']>;
  id_not_in?: InputMaybe<Array<Scalars['ID']>>;
  id_not_starts_with?: InputMaybe<Scalars['ID']>;
  id_starts_with?: InputMaybe<Scalars['ID']>;
  institutionDataSource?: InputMaybe<InstitutionDataSource>;
  institutionDataSource_in?: InputMaybe<Array<InstitutionDataSource>>;
  institutionDataSource_not?: InputMaybe<InstitutionDataSource>;
  institutionDataSource_not_in?: InputMaybe<Array<InstitutionDataSource>>;
  institutionId?: InputMaybe<Scalars['String']>;
  institutionId_contains?: InputMaybe<Scalars['String']>;
  institutionId_ends_with?: InputMaybe<Scalars['String']>;
  institutionId_gt?: InputMaybe<Scalars['String']>;
  institutionId_gte?: InputMaybe<Scalars['String']>;
  institutionId_in?: InputMaybe<Array<Scalars['String']>>;
  institutionId_lt?: InputMaybe<Scalars['String']>;
  institutionId_lte?: InputMaybe<Scalars['String']>;
  institutionId_not?: InputMaybe<Scalars['String']>;
  institutionId_not_contains?: InputMaybe<Scalars['String']>;
  institutionId_not_ends_with?: InputMaybe<Scalars['String']>;
  institutionId_not_in?: InputMaybe<Array<Scalars['String']>>;
  institutionId_not_starts_with?: InputMaybe<Scalars['String']>;
  institutionId_starts_with?: InputMaybe<Scalars['String']>;
  invoiceInfo?: InputMaybe<ContactDetailsWhereInput>;
  licensePool?: InputMaybe<LicensePoolWhereInput>;
  licenseSubscription?: InputMaybe<LicenseSubscriptionInfoWhereInput>;
  name?: InputMaybe<Scalars['String']>;
  name_contains?: InputMaybe<Scalars['String']>;
  name_ends_with?: InputMaybe<Scalars['String']>;
  name_gt?: InputMaybe<Scalars['String']>;
  name_gte?: InputMaybe<Scalars['String']>;
  name_in?: InputMaybe<Array<Scalars['String']>>;
  name_lt?: InputMaybe<Scalars['String']>;
  name_lte?: InputMaybe<Scalars['String']>;
  name_not?: InputMaybe<Scalars['String']>;
  name_not_contains?: InputMaybe<Scalars['String']>;
  name_not_ends_with?: InputMaybe<Scalars['String']>;
  name_not_in?: InputMaybe<Array<Scalars['String']>>;
  name_not_starts_with?: InputMaybe<Scalars['String']>;
  name_starts_with?: InputMaybe<Scalars['String']>;
  organisationType?: InputMaybe<SchoolOrganisationType>;
  organisationType_in?: InputMaybe<Array<SchoolOrganisationType>>;
  organisationType_not?: InputMaybe<SchoolOrganisationType>;
  organisationType_not_in?: InputMaybe<Array<SchoolOrganisationType>>;
  partner?: InputMaybe<PartnerWhereInput>;
  phone?: InputMaybe<Scalars['String']>;
  phone_contains?: InputMaybe<Scalars['String']>;
  phone_ends_with?: InputMaybe<Scalars['String']>;
  phone_gt?: InputMaybe<Scalars['String']>;
  phone_gte?: InputMaybe<Scalars['String']>;
  phone_in?: InputMaybe<Array<Scalars['String']>>;
  phone_lt?: InputMaybe<Scalars['String']>;
  phone_lte?: InputMaybe<Scalars['String']>;
  phone_not?: InputMaybe<Scalars['String']>;
  phone_not_contains?: InputMaybe<Scalars['String']>;
  phone_not_ends_with?: InputMaybe<Scalars['String']>;
  phone_not_in?: InputMaybe<Array<Scalars['String']>>;
  phone_not_starts_with?: InputMaybe<Scalars['String']>;
  phone_starts_with?: InputMaybe<Scalars['String']>;
  previousSubscriptions_every?: InputMaybe<LicenseSubscriptionInfoWhereInput>;
  previousSubscriptions_none?: InputMaybe<LicenseSubscriptionInfoWhereInput>;
  previousSubscriptions_some?: InputMaybe<LicenseSubscriptionInfoWhereInput>;
  receivedSignedDataProcessingAgreement?: InputMaybe<Scalars['Boolean']>;
  receivedSignedDataProcessingAgreement_not?: InputMaybe<Scalars['Boolean']>;
  schoolDistrict?: InputMaybe<SchoolDistrictWhereInput>;
  subscribedToEmails?: InputMaybe<Scalars['Boolean']>;
  subscribedToEmails_not?: InputMaybe<Scalars['Boolean']>;
  teamleaderID?: InputMaybe<Scalars['String']>;
  teamleaderID_contains?: InputMaybe<Scalars['String']>;
  teamleaderID_ends_with?: InputMaybe<Scalars['String']>;
  teamleaderID_gt?: InputMaybe<Scalars['String']>;
  teamleaderID_gte?: InputMaybe<Scalars['String']>;
  teamleaderID_in?: InputMaybe<Array<Scalars['String']>>;
  teamleaderID_lt?: InputMaybe<Scalars['String']>;
  teamleaderID_lte?: InputMaybe<Scalars['String']>;
  teamleaderID_not?: InputMaybe<Scalars['String']>;
  teamleaderID_not_contains?: InputMaybe<Scalars['String']>;
  teamleaderID_not_ends_with?: InputMaybe<Scalars['String']>;
  teamleaderID_not_in?: InputMaybe<Array<Scalars['String']>>;
  teamleaderID_not_starts_with?: InputMaybe<Scalars['String']>;
  teamleaderID_starts_with?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
  updatedAt_gt?: InputMaybe<Scalars['DateTime']>;
  updatedAt_gte?: InputMaybe<Scalars['DateTime']>;
  updatedAt_in?: InputMaybe<Array<Scalars['DateTime']>>;
  updatedAt_lt?: InputMaybe<Scalars['DateTime']>;
  updatedAt_lte?: InputMaybe<Scalars['DateTime']>;
  updatedAt_not?: InputMaybe<Scalars['DateTime']>;
  updatedAt_not_in?: InputMaybe<Array<Scalars['DateTime']>>;
  users_every?: InputMaybe<BeheerUserWhereInput>;
  users_none?: InputMaybe<BeheerUserWhereInput>;
  users_some?: InputMaybe<BeheerUserWhereInput>;
};

export type SchoolWhereUniqueInput = {
  chamberOfCommerceNumber?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['ID']>;
  teamleaderID?: InputMaybe<Scalars['String']>;
};

export type SchoolsFilterInput = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<SchoolOrderByInput>;
  skip?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<SchoolWhereInput>;
};

export type SearchUsersInput = {
  nameOrEmailContains: Scalars['String'];
};

export type SendMessageInput = {
  content: Scalars['String'];
  courseGroupId?: InputMaybe<Scalars['String']>;
  recipients: Array<Scalars['String']>;
  sendAs?: InputMaybe<Scalars['String']>;
  subject: Scalars['String'];
};

export type SendMessageResponse = Message | MessagesResponse;

export type SendSystemMessageInput = {
  content: Scalars['String'];
  schools?: InputMaybe<SendToOrganisationInput>;
  subject: Scalars['String'];
  users?: InputMaybe<SendSystemMessageUserInput>;
};

export type SendSystemMessageUserInput = {
  keyboardLayout?: InputMaybe<KeyboardLayout>;
  roles?: InputMaybe<Array<Role>>;
};

export type SendToOrganisationInput = {
  defaultKeyboardLayout?: InputMaybe<KeyboardLayout>;
  id_in?: InputMaybe<Array<Scalars['ID']>>;
  id_not_in?: InputMaybe<Array<Scalars['ID']>>;
};

export type SimplePageInfo = {
  hasNextPage: Scalars['Boolean'];
};

export type SkillCourse = {
  challenge?: Maybe<Challenge>;
  datetime: Scalars['DateTime'];
  id: Scalars['ID'];
  skill: Scalars['Decimal'];
  userLevel?: Maybe<UserLevel>;
};

export type SkillCourseConnection = {
  aggregate: AggregateSkillCourse;
  edges: Array<Maybe<SkillCourseEdge>>;
  pageInfo: PageInfo;
};

export type SkillCourseCreateInput = {
  challenge?: InputMaybe<ChallengeCreateOneWithoutSkillCourseInput>;
  id?: InputMaybe<Scalars['ID']>;
  skill: Scalars['Decimal'];
  userLevel?: InputMaybe<UserLevelCreateOneWithoutSkillCourseInput>;
};

export type SkillCourseCreateManyWithoutChallengeInput = {
  connect?: InputMaybe<Array<SkillCourseWhereUniqueInput>>;
  create?: InputMaybe<Array<SkillCourseCreateWithoutChallengeInput>>;
};

export type SkillCourseCreateManyWithoutUserLevelInput = {
  connect?: InputMaybe<Array<SkillCourseWhereUniqueInput>>;
  create?: InputMaybe<Array<SkillCourseCreateWithoutUserLevelInput>>;
};

export type SkillCourseCreateWithoutChallengeInput = {
  id?: InputMaybe<Scalars['ID']>;
  skill: Scalars['Decimal'];
  userLevel?: InputMaybe<UserLevelCreateOneWithoutSkillCourseInput>;
};

export type SkillCourseCreateWithoutUserLevelInput = {
  challenge?: InputMaybe<ChallengeCreateOneWithoutSkillCourseInput>;
  id?: InputMaybe<Scalars['ID']>;
  skill: Scalars['Decimal'];
};

export type SkillCourseEdge = {
  cursor: Scalars['String'];
  node: SkillCourse;
};

export type SkillCourseOrderByInput =
  | 'datetime_ASC'
  | 'datetime_DESC'
  | 'id_ASC'
  | 'id_DESC'
  | 'skill_ASC'
  | 'skill_DESC';

export type SkillCourseScalarWhereInput = {
  AND?: InputMaybe<Array<SkillCourseScalarWhereInput>>;
  NOT?: InputMaybe<Array<SkillCourseScalarWhereInput>>;
  OR?: InputMaybe<Array<SkillCourseScalarWhereInput>>;
  datetime?: InputMaybe<Scalars['DateTime']>;
  datetime_gt?: InputMaybe<Scalars['DateTime']>;
  datetime_gte?: InputMaybe<Scalars['DateTime']>;
  datetime_in?: InputMaybe<Array<Scalars['DateTime']>>;
  datetime_lt?: InputMaybe<Scalars['DateTime']>;
  datetime_lte?: InputMaybe<Scalars['DateTime']>;
  datetime_not?: InputMaybe<Scalars['DateTime']>;
  datetime_not_in?: InputMaybe<Array<Scalars['DateTime']>>;
  id?: InputMaybe<Scalars['ID']>;
  id_contains?: InputMaybe<Scalars['ID']>;
  id_ends_with?: InputMaybe<Scalars['ID']>;
  id_gt?: InputMaybe<Scalars['ID']>;
  id_gte?: InputMaybe<Scalars['ID']>;
  id_in?: InputMaybe<Array<Scalars['ID']>>;
  id_lt?: InputMaybe<Scalars['ID']>;
  id_lte?: InputMaybe<Scalars['ID']>;
  id_not?: InputMaybe<Scalars['ID']>;
  id_not_contains?: InputMaybe<Scalars['ID']>;
  id_not_ends_with?: InputMaybe<Scalars['ID']>;
  id_not_in?: InputMaybe<Array<Scalars['ID']>>;
  id_not_starts_with?: InputMaybe<Scalars['ID']>;
  id_starts_with?: InputMaybe<Scalars['ID']>;
  skill?: InputMaybe<Scalars['Decimal']>;
  skill_gt?: InputMaybe<Scalars['Decimal']>;
  skill_gte?: InputMaybe<Scalars['Decimal']>;
  skill_in?: InputMaybe<Array<Scalars['Decimal']>>;
  skill_lt?: InputMaybe<Scalars['Decimal']>;
  skill_lte?: InputMaybe<Scalars['Decimal']>;
  skill_not?: InputMaybe<Scalars['Decimal']>;
  skill_not_in?: InputMaybe<Array<Scalars['Decimal']>>;
};

export type SkillCourseUpdateInput = {
  challenge?: InputMaybe<ChallengeUpdateOneWithoutSkillCourseInput>;
  skill?: InputMaybe<Scalars['Decimal']>;
  userLevel?: InputMaybe<UserLevelUpdateOneWithoutSkillCourseInput>;
};

export type SkillCourseUpdateManyDataInput = {
  skill?: InputMaybe<Scalars['Decimal']>;
};

export type SkillCourseUpdateManyMutationInput = {
  skill?: InputMaybe<Scalars['Decimal']>;
};

export type SkillCourseUpdateManyWithWhereNestedInput = {
  data: SkillCourseUpdateManyDataInput;
  where: SkillCourseScalarWhereInput;
};

export type SkillCourseUpdateManyWithoutChallengeInput = {
  connect?: InputMaybe<Array<SkillCourseWhereUniqueInput>>;
  create?: InputMaybe<Array<SkillCourseCreateWithoutChallengeInput>>;
  delete?: InputMaybe<Array<SkillCourseWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<SkillCourseScalarWhereInput>>;
  disconnect?: InputMaybe<Array<SkillCourseWhereUniqueInput>>;
  set?: InputMaybe<Array<SkillCourseWhereUniqueInput>>;
  update?: InputMaybe<
    Array<SkillCourseUpdateWithWhereUniqueWithoutChallengeInput>
  >;
  updateMany?: InputMaybe<Array<SkillCourseUpdateManyWithWhereNestedInput>>;
  upsert?: InputMaybe<
    Array<SkillCourseUpsertWithWhereUniqueWithoutChallengeInput>
  >;
};

export type SkillCourseUpdateManyWithoutUserLevelInput = {
  connect?: InputMaybe<Array<SkillCourseWhereUniqueInput>>;
  create?: InputMaybe<Array<SkillCourseCreateWithoutUserLevelInput>>;
  delete?: InputMaybe<Array<SkillCourseWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<SkillCourseScalarWhereInput>>;
  disconnect?: InputMaybe<Array<SkillCourseWhereUniqueInput>>;
  set?: InputMaybe<Array<SkillCourseWhereUniqueInput>>;
  update?: InputMaybe<
    Array<SkillCourseUpdateWithWhereUniqueWithoutUserLevelInput>
  >;
  updateMany?: InputMaybe<Array<SkillCourseUpdateManyWithWhereNestedInput>>;
  upsert?: InputMaybe<
    Array<SkillCourseUpsertWithWhereUniqueWithoutUserLevelInput>
  >;
};

export type SkillCourseUpdateWithWhereUniqueWithoutChallengeInput = {
  data: SkillCourseUpdateWithoutChallengeDataInput;
  where: SkillCourseWhereUniqueInput;
};

export type SkillCourseUpdateWithWhereUniqueWithoutUserLevelInput = {
  data: SkillCourseUpdateWithoutUserLevelDataInput;
  where: SkillCourseWhereUniqueInput;
};

export type SkillCourseUpdateWithoutChallengeDataInput = {
  skill?: InputMaybe<Scalars['Decimal']>;
  userLevel?: InputMaybe<UserLevelUpdateOneWithoutSkillCourseInput>;
};

export type SkillCourseUpdateWithoutUserLevelDataInput = {
  challenge?: InputMaybe<ChallengeUpdateOneWithoutSkillCourseInput>;
  skill?: InputMaybe<Scalars['Decimal']>;
};

export type SkillCourseUpsertWithWhereUniqueWithoutChallengeInput = {
  create: SkillCourseCreateWithoutChallengeInput;
  update: SkillCourseUpdateWithoutChallengeDataInput;
  where: SkillCourseWhereUniqueInput;
};

export type SkillCourseUpsertWithWhereUniqueWithoutUserLevelInput = {
  create: SkillCourseCreateWithoutUserLevelInput;
  update: SkillCourseUpdateWithoutUserLevelDataInput;
  where: SkillCourseWhereUniqueInput;
};

export type SkillCourseWhereInput = {
  AND?: InputMaybe<Array<SkillCourseWhereInput>>;
  NOT?: InputMaybe<Array<SkillCourseWhereInput>>;
  OR?: InputMaybe<Array<SkillCourseWhereInput>>;
  challenge?: InputMaybe<ChallengeWhereInput>;
  datetime?: InputMaybe<Scalars['DateTime']>;
  datetime_gt?: InputMaybe<Scalars['DateTime']>;
  datetime_gte?: InputMaybe<Scalars['DateTime']>;
  datetime_in?: InputMaybe<Array<Scalars['DateTime']>>;
  datetime_lt?: InputMaybe<Scalars['DateTime']>;
  datetime_lte?: InputMaybe<Scalars['DateTime']>;
  datetime_not?: InputMaybe<Scalars['DateTime']>;
  datetime_not_in?: InputMaybe<Array<Scalars['DateTime']>>;
  id?: InputMaybe<Scalars['ID']>;
  id_contains?: InputMaybe<Scalars['ID']>;
  id_ends_with?: InputMaybe<Scalars['ID']>;
  id_gt?: InputMaybe<Scalars['ID']>;
  id_gte?: InputMaybe<Scalars['ID']>;
  id_in?: InputMaybe<Array<Scalars['ID']>>;
  id_lt?: InputMaybe<Scalars['ID']>;
  id_lte?: InputMaybe<Scalars['ID']>;
  id_not?: InputMaybe<Scalars['ID']>;
  id_not_contains?: InputMaybe<Scalars['ID']>;
  id_not_ends_with?: InputMaybe<Scalars['ID']>;
  id_not_in?: InputMaybe<Array<Scalars['ID']>>;
  id_not_starts_with?: InputMaybe<Scalars['ID']>;
  id_starts_with?: InputMaybe<Scalars['ID']>;
  skill?: InputMaybe<Scalars['Decimal']>;
  skill_gt?: InputMaybe<Scalars['Decimal']>;
  skill_gte?: InputMaybe<Scalars['Decimal']>;
  skill_in?: InputMaybe<Array<Scalars['Decimal']>>;
  skill_lt?: InputMaybe<Scalars['Decimal']>;
  skill_lte?: InputMaybe<Scalars['Decimal']>;
  skill_not?: InputMaybe<Scalars['Decimal']>;
  skill_not_in?: InputMaybe<Array<Scalars['Decimal']>>;
  userLevel?: InputMaybe<UserLevelWhereInput>;
};

export type SkillCourseWhereUniqueInput = {
  id?: InputMaybe<Scalars['ID']>;
};

export type SortOrder = 'ASC' | 'DESC';

export type StringFilter = {
  contains?: InputMaybe<Scalars['String']>;
  endsWith?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  gt?: InputMaybe<Scalars['String']>;
  gte?: InputMaybe<Scalars['String']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  lt?: InputMaybe<Scalars['String']>;
  lte?: InputMaybe<Scalars['String']>;
  mode?: InputMaybe<FilterMode>;
  not?: InputMaybe<Scalars['String']>;
  notIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  startsWith?: InputMaybe<Scalars['String']>;
};

export type StringFilterInput = {
  contains?: InputMaybe<Scalars['String']>;
  eq?: InputMaybe<Scalars['String']>;
  in?: InputMaybe<Array<Scalars['String']>>;
  notIn?: InputMaybe<Array<Scalars['String']>>;
};

export type StudentReportAccuracy = {
  accuracy?: Maybe<Scalars['Int']>;
  courseGroupName?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  name: Scalars['String'];
};

export type StudentReportCpm = {
  charactersPerMinute?: Maybe<Scalars['Int']>;
  courseGroupName?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  name: Scalars['String'];
};

export type StudentReportNotPlayed = {
  courseGroupName?: Maybe<Scalars['String']>;
  days?: Maybe<Scalars['Int']>;
  id: Scalars['ID'];
  name: Scalars['String'];
};

export type StudentReportPlaytime = {
  courseGroupName?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  name: Scalars['String'];
  playtimeInMinutes?: Maybe<Scalars['Int']>;
};

export type SubmitChallengeResult = ChallengeResult | ExerciseResult;

export type SuccessfulLoginPayLoad = {
  user: User;
};

export type SwitchContextInput = {
  resource?: InputMaybe<ResourceInput>;
  role?: InputMaybe<Role>;
  userId: Scalars['String'];
};

export type SystemMessageWhereInput = {
  content?: InputMaybe<StringFilter>;
  subject?: InputMaybe<StringFilter>;
};

export type Teamleader = {
  access: Scalars['Boolean'];
  clientId: Scalars['String'];
};

export type TeamleaderAccessCodeInput = {
  code: Scalars['String'];
  redirectUri: Scalars['String'];
};

export type TeamleaderAddress = {
  address?: Maybe<Scalars['String']>;
  city?: Maybe<Scalars['String']>;
  country?: Maybe<Scalars['String']>;
  postalCode?: Maybe<Scalars['String']>;
};

export type TeamleaderCompaniesWhereInput = {
  termContains: Scalars['String'];
};

export type TeamleaderCompany = {
  id: Scalars['String'];
  name: Scalars['String'];
  primaryAddress: TeamleaderAddress;
};

export type TimeSeriesBucket = 'Day' | 'Month' | 'Week' | 'Year';

export type TypeEnumFilter = {
  equals?: InputMaybe<MessageType>;
  in?: InputMaybe<Array<MessageType>>;
  not?: InputMaybe<TypeEnumFilter>;
  notIn?: InputMaybe<Array<MessageType>>;
};

export type UpsertNoteInput = {
  content: Scalars['String'];
};

export type UpsertNoteWhereInput = {
  userId: Scalars['ID'];
};

export type User = {
  basispoortId?: Maybe<Scalars['Int']>;
  beheer?: Maybe<BeheerUser>;
  birthDate?: Maybe<Scalars['DateTime']>;
  coachedCourseGroups: CourseGroupSearchResult;
  completedGames: Array<Game>;
  createdAt?: Maybe<Scalars['DateTime']>;
  educationGroup?: Maybe<EducationGroup>;
  email: Scalars['String'];
  emailConfirmedAt?: Maybe<Scalars['DateTime']>;
  emailPreferences: EmailPreferences;
  endDate?: Maybe<Scalars['DateTime']>;
  firstName: Scalars['String'];
  followingCourseGroup?: Maybe<CourseGroup>;
  gender?: Maybe<Gender>;
  hasExtendedLicense: Scalars['Boolean'];
  id: Scalars['ID'];
  keyboardLayout: KeyboardLayout;
  lastMessageSentAt?: Maybe<Scalars['DateTime']>;
  lastName: Scalars['String'];
  license?: Maybe<License>;
  licenseStatus: LicenseStatus;
  messagePreferences: MessagePreferences;
  mobile?: Maybe<Scalars['String']>;
  mostRecentLoginDate?: Maybe<Scalars['DateTime']>;
  mostRecentResource?: Maybe<MostRecentResource>;
  mostRecentRole?: Maybe<Role>;
  note?: Maybe<Note>;
  partners: Array<Partner>;
  phone?: Maybe<Scalars['String']>;
  prefix?: Maybe<Scalars['String']>;
  receivedMessages: MessageConnection;
  registrationNumber?: Maybe<Scalars['String']>;
  roles: Array<Role>;
  schoolDistricts: Array<SchoolDistrict>;
  schools: Array<School>;
  secondaryEmails: Array<Scalars['String']>;
  sentMessages: MessageConnection;
  sentMessagesCount: Scalars['Int'];
  startDate?: Maybe<Scalars['DateTime']>;
  students: UsersFilterMessage;
  typetuin?: Maybe<GameUser>;
  unreadMessagesCount: Scalars['Int'];
  username: Scalars['String'];
};

export type UserCoachedCourseGroupsArgs = {
  filter?: InputMaybe<CourseGroupsFilterInput>;
};

export type UserNoteArgs = {
  game?: InputMaybe<Game>;
};

export type UserReceivedMessagesArgs = {
  filter?: InputMaybe<MessageFilterInput>;
};

export type UserSentMessagesArgs = {
  filter?: InputMaybe<MessageFilterInput>;
};

export type UserStudentsArgs = {
  filter?: InputMaybe<UsersFilterArguments>;
};

export type UserUnreadMessagesCountArgs = {
  filter?: InputMaybe<MessageCountInput>;
};

export type UserCourseGroupInput = {
  coaches?: InputMaybe<Array<Scalars['ID']>>;
  courseGroupId: Scalars['ID'];
  students?: InputMaybe<Array<Scalars['ID']>>;
};

export type UserCreateInput = {
  birthDate?: InputMaybe<Scalars['DateTime']>;
  courseGroupId?: InputMaybe<Scalars['ID']>;
  educationGroupSlug?: InputMaybe<Scalars['String']>;
  email: Scalars['String'];
  emailConfirmedAt?: InputMaybe<Scalars['DateTime']>;
  endDate?: InputMaybe<Scalars['DateTime']>;
  firstName: Scalars['String'];
  gender?: InputMaybe<Gender>;
  isTempPassword?: InputMaybe<Scalars['Boolean']>;
  keyboardLayout?: InputMaybe<KeyboardLayout>;
  lastName: Scalars['String'];
  mobile?: InputMaybe<Scalars['String']>;
  password?: InputMaybe<Scalars['String']>;
  passwordConfirmation?: InputMaybe<Scalars['String']>;
  passwordResetToken?: InputMaybe<Scalars['String']>;
  phone?: InputMaybe<Scalars['String']>;
  prefix?: InputMaybe<Scalars['String']>;
  refreshToken?: InputMaybe<Scalars['String']>;
  resource?: InputMaybe<ResourceInput>;
  roles: Array<Role>;
  secondaryEmails?: InputMaybe<Array<Scalars['String']>>;
  startDate?: InputMaybe<Scalars['DateTime']>;
  tempPassword?: InputMaybe<Scalars['String']>;
  username?: InputMaybe<Scalars['String']>;
};

export type UserLevel = {
  accuracy?: Maybe<Scalars['Decimal']>;
  challengeRequestsCount?: Maybe<Scalars['Int']>;
  challengeResultsCount?: Maybe<Scalars['Int']>;
  charactersPerMinute?: Maybe<Scalars['Decimal']>;
  coachState: UserLevelState;
  completed: Scalars['Boolean'];
  createdAt: Scalars['DateTime'];
  firstTime: Scalars['Boolean'];
  id: Scalars['ID'];
  lastPlay?: Maybe<ChallengeResult>;
  level?: Maybe<Level>;
  progress?: Maybe<Scalars['Decimal']>;
  showedUnlockAnimation: Scalars['Boolean'];
  skill: Scalars['Decimal'];
  skillCourse?: Maybe<Array<SkillCourse>>;
  stars: Scalars['Int'];
  state: UserLevelState;
  unlocked?: Maybe<Scalars['Boolean']>;
  updatedAt: Scalars['DateTime'];
  user?: Maybe<GameUser>;
};

export type UserLevelConnection = {
  aggregate: AggregateUserLevel;
  edges: Array<Maybe<UserLevelEdge>>;
  pageInfo: PageInfo;
};

export type UserLevelCreateInput = {
  accuracy?: InputMaybe<Scalars['Decimal']>;
  charactersPerMinute?: InputMaybe<Scalars['Decimal']>;
  coachState?: InputMaybe<UserLevelState>;
  completed?: InputMaybe<Scalars['Boolean']>;
  firstTime?: InputMaybe<Scalars['Boolean']>;
  id?: InputMaybe<Scalars['ID']>;
  lastPlay?: InputMaybe<ChallengeResultCreateOneInput>;
  level: LevelCreateOneInput;
  previous?: InputMaybe<UserLevelCreateOneInput>;
  showedUnlockAnimation?: InputMaybe<Scalars['Boolean']>;
  skill?: InputMaybe<Scalars['Decimal']>;
  skillCourse?: InputMaybe<SkillCourseCreateManyWithoutUserLevelInput>;
  stars?: InputMaybe<Scalars['Int']>;
  state?: InputMaybe<UserLevelState>;
  unlocked?: InputMaybe<Scalars['Boolean']>;
  user: GameUserCreateOneWithoutUserLevelsInput;
};

export type UserLevelCreateManyWithoutUserInput = {
  connect?: InputMaybe<Array<UserLevelWhereUniqueInput>>;
  create?: InputMaybe<Array<UserLevelCreateWithoutUserInput>>;
};

export type UserLevelCreateOneInput = {
  connect?: InputMaybe<UserLevelWhereUniqueInput>;
  create?: InputMaybe<UserLevelCreateInput>;
};

export type UserLevelCreateOneWithoutSkillCourseInput = {
  connect?: InputMaybe<UserLevelWhereUniqueInput>;
  create?: InputMaybe<UserLevelCreateWithoutSkillCourseInput>;
};

export type UserLevelCreateWithoutSkillCourseInput = {
  accuracy?: InputMaybe<Scalars['Decimal']>;
  charactersPerMinute?: InputMaybe<Scalars['Decimal']>;
  coachState?: InputMaybe<UserLevelState>;
  completed?: InputMaybe<Scalars['Boolean']>;
  firstTime?: InputMaybe<Scalars['Boolean']>;
  id?: InputMaybe<Scalars['ID']>;
  lastPlay?: InputMaybe<ChallengeResultCreateOneInput>;
  level: LevelCreateOneInput;
  previous?: InputMaybe<UserLevelCreateOneInput>;
  showedUnlockAnimation?: InputMaybe<Scalars['Boolean']>;
  skill?: InputMaybe<Scalars['Decimal']>;
  stars?: InputMaybe<Scalars['Int']>;
  state?: InputMaybe<UserLevelState>;
  unlocked?: InputMaybe<Scalars['Boolean']>;
  user: GameUserCreateOneWithoutUserLevelsInput;
};

export type UserLevelCreateWithoutUserInput = {
  accuracy?: InputMaybe<Scalars['Decimal']>;
  charactersPerMinute?: InputMaybe<Scalars['Decimal']>;
  coachState?: InputMaybe<UserLevelState>;
  completed?: InputMaybe<Scalars['Boolean']>;
  firstTime?: InputMaybe<Scalars['Boolean']>;
  id?: InputMaybe<Scalars['ID']>;
  lastPlay?: InputMaybe<ChallengeResultCreateOneInput>;
  level: LevelCreateOneInput;
  previous?: InputMaybe<UserLevelCreateOneInput>;
  showedUnlockAnimation?: InputMaybe<Scalars['Boolean']>;
  skill?: InputMaybe<Scalars['Decimal']>;
  skillCourse?: InputMaybe<SkillCourseCreateManyWithoutUserLevelInput>;
  stars?: InputMaybe<Scalars['Int']>;
  state?: InputMaybe<UserLevelState>;
  unlocked?: InputMaybe<Scalars['Boolean']>;
};

export type UserLevelEdge = {
  cursor: Scalars['String'];
  node: UserLevel;
};

export type UserLevelOrderByInput =
  | 'accuracy_ASC'
  | 'accuracy_DESC'
  | 'charactersPerMinute_ASC'
  | 'charactersPerMinute_DESC'
  | 'coachState_ASC'
  | 'coachState_DESC'
  | 'completed_ASC'
  | 'completed_DESC'
  | 'createdAt_ASC'
  | 'createdAt_DESC'
  | 'firstTime_ASC'
  | 'firstTime_DESC'
  | 'id_ASC'
  | 'id_DESC'
  | 'showedUnlockAnimation_ASC'
  | 'showedUnlockAnimation_DESC'
  | 'skill_ASC'
  | 'skill_DESC'
  | 'stars_ASC'
  | 'stars_DESC'
  | 'state_ASC'
  | 'state_DESC'
  | 'unlocked_ASC'
  | 'unlocked_DESC'
  | 'updatedAt_ASC'
  | 'updatedAt_DESC';

export type UserLevelScalarWhereInput = {
  AND?: InputMaybe<Array<UserLevelScalarWhereInput>>;
  NOT?: InputMaybe<Array<UserLevelScalarWhereInput>>;
  OR?: InputMaybe<Array<UserLevelScalarWhereInput>>;
  accuracy?: InputMaybe<Scalars['Decimal']>;
  accuracy_gt?: InputMaybe<Scalars['Decimal']>;
  accuracy_gte?: InputMaybe<Scalars['Decimal']>;
  accuracy_in?: InputMaybe<Array<Scalars['Decimal']>>;
  accuracy_lt?: InputMaybe<Scalars['Decimal']>;
  accuracy_lte?: InputMaybe<Scalars['Decimal']>;
  accuracy_not?: InputMaybe<Scalars['Decimal']>;
  accuracy_not_in?: InputMaybe<Array<Scalars['Decimal']>>;
  charactersPerMinute?: InputMaybe<Scalars['Decimal']>;
  charactersPerMinute_gt?: InputMaybe<Scalars['Decimal']>;
  charactersPerMinute_gte?: InputMaybe<Scalars['Decimal']>;
  charactersPerMinute_in?: InputMaybe<Array<Scalars['Decimal']>>;
  charactersPerMinute_lt?: InputMaybe<Scalars['Decimal']>;
  charactersPerMinute_lte?: InputMaybe<Scalars['Decimal']>;
  charactersPerMinute_not?: InputMaybe<Scalars['Decimal']>;
  charactersPerMinute_not_in?: InputMaybe<Array<Scalars['Decimal']>>;
  coachState?: InputMaybe<UserLevelState>;
  coachState_in?: InputMaybe<Array<UserLevelState>>;
  coachState_not?: InputMaybe<UserLevelState>;
  coachState_not_in?: InputMaybe<Array<UserLevelState>>;
  completed?: InputMaybe<Scalars['Boolean']>;
  completed_not?: InputMaybe<Scalars['Boolean']>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  createdAt_gt?: InputMaybe<Scalars['DateTime']>;
  createdAt_gte?: InputMaybe<Scalars['DateTime']>;
  createdAt_in?: InputMaybe<Array<Scalars['DateTime']>>;
  createdAt_lt?: InputMaybe<Scalars['DateTime']>;
  createdAt_lte?: InputMaybe<Scalars['DateTime']>;
  createdAt_not?: InputMaybe<Scalars['DateTime']>;
  createdAt_not_in?: InputMaybe<Array<Scalars['DateTime']>>;
  firstTime?: InputMaybe<Scalars['Boolean']>;
  firstTime_not?: InputMaybe<Scalars['Boolean']>;
  id?: InputMaybe<Scalars['ID']>;
  id_contains?: InputMaybe<Scalars['ID']>;
  id_ends_with?: InputMaybe<Scalars['ID']>;
  id_gt?: InputMaybe<Scalars['ID']>;
  id_gte?: InputMaybe<Scalars['ID']>;
  id_in?: InputMaybe<Array<Scalars['ID']>>;
  id_lt?: InputMaybe<Scalars['ID']>;
  id_lte?: InputMaybe<Scalars['ID']>;
  id_not?: InputMaybe<Scalars['ID']>;
  id_not_contains?: InputMaybe<Scalars['ID']>;
  id_not_ends_with?: InputMaybe<Scalars['ID']>;
  id_not_in?: InputMaybe<Array<Scalars['ID']>>;
  id_not_starts_with?: InputMaybe<Scalars['ID']>;
  id_starts_with?: InputMaybe<Scalars['ID']>;
  showedUnlockAnimation?: InputMaybe<Scalars['Boolean']>;
  showedUnlockAnimation_not?: InputMaybe<Scalars['Boolean']>;
  skill?: InputMaybe<Scalars['Decimal']>;
  skill_gt?: InputMaybe<Scalars['Decimal']>;
  skill_gte?: InputMaybe<Scalars['Decimal']>;
  skill_in?: InputMaybe<Array<Scalars['Decimal']>>;
  skill_lt?: InputMaybe<Scalars['Decimal']>;
  skill_lte?: InputMaybe<Scalars['Decimal']>;
  skill_not?: InputMaybe<Scalars['Decimal']>;
  skill_not_in?: InputMaybe<Array<Scalars['Decimal']>>;
  stars?: InputMaybe<Scalars['Int']>;
  stars_gt?: InputMaybe<Scalars['Int']>;
  stars_gte?: InputMaybe<Scalars['Int']>;
  stars_in?: InputMaybe<Array<Scalars['Int']>>;
  stars_lt?: InputMaybe<Scalars['Int']>;
  stars_lte?: InputMaybe<Scalars['Int']>;
  stars_not?: InputMaybe<Scalars['Int']>;
  stars_not_in?: InputMaybe<Array<Scalars['Int']>>;
  state?: InputMaybe<UserLevelState>;
  state_in?: InputMaybe<Array<UserLevelState>>;
  state_not?: InputMaybe<UserLevelState>;
  state_not_in?: InputMaybe<Array<UserLevelState>>;
  unlocked?: InputMaybe<Scalars['Boolean']>;
  unlocked_not?: InputMaybe<Scalars['Boolean']>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
  updatedAt_gt?: InputMaybe<Scalars['DateTime']>;
  updatedAt_gte?: InputMaybe<Scalars['DateTime']>;
  updatedAt_in?: InputMaybe<Array<Scalars['DateTime']>>;
  updatedAt_lt?: InputMaybe<Scalars['DateTime']>;
  updatedAt_lte?: InputMaybe<Scalars['DateTime']>;
  updatedAt_not?: InputMaybe<Scalars['DateTime']>;
  updatedAt_not_in?: InputMaybe<Array<Scalars['DateTime']>>;
};

export type UserLevelState = 'Disabled' | 'Enabled' | 'None';

export type UserLevelUpdateDataInput = {
  accuracy?: InputMaybe<Scalars['Decimal']>;
  charactersPerMinute?: InputMaybe<Scalars['Decimal']>;
  coachState?: InputMaybe<UserLevelState>;
  completed?: InputMaybe<Scalars['Boolean']>;
  firstTime?: InputMaybe<Scalars['Boolean']>;
  lastPlay?: InputMaybe<ChallengeResultUpdateOneInput>;
  level?: InputMaybe<LevelUpdateOneRequiredInput>;
  previous?: InputMaybe<UserLevelUpdateOneInput>;
  showedUnlockAnimation?: InputMaybe<Scalars['Boolean']>;
  skill?: InputMaybe<Scalars['Decimal']>;
  skillCourse?: InputMaybe<SkillCourseUpdateManyWithoutUserLevelInput>;
  stars?: InputMaybe<Scalars['Int']>;
  state?: InputMaybe<UserLevelState>;
  unlocked?: InputMaybe<Scalars['Boolean']>;
  user?: InputMaybe<GameUserUpdateOneRequiredWithoutUserLevelsInput>;
};

export type UserLevelUpdateInput = {
  coachState?: InputMaybe<UserLevelState>;
  firstTime?: InputMaybe<Scalars['Boolean']>;
  showedUnlockAnimation?: InputMaybe<Scalars['Boolean']>;
  stars?: InputMaybe<Scalars['Int']>;
  state?: InputMaybe<UserLevelState>;
};

export type UserLevelUpdateManyDataInput = {
  accuracy?: InputMaybe<Scalars['Decimal']>;
  charactersPerMinute?: InputMaybe<Scalars['Decimal']>;
  coachState?: InputMaybe<UserLevelState>;
  completed?: InputMaybe<Scalars['Boolean']>;
  firstTime?: InputMaybe<Scalars['Boolean']>;
  showedUnlockAnimation?: InputMaybe<Scalars['Boolean']>;
  skill?: InputMaybe<Scalars['Decimal']>;
  stars?: InputMaybe<Scalars['Int']>;
  state?: InputMaybe<UserLevelState>;
  unlocked?: InputMaybe<Scalars['Boolean']>;
};

export type UserLevelUpdateManyMutationInput = {
  accuracy?: InputMaybe<Scalars['Decimal']>;
  charactersPerMinute?: InputMaybe<Scalars['Decimal']>;
  coachState?: InputMaybe<UserLevelState>;
  completed?: InputMaybe<Scalars['Boolean']>;
  firstTime?: InputMaybe<Scalars['Boolean']>;
  showedUnlockAnimation?: InputMaybe<Scalars['Boolean']>;
  skill?: InputMaybe<Scalars['Decimal']>;
  stars?: InputMaybe<Scalars['Int']>;
  state?: InputMaybe<UserLevelState>;
  unlocked?: InputMaybe<Scalars['Boolean']>;
};

export type UserLevelUpdateManyWithWhereNestedInput = {
  data: UserLevelUpdateManyDataInput;
  where: UserLevelScalarWhereInput;
};

export type UserLevelUpdateManyWithoutUserInput = {
  connect?: InputMaybe<Array<UserLevelWhereUniqueInput>>;
  create?: InputMaybe<Array<UserLevelCreateWithoutUserInput>>;
  delete?: InputMaybe<Array<UserLevelWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<UserLevelScalarWhereInput>>;
  disconnect?: InputMaybe<Array<UserLevelWhereUniqueInput>>;
  set?: InputMaybe<Array<UserLevelWhereUniqueInput>>;
  update?: InputMaybe<Array<UserLevelUpdateWithWhereUniqueWithoutUserInput>>;
  updateMany?: InputMaybe<Array<UserLevelUpdateManyWithWhereNestedInput>>;
  upsert?: InputMaybe<Array<UserLevelUpsertWithWhereUniqueWithoutUserInput>>;
};

export type UserLevelUpdateOneInput = {
  connect?: InputMaybe<UserLevelWhereUniqueInput>;
  create?: InputMaybe<UserLevelCreateInput>;
  delete?: InputMaybe<Scalars['Boolean']>;
  disconnect?: InputMaybe<Scalars['Boolean']>;
  update?: InputMaybe<UserLevelUpdateDataInput>;
  upsert?: InputMaybe<UserLevelUpsertNestedInput>;
};

export type UserLevelUpdateOneWithoutSkillCourseInput = {
  connect?: InputMaybe<UserLevelWhereUniqueInput>;
  create?: InputMaybe<UserLevelCreateWithoutSkillCourseInput>;
  delete?: InputMaybe<Scalars['Boolean']>;
  disconnect?: InputMaybe<Scalars['Boolean']>;
  update?: InputMaybe<UserLevelUpdateWithoutSkillCourseDataInput>;
  upsert?: InputMaybe<UserLevelUpsertWithoutSkillCourseInput>;
};

export type UserLevelUpdateUserLevelState = {
  coachState?: InputMaybe<UserLevelState>;
  state?: InputMaybe<UserLevelState>;
  where: UserLevelWhereUniqueInput;
};

export type UserLevelUpdateWithWhereUniqueWithoutUserInput = {
  data: UserLevelUpdateWithoutUserDataInput;
  where: UserLevelWhereUniqueInput;
};

export type UserLevelUpdateWithoutSkillCourseDataInput = {
  accuracy?: InputMaybe<Scalars['Decimal']>;
  charactersPerMinute?: InputMaybe<Scalars['Decimal']>;
  coachState?: InputMaybe<UserLevelState>;
  completed?: InputMaybe<Scalars['Boolean']>;
  firstTime?: InputMaybe<Scalars['Boolean']>;
  lastPlay?: InputMaybe<ChallengeResultUpdateOneInput>;
  level?: InputMaybe<LevelUpdateOneRequiredInput>;
  previous?: InputMaybe<UserLevelUpdateOneInput>;
  showedUnlockAnimation?: InputMaybe<Scalars['Boolean']>;
  skill?: InputMaybe<Scalars['Decimal']>;
  stars?: InputMaybe<Scalars['Int']>;
  state?: InputMaybe<UserLevelState>;
  unlocked?: InputMaybe<Scalars['Boolean']>;
  user?: InputMaybe<GameUserUpdateOneRequiredWithoutUserLevelsInput>;
};

export type UserLevelUpdateWithoutUserDataInput = {
  accuracy?: InputMaybe<Scalars['Decimal']>;
  charactersPerMinute?: InputMaybe<Scalars['Decimal']>;
  coachState?: InputMaybe<UserLevelState>;
  completed?: InputMaybe<Scalars['Boolean']>;
  firstTime?: InputMaybe<Scalars['Boolean']>;
  lastPlay?: InputMaybe<ChallengeResultUpdateOneInput>;
  level?: InputMaybe<LevelUpdateOneRequiredInput>;
  previous?: InputMaybe<UserLevelUpdateOneInput>;
  showedUnlockAnimation?: InputMaybe<Scalars['Boolean']>;
  skill?: InputMaybe<Scalars['Decimal']>;
  skillCourse?: InputMaybe<SkillCourseUpdateManyWithoutUserLevelInput>;
  stars?: InputMaybe<Scalars['Int']>;
  state?: InputMaybe<UserLevelState>;
  unlocked?: InputMaybe<Scalars['Boolean']>;
};

export type UserLevelUpsertNestedInput = {
  create: UserLevelCreateInput;
  update: UserLevelUpdateDataInput;
};

export type UserLevelUpsertWithWhereUniqueWithoutUserInput = {
  create: UserLevelCreateWithoutUserInput;
  update: UserLevelUpdateWithoutUserDataInput;
  where: UserLevelWhereUniqueInput;
};

export type UserLevelUpsertWithoutSkillCourseInput = {
  create: UserLevelCreateWithoutSkillCourseInput;
  update: UserLevelUpdateWithoutSkillCourseDataInput;
};

export type UserLevelWhereInput = {
  AND?: InputMaybe<Array<UserLevelWhereInput>>;
  NOT?: InputMaybe<Array<UserLevelWhereInput>>;
  OR?: InputMaybe<Array<UserLevelWhereInput>>;
  accuracy?: InputMaybe<Scalars['Decimal']>;
  accuracy_gt?: InputMaybe<Scalars['Decimal']>;
  accuracy_gte?: InputMaybe<Scalars['Decimal']>;
  accuracy_in?: InputMaybe<Array<Scalars['Decimal']>>;
  accuracy_lt?: InputMaybe<Scalars['Decimal']>;
  accuracy_lte?: InputMaybe<Scalars['Decimal']>;
  accuracy_not?: InputMaybe<Scalars['Decimal']>;
  accuracy_not_in?: InputMaybe<Array<Scalars['Decimal']>>;
  charactersPerMinute?: InputMaybe<Scalars['Decimal']>;
  charactersPerMinute_gt?: InputMaybe<Scalars['Decimal']>;
  charactersPerMinute_gte?: InputMaybe<Scalars['Decimal']>;
  charactersPerMinute_in?: InputMaybe<Array<Scalars['Decimal']>>;
  charactersPerMinute_lt?: InputMaybe<Scalars['Decimal']>;
  charactersPerMinute_lte?: InputMaybe<Scalars['Decimal']>;
  charactersPerMinute_not?: InputMaybe<Scalars['Decimal']>;
  charactersPerMinute_not_in?: InputMaybe<Array<Scalars['Decimal']>>;
  coachState?: InputMaybe<UserLevelState>;
  coachState_in?: InputMaybe<Array<UserLevelState>>;
  coachState_not?: InputMaybe<UserLevelState>;
  coachState_not_in?: InputMaybe<Array<UserLevelState>>;
  completed?: InputMaybe<Scalars['Boolean']>;
  completed_not?: InputMaybe<Scalars['Boolean']>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  createdAt_gt?: InputMaybe<Scalars['DateTime']>;
  createdAt_gte?: InputMaybe<Scalars['DateTime']>;
  createdAt_in?: InputMaybe<Array<Scalars['DateTime']>>;
  createdAt_lt?: InputMaybe<Scalars['DateTime']>;
  createdAt_lte?: InputMaybe<Scalars['DateTime']>;
  createdAt_not?: InputMaybe<Scalars['DateTime']>;
  createdAt_not_in?: InputMaybe<Array<Scalars['DateTime']>>;
  firstTime?: InputMaybe<Scalars['Boolean']>;
  firstTime_not?: InputMaybe<Scalars['Boolean']>;
  id?: InputMaybe<Scalars['ID']>;
  id_contains?: InputMaybe<Scalars['ID']>;
  id_ends_with?: InputMaybe<Scalars['ID']>;
  id_gt?: InputMaybe<Scalars['ID']>;
  id_gte?: InputMaybe<Scalars['ID']>;
  id_in?: InputMaybe<Array<Scalars['ID']>>;
  id_lt?: InputMaybe<Scalars['ID']>;
  id_lte?: InputMaybe<Scalars['ID']>;
  id_not?: InputMaybe<Scalars['ID']>;
  id_not_contains?: InputMaybe<Scalars['ID']>;
  id_not_ends_with?: InputMaybe<Scalars['ID']>;
  id_not_in?: InputMaybe<Array<Scalars['ID']>>;
  id_not_starts_with?: InputMaybe<Scalars['ID']>;
  id_starts_with?: InputMaybe<Scalars['ID']>;
  lastPlay?: InputMaybe<ChallengeResultWhereInput>;
  level?: InputMaybe<LevelWhereInput>;
  previous?: InputMaybe<UserLevelWhereInput>;
  showedUnlockAnimation?: InputMaybe<Scalars['Boolean']>;
  showedUnlockAnimation_not?: InputMaybe<Scalars['Boolean']>;
  skill?: InputMaybe<Scalars['Decimal']>;
  skillCourse_every?: InputMaybe<SkillCourseWhereInput>;
  skillCourse_none?: InputMaybe<SkillCourseWhereInput>;
  skillCourse_some?: InputMaybe<SkillCourseWhereInput>;
  skill_gt?: InputMaybe<Scalars['Decimal']>;
  skill_gte?: InputMaybe<Scalars['Decimal']>;
  skill_in?: InputMaybe<Array<Scalars['Decimal']>>;
  skill_lt?: InputMaybe<Scalars['Decimal']>;
  skill_lte?: InputMaybe<Scalars['Decimal']>;
  skill_not?: InputMaybe<Scalars['Decimal']>;
  skill_not_in?: InputMaybe<Array<Scalars['Decimal']>>;
  stars?: InputMaybe<Scalars['Int']>;
  stars_gt?: InputMaybe<Scalars['Int']>;
  stars_gte?: InputMaybe<Scalars['Int']>;
  stars_in?: InputMaybe<Array<Scalars['Int']>>;
  stars_lt?: InputMaybe<Scalars['Int']>;
  stars_lte?: InputMaybe<Scalars['Int']>;
  stars_not?: InputMaybe<Scalars['Int']>;
  stars_not_in?: InputMaybe<Array<Scalars['Int']>>;
  state?: InputMaybe<UserLevelState>;
  state_in?: InputMaybe<Array<UserLevelState>>;
  state_not?: InputMaybe<UserLevelState>;
  state_not_in?: InputMaybe<Array<UserLevelState>>;
  unlocked?: InputMaybe<Scalars['Boolean']>;
  unlocked_not?: InputMaybe<Scalars['Boolean']>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
  updatedAt_gt?: InputMaybe<Scalars['DateTime']>;
  updatedAt_gte?: InputMaybe<Scalars['DateTime']>;
  updatedAt_in?: InputMaybe<Array<Scalars['DateTime']>>;
  updatedAt_lt?: InputMaybe<Scalars['DateTime']>;
  updatedAt_lte?: InputMaybe<Scalars['DateTime']>;
  updatedAt_not?: InputMaybe<Scalars['DateTime']>;
  updatedAt_not_in?: InputMaybe<Array<Scalars['DateTime']>>;
  user?: InputMaybe<GameUserWhereInput>;
};

export type UserLevelWhereUniqueInput = {
  id?: InputMaybe<Scalars['ID']>;
};

export type UserUpdateInput = {
  birthDate?: InputMaybe<Scalars['DateTime']>;
  educationGroup?: InputMaybe<EducationGroupUpdateOneInput>;
  email?: InputMaybe<Scalars['String']>;
  endDate?: InputMaybe<Scalars['DateTime']>;
  firstName?: InputMaybe<Scalars['String']>;
  gender?: InputMaybe<Gender>;
  keyboardLayout?: InputMaybe<KeyboardLayout>;
  lastName?: InputMaybe<Scalars['String']>;
  mobile?: InputMaybe<Scalars['String']>;
  phone?: InputMaybe<Scalars['String']>;
  prefix?: InputMaybe<Scalars['String']>;
  roles?: InputMaybe<Array<Role>>;
  secondaryEmails?: InputMaybe<Array<Scalars['String']>>;
  startDate?: InputMaybe<Scalars['DateTime']>;
  username?: InputMaybe<Scalars['String']>;
};

export type UserUpdateManyInput = {
  email?: InputMaybe<Scalars['String']>;
  endDate?: InputMaybe<Scalars['DateTime']>;
  startDate?: InputMaybe<Scalars['DateTime']>;
  tempPassword?: InputMaybe<Scalars['String']>;
};

export type UserUpdateSelfInput = {
  secondaryEmails?: InputMaybe<Array<Scalars['String']>>;
};

export type UserWhereInput = {
  id?: InputMaybe<IdFilter>;
  schoolId?: InputMaybe<IdFilter>;
};

export type UserWhereUniqueInput = {
  id?: InputMaybe<Scalars['ID']>;
  username?: InputMaybe<Scalars['String']>;
};

export type UsernameExistsInput = {
  username: Scalars['String'];
};

export type UsersFilterArguments = {
  first?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<UsersFilterOrderByInput>;
  skip?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<UsersFilterWhereInput>;
};

export type UsersFilterMessage = {
  count: Scalars['Int'];
  users: Array<Maybe<User>>;
};

export type UsersFilterOrderByInput = {
  columnName?: InputMaybe<UsersFilterOrderByInputColumns>;
  order?: InputMaybe<SortOrder>;
};

export type UsersFilterOrderByInputColumns =
  /** Student fields */
  | 'birthDate'
  | 'charactersPerMinuteStandard'
  | 'coachNames'
  | 'courseGroupStartDate'
  | 'courseGroupStbId'
  /** Coach Fields */
  | 'courseGroups'
  | 'educationGroup'
  | 'email'
  | 'endDate'
  | 'firstName'
  | 'followingCourseGroup'
  | 'followingCourseGroupName'
  | 'gameCompletedDate'
  /** Generic User Fields */
  | 'id'
  | 'keyboardLayout'
  | 'lastMessageSentAt'
  | 'lastName'
  | 'lastPlayAt'
  | 'licenseEndDate'
  | 'licenseId'
  | 'licenseStartDate'
  | 'licenseStatus'
  | 'mostRecentLoginDate'
  | 'registrationNumber'
  | 'sentMessagesCount'
  | 'startDate'
  | 'username';

export type UsersFilterWhereInput = {
  basispoortId?: InputMaybe<NumberFilterInput>;
  /** Student fields */
  birthDate?: InputMaybe<DateFilterInput>;
  charactersPerMinuteStandard?: InputMaybe<NumberFilterInput>;
  coachNames?: InputMaybe<StringFilterInput>;
  courseGroupStartDate?: InputMaybe<DateFilterInput>;
  courseGroupStbId?: InputMaybe<StringFilterInput>;
  /** Coach fields */
  courseGroups?: InputMaybe<StringFilterInput>;
  educationGroup?: InputMaybe<StringFilterInput>;
  email?: InputMaybe<StringFilterInput>;
  endDate?: InputMaybe<DateFilterInput>;
  firstName?: InputMaybe<StringFilterInput>;
  followingCourseGroup?: InputMaybe<StringFilterInput>;
  followingCourseGroupName?: InputMaybe<StringFilterInput>;
  gameCompletedDate?: InputMaybe<DateFilterInput>;
  /** Generic User Fields */
  id?: InputMaybe<StringFilterInput>;
  keyboardLayout?: InputMaybe<KeyboardLayoutInput>;
  lastMessageSentAt?: InputMaybe<DateFilterInput>;
  lastName?: InputMaybe<StringFilterInput>;
  licenseEndDate?: InputMaybe<DateFilterInput>;
  licenseId?: InputMaybe<StringFilterInput>;
  licenseStartDate?: InputMaybe<DateFilterInput>;
  licenseStatus?: InputMaybe<LicenseStatusInput>;
  mostRecentLoginDate?: InputMaybe<DateFilterInput>;
  registrationNumber?: InputMaybe<StringFilterInput>;
  sentMessagesCount?: InputMaybe<NumberFilterInput>;
  startDate?: InputMaybe<DateFilterInput>;
  username?: InputMaybe<StringFilterInput>;
};

export type MeAuthQueryVariables = Exact<{ [key: string]: never }>;

export type MeAuthQuery = {
  __typename: 'Query';
  me?: {
    __typename: 'User';
    id: string;
    username: string;
    keyboardLayout: KeyboardLayout;
    typetuin?: {
      __typename: 'GameUser';
      allowedToRequestDiploma: boolean;
      hasRequestedDiploma: boolean;
      introductionCompleted: boolean;
      id: string;
      highestCups: number;
      diamonds: number;
      gamename?: string | null;
      charactersPerMinuteStandard: number;
      fontType: FontType;
      focusMode: boolean;
      hideDiamonds: boolean;
      gameCompleted: boolean;
      showInterpunct: boolean;
      audioMuted: boolean;
      displayedAlfredoMessages?: Array<{
        __typename: 'AlfredoMessageGameUser';
        id: string;
        displayedAt: string;
        alfredoMessage: {
          __typename: 'AlfredoMessage';
          id: string;
          message: string;
        };
      }> | null;
    } | null;
  } | null;
};

export type MyKeyboardLayoutQueryVariables = Exact<{ [key: string]: never }>;

export type MyKeyboardLayoutQuery = {
  __typename: 'Query';
  me?: {
    __typename: 'User';
    id: string;
    keyboardLayout: KeyboardLayout;
  } | null;
};

export type ForgotUsernamesMutationVariables = Exact<{
  email: Scalars['String'];
}>;

export type ForgotUsernamesMutation = {
  __typename: 'Mutation';
  forgotUsernames: { __typename: 'AuthResponsePayload'; message: string };
};

export type ChangePasswordMutationVariables = Exact<{
  data?: InputMaybe<ChangePasswordInput>;
}>;

export type ChangePasswordMutation = {
  __typename: 'Mutation';
  changePassword: { __typename: 'AuthResponsePayload'; message: string };
};

export type ForgotPasswordMutationVariables = Exact<{
  data?: InputMaybe<ForgotPasswordInput>;
}>;

export type ForgotPasswordMutation = {
  __typename: 'Mutation';
  forgotPassword: { __typename: 'AuthResponsePayload'; message: string };
};

export type MeLoginQueryVariables = Exact<{ [key: string]: never }>;

export type MeLoginQuery = {
  __typename: 'Query';
  me?: {
    __typename: 'User';
    id: string;
    typetuin?: {
      __typename: 'GameUser';
      id: string;
      gamename?: string | null;
    } | null;
  } | null;
};

export type BasispoortUserFragment = {
  __typename: 'User';
  basispoortId?: number | null;
};

export type ChallengeResultsQueryVariables = Exact<{
  userId?: InputMaybe<Scalars['ID']>;
  levelId?: InputMaybe<Scalars['ID']>;
}>;

export type ChallengeResultsQuery = {
  __typename: 'Query';
  challengeResults: Array<{
    __typename: 'ChallengeResult';
    id: string;
    charactersPerMinute: number;
    charactersPerMinuteStandard: number;
    cupsEarned?: number | null;
    passed: boolean;
    accuracy: number;
    challengeRequest: {
      __typename: 'ChallengeRequest';
      id: string;
      createdAt: string;
      exercise: {
        __typename: 'Exercise';
        id: string;
        user: { __typename: 'GameUser'; id: string };
        level: { __typename: 'Level'; id: string };
      };
    };
  } | null>;
};

export type ExamMeQueryVariables = Exact<{ [key: string]: never }>;

export type ExamMeQuery = {
  __typename: 'Query';
  me?: {
    __typename: 'User';
    id: string;
    followingCourseGroup?: {
      __typename: 'CourseGroup';
      id: string;
      useLevelSettings: boolean;
      levelSettings: Array<{
        __typename: 'LevelSetting';
        id: string;
        state: LevelState;
        level: string;
      }>;
    } | null;
    typetuin?: {
      __typename: 'GameUser';
      id: string;
      gameCompleted: boolean;
      usePersonalLevelSettings: boolean;
      examRequests?: Array<{
        __typename: 'ChallengeRequest';
        id: string;
      } | null> | null;
      userLevels: Array<{
        __typename: 'UserLevel';
        id: string;
        state: UserLevelState;
        unlocked?: boolean | null;
        user?: { __typename: 'GameUser'; id: string } | null;
        level?: { __typename: 'Level'; id: string } | null;
      }>;
    } | null;
  } | null;
};

export type UpdateGameUserDiamondsMutationVariables = Exact<{
  userId?: InputMaybe<Scalars['ID']>;
  diamonds?: InputMaybe<Scalars['Int']>;
}>;

export type UpdateGameUserDiamondsMutation = {
  __typename: 'Mutation';
  updateGameUser?: {
    __typename: 'GameUser';
    id: string;
    userId: string;
    diamonds: number;
  } | null;
};

export type ActivateKwouwselAccessoryMutationVariables = Exact<{
  id?: InputMaybe<Scalars['ID']>;
}>;

export type ActivateKwouwselAccessoryMutation = {
  __typename: 'Mutation';
  activateKwouwselAccessory: {
    __typename: 'GameUserKwouwselAccessory';
    id: string;
    bought: boolean;
    active: boolean;
  };
};

export type ActivateKwouwselUpgradeMutationVariables = Exact<{
  id?: InputMaybe<Scalars['ID']>;
}>;

export type ActivateKwouwselUpgradeMutation = {
  __typename: 'Mutation';
  activateKwouwselUpgrade: {
    __typename: 'GameUserKwouwselUpgrade';
    id: string;
    bought: boolean;
    active: boolean;
  };
};

export type BuyKwouwselAccessoryMutationVariables = Exact<{
  id?: InputMaybe<Scalars['ID']>;
}>;

export type BuyKwouwselAccessoryMutation = {
  __typename: 'Mutation';
  buyKwouwselAccessory: {
    __typename: 'GameUserKwouwselAccessory';
    id: string;
    bought: boolean;
    active: boolean;
  };
};

export type BuyKwouwselUpgradeMutationVariables = Exact<{
  id?: InputMaybe<Scalars['ID']>;
}>;

export type BuyKwouwselUpgradeMutation = {
  __typename: 'Mutation';
  buyKwouwselUpgrade: {
    __typename: 'GameUserKwouwselUpgrade';
    id: string;
    bought: boolean;
    active: boolean;
  };
};

export type DeactivateKwouwselAccessoryMutationVariables = Exact<{
  id?: InputMaybe<Scalars['ID']>;
}>;

export type DeactivateKwouwselAccessoryMutation = {
  __typename: 'Mutation';
  deactivateKwouwselAccessory: {
    __typename: 'GameUserKwouwselAccessory';
    id: string;
    bought: boolean;
    active: boolean;
  };
};

export type DeactivateKwouwselUpgradeMutationVariables = Exact<{
  id?: InputMaybe<Scalars['ID']>;
}>;

export type DeactivateKwouwselUpgradeMutation = {
  __typename: 'Mutation';
  deactivateKwouwselUpgrade: {
    __typename: 'GameUserKwouwselUpgrade';
    id: string;
    bought: boolean;
    active: boolean;
  };
};

export type SellKwouwselAccessoryMutationVariables = Exact<{
  id?: InputMaybe<Scalars['ID']>;
}>;

export type SellKwouwselAccessoryMutation = {
  __typename: 'Mutation';
  sellKwouwselAccessory: {
    __typename: 'GameUserKwouwselAccessory';
    id: string;
    bought: boolean;
    active: boolean;
  };
};

export type SellKwouwselUpgradeMutationVariables = Exact<{
  id?: InputMaybe<Scalars['ID']>;
}>;

export type SellKwouwselUpgradeMutation = {
  __typename: 'Mutation';
  sellKwouwselUpgrade: {
    __typename: 'GameUserKwouwselUpgrade';
    id: string;
    bought: boolean;
    active: boolean;
  };
};

export type KwouwselQueryVariables = Exact<{ [key: string]: never }>;

export type KwouwselQuery = {
  __typename: 'Query';
  me?: {
    __typename: 'User';
    id: string;
    unreadMessagesCount: number;
    followingCourseGroup?: {
      __typename: 'CourseGroup';
      useLevelSettings: boolean;
      id: string;
      levelSettings: Array<{
        __typename: 'LevelSetting';
        id: string;
        state: LevelState;
        level: string;
      }>;
    } | null;
    typetuin?: {
      __typename: 'GameUser';
      id: string;
      gamename?: string | null;
      gameCompleted: boolean;
      diamonds: number;
      usePersonalLevelSettings: boolean;
      kwouwselUpgrades: Array<{
        __typename: 'GameUserKwouwselUpgrade';
        id: string;
        bought: boolean;
        active: boolean;
        type: {
          __typename: 'KwouwselUpgrade';
          id: string;
          name: string;
          price: number;
          requiredStars: number;
          level: { __typename: 'Level'; id: string };
        };
      } | null>;
      kwouwselAccessories: Array<{
        __typename: 'GameUserKwouwselAccessory';
        id: string;
        bought: boolean;
        active: boolean;
        type: {
          __typename: 'KwouwselAccessory';
          id: string;
          name: string;
          price: number;
          level: { __typename: 'Level'; id: string };
        };
      } | null>;
      userLevels: Array<{
        __typename: 'UserLevel';
        id: string;
        completed: boolean;
        stars: number;
        unlocked?: boolean | null;
        state: UserLevelState;
        user?: { __typename: 'GameUser'; id: string } | null;
        level?: { __typename: 'Level'; id: string } | null;
      }>;
    } | null;
  } | null;
};

export type SubmitChallengeResultMutationVariables = Exact<{
  data: ChallengeResultCreateInput;
}>;

export type SubmitChallengeResultMutation = {
  __typename: 'Mutation';
  submitChallengeResult?:
    | {
        __typename: 'ChallengeResult';
        id: string;
        createdAt: string;
        updatedAt: string;
        accuracy: number;
        charactersPerMinute: number;
        diamondsEarned?: number | null;
        challengeRequest: { __typename: 'ChallengeRequest'; id: string };
      }
    | {
        __typename: 'ExerciseResult';
        id: string;
        createdAt: string;
        updatedAt: string;
        extraDiamonds: number;
        accuracy: number;
        charactersPerMinute: number;
        averageCharactersPerMinute?: number | null;
        averageAccuracy?: number | null;
        correctChallengesPercentage?: number | null;
      }
    | null;
};

export type CreateExerciseMutationVariables = Exact<{
  levelId?: InputMaybe<Scalars['ID']>;
}>;

export type CreateExerciseMutation = {
  __typename: 'Mutation';
  createExercise: {
    __typename: 'Exercise';
    id: string;
    numberOfChallenges: number;
  };
};

export type RequestChallengeMutationVariables = Exact<{
  exerciseId?: InputMaybe<Scalars['ID']>;
}>;

export type RequestChallengeMutation = {
  __typename: 'Mutation';
  requestChallenge: {
    __typename: 'ChallengeRequest';
    id: string;
    challenge: {
      __typename: 'Challenge';
      id: string;
      text: string;
      skill: number;
      level: {
        __typename: 'Level';
        loop: number;
        id: string;
        timeInMs: number;
      };
    };
  };
};

export type RequestChallengesMutationVariables = Exact<{
  exerciseId?: InputMaybe<Scalars['ID']>;
}>;

export type RequestChallengesMutation = {
  __typename: 'Mutation';
  requestChallenges: Array<{
    __typename: 'ChallengeRequest';
    id: string;
    challenge: {
      __typename: 'Challenge';
      id: string;
      text: string;
      skill: number;
      level: {
        __typename: 'Level';
        loop: number;
        id: string;
        timeInMs: number;
      };
    };
  } | null>;
};

export type LevelsQueryVariables = Exact<{ [key: string]: never }>;

export type LevelsQuery = {
  __typename: 'Query';
  me?: {
    __typename: 'User';
    id: string;
    followingCourseGroup?: {
      __typename: 'CourseGroup';
      id: string;
      useLevelSettings: boolean;
      levelSettings: Array<{
        __typename: 'LevelSetting';
        id: string;
        level: string;
        state: LevelState;
      }>;
    } | null;
    typetuin?: {
      __typename: 'GameUser';
      gameCompleted: boolean;
      id: string;
      diamonds: number;
      fontType: FontType;
      focusMode: boolean;
      hideDiamonds: boolean;
      showInterpunct: boolean;
      usePersonalLevelSettings: boolean;
      userLevels: Array<{
        __typename: 'UserLevel';
        id: string;
        unlocked?: boolean | null;
        state: UserLevelState;
        user?: { __typename: 'GameUser'; id: string } | null;
        level?: {
          __typename: 'Level';
          allowBackspace: boolean;
          diamonds: number;
          id: string;
          name: string;
          lives: number;
          timeInMs: number;
        } | null;
      }>;
    } | null;
  } | null;
};

export type LevelMeQueryVariables = Exact<{ [key: string]: never }>;

export type LevelMeQuery = {
  __typename: 'Query';
  me?: {
    __typename: 'User';
    id: string;
    followingCourseGroup?: {
      __typename: 'CourseGroup';
      id: string;
      useLevelSettings: boolean;
      levelSettings: Array<{
        __typename: 'LevelSetting';
        id: string;
        state: LevelState;
        level: string;
      }>;
    } | null;
    typetuin?: {
      __typename: 'GameUser';
      id: string;
      gameCompleted: boolean;
      usePersonalLevelSettings: boolean;
      userLevels: Array<{
        __typename: 'UserLevel';
        id: string;
        firstTime: boolean;
        showedUnlockAnimation: boolean;
        unlocked?: boolean | null;
        state: UserLevelState;
        user?: { __typename: 'GameUser'; id: string } | null;
        level?: {
          __typename: 'Level';
          id: string;
          name: string;
          characterName: string;
          characterPrefix: string;
          previous: string;
        } | null;
      }>;
    } | null;
  } | null;
};

export type MeAudioQueryVariables = Exact<{ [key: string]: never }>;

export type MeAudioQuery = {
  __typename: 'Query';
  me?: {
    __typename: 'User';
    id: string;
    typetuin?: {
      __typename: 'GameUser';
      id: string;
      audioMuted: boolean;
    } | null;
  } | null;
};

export type MarkMessageAsReadMutationVariables = Exact<{
  messageId: Scalars['String'];
}>;

export type MarkMessageAsReadMutation = {
  __typename: 'Mutation';
  markMessageAsRead?: {
    __typename: 'Message';
    id: string;
    subject?: string | null;
    content: string;
    sentAt: string;
    sender?: {
      __typename: 'User';
      id: string;
      firstName: string;
      prefix?: string | null;
      lastName: string;
    } | null;
    recipients: Array<{
      __typename: 'Recipient';
      readAt?: string | null;
      user?: {
        __typename: 'User';
        id: string;
        username: string;
        firstName: string;
        lastName: string;
      } | null;
    }>;
  } | null;
};

export type ReplyToMessageMutationVariables = Exact<{
  messageId: Scalars['String'];
  content: Scalars['String'];
}>;

export type ReplyToMessageMutation = {
  __typename: 'Mutation';
  replyToMessage?: {
    __typename: 'Message';
    id: string;
    subject?: string | null;
    content: string;
    sentAt: string;
    sender?: {
      __typename: 'User';
      id: string;
      firstName: string;
      prefix?: string | null;
      lastName: string;
    } | null;
    recipients: Array<{
      __typename: 'Recipient';
      readAt?: string | null;
      user?: {
        __typename: 'User';
        id: string;
        firstName: string;
        prefix?: string | null;
        lastName: string;
      } | null;
    }>;
    replies: Array<{
      __typename: 'Message';
      id: string;
      subject?: string | null;
      content: string;
      sentAt: string;
      sender?: {
        __typename: 'User';
        id: string;
        firstName: string;
        prefix?: string | null;
        lastName: string;
      } | null;
    }>;
  } | null;
};

export type SendMessageMutationVariables = Exact<{
  subject: Scalars['String'];
  content: Scalars['String'];
  recipients: Array<Scalars['String']> | Scalars['String'];
}>;

export type SendMessageMutation = {
  __typename: 'Mutation';
  sendMessage?:
    | {
        __typename: 'Message';
        id: string;
        subject?: string | null;
        content: string;
        sentAt: string;
        sender?: { __typename: 'User'; id: string; username: string } | null;
        recipients: Array<{
          __typename: 'Recipient';
          readAt?: string | null;
          user?: {
            __typename: 'User';
            id: string;
            username: string;
            firstName: string;
            lastName: string;
          } | null;
        }>;
        replies: Array<{
          __typename: 'Message';
          id: string;
          subject?: string | null;
          content: string;
          sentAt: string;
          sender?: {
            __typename: 'User';
            id: string;
            firstName: string;
            prefix?: string | null;
            lastName: string;
          } | null;
          recipients: Array<{
            __typename: 'Recipient';
            readAt?: string | null;
            user?: {
              __typename: 'User';
              id: string;
              username: string;
              prefix?: string | null;
              firstName: string;
              lastName: string;
            } | null;
          }>;
        }>;
      }
    | {
        __typename: 'MessagesResponse';
        messages: Array<{
          __typename: 'Message';
          id: string;
          subject?: string | null;
          content: string;
          sentAt: string;
          sender?: { __typename: 'User'; id: string; username: string } | null;
          recipients: Array<{
            __typename: 'Recipient';
            readAt?: string | null;
            user?: {
              __typename: 'User';
              id: string;
              username: string;
              firstName: string;
              lastName: string;
            } | null;
          }>;
          replies: Array<{
            __typename: 'Message';
            id: string;
            subject?: string | null;
            content: string;
            sentAt: string;
            sender?: {
              __typename: 'User';
              id: string;
              firstName: string;
              prefix?: string | null;
              lastName: string;
            } | null;
            recipients: Array<{
              __typename: 'Recipient';
              readAt?: string | null;
              user?: {
                __typename: 'User';
                id: string;
                username: string;
                prefix?: string | null;
                firstName: string;
                lastName: string;
              } | null;
            }>;
          }>;
        }>;
      }
    | null;
};

export type MeDisplayedAlfredoMessagesQueryVariables = Exact<{
  [key: string]: never;
}>;

export type MeDisplayedAlfredoMessagesQuery = {
  __typename: 'Query';
  me?: {
    __typename: 'User';
    id: string;
    typetuin?: {
      __typename: 'GameUser';
      id: string;
      displayedAlfredoMessages?: Array<{
        __typename: 'AlfredoMessageGameUser';
        id: string;
        displayedAt: string;
        alfredoMessage: {
          __typename: 'AlfredoMessage';
          id: string;
          message: string;
        };
      }> | null;
    } | null;
  } | null;
};

export type MeReceivedMessagesQueryVariables = Exact<{
  first?: InputMaybe<Scalars['Int']>;
  skip?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<MessageWithUserWhereInput>;
  orderBy?: InputMaybe<MessageOrderByInput>;
  repliesOrderBy?: InputMaybe<MessageOrderByInput>;
}>;

export type MeReceivedMessagesQuery = {
  __typename: 'Query';
  me?: {
    __typename: 'User';
    id: string;
    receivedMessages: {
      __typename: 'MessageConnection';
      edges: Array<{
        __typename: 'MessageEdge';
        cursor: string;
        node: {
          __typename: 'Message';
          id: string;
          subject?: string | null;
          content: string;
          sentAt: string;
          type?: MessageType | null;
          sender?: {
            __typename: 'User';
            id: string;
            firstName: string;
            prefix?: string | null;
            lastName: string;
          } | null;
          recipients: Array<{
            __typename: 'Recipient';
            readAt?: string | null;
            user?: {
              __typename: 'User';
              id: string;
              username: string;
              prefix?: string | null;
              firstName: string;
              lastName: string;
            } | null;
          }>;
          replies: Array<{
            __typename: 'Message';
            id: string;
            subject?: string | null;
            content: string;
            sentAt: string;
            sender?: {
              __typename: 'User';
              id: string;
              firstName: string;
              prefix?: string | null;
              lastName: string;
            } | null;
            recipients: Array<{
              __typename: 'Recipient';
              readAt?: string | null;
              user?: {
                __typename: 'User';
                id: string;
                username: string;
                prefix?: string | null;
                firstName: string;
                lastName: string;
              } | null;
            }>;
          }>;
        };
      } | null>;
      aggregate: { __typename: 'Aggregate'; count: number };
    };
  } | null;
};

export type MeRecipientsQueryVariables = Exact<{ [key: string]: never }>;

export type MeRecipientsQuery = {
  __typename: 'Query';
  me?: {
    __typename: 'User';
    id: string;
    followingCourseGroup?: {
      __typename: 'CourseGroup';
      id: string;
      name: string;
      coaches?: {
        __typename: 'UsersFilterMessage';
        users: Array<{
          __typename: 'User';
          id: string;
          firstName: string;
          prefix?: string | null;
          lastName: string;
        } | null>;
      } | null;
    } | null;
  } | null;
};

export type MeSentMessagesQueryVariables = Exact<{
  first?: InputMaybe<Scalars['Int']>;
  skip?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<MessageWithUserWhereInput>;
  orderBy?: InputMaybe<MessageOrderByInput>;
}>;

export type MeSentMessagesQuery = {
  __typename: 'Query';
  me?: {
    __typename: 'User';
    id: string;
    sentMessages: {
      __typename: 'MessageConnection';
      edges: Array<{
        __typename: 'MessageEdge';
        cursor: string;
        node: {
          __typename: 'Message';
          id: string;
          subject?: string | null;
          content: string;
          sentAt: string;
          type?: MessageType | null;
          sender?: {
            __typename: 'User';
            id: string;
            firstName: string;
            prefix?: string | null;
            lastName: string;
          } | null;
          recipients: Array<{
            __typename: 'Recipient';
            readAt?: string | null;
            user?: {
              __typename: 'User';
              id: string;
              username: string;
              prefix?: string | null;
              firstName: string;
              lastName: string;
            } | null;
          }>;
        };
      } | null>;
      aggregate: { __typename: 'Aggregate'; count: number };
    };
  } | null;
};

export type MessageQueryVariables = Exact<{
  id: Scalars['String'];
  repliesOrderBy?: InputMaybe<MessageOrderByInput>;
}>;

export type MessageQuery = {
  __typename: 'Query';
  message?: {
    __typename: 'Message';
    id: string;
    type?: MessageType | null;
    subject?: string | null;
    content: string;
    sentAt: string;
    sender?: {
      __typename: 'User';
      id: string;
      firstName: string;
      prefix?: string | null;
      lastName: string;
    } | null;
    recipients: Array<{
      __typename: 'Recipient';
      readAt?: string | null;
      user?: {
        __typename: 'User';
        id: string;
        firstName: string;
        prefix?: string | null;
        lastName: string;
      } | null;
    }>;
    replies: Array<{
      __typename: 'Message';
      id: string;
      subject?: string | null;
      content: string;
      sentAt: string;
      sender?: {
        __typename: 'User';
        id: string;
        firstName: string;
        prefix?: string | null;
        lastName: string;
      } | null;
      recipients: Array<{
        __typename: 'Recipient';
        readAt?: string | null;
        user?: {
          __typename: 'User';
          id: string;
          username: string;
          prefix?: string | null;
          firstName: string;
          lastName: string;
        } | null;
      }>;
    }>;
  } | null;
};

export type UpdateGameUserAudioMutationVariables = Exact<{
  userId?: InputMaybe<Scalars['ID']>;
  audioMuted?: InputMaybe<Scalars['Boolean']>;
}>;

export type UpdateGameUserAudioMutation = {
  __typename: 'Mutation';
  updateGameUser?: {
    __typename: 'GameUser';
    id: string;
    userId: string;
    audioMuted: boolean;
  } | null;
};

export type DisplayedAlfredoMessageMutationVariables = Exact<{
  id?: InputMaybe<Scalars['ID']>;
}>;

export type DisplayedAlfredoMessageMutation = {
  __typename: 'Mutation';
  displayedAlfredoMessage: {
    __typename: 'GameUser';
    id: string;
    displayedAlfredoMessages?: Array<{
      __typename: 'AlfredoMessageGameUser';
      id: string;
      displayedAt: string;
      alfredoMessage: {
        __typename: 'AlfredoMessage';
        id: string;
        message: string;
      };
    }> | null;
  };
};

export type UpdateUserLevelMutationVariables = Exact<{
  userLevelId?: InputMaybe<Scalars['ID']>;
  data: UserLevelUpdateInput;
}>;

export type UpdateUserLevelMutation = {
  __typename: 'Mutation';
  updateUserLevel?: {
    __typename: 'UserLevel';
    id: string;
    firstTime: boolean;
    state: UserLevelState;
    unlocked?: boolean | null;
    showedUnlockAnimation: boolean;
  } | null;
};

export type AlfredoMessagesQueryVariables = Exact<{ [key: string]: never }>;

export type AlfredoMessagesQuery = {
  __typename: 'Query';
  alfredoMessages: Array<{
    __typename: 'AlfredoMessage';
    id: string;
    message: string;
  } | null>;
};

export type OverviewQueryVariables = Exact<{ [key: string]: never }>;

export type OverviewQuery = {
  __typename: 'Query';
  me?: {
    __typename: 'User';
    id: string;
    unreadMessagesCount: number;
    followingCourseGroup?: {
      __typename: 'CourseGroup';
      id: string;
      useLevelSettings: boolean;
      levelSettings: Array<{
        __typename: 'LevelSetting';
        id: string;
        state: LevelState;
        level: string;
      }>;
    } | null;
    typetuin?: {
      __typename: 'GameUser';
      id: string;
      amountOfChallengesToCalculateStars?: number | null;
      diamonds: number;
      gamename?: string | null;
      charactersPerMinuteStandard: number;
      fontType: FontType;
      focusMode: boolean;
      hideDiamonds: boolean;
      showInterpunct: boolean;
      showPracticeTimeTimer: boolean;
      gameCompleted: boolean;
      examOpeningDayCountDown: number;
      stars?: number | null;
      audioMuted: boolean;
      usePersonalLevelSettings: boolean;
      miniGamesStates: {
        __typename: 'MiniGamesStates';
        first: MiniGameState;
        second: MiniGameState;
        third: MiniGameState;
      };
      displayedAlfredoMessages?: Array<{
        __typename: 'AlfredoMessageGameUser';
        id: string;
        displayedAt: string;
        alfredoMessage: {
          __typename: 'AlfredoMessage';
          id: string;
          message: string;
        };
      }> | null;
      lastPlay?: {
        __typename: 'ChallengeResult';
        id: string;
        createdAt: string;
      } | null;
      firstSuccessfulTestExam?: {
        __typename: 'ChallengeResult';
        id: string;
        createdAt: string;
      } | null;
      userLevels: Array<{
        __typename: 'UserLevel';
        id: string;
        completed: boolean;
        charactersPerMinute?: number | null;
        accuracy?: number | null;
        stars: number;
        progress?: number | null;
        showedUnlockAnimation: boolean;
        state: UserLevelState;
        unlocked?: boolean | null;
        user?: { __typename: 'GameUser'; id: string } | null;
        level?: {
          __typename: 'Level';
          id: string;
          previous: string;
          name: string;
          amountOfChallengeResultsToPass: number;
          charactersPerMinutePercentage?: number | null;
          requiredPercentageOfCpmsForStars?: Array<number | null> | null;
          requiredPercentagesOfAccuracyForStars?: Array<number | null> | null;
        } | null;
      }>;
    } | null;
  } | null;
};

export type OverviewPracticeTimeQueryVariables = Exact<{
  from: Scalars['DateTime'];
  to: Scalars['DateTime'];
  bucket: TimeSeriesBucket;
}>;

export type OverviewPracticeTimeQuery = {
  __typename: 'Query';
  me?: {
    __typename: 'User';
    id: string;
    typetuin?: {
      __typename: 'GameUser';
      id: string;
      practiceTime: Array<{
        __typename: 'PracticeTimeBucket';
        from: string;
        to: string;
        duration: number;
      }>;
    } | null;
  } | null;
};

export type UserLevelByIdQueryVariables = Exact<{
  id?: InputMaybe<Scalars['ID']>;
}>;

export type UserLevelByIdQuery = {
  __typename: 'Query';
  userLevel?: {
    __typename: 'UserLevel';
    id: string;
    challengeResultsCount?: number | null;
  } | null;
};

export type UpdateGameUserProfileMutationVariables = Exact<{
  data: GameUserUpdateInput;
  userId: Scalars['ID'];
}>;

export type UpdateGameUserProfileMutation = {
  __typename: 'Mutation';
  updateGameUser?: {
    __typename: 'GameUser';
    id: string;
    userId: string;
    hasRequestedDiploma: boolean;
    allowedToRequestDiploma: boolean;
    hasRequestedParticipationCertificate: boolean;
    allowedToRequestParticipationCertificate: boolean;
  } | null;
};

export type UpdateSelfMutationVariables = Exact<{
  data: UserUpdateSelfInput;
}>;

export type UpdateSelfMutation = {
  __typename: 'Mutation';
  updateSelf?: {
    __typename: 'User';
    id: string;
    secondaryEmails: Array<string>;
  } | null;
};

export type UpdateGameUserProfileDataMutationVariables = Exact<{
  userId?: InputMaybe<Scalars['ID']>;
  fontType?: InputMaybe<FontType>;
  focusMode?: InputMaybe<Scalars['Boolean']>;
  hideDiamonds?: InputMaybe<Scalars['Boolean']>;
  showInterpunct?: InputMaybe<Scalars['Boolean']>;
  showPracticeTimeTimer?: InputMaybe<Scalars['Boolean']>;
}>;

export type UpdateGameUserProfileDataMutation = {
  __typename: 'Mutation';
  updateGameUser?: {
    __typename: 'GameUser';
    id: string;
    userId: string;
    fontType: FontType;
    focusMode: boolean;
    hideDiamonds: boolean;
    showInterpunct: boolean;
    showPracticeTimeTimer: boolean;
  } | null;
};

export type MeProfileQueryVariables = Exact<{ [key: string]: never }>;

export type MeProfileQuery = {
  __typename: 'Query';
  me?: {
    __typename: 'User';
    id: string;
    firstName: string;
    prefix?: string | null;
    lastName: string;
    birthDate?: string | null;
    username: string;
    email: string;
    secondaryEmails: Array<string>;
    startDate?: string | null;
    endDate?: string | null;
    keyboardLayout: KeyboardLayout;
    basispoortId?: number | null;
    educationGroup?: {
      __typename: 'EducationGroup';
      id: string;
      name: string;
    } | null;
    schools: Array<{ __typename: 'School'; id: string; name: string }>;
    followingCourseGroup?: {
      __typename: 'CourseGroup';
      id: string;
      name: string;
      coaches?: {
        __typename: 'UsersFilterMessage';
        users: Array<{
          __typename: 'User';
          id: string;
          firstName: string;
          lastName: string;
          prefix?: string | null;
        } | null>;
      } | null;
    } | null;
    typetuin?: {
      __typename: 'GameUser';
      id: string;
      gameCompleted: boolean;
      fontType: FontType;
      focusMode: boolean;
      highestCups: number;
      hideDiamonds: boolean;
      showInterpunct: boolean;
      showPracticeTimeTimer: boolean;
      charactersPerMinuteStandard: number;
      hasRequestedDiploma: boolean;
      allowedToRequestDiploma: boolean;
      hasRequestedParticipationCertificate: boolean;
      allowedToRequestParticipationCertificate: boolean;
      examState: ExamState;
      examRequests?: Array<{
        __typename: 'ChallengeRequest';
        id: string;
      } | null> | null;
      examResults?: Array<{
        __typename: 'ChallengeResult';
        id: string;
        passed: boolean;
        cupsEarned?: number | null;
        charactersPerMinute: number;
        challengeRequest: { __typename: 'ChallengeRequest'; id: string };
      } | null> | null;
    } | null;
  } | null;
};

export type ProgressQueryVariables = Exact<{ [key: string]: never }>;

export type ProgressQuery = {
  __typename: 'Query';
  me?: {
    __typename: 'User';
    id: string;
    followingCourseGroup?: {
      __typename: 'CourseGroup';
      id: string;
      useLevelSettings: boolean;
      levelSettings: Array<{
        __typename: 'LevelSetting';
        id: string;
        state: LevelState;
        level: string;
      }>;
    } | null;
    typetuin?: {
      __typename: 'GameUser';
      id: string;
      gamename?: string | null;
      gameCompleted: boolean;
      averageAccuracy?: number | null;
      averageCharactersPerMinute?: number | null;
      examState: ExamState;
      usePersonalLevelSettings: boolean;
      testExamResults?: Array<{
        __typename: 'ChallengeResult';
        id: string;
        createdAt: string;
        charactersPerMinute: number;
        accuracy: number;
        cupsEarned?: number | null;
      } | null> | null;
      examResults?: Array<{
        __typename: 'ChallengeResult';
        id: string;
        createdAt: string;
        charactersPerMinute: number;
        accuracy: number;
        cupsEarned?: number | null;
      } | null> | null;
      userLevels: Array<{
        __typename: 'UserLevel';
        id: string;
        completed: boolean;
        stars: number;
        charactersPerMinute?: number | null;
        accuracy?: number | null;
        progress?: number | null;
        state: UserLevelState;
        unlocked?: boolean | null;
        level?: {
          __typename: 'Level';
          id: string;
          name: string;
          previous: string;
        } | null;
        user?: { __typename: 'GameUser'; id: string } | null;
      }>;
    } | null;
  } | null;
};

export type ConfirmUserMutationVariables = Exact<{
  data?: InputMaybe<ConfirmUserInput>;
}>;

export type ConfirmUserMutation = {
  __typename: 'Mutation';
  confirmUser?: { __typename: 'User'; id: string; firstName: string } | null;
};

export type UpdateGameUserMutationVariables = Exact<{
  userId?: InputMaybe<Scalars['ID']>;
  gamename?: InputMaybe<Scalars['String']>;
}>;

export type UpdateGameUserMutation = {
  __typename: 'Mutation';
  updateGameUser?: {
    __typename: 'GameUser';
    id: string;
    userId: string;
    gamename?: string | null;
  } | null;
};

export type RegisterDemoUserMutationVariables = Exact<{
  keyboardLayout?: InputMaybe<KeyboardLayout>;
}>;

export type RegisterDemoUserMutation = {
  __typename: 'Mutation';
  registerDemoUser?: {
    __typename: 'SuccessfulLoginPayLoad';
    user: {
      __typename: 'User';
      id: string;
      typetuin?: { __typename: 'GameUser'; id: string } | null;
    };
  } | null;
};

export type LoginMutationVariables = Exact<{
  username: Scalars['String'];
  password: Scalars['String'];
}>;

export type LoginMutation = {
  __typename: 'Mutation';
  loginUser?: {
    __typename: 'SuccessfulLoginPayLoad';
    user: { __typename: 'User'; id: string };
  } | null;
};

export type RefreshMutationVariables = Exact<{
  userId: Scalars['String'];
}>;

export type RefreshMutation = {
  __typename: 'Mutation';
  refreshToken?: {
    __typename: 'SuccessfulLoginPayLoad';
    user: { __typename: 'User'; id: string };
  } | null;
};

export type ImpersonateMutationVariables = Exact<{
  userId: Scalars['ID'];
}>;

export type ImpersonateMutation = {
  __typename: 'Mutation';
  impersonateUser: {
    __typename: 'ImpersonateUserPayload';
    user: { __typename: 'User'; id: string };
  };
};

export type PageSequenceExamQueryVariables = Exact<{ [key: string]: never }>;

export type PageSequenceExamQuery = {
  __typename: 'Query';
  me?: {
    __typename: 'User';
    id: string;
    typetuin?: {
      __typename: 'GameUser';
      id: string;
      examRequests?: Array<{
        __typename: 'ChallengeRequest';
        id: string;
      } | null> | null;
    } | null;
  } | null;
};

export type IntroductionPageSequenceQueryVariables = Exact<{
  [key: string]: never;
}>;

export type IntroductionPageSequenceQuery = {
  __typename: 'Query';
  me?: {
    __typename: 'User';
    id: string;
    typetuin?: {
      __typename: 'GameUser';
      id: string;
      introductionCompleted: boolean;
    } | null;
  } | null;
};

export type MeExamQueryVariables = Exact<{ [key: string]: never }>;

export type MeExamQuery = {
  __typename: 'Query';
  me?: {
    __typename: 'User';
    id: string;
    typetuin?: {
      __typename: 'GameUser';
      id: string;
      highestCups: number;
      charactersPerMinuteStandard: number;
      examRequests?: Array<{
        __typename: 'ChallengeRequest';
        id: string;
        createdAt: string;
      } | null> | null;
      examResults?: Array<{
        __typename: 'ChallengeResult';
        id: string;
        charactersPerMinute: number;
        charactersPerMinuteStandard: number;
        cupsEarned?: number | null;
        passed: boolean;
        accuracy: number;
        challengeRequest: {
          __typename: 'ChallengeRequest';
          id: string;
          createdAt: string;
          exercise: {
            __typename: 'Exercise';
            id: string;
            user: { __typename: 'GameUser'; id: string };
            level: { __typename: 'Level'; id: string };
          };
        };
      } | null> | null;
    } | null;
  } | null;
};

export type IntroductionWelcomeNameQueryVariables = Exact<{
  [key: string]: never;
}>;

export type IntroductionWelcomeNameQuery = {
  __typename: 'Query';
  me?: {
    __typename: 'User';
    id: string;
    typetuin?: {
      __typename: 'GameUser';
      id: string;
      gamename?: string | null;
    } | null;
  } | null;
};

export type IntroductionCompletedQueryVariables = Exact<{
  [key: string]: never;
}>;

export type IntroductionCompletedQuery = {
  __typename: 'Query';
  me?: {
    __typename: 'User';
    id: string;
    typetuin?: {
      __typename: 'GameUser';
      id: string;
      introductionCompleted: boolean;
    } | null;
  } | null;
};

export type TestExamIntroductionSkipableQueryVariables = Exact<{
  [key: string]: never;
}>;

export type TestExamIntroductionSkipableQuery = {
  __typename: 'Query';
  me?: {
    __typename: 'User';
    id: string;
    typetuin?: {
      __typename: 'GameUser';
      id: string;
      userLevels: Array<{
        __typename: 'UserLevel';
        id: string;
        firstTime: boolean;
        showedUnlockAnimation: boolean;
        level?: { __typename: 'Level'; id: string } | null;
      }>;
    } | null;
  } | null;
};

export type MeTestExamQueryVariables = Exact<{ [key: string]: never }>;

export type MeTestExamQuery = {
  __typename: 'Query';
  me?: {
    __typename: 'User';
    id: string;
    typetuin?: {
      __typename: 'GameUser';
      id: string;
      charactersPerMinuteStandard: number;
      examOpeningDayCountDown: number;
      firstSuccessfulTestExam?: {
        __typename: 'ChallengeResult';
        id: string;
        createdAt: string;
      } | null;
    } | null;
  } | null;
};

export const BasispoortUserFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'BasispoortUser' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'User' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'basispoortId' } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<BasispoortUserFragment, unknown>;
export const MeAuthDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'MeAuth' },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'me' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'username' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'keyboardLayout' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'typetuin' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: {
                          kind: 'Name',
                          value: 'allowedToRequestDiploma',
                        },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'hasRequestedDiploma' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'introductionCompleted' },
                      },
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'highestCups' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'diamonds' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'gamename' },
                      },
                      {
                        kind: 'Field',
                        name: {
                          kind: 'Name',
                          value: 'charactersPerMinuteStandard',
                        },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'fontType' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'focusMode' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'hideDiamonds' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'gameCompleted' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'showInterpunct' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'audioMuted' },
                      },
                      {
                        kind: 'Field',
                        name: {
                          kind: 'Name',
                          value: 'displayedAlfredoMessages',
                        },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'id' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'displayedAt' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'alfredoMessage' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'id' },
                                  },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'message' },
                                  },
                                ],
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<MeAuthQuery, MeAuthQueryVariables>;
export const MyKeyboardLayoutDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'MyKeyboardLayout' },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'me' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'keyboardLayout' },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  MyKeyboardLayoutQuery,
  MyKeyboardLayoutQueryVariables
>;
export const ForgotUsernamesDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'ForgotUsernames' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'email' },
          },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'String' },
            },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'forgotUsernames' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'data' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'email' },
                      value: {
                        kind: 'Variable',
                        name: { kind: 'Name', value: 'email' },
                      },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'message' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  ForgotUsernamesMutation,
  ForgotUsernamesMutationVariables
>;
export const ChangePasswordDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'ChangePassword' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'data' } },
          type: {
            kind: 'NamedType',
            name: { kind: 'Name', value: 'ChangePasswordInput' },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'changePassword' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'data' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'data' },
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'message' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  ChangePasswordMutation,
  ChangePasswordMutationVariables
>;
export const ForgotPasswordDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'ForgotPassword' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'data' } },
          type: {
            kind: 'NamedType',
            name: { kind: 'Name', value: 'ForgotPasswordInput' },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'forgotPassword' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'data' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'data' },
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'message' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  ForgotPasswordMutation,
  ForgotPasswordMutationVariables
>;
export const MeLoginDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'MeLogin' },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'me' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'typetuin' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'gamename' },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<MeLoginQuery, MeLoginQueryVariables>;
export const ChallengeResultsDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'ChallengeResults' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'userId' },
          },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } },
        },
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'levelId' },
          },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'challengeResults' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'where' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'challengeRequest' },
                      value: {
                        kind: 'ObjectValue',
                        fields: [
                          {
                            kind: 'ObjectField',
                            name: { kind: 'Name', value: 'exercise' },
                            value: {
                              kind: 'ObjectValue',
                              fields: [
                                {
                                  kind: 'ObjectField',
                                  name: { kind: 'Name', value: 'user' },
                                  value: {
                                    kind: 'ObjectValue',
                                    fields: [
                                      {
                                        kind: 'ObjectField',
                                        name: { kind: 'Name', value: 'id' },
                                        value: {
                                          kind: 'Variable',
                                          name: {
                                            kind: 'Name',
                                            value: 'userId',
                                          },
                                        },
                                      },
                                    ],
                                  },
                                },
                                {
                                  kind: 'ObjectField',
                                  name: { kind: 'Name', value: 'level' },
                                  value: {
                                    kind: 'ObjectValue',
                                    fields: [
                                      {
                                        kind: 'ObjectField',
                                        name: { kind: 'Name', value: 'id' },
                                        value: {
                                          kind: 'Variable',
                                          name: {
                                            kind: 'Name',
                                            value: 'levelId',
                                          },
                                        },
                                      },
                                    ],
                                  },
                                },
                              ],
                            },
                          },
                        ],
                      },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'charactersPerMinute' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'charactersPerMinuteStandard' },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'cupsEarned' } },
                { kind: 'Field', name: { kind: 'Name', value: 'passed' } },
                { kind: 'Field', name: { kind: 'Name', value: 'accuracy' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'challengeRequest' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'createdAt' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'exercise' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'id' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'user' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'id' },
                                  },
                                ],
                              },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'level' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'id' },
                                  },
                                ],
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  ChallengeResultsQuery,
  ChallengeResultsQueryVariables
>;
export const ExamMeDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'ExamMe' },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'me' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'followingCourseGroup' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'useLevelSettings' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'levelSettings' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'id' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'state' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'level' },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'typetuin' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'examRequests' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'id' },
                            },
                          ],
                        },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'gameCompleted' },
                      },
                      {
                        kind: 'Field',
                        name: {
                          kind: 'Name',
                          value: 'usePersonalLevelSettings',
                        },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'userLevels' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'id' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'user' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'id' },
                                  },
                                ],
                              },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'level' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'id' },
                                  },
                                ],
                              },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'state' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'unlocked' },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<ExamMeQuery, ExamMeQueryVariables>;
export const UpdateGameUserDiamondsDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'UpdateGameUserDiamonds' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'userId' },
          },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } },
        },
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'diamonds' },
          },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'Int' } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'updateGameUser' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'where' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'userId' },
                      value: {
                        kind: 'Variable',
                        name: { kind: 'Name', value: 'userId' },
                      },
                    },
                  ],
                },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'data' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'diamonds' },
                      value: {
                        kind: 'Variable',
                        name: { kind: 'Name', value: 'diamonds' },
                      },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'introductionCompleted' },
                      value: { kind: 'BooleanValue', value: true },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'userId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'diamonds' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  UpdateGameUserDiamondsMutation,
  UpdateGameUserDiamondsMutationVariables
>;
export const ActivateKwouwselAccessoryDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'ActivateKwouwselAccessory' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'id' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'activateKwouwselAccessory' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'where' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'id' },
                      value: {
                        kind: 'Variable',
                        name: { kind: 'Name', value: 'id' },
                      },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'bought' } },
                { kind: 'Field', name: { kind: 'Name', value: 'active' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  ActivateKwouwselAccessoryMutation,
  ActivateKwouwselAccessoryMutationVariables
>;
export const ActivateKwouwselUpgradeDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'ActivateKwouwselUpgrade' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'id' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'activateKwouwselUpgrade' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'where' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'id' },
                      value: {
                        kind: 'Variable',
                        name: { kind: 'Name', value: 'id' },
                      },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'bought' } },
                { kind: 'Field', name: { kind: 'Name', value: 'active' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  ActivateKwouwselUpgradeMutation,
  ActivateKwouwselUpgradeMutationVariables
>;
export const BuyKwouwselAccessoryDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'BuyKwouwselAccessory' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'id' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'buyKwouwselAccessory' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'where' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'id' },
                      value: {
                        kind: 'Variable',
                        name: { kind: 'Name', value: 'id' },
                      },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'bought' } },
                { kind: 'Field', name: { kind: 'Name', value: 'active' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  BuyKwouwselAccessoryMutation,
  BuyKwouwselAccessoryMutationVariables
>;
export const BuyKwouwselUpgradeDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'BuyKwouwselUpgrade' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'id' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'buyKwouwselUpgrade' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'where' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'id' },
                      value: {
                        kind: 'Variable',
                        name: { kind: 'Name', value: 'id' },
                      },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'bought' } },
                { kind: 'Field', name: { kind: 'Name', value: 'active' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  BuyKwouwselUpgradeMutation,
  BuyKwouwselUpgradeMutationVariables
>;
export const DeactivateKwouwselAccessoryDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'DeactivateKwouwselAccessory' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'id' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'deactivateKwouwselAccessory' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'where' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'id' },
                      value: {
                        kind: 'Variable',
                        name: { kind: 'Name', value: 'id' },
                      },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'bought' } },
                { kind: 'Field', name: { kind: 'Name', value: 'active' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  DeactivateKwouwselAccessoryMutation,
  DeactivateKwouwselAccessoryMutationVariables
>;
export const DeactivateKwouwselUpgradeDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'DeactivateKwouwselUpgrade' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'id' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'deactivateKwouwselUpgrade' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'where' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'id' },
                      value: {
                        kind: 'Variable',
                        name: { kind: 'Name', value: 'id' },
                      },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'bought' } },
                { kind: 'Field', name: { kind: 'Name', value: 'active' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  DeactivateKwouwselUpgradeMutation,
  DeactivateKwouwselUpgradeMutationVariables
>;
export const SellKwouwselAccessoryDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'SellKwouwselAccessory' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'id' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'sellKwouwselAccessory' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'where' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'id' },
                      value: {
                        kind: 'Variable',
                        name: { kind: 'Name', value: 'id' },
                      },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'bought' } },
                { kind: 'Field', name: { kind: 'Name', value: 'active' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  SellKwouwselAccessoryMutation,
  SellKwouwselAccessoryMutationVariables
>;
export const SellKwouwselUpgradeDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'SellKwouwselUpgrade' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'id' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'sellKwouwselUpgrade' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'where' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'id' },
                      value: {
                        kind: 'Variable',
                        name: { kind: 'Name', value: 'id' },
                      },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'bought' } },
                { kind: 'Field', name: { kind: 'Name', value: 'active' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  SellKwouwselUpgradeMutation,
  SellKwouwselUpgradeMutationVariables
>;
export const KwouwselDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'Kwouwsel' },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'me' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'unreadMessagesCount' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'followingCourseGroup' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'useLevelSettings' },
                      },
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'levelSettings' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'id' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'state' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'level' },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'typetuin' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'gamename' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'gameCompleted' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'diamonds' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'kwouwselUpgrades' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'id' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'bought' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'active' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'type' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'id' },
                                  },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'name' },
                                  },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'price' },
                                  },
                                  {
                                    kind: 'Field',
                                    name: {
                                      kind: 'Name',
                                      value: 'requiredStars',
                                    },
                                  },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'level' },
                                    selectionSet: {
                                      kind: 'SelectionSet',
                                      selections: [
                                        {
                                          kind: 'Field',
                                          name: { kind: 'Name', value: 'id' },
                                        },
                                      ],
                                    },
                                  },
                                ],
                              },
                            },
                          ],
                        },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'kwouwselAccessories' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'id' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'bought' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'active' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'type' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'id' },
                                  },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'name' },
                                  },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'price' },
                                  },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'level' },
                                    selectionSet: {
                                      kind: 'SelectionSet',
                                      selections: [
                                        {
                                          kind: 'Field',
                                          name: { kind: 'Name', value: 'id' },
                                        },
                                      ],
                                    },
                                  },
                                ],
                              },
                            },
                          ],
                        },
                      },
                      {
                        kind: 'Field',
                        name: {
                          kind: 'Name',
                          value: 'usePersonalLevelSettings',
                        },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'userLevels' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'id' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'completed' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'stars' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'unlocked' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'state' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'user' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'id' },
                                  },
                                ],
                              },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'level' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'id' },
                                  },
                                ],
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<KwouwselQuery, KwouwselQueryVariables>;
export const SubmitChallengeResultDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'SubmitChallengeResult' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'data' } },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'ChallengeResultCreateInput' },
            },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'submitChallengeResult' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'data' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'data' },
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                {
                  kind: 'InlineFragment',
                  typeCondition: {
                    kind: 'NamedType',
                    name: { kind: 'Name', value: 'ChallengeResult' },
                  },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'createdAt' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'updatedAt' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'accuracy' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'charactersPerMinute' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'diamondsEarned' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'challengeRequest' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'id' },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
                {
                  kind: 'InlineFragment',
                  typeCondition: {
                    kind: 'NamedType',
                    name: { kind: 'Name', value: 'ExerciseResult' },
                  },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'createdAt' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'updatedAt' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'extraDiamonds' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'accuracy' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'charactersPerMinute' },
                      },
                      {
                        kind: 'Field',
                        name: {
                          kind: 'Name',
                          value: 'averageCharactersPerMinute',
                        },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'averageAccuracy' },
                      },
                      {
                        kind: 'Field',
                        name: {
                          kind: 'Name',
                          value: 'correctChallengesPercentage',
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  SubmitChallengeResultMutation,
  SubmitChallengeResultMutationVariables
>;
export const CreateExerciseDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'CreateExercise' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'levelId' },
          },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'createExercise' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'data' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'level' },
                      value: {
                        kind: 'ObjectValue',
                        fields: [
                          {
                            kind: 'ObjectField',
                            name: { kind: 'Name', value: 'connect' },
                            value: {
                              kind: 'ObjectValue',
                              fields: [
                                {
                                  kind: 'ObjectField',
                                  name: { kind: 'Name', value: 'id' },
                                  value: {
                                    kind: 'Variable',
                                    name: { kind: 'Name', value: 'levelId' },
                                  },
                                },
                              ],
                            },
                          },
                        ],
                      },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'numberOfChallenges' },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  CreateExerciseMutation,
  CreateExerciseMutationVariables
>;
export const RequestChallengeDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'RequestChallenge' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'exerciseId' },
          },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'requestChallenge' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'where' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'id' },
                      value: {
                        kind: 'Variable',
                        name: { kind: 'Name', value: 'exerciseId' },
                      },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'challenge' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'text' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'level' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'loop' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'id' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'timeInMs' },
                            },
                          ],
                        },
                      },
                      { kind: 'Field', name: { kind: 'Name', value: 'skill' } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  RequestChallengeMutation,
  RequestChallengeMutationVariables
>;
export const RequestChallengesDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'RequestChallenges' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'exerciseId' },
          },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'requestChallenges' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'where' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'id' },
                      value: {
                        kind: 'Variable',
                        name: { kind: 'Name', value: 'exerciseId' },
                      },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'challenge' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'text' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'level' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'loop' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'id' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'timeInMs' },
                            },
                          ],
                        },
                      },
                      { kind: 'Field', name: { kind: 'Name', value: 'skill' } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  RequestChallengesMutation,
  RequestChallengesMutationVariables
>;
export const LevelsDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'Levels' },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'me' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'followingCourseGroup' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'useLevelSettings' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'levelSettings' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'id' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'level' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'state' },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'typetuin' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'gameCompleted' },
                      },
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'diamonds' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'fontType' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'focusMode' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'hideDiamonds' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'showInterpunct' },
                      },
                      {
                        kind: 'Field',
                        name: {
                          kind: 'Name',
                          value: 'usePersonalLevelSettings',
                        },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'userLevels' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'id' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'unlocked' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'state' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'user' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'id' },
                                  },
                                ],
                              },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'level' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  {
                                    kind: 'Field',
                                    name: {
                                      kind: 'Name',
                                      value: 'allowBackspace',
                                    },
                                  },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'diamonds' },
                                  },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'id' },
                                  },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'name' },
                                  },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'lives' },
                                  },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'timeInMs' },
                                  },
                                ],
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<LevelsQuery, LevelsQueryVariables>;
export const LevelMeDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'LevelMe' },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'me' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'followingCourseGroup' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'useLevelSettings' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'levelSettings' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'id' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'state' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'level' },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'typetuin' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'gameCompleted' },
                      },
                      {
                        kind: 'Field',
                        name: {
                          kind: 'Name',
                          value: 'usePersonalLevelSettings',
                        },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'userLevels' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'id' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'firstTime' },
                            },
                            {
                              kind: 'Field',
                              name: {
                                kind: 'Name',
                                value: 'showedUnlockAnimation',
                              },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'user' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'id' },
                                  },
                                ],
                              },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'level' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'id' },
                                  },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'name' },
                                  },
                                  {
                                    kind: 'Field',
                                    name: {
                                      kind: 'Name',
                                      value: 'characterName',
                                    },
                                  },
                                  {
                                    kind: 'Field',
                                    name: {
                                      kind: 'Name',
                                      value: 'characterPrefix',
                                    },
                                  },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'previous' },
                                  },
                                ],
                              },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'unlocked' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'state' },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<LevelMeQuery, LevelMeQueryVariables>;
export const MeAudioDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'MeAudio' },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'me' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'typetuin' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'audioMuted' },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<MeAudioQuery, MeAudioQueryVariables>;
export const MarkMessageAsReadDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'MarkMessageAsRead' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'messageId' },
          },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'String' },
            },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'markMessageAsRead' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'data' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'messageId' },
                      value: {
                        kind: 'Variable',
                        name: { kind: 'Name', value: 'messageId' },
                      },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'sender' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'firstName' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'prefix' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'lastName' },
                      },
                    ],
                  },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'subject' } },
                { kind: 'Field', name: { kind: 'Name', value: 'content' } },
                { kind: 'Field', name: { kind: 'Name', value: 'sentAt' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'recipients' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'user' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'id' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'username' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'firstName' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'lastName' },
                            },
                          ],
                        },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'readAt' },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  MarkMessageAsReadMutation,
  MarkMessageAsReadMutationVariables
>;
export const ReplyToMessageDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'ReplyToMessage' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'messageId' },
          },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'String' },
            },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'content' },
          },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'String' },
            },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'replyToMessage' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'data' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'messageId' },
                      value: {
                        kind: 'Variable',
                        name: { kind: 'Name', value: 'messageId' },
                      },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'content' },
                      value: {
                        kind: 'Variable',
                        name: { kind: 'Name', value: 'content' },
                      },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'sender' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'firstName' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'prefix' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'lastName' },
                      },
                    ],
                  },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'subject' } },
                { kind: 'Field', name: { kind: 'Name', value: 'content' } },
                { kind: 'Field', name: { kind: 'Name', value: 'sentAt' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'recipients' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'user' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'id' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'firstName' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'prefix' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'lastName' },
                            },
                          ],
                        },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'readAt' },
                      },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'replies' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'subject' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'content' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'sentAt' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'sender' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'id' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'firstName' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'prefix' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'lastName' },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  ReplyToMessageMutation,
  ReplyToMessageMutationVariables
>;
export const SendMessageDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'SendMessage' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'subject' },
          },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'String' },
            },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'content' },
          },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'String' },
            },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'recipients' },
          },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'ListType',
              type: {
                kind: 'NonNullType',
                type: {
                  kind: 'NamedType',
                  name: { kind: 'Name', value: 'String' },
                },
              },
            },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'sendMessage' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'data' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'subject' },
                      value: {
                        kind: 'Variable',
                        name: { kind: 'Name', value: 'subject' },
                      },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'content' },
                      value: {
                        kind: 'Variable',
                        name: { kind: 'Name', value: 'content' },
                      },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'recipients' },
                      value: {
                        kind: 'Variable',
                        name: { kind: 'Name', value: 'recipients' },
                      },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                {
                  kind: 'InlineFragment',
                  typeCondition: {
                    kind: 'NamedType',
                    name: { kind: 'Name', value: 'Message' },
                  },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'sender' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'id' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'username' },
                            },
                          ],
                        },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'subject' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'content' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'sentAt' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'recipients' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'readAt' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'user' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'id' },
                                  },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'username' },
                                  },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'firstName' },
                                  },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'lastName' },
                                  },
                                ],
                              },
                            },
                          ],
                        },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'replies' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'id' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'sender' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'id' },
                                  },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'firstName' },
                                  },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'prefix' },
                                  },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'lastName' },
                                  },
                                ],
                              },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'subject' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'content' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'sentAt' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'recipients' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'user' },
                                    selectionSet: {
                                      kind: 'SelectionSet',
                                      selections: [
                                        {
                                          kind: 'Field',
                                          name: { kind: 'Name', value: 'id' },
                                        },
                                        {
                                          kind: 'Field',
                                          name: {
                                            kind: 'Name',
                                            value: 'username',
                                          },
                                        },
                                        {
                                          kind: 'Field',
                                          name: {
                                            kind: 'Name',
                                            value: 'prefix',
                                          },
                                        },
                                        {
                                          kind: 'Field',
                                          name: {
                                            kind: 'Name',
                                            value: 'firstName',
                                          },
                                        },
                                        {
                                          kind: 'Field',
                                          name: {
                                            kind: 'Name',
                                            value: 'lastName',
                                          },
                                        },
                                      ],
                                    },
                                  },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'readAt' },
                                  },
                                ],
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
                {
                  kind: 'InlineFragment',
                  typeCondition: {
                    kind: 'NamedType',
                    name: { kind: 'Name', value: 'MessagesResponse' },
                  },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'messages' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'id' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'sender' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'id' },
                                  },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'username' },
                                  },
                                ],
                              },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'subject' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'content' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'sentAt' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'recipients' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'readAt' },
                                  },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'user' },
                                    selectionSet: {
                                      kind: 'SelectionSet',
                                      selections: [
                                        {
                                          kind: 'Field',
                                          name: { kind: 'Name', value: 'id' },
                                        },
                                        {
                                          kind: 'Field',
                                          name: {
                                            kind: 'Name',
                                            value: 'username',
                                          },
                                        },
                                        {
                                          kind: 'Field',
                                          name: {
                                            kind: 'Name',
                                            value: 'firstName',
                                          },
                                        },
                                        {
                                          kind: 'Field',
                                          name: {
                                            kind: 'Name',
                                            value: 'lastName',
                                          },
                                        },
                                      ],
                                    },
                                  },
                                ],
                              },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'replies' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'id' },
                                  },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'sender' },
                                    selectionSet: {
                                      kind: 'SelectionSet',
                                      selections: [
                                        {
                                          kind: 'Field',
                                          name: { kind: 'Name', value: 'id' },
                                        },
                                        {
                                          kind: 'Field',
                                          name: {
                                            kind: 'Name',
                                            value: 'firstName',
                                          },
                                        },
                                        {
                                          kind: 'Field',
                                          name: {
                                            kind: 'Name',
                                            value: 'prefix',
                                          },
                                        },
                                        {
                                          kind: 'Field',
                                          name: {
                                            kind: 'Name',
                                            value: 'lastName',
                                          },
                                        },
                                      ],
                                    },
                                  },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'subject' },
                                  },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'content' },
                                  },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'sentAt' },
                                  },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'recipients' },
                                    selectionSet: {
                                      kind: 'SelectionSet',
                                      selections: [
                                        {
                                          kind: 'Field',
                                          name: { kind: 'Name', value: 'user' },
                                          selectionSet: {
                                            kind: 'SelectionSet',
                                            selections: [
                                              {
                                                kind: 'Field',
                                                name: {
                                                  kind: 'Name',
                                                  value: 'id',
                                                },
                                              },
                                              {
                                                kind: 'Field',
                                                name: {
                                                  kind: 'Name',
                                                  value: 'username',
                                                },
                                              },
                                              {
                                                kind: 'Field',
                                                name: {
                                                  kind: 'Name',
                                                  value: 'prefix',
                                                },
                                              },
                                              {
                                                kind: 'Field',
                                                name: {
                                                  kind: 'Name',
                                                  value: 'firstName',
                                                },
                                              },
                                              {
                                                kind: 'Field',
                                                name: {
                                                  kind: 'Name',
                                                  value: 'lastName',
                                                },
                                              },
                                            ],
                                          },
                                        },
                                        {
                                          kind: 'Field',
                                          name: {
                                            kind: 'Name',
                                            value: 'readAt',
                                          },
                                        },
                                      ],
                                    },
                                  },
                                ],
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<SendMessageMutation, SendMessageMutationVariables>;
export const MeDisplayedAlfredoMessagesDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'MeDisplayedAlfredoMessages' },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'me' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'typetuin' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      {
                        kind: 'Field',
                        name: {
                          kind: 'Name',
                          value: 'displayedAlfredoMessages',
                        },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'id' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'displayedAt' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'alfredoMessage' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'id' },
                                  },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'message' },
                                  },
                                ],
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  MeDisplayedAlfredoMessagesQuery,
  MeDisplayedAlfredoMessagesQueryVariables
>;
export const MeReceivedMessagesDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'MeReceivedMessages' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'first' },
          },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'Int' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'skip' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'Int' } },
        },
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'where' },
          },
          type: {
            kind: 'NamedType',
            name: { kind: 'Name', value: 'MessageWithUserWhereInput' },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'orderBy' },
          },
          type: {
            kind: 'NamedType',
            name: { kind: 'Name', value: 'MessageOrderByInput' },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'repliesOrderBy' },
          },
          type: {
            kind: 'NamedType',
            name: { kind: 'Name', value: 'MessageOrderByInput' },
          },
          defaultValue: { kind: 'EnumValue', value: 'lastReplyAt_ASC' },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'me' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'receivedMessages' },
                  arguments: [
                    {
                      kind: 'Argument',
                      name: { kind: 'Name', value: 'filter' },
                      value: {
                        kind: 'ObjectValue',
                        fields: [
                          {
                            kind: 'ObjectField',
                            name: { kind: 'Name', value: 'where' },
                            value: {
                              kind: 'Variable',
                              name: { kind: 'Name', value: 'where' },
                            },
                          },
                          {
                            kind: 'ObjectField',
                            name: { kind: 'Name', value: 'first' },
                            value: {
                              kind: 'Variable',
                              name: { kind: 'Name', value: 'first' },
                            },
                          },
                          {
                            kind: 'ObjectField',
                            name: { kind: 'Name', value: 'skip' },
                            value: {
                              kind: 'Variable',
                              name: { kind: 'Name', value: 'skip' },
                            },
                          },
                          {
                            kind: 'ObjectField',
                            name: { kind: 'Name', value: 'orderBy' },
                            value: {
                              kind: 'Variable',
                              name: { kind: 'Name', value: 'orderBy' },
                            },
                          },
                        ],
                      },
                    },
                  ],
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'edges' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'node' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'id' },
                                  },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'sender' },
                                    selectionSet: {
                                      kind: 'SelectionSet',
                                      selections: [
                                        {
                                          kind: 'Field',
                                          name: { kind: 'Name', value: 'id' },
                                        },
                                        {
                                          kind: 'Field',
                                          name: {
                                            kind: 'Name',
                                            value: 'firstName',
                                          },
                                        },
                                        {
                                          kind: 'Field',
                                          name: {
                                            kind: 'Name',
                                            value: 'prefix',
                                          },
                                        },
                                        {
                                          kind: 'Field',
                                          name: {
                                            kind: 'Name',
                                            value: 'lastName',
                                          },
                                        },
                                      ],
                                    },
                                  },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'subject' },
                                  },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'content' },
                                  },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'sentAt' },
                                  },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'type' },
                                  },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'recipients' },
                                    selectionSet: {
                                      kind: 'SelectionSet',
                                      selections: [
                                        {
                                          kind: 'Field',
                                          name: { kind: 'Name', value: 'user' },
                                          selectionSet: {
                                            kind: 'SelectionSet',
                                            selections: [
                                              {
                                                kind: 'Field',
                                                name: {
                                                  kind: 'Name',
                                                  value: 'id',
                                                },
                                              },
                                              {
                                                kind: 'Field',
                                                name: {
                                                  kind: 'Name',
                                                  value: 'username',
                                                },
                                              },
                                              {
                                                kind: 'Field',
                                                name: {
                                                  kind: 'Name',
                                                  value: 'prefix',
                                                },
                                              },
                                              {
                                                kind: 'Field',
                                                name: {
                                                  kind: 'Name',
                                                  value: 'firstName',
                                                },
                                              },
                                              {
                                                kind: 'Field',
                                                name: {
                                                  kind: 'Name',
                                                  value: 'lastName',
                                                },
                                              },
                                            ],
                                          },
                                        },
                                        {
                                          kind: 'Field',
                                          name: {
                                            kind: 'Name',
                                            value: 'readAt',
                                          },
                                        },
                                      ],
                                    },
                                  },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'replies' },
                                    arguments: [
                                      {
                                        kind: 'Argument',
                                        name: {
                                          kind: 'Name',
                                          value: 'orderBy',
                                        },
                                        value: {
                                          kind: 'Variable',
                                          name: {
                                            kind: 'Name',
                                            value: 'repliesOrderBy',
                                          },
                                        },
                                      },
                                    ],
                                    selectionSet: {
                                      kind: 'SelectionSet',
                                      selections: [
                                        {
                                          kind: 'Field',
                                          name: { kind: 'Name', value: 'id' },
                                        },
                                        {
                                          kind: 'Field',
                                          name: {
                                            kind: 'Name',
                                            value: 'sender',
                                          },
                                          selectionSet: {
                                            kind: 'SelectionSet',
                                            selections: [
                                              {
                                                kind: 'Field',
                                                name: {
                                                  kind: 'Name',
                                                  value: 'id',
                                                },
                                              },
                                              {
                                                kind: 'Field',
                                                name: {
                                                  kind: 'Name',
                                                  value: 'firstName',
                                                },
                                              },
                                              {
                                                kind: 'Field',
                                                name: {
                                                  kind: 'Name',
                                                  value: 'prefix',
                                                },
                                              },
                                              {
                                                kind: 'Field',
                                                name: {
                                                  kind: 'Name',
                                                  value: 'lastName',
                                                },
                                              },
                                            ],
                                          },
                                        },
                                        {
                                          kind: 'Field',
                                          name: {
                                            kind: 'Name',
                                            value: 'subject',
                                          },
                                        },
                                        {
                                          kind: 'Field',
                                          name: {
                                            kind: 'Name',
                                            value: 'content',
                                          },
                                        },
                                        {
                                          kind: 'Field',
                                          name: {
                                            kind: 'Name',
                                            value: 'sentAt',
                                          },
                                        },
                                        {
                                          kind: 'Field',
                                          name: {
                                            kind: 'Name',
                                            value: 'recipients',
                                          },
                                          selectionSet: {
                                            kind: 'SelectionSet',
                                            selections: [
                                              {
                                                kind: 'Field',
                                                name: {
                                                  kind: 'Name',
                                                  value: 'user',
                                                },
                                                selectionSet: {
                                                  kind: 'SelectionSet',
                                                  selections: [
                                                    {
                                                      kind: 'Field',
                                                      name: {
                                                        kind: 'Name',
                                                        value: 'id',
                                                      },
                                                    },
                                                    {
                                                      kind: 'Field',
                                                      name: {
                                                        kind: 'Name',
                                                        value: 'username',
                                                      },
                                                    },
                                                    {
                                                      kind: 'Field',
                                                      name: {
                                                        kind: 'Name',
                                                        value: 'prefix',
                                                      },
                                                    },
                                                    {
                                                      kind: 'Field',
                                                      name: {
                                                        kind: 'Name',
                                                        value: 'firstName',
                                                      },
                                                    },
                                                    {
                                                      kind: 'Field',
                                                      name: {
                                                        kind: 'Name',
                                                        value: 'lastName',
                                                      },
                                                    },
                                                  ],
                                                },
                                              },
                                              {
                                                kind: 'Field',
                                                name: {
                                                  kind: 'Name',
                                                  value: 'readAt',
                                                },
                                              },
                                            ],
                                          },
                                        },
                                      ],
                                    },
                                  },
                                ],
                              },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'cursor' },
                            },
                          ],
                        },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'aggregate' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'count' },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  MeReceivedMessagesQuery,
  MeReceivedMessagesQueryVariables
>;
export const MeRecipientsDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'MeRecipients' },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'me' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'followingCourseGroup' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'coaches' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'users' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'id' },
                                  },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'firstName' },
                                  },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'prefix' },
                                  },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'lastName' },
                                  },
                                ],
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<MeRecipientsQuery, MeRecipientsQueryVariables>;
export const MeSentMessagesDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'MeSentMessages' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'first' },
          },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'Int' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'skip' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'Int' } },
        },
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'where' },
          },
          type: {
            kind: 'NamedType',
            name: { kind: 'Name', value: 'MessageWithUserWhereInput' },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'orderBy' },
          },
          type: {
            kind: 'NamedType',
            name: { kind: 'Name', value: 'MessageOrderByInput' },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'me' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'sentMessages' },
                  arguments: [
                    {
                      kind: 'Argument',
                      name: { kind: 'Name', value: 'filter' },
                      value: {
                        kind: 'ObjectValue',
                        fields: [
                          {
                            kind: 'ObjectField',
                            name: { kind: 'Name', value: 'where' },
                            value: {
                              kind: 'Variable',
                              name: { kind: 'Name', value: 'where' },
                            },
                          },
                          {
                            kind: 'ObjectField',
                            name: { kind: 'Name', value: 'first' },
                            value: {
                              kind: 'Variable',
                              name: { kind: 'Name', value: 'first' },
                            },
                          },
                          {
                            kind: 'ObjectField',
                            name: { kind: 'Name', value: 'skip' },
                            value: {
                              kind: 'Variable',
                              name: { kind: 'Name', value: 'skip' },
                            },
                          },
                          {
                            kind: 'ObjectField',
                            name: { kind: 'Name', value: 'orderBy' },
                            value: {
                              kind: 'Variable',
                              name: { kind: 'Name', value: 'orderBy' },
                            },
                          },
                        ],
                      },
                    },
                  ],
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'edges' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'node' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'id' },
                                  },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'sender' },
                                    selectionSet: {
                                      kind: 'SelectionSet',
                                      selections: [
                                        {
                                          kind: 'Field',
                                          name: { kind: 'Name', value: 'id' },
                                        },
                                        {
                                          kind: 'Field',
                                          name: {
                                            kind: 'Name',
                                            value: 'firstName',
                                          },
                                        },
                                        {
                                          kind: 'Field',
                                          name: {
                                            kind: 'Name',
                                            value: 'prefix',
                                          },
                                        },
                                        {
                                          kind: 'Field',
                                          name: {
                                            kind: 'Name',
                                            value: 'lastName',
                                          },
                                        },
                                      ],
                                    },
                                  },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'subject' },
                                  },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'content' },
                                  },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'sentAt' },
                                  },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'type' },
                                  },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'recipients' },
                                    selectionSet: {
                                      kind: 'SelectionSet',
                                      selections: [
                                        {
                                          kind: 'Field',
                                          name: { kind: 'Name', value: 'user' },
                                          selectionSet: {
                                            kind: 'SelectionSet',
                                            selections: [
                                              {
                                                kind: 'Field',
                                                name: {
                                                  kind: 'Name',
                                                  value: 'id',
                                                },
                                              },
                                              {
                                                kind: 'Field',
                                                name: {
                                                  kind: 'Name',
                                                  value: 'username',
                                                },
                                              },
                                              {
                                                kind: 'Field',
                                                name: {
                                                  kind: 'Name',
                                                  value: 'prefix',
                                                },
                                              },
                                              {
                                                kind: 'Field',
                                                name: {
                                                  kind: 'Name',
                                                  value: 'firstName',
                                                },
                                              },
                                              {
                                                kind: 'Field',
                                                name: {
                                                  kind: 'Name',
                                                  value: 'lastName',
                                                },
                                              },
                                            ],
                                          },
                                        },
                                        {
                                          kind: 'Field',
                                          name: {
                                            kind: 'Name',
                                            value: 'readAt',
                                          },
                                        },
                                      ],
                                    },
                                  },
                                ],
                              },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'cursor' },
                            },
                          ],
                        },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'aggregate' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'count' },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<MeSentMessagesQuery, MeSentMessagesQueryVariables>;
export const MessageDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'Message' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'id' } },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'String' },
            },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'repliesOrderBy' },
          },
          type: {
            kind: 'NamedType',
            name: { kind: 'Name', value: 'MessageOrderByInput' },
          },
          defaultValue: { kind: 'EnumValue', value: 'lastReplyAt_ASC' },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'message' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'id' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'id' },
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'sender' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'firstName' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'prefix' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'lastName' },
                      },
                    ],
                  },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'type' } },
                { kind: 'Field', name: { kind: 'Name', value: 'subject' } },
                { kind: 'Field', name: { kind: 'Name', value: 'content' } },
                { kind: 'Field', name: { kind: 'Name', value: 'sentAt' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'recipients' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'user' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'id' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'firstName' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'prefix' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'lastName' },
                            },
                          ],
                        },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'readAt' },
                      },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'replies' },
                  arguments: [
                    {
                      kind: 'Argument',
                      name: { kind: 'Name', value: 'orderBy' },
                      value: {
                        kind: 'Variable',
                        name: { kind: 'Name', value: 'repliesOrderBy' },
                      },
                    },
                  ],
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'sender' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'id' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'firstName' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'prefix' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'lastName' },
                            },
                          ],
                        },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'subject' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'content' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'sentAt' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'recipients' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'user' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'id' },
                                  },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'username' },
                                  },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'prefix' },
                                  },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'firstName' },
                                  },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'lastName' },
                                  },
                                ],
                              },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'readAt' },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<MessageQuery, MessageQueryVariables>;
export const UpdateGameUserAudioDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'UpdateGameUserAudio' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'userId' },
          },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } },
        },
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'audioMuted' },
          },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'Boolean' } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'updateGameUser' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'where' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'userId' },
                      value: {
                        kind: 'Variable',
                        name: { kind: 'Name', value: 'userId' },
                      },
                    },
                  ],
                },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'data' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'audioMuted' },
                      value: {
                        kind: 'Variable',
                        name: { kind: 'Name', value: 'audioMuted' },
                      },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'userId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'audioMuted' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  UpdateGameUserAudioMutation,
  UpdateGameUserAudioMutationVariables
>;
export const DisplayedAlfredoMessageDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'DisplayedAlfredoMessage' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'id' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'displayedAlfredoMessage' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'where' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'id' },
                      value: {
                        kind: 'Variable',
                        name: { kind: 'Name', value: 'id' },
                      },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'displayedAlfredoMessages' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'displayedAt' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'alfredoMessage' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'id' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'message' },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  DisplayedAlfredoMessageMutation,
  DisplayedAlfredoMessageMutationVariables
>;
export const UpdateUserLevelDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'UpdateUserLevel' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'userLevelId' },
          },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'data' } },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'UserLevelUpdateInput' },
            },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'updateUserLevel' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'data' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'data' },
                },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'where' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'id' },
                      value: {
                        kind: 'Variable',
                        name: { kind: 'Name', value: 'userLevelId' },
                      },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'firstTime' } },
                { kind: 'Field', name: { kind: 'Name', value: 'state' } },
                { kind: 'Field', name: { kind: 'Name', value: 'unlocked' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'showedUnlockAnimation' },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  UpdateUserLevelMutation,
  UpdateUserLevelMutationVariables
>;
export const AlfredoMessagesDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'AlfredoMessages' },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'alfredoMessages' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'message' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  AlfredoMessagesQuery,
  AlfredoMessagesQueryVariables
>;
export const OverviewDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'Overview' },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'me' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'unreadMessagesCount' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'followingCourseGroup' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'useLevelSettings' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'levelSettings' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'id' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'state' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'level' },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'typetuin' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      {
                        kind: 'Field',
                        name: {
                          kind: 'Name',
                          value: 'amountOfChallengesToCalculateStars',
                        },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'miniGamesStates' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'first' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'second' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'third' },
                            },
                          ],
                        },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'diamonds' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'gamename' },
                      },
                      {
                        kind: 'Field',
                        name: {
                          kind: 'Name',
                          value: 'charactersPerMinuteStandard',
                        },
                      },
                      {
                        kind: 'Field',
                        name: {
                          kind: 'Name',
                          value: 'displayedAlfredoMessages',
                        },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'id' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'displayedAt' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'alfredoMessage' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'id' },
                                  },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'message' },
                                  },
                                ],
                              },
                            },
                          ],
                        },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'lastPlay' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'id' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'createdAt' },
                            },
                          ],
                        },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'fontType' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'focusMode' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'hideDiamonds' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'showInterpunct' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'showPracticeTimeTimer' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'gameCompleted' },
                      },
                      {
                        kind: 'Field',
                        name: {
                          kind: 'Name',
                          value: 'examOpeningDayCountDown',
                        },
                      },
                      {
                        kind: 'Field',
                        name: {
                          kind: 'Name',
                          value: 'firstSuccessfulTestExam',
                        },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'id' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'createdAt' },
                            },
                          ],
                        },
                      },
                      { kind: 'Field', name: { kind: 'Name', value: 'stars' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'audioMuted' },
                      },
                      {
                        kind: 'Field',
                        name: {
                          kind: 'Name',
                          value: 'usePersonalLevelSettings',
                        },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'userLevels' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'id' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'completed' },
                            },
                            {
                              kind: 'Field',
                              name: {
                                kind: 'Name',
                                value: 'charactersPerMinute',
                              },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'accuracy' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'stars' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'progress' },
                            },
                            {
                              kind: 'Field',
                              name: {
                                kind: 'Name',
                                value: 'showedUnlockAnimation',
                              },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'state' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'unlocked' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'user' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'id' },
                                  },
                                ],
                              },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'level' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'id' },
                                  },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'previous' },
                                  },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'name' },
                                  },
                                  {
                                    kind: 'Field',
                                    name: {
                                      kind: 'Name',
                                      value: 'amountOfChallengeResultsToPass',
                                    },
                                  },
                                  {
                                    kind: 'Field',
                                    name: {
                                      kind: 'Name',
                                      value: 'charactersPerMinutePercentage',
                                    },
                                  },
                                  {
                                    kind: 'Field',
                                    name: {
                                      kind: 'Name',
                                      value: 'requiredPercentageOfCpmsForStars',
                                    },
                                  },
                                  {
                                    kind: 'Field',
                                    name: {
                                      kind: 'Name',
                                      value:
                                        'requiredPercentagesOfAccuracyForStars',
                                    },
                                  },
                                ],
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<OverviewQuery, OverviewQueryVariables>;
export const OverviewPracticeTimeDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'OverviewPracticeTime' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'from' } },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'DateTime' },
            },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'to' } },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'DateTime' },
            },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'bucket' },
          },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'TimeSeriesBucket' },
            },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'me' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'typetuin' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'practiceTime' },
                        arguments: [
                          {
                            kind: 'Argument',
                            name: { kind: 'Name', value: 'from' },
                            value: {
                              kind: 'Variable',
                              name: { kind: 'Name', value: 'from' },
                            },
                          },
                          {
                            kind: 'Argument',
                            name: { kind: 'Name', value: 'to' },
                            value: {
                              kind: 'Variable',
                              name: { kind: 'Name', value: 'to' },
                            },
                          },
                          {
                            kind: 'Argument',
                            name: { kind: 'Name', value: 'bucket' },
                            value: {
                              kind: 'Variable',
                              name: { kind: 'Name', value: 'bucket' },
                            },
                          },
                        ],
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'from' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'to' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'duration' },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  OverviewPracticeTimeQuery,
  OverviewPracticeTimeQueryVariables
>;
export const UserLevelByIdDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'UserLevelById' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'id' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'userLevel' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'where' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'id' },
                      value: {
                        kind: 'Variable',
                        name: { kind: 'Name', value: 'id' },
                      },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'challengeResultsCount' },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<UserLevelByIdQuery, UserLevelByIdQueryVariables>;
export const UpdateGameUserProfileDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'UpdateGameUserProfile' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'data' } },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'GameUserUpdateInput' },
            },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'userId' },
          },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'updateGameUser' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'data' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'data' },
                },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'where' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'userId' },
                      value: {
                        kind: 'Variable',
                        name: { kind: 'Name', value: 'userId' },
                      },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'userId' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'hasRequestedDiploma' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'allowedToRequestDiploma' },
                },
                {
                  kind: 'Field',
                  name: {
                    kind: 'Name',
                    value: 'hasRequestedParticipationCertificate',
                  },
                },
                {
                  kind: 'Field',
                  name: {
                    kind: 'Name',
                    value: 'allowedToRequestParticipationCertificate',
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  UpdateGameUserProfileMutation,
  UpdateGameUserProfileMutationVariables
>;
export const UpdateSelfDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'UpdateSelf' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'data' } },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'UserUpdateSelfInput' },
            },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'updateSelf' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'data' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'data' },
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'secondaryEmails' },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<UpdateSelfMutation, UpdateSelfMutationVariables>;
export const UpdateGameUserProfileDataDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'UpdateGameUserProfileData' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'userId' },
          },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } },
        },
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'fontType' },
          },
          type: {
            kind: 'NamedType',
            name: { kind: 'Name', value: 'FontType' },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'focusMode' },
          },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'Boolean' } },
        },
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'hideDiamonds' },
          },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'Boolean' } },
        },
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'showInterpunct' },
          },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'Boolean' } },
        },
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'showPracticeTimeTimer' },
          },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'Boolean' } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'updateGameUser' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'where' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'userId' },
                      value: {
                        kind: 'Variable',
                        name: { kind: 'Name', value: 'userId' },
                      },
                    },
                  ],
                },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'data' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'fontType' },
                      value: {
                        kind: 'Variable',
                        name: { kind: 'Name', value: 'fontType' },
                      },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'focusMode' },
                      value: {
                        kind: 'Variable',
                        name: { kind: 'Name', value: 'focusMode' },
                      },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'hideDiamonds' },
                      value: {
                        kind: 'Variable',
                        name: { kind: 'Name', value: 'hideDiamonds' },
                      },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'showInterpunct' },
                      value: {
                        kind: 'Variable',
                        name: { kind: 'Name', value: 'showInterpunct' },
                      },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'showPracticeTimeTimer' },
                      value: {
                        kind: 'Variable',
                        name: { kind: 'Name', value: 'showPracticeTimeTimer' },
                      },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'userId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'fontType' } },
                { kind: 'Field', name: { kind: 'Name', value: 'focusMode' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'hideDiamonds' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'showInterpunct' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'showPracticeTimeTimer' },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  UpdateGameUserProfileDataMutation,
  UpdateGameUserProfileDataMutationVariables
>;
export const MeProfileDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'MeProfile' },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'me' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'firstName' } },
                { kind: 'Field', name: { kind: 'Name', value: 'prefix' } },
                { kind: 'Field', name: { kind: 'Name', value: 'lastName' } },
                { kind: 'Field', name: { kind: 'Name', value: 'birthDate' } },
                { kind: 'Field', name: { kind: 'Name', value: 'username' } },
                { kind: 'Field', name: { kind: 'Name', value: 'email' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'secondaryEmails' },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'startDate' } },
                { kind: 'Field', name: { kind: 'Name', value: 'endDate' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'keyboardLayout' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'educationGroup' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'schools' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'followingCourseGroup' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'coaches' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'users' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'id' },
                                  },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'firstName' },
                                  },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'lastName' },
                                  },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'prefix' },
                                  },
                                ],
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'typetuin' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'gameCompleted' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'fontType' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'focusMode' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'highestCups' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'hideDiamonds' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'showInterpunct' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'showPracticeTimeTimer' },
                      },
                      {
                        kind: 'Field',
                        name: {
                          kind: 'Name',
                          value: 'charactersPerMinuteStandard',
                        },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'hasRequestedDiploma' },
                      },
                      {
                        kind: 'Field',
                        name: {
                          kind: 'Name',
                          value: 'allowedToRequestDiploma',
                        },
                      },
                      {
                        kind: 'Field',
                        name: {
                          kind: 'Name',
                          value: 'hasRequestedParticipationCertificate',
                        },
                      },
                      {
                        kind: 'Field',
                        name: {
                          kind: 'Name',
                          value: 'allowedToRequestParticipationCertificate',
                        },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'examRequests' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'id' },
                            },
                          ],
                        },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'examResults' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'id' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'passed' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'cupsEarned' },
                            },
                            {
                              kind: 'Field',
                              name: {
                                kind: 'Name',
                                value: 'charactersPerMinute',
                              },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'challengeRequest' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'id' },
                                  },
                                ],
                              },
                            },
                          ],
                        },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'examState' },
                      },
                    ],
                  },
                },
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'BasispoortUser' },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'BasispoortUser' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'User' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'basispoortId' } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<MeProfileQuery, MeProfileQueryVariables>;
export const ProgressDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'Progress' },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'me' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'followingCourseGroup' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'useLevelSettings' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'levelSettings' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'id' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'state' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'level' },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'typetuin' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'gamename' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'gameCompleted' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'averageAccuracy' },
                      },
                      {
                        kind: 'Field',
                        name: {
                          kind: 'Name',
                          value: 'averageCharactersPerMinute',
                        },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'examState' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'testExamResults' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'id' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'createdAt' },
                            },
                            {
                              kind: 'Field',
                              name: {
                                kind: 'Name',
                                value: 'charactersPerMinute',
                              },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'accuracy' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'cupsEarned' },
                            },
                          ],
                        },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'examResults' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'id' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'createdAt' },
                            },
                            {
                              kind: 'Field',
                              name: {
                                kind: 'Name',
                                value: 'charactersPerMinute',
                              },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'accuracy' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'cupsEarned' },
                            },
                          ],
                        },
                      },
                      {
                        kind: 'Field',
                        name: {
                          kind: 'Name',
                          value: 'usePersonalLevelSettings',
                        },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'userLevels' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'id' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'completed' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'level' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'id' },
                                  },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'name' },
                                  },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'previous' },
                                  },
                                ],
                              },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'user' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'id' },
                                  },
                                ],
                              },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'stars' },
                            },
                            {
                              kind: 'Field',
                              name: {
                                kind: 'Name',
                                value: 'charactersPerMinute',
                              },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'accuracy' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'progress' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'state' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'unlocked' },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<ProgressQuery, ProgressQueryVariables>;
export const ConfirmUserDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'ConfirmUser' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'data' } },
          type: {
            kind: 'NamedType',
            name: { kind: 'Name', value: 'ConfirmUserInput' },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'confirmUser' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'data' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'data' },
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'firstName' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<ConfirmUserMutation, ConfirmUserMutationVariables>;
export const UpdateGameUserDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'UpdateGameUser' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'userId' },
          },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } },
        },
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'gamename' },
          },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'updateGameUser' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'where' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'userId' },
                      value: {
                        kind: 'Variable',
                        name: { kind: 'Name', value: 'userId' },
                      },
                    },
                  ],
                },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'data' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'gamename' },
                      value: {
                        kind: 'Variable',
                        name: { kind: 'Name', value: 'gamename' },
                      },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'userId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'gamename' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  UpdateGameUserMutation,
  UpdateGameUserMutationVariables
>;
export const RegisterDemoUserDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'RegisterDemoUser' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'keyboardLayout' },
          },
          type: {
            kind: 'NamedType',
            name: { kind: 'Name', value: 'KeyboardLayout' },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'registerDemoUser' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'data' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'keyboardLayout' },
                      value: {
                        kind: 'Variable',
                        name: { kind: 'Name', value: 'keyboardLayout' },
                      },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'user' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'typetuin' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'id' },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  RegisterDemoUserMutation,
  RegisterDemoUserMutationVariables
>;
export const LoginDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'Login' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'username' },
          },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'String' },
            },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'password' },
          },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'String' },
            },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'loginUser' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'data' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'login' },
                      value: {
                        kind: 'Variable',
                        name: { kind: 'Name', value: 'username' },
                      },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'password' },
                      value: {
                        kind: 'Variable',
                        name: { kind: 'Name', value: 'password' },
                      },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'user' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<LoginMutation, LoginMutationVariables>;
export const RefreshDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'Refresh' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'userId' },
          },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'String' },
            },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'refreshToken' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'data' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'userId' },
                      value: {
                        kind: 'Variable',
                        name: { kind: 'Name', value: 'userId' },
                      },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'user' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<RefreshMutation, RefreshMutationVariables>;
export const ImpersonateDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'Impersonate' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'userId' },
          },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'impersonateUser' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'data' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'userId' },
                      value: {
                        kind: 'Variable',
                        name: { kind: 'Name', value: 'userId' },
                      },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'user' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<ImpersonateMutation, ImpersonateMutationVariables>;
export const PageSequenceExamDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'PageSequenceExam' },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'me' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'typetuin' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'examRequests' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'id' },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  PageSequenceExamQuery,
  PageSequenceExamQueryVariables
>;
export const IntroductionPageSequenceDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'IntroductionPageSequence' },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'me' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'typetuin' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'introductionCompleted' },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  IntroductionPageSequenceQuery,
  IntroductionPageSequenceQueryVariables
>;
export const MeExamDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'MeExam' },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'me' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'typetuin' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'highestCups' },
                      },
                      {
                        kind: 'Field',
                        name: {
                          kind: 'Name',
                          value: 'charactersPerMinuteStandard',
                        },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'examRequests' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'id' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'createdAt' },
                            },
                          ],
                        },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'examResults' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'id' },
                            },
                            {
                              kind: 'Field',
                              name: {
                                kind: 'Name',
                                value: 'charactersPerMinute',
                              },
                            },
                            {
                              kind: 'Field',
                              name: {
                                kind: 'Name',
                                value: 'charactersPerMinuteStandard',
                              },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'cupsEarned' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'passed' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'accuracy' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'challengeRequest' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'id' },
                                  },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'createdAt' },
                                  },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'exercise' },
                                    selectionSet: {
                                      kind: 'SelectionSet',
                                      selections: [
                                        {
                                          kind: 'Field',
                                          name: { kind: 'Name', value: 'id' },
                                        },
                                        {
                                          kind: 'Field',
                                          name: { kind: 'Name', value: 'user' },
                                          selectionSet: {
                                            kind: 'SelectionSet',
                                            selections: [
                                              {
                                                kind: 'Field',
                                                name: {
                                                  kind: 'Name',
                                                  value: 'id',
                                                },
                                              },
                                            ],
                                          },
                                        },
                                        {
                                          kind: 'Field',
                                          name: {
                                            kind: 'Name',
                                            value: 'level',
                                          },
                                          selectionSet: {
                                            kind: 'SelectionSet',
                                            selections: [
                                              {
                                                kind: 'Field',
                                                name: {
                                                  kind: 'Name',
                                                  value: 'id',
                                                },
                                              },
                                            ],
                                          },
                                        },
                                      ],
                                    },
                                  },
                                ],
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<MeExamQuery, MeExamQueryVariables>;
export const IntroductionWelcomeNameDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'IntroductionWelcomeName' },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'me' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'typetuin' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'gamename' },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  IntroductionWelcomeNameQuery,
  IntroductionWelcomeNameQueryVariables
>;
export const IntroductionCompletedDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'IntroductionCompleted' },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'me' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'typetuin' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'introductionCompleted' },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  IntroductionCompletedQuery,
  IntroductionCompletedQueryVariables
>;
export const TestExamIntroductionSkipableDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'TestExamIntroductionSkipable' },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'me' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'typetuin' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'userLevels' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'id' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'level' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'id' },
                                  },
                                ],
                              },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'firstTime' },
                            },
                            {
                              kind: 'Field',
                              name: {
                                kind: 'Name',
                                value: 'showedUnlockAnimation',
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  TestExamIntroductionSkipableQuery,
  TestExamIntroductionSkipableQueryVariables
>;
export const MeTestExamDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'MeTestExam' },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'me' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'typetuin' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      {
                        kind: 'Field',
                        name: {
                          kind: 'Name',
                          value: 'charactersPerMinuteStandard',
                        },
                      },
                      {
                        kind: 'Field',
                        name: {
                          kind: 'Name',
                          value: 'firstSuccessfulTestExam',
                        },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'id' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'createdAt' },
                            },
                          ],
                        },
                      },
                      {
                        kind: 'Field',
                        name: {
                          kind: 'Name',
                          value: 'examOpeningDayCountDown',
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<MeTestExamQuery, MeTestExamQueryVariables>;
